(() => {
  var t = {
      646: (t, e) => {
        "use strict";
        function i() {
          return window
            .getComputedStyle(document.documentElement, ":after")
            .getPropertyValue("content")
            .replace(/"/g, "");
        }
        Object.defineProperty(e, "__esModule", { value: !0 });
        var n = [],
          s = window
            .getComputedStyle(document.documentElement, ":before")
            .getPropertyValue("content")
            .replace(/"/g, "")
            .split(","),
          o = (function () {
            function t(t) {
              this.cssBreakpoint = t;
            }
            return (
              Object.defineProperty(t.prototype, "value", {
                get: function () {
                  return this.cssBreakpoint;
                },
                enumerable: !0,
                configurable: !0,
              }),
              (t.prototype.min = function (t) {
                return s.indexOf(this.value) - s.indexOf(t) >= 0;
              }),
              (t.prototype.max = function (t) {
                return s.indexOf(this.value) - s.indexOf(t) <= 0;
              }),
              (t.prototype.range = function (t, e) {
                var i = s.indexOf(this.value),
                  n = s.indexOf(t),
                  o = s.indexOf(e);
                return n <= i && i <= o;
              }),
              (t.prototype.is = function () {
                for (var t = this, e = [], i = 0; i < arguments.length; i++)
                  e[i] = arguments[i];
                return e.some(function (e) {
                  return e === t.value;
                });
              }),
              t
            );
          })(),
          r = { previous: new o(i()), current: new o(i()) };
        (e.get = function () {
          return r;
        }),
          (e.onChange = function (t) {
            -1 === n.indexOf(t) && n.push(t);
          }),
          (e.offChange = function (t) {
            var e = n.indexOf(t);
            -1 !== e && n.splice(e, 1);
          });
        e.min = function (t) {
          return r.current.min(t);
        };
        e.max = function (t) {
          return r.current.max(t);
        };
        e.range = function (t, e) {
          return r.current.range(t, e);
        };
        e.is = function () {
          for (var t, e = [], i = 0; i < arguments.length; i++)
            e[i] = arguments[i];
          return (t = r.current).is.apply(t, e);
        };
        var a = document.styleSheets,
          l = Object.keys(a).reduce(function (t, e) {
            var i = a[e];
            if (!i.href || -1 === i.href.indexOf("theme")) return t;
            try {
              for (var n = i.cssRules, s = 0; s < n.length; s++) {
                var o = i.cssRules[s];
                if (o instanceof CSSMediaRule)
                  for (var r = 0; r < n.length; r++) {
                    var l = o.cssRules[r];
                    l instanceof CSSStyleRule &&
                      l.selectorText &&
                      -1 !== l.selectorText.indexOf("html::after") &&
                      t.push(o.media);
                  }
              }
            } catch (e) {
              return t;
            }
            return t;
          }, []);
        l.length > 0
          ? l.forEach(function (t) {
              window.matchMedia(t.mediaText).addListener(function () {
                var t = i();
                r.current.value !== t &&
                  ((r.previous = r.current),
                  (r.current = new o(t)),
                  n.forEach(function (t) {
                    return t(r);
                  }));
              });
            })
          : window.addEventListener("resize", function () {
              var t = i();
              r.current.value !== t &&
                ((r.previous = r.current),
                (r.current = new o(t)),
                n.forEach(function (t) {
                  return t(r);
                }));
            });
      },
      766: (t, e) => {
        "use strict";
        var i = (function () {
          function t() {
            this.events = [];
          }
          return (
            (t.prototype.register = function (t, e, i) {
              return t && e && i
                ? (this.events.push({ el: t, event: e, listener: i }),
                  t.addEventListener(e, i),
                  { el: t, event: e, listener: i })
                : null;
            }),
            (t.prototype.unregister = function (t) {
              var e = t.el,
                i = t.event,
                n = t.listener;
              return e && i && n
                ? ((this.events = this.events.filter(function (t) {
                    return e !== t.el || i !== t.event || n !== t.listener;
                  })),
                  e.removeEventListener(i, n),
                  { el: e, event: i, listener: n })
                : null;
            }),
            (t.prototype.unregisterAll = function () {
              this.events.forEach(function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e.removeEventListener(i, n);
              }),
                (this.events = []);
            }),
            t
          );
        })();
        e.Z = i;
      },
      722: () => {
        class t extends HTMLElement {
          static get observedAttributes() {
            return ["variant"];
          }
          constructor() {
            super(),
              (this._loaded = !1),
              (this._productFetcher = Promise.resolve(!1)),
              (this._onMainElChange = (t) => {
                this.variant = t.currentTarget.value;
              });
            const t = this.querySelector("input[data-variants]");
            this._mainEl = t || this.querySelector("select[data-variants]");
          }
          set variant(t) {
            t
              ? this.setAttribute("variant", t)
              : this.removeAttribute("variant");
          }
          get variant() {
            return this.getAttribute("variant");
          }
          connectedCallback() {
            this._productFetcher = this._fetchProduct();
            const t = this.querySelector("input[data-variants]");
            (this._mainEl = t || this.querySelector("select[data-variants]")),
              this._mainEl.addEventListener("change", this._onMainElChange),
              (this.variant = this._mainEl.value);
          }
          disconnectedCallback() {
            this._mainEl.removeEventListener("change", this._onMainElChange),
              (this._mainEl = null);
          }
          attributeChangedCallback(t, e, i) {
            if (e !== i)
              switch (t) {
                case "variant":
                  this._changeVariant(i);
                  break;
              }
          }
          getProduct() {
            return this._loaded
              ? Promise.resolve(this._product)
              : this._productFetcher;
          }
          getVariant() {
            return this.getProduct()
              .then(
                (t) =>
                  (t &&
                    t.variants.find((t) => t.id.toString() === this.variant)) ||
                  !1
              )
              .catch(() => !1);
          }
          getState() {
            return this.getVariant().then((t) =>
              t ? "selected" : this.getAttribute("variant")
            );
          }
          _changeVariant(t) {
            this._dispatchEvent(t).then(() => {
              this._mainEl.value = t;
            });
          }
          _fetchProduct() {
            return fetch(this.getAttribute("product-url"))
              .then((t) => t.json())
              .then((t) => ((this._product = t), t))
              .catch(() => {
                this._product = null;
              })
              .finally(() => {
                this._loaded = !0;
              });
          }
          _dispatchEvent(t) {
            return this.getProduct().then((e) => {
              const i =
                  (e && e.variants.find((e) => e.id.toString() === t)) || !1,
                n = new CustomEvent("variant-change", {
                  detail: { product: e, variant: i, state: i ? "selected" : t },
                });
              this.dispatchEvent(n);
            });
          }
        }
        const e = "option",
          i = 'input[type="radio"]';
        function n(t) {
          const n = [],
            s = [];
          for (let o = 0; o < t.length; o++) {
            const r = t[o],
              a = r.matches("[data-variant-option-value-wrapper]")
                ? [r]
                : Array.prototype.slice.call(
                    r.querySelectorAll("[data-variant-option-value-wrapper]")
                  ),
              l = r.matches("[data-variant-option-value]")
                ? [r]
                : Array.prototype.slice.call(
                    r.querySelectorAll("[data-variant-option-value]")
                  );
            if (!l.length) break;
            const c = { option: r, wrappers: a, values: l };
            l[0].matches(e) ? n.push(c) : l[0].matches(i) && s.push(c);
          }
          return { select: n, radio: s };
        }
        function s(t, e, i) {
          const n = t.options.map(() => "not-selected");
          return (
            e.forEach(({ option: t }) => {
              "not-selected" !== t.value &&
                (n[parseInt(t.dataset.variantOptionIndex, 10)] = t.value);
            }),
            i.forEach(({ values: t }) => {
              t.forEach((t) => {
                t.checked &&
                  (n[parseInt(t.dataset.variantOptionValueIndex, 10)] =
                    t.value);
              });
            }),
            n
          );
        }
        function o(t, e, i, n, s = null, o = null) {
          const r = { ...i },
            a = [n, s, o].filter((t) => !!t),
            l = (function (t, e) {
              return t.find((t) => t.options.every((t, i) => t === e[i]));
            })(t.variants, a),
            c = a.filter((t, i) => t === e[i]).length,
            h = c === t.options.length,
            d = c === t.options.length - 1;
          for (let t = 0; t < a.length; t++) {
            const e = a[t];
            if (e) {
              let {
                setByCurrentVariant: n,
                setByNeighbor: s,
                accessible: o,
                available: a,
              } = i[t][e];
              l
                ? ((o = l.available || o),
                  h
                    ? ((n = !0), ({ available: a } = l))
                    : !n && d && ((a = (s && a) || l.available), (s = !0)))
                : h
                ? ((n = !0), (a = !1))
                : !n && d && ((a = !!s && a), (s = !0)),
                n || s || (a = o),
                (r[t][e] = {
                  setByCurrentVariant: n,
                  setByNeighbor: s,
                  accessible: o,
                  available: a,
                });
            }
          }
          return r;
        }
        function r(t, e, i, n, s, r) {
          const a = [...e, ...i];
          if (0 === a.length) return;
          const l = (function (t, e) {
            let i = t.options.map(() => ({}));
            for (let e = 0; e < t.options.length; e++)
              for (let n = 0; n < t.variants.length; n++) {
                const s = t.variants[n].options[e];
                i[e][s] = {
                  setByCurrentVariant: !1,
                  setByNeighbor: !1,
                  accessible: !1,
                  available: !1,
                };
              }
            const n = i.length >= 1 ? Object.keys(i[0]) : [],
              s = i.length >= 2 ? Object.keys(i[1]) : [],
              r = i.length >= 3 ? Object.keys(i[2]) : [];
            return (
              n.forEach((n) => {
                s.forEach((s) => {
                  r.forEach((r) => {
                    i = o(t, e, i, n, s, r);
                  }),
                    r.length || (i = o(t, e, i, n, s));
                }),
                  s.length || (i = o(t, e, i, n));
              }),
              i
            );
          })(t, n);
          for (let e = 0; e < t.options.length; e++) {
            const t = a.find(
              ({ option: t }) =>
                parseInt(t.dataset.variantOptionIndex, 10) === e
            );
            if (t) {
              const i = document.createDocumentFragment(),
                { option: n, wrappers: o, values: a } = t;
              for (let t = a.length - 1; t >= 0; t--) {
                const n = o[t],
                  c = a[t],
                  { value: h } = c,
                  { available: d } = h in l[e] && l[e][h],
                  { accessible: u } = h in l[e] && l[e][h],
                  p = "not-selected" === h;
                (c.disabled = p || (s && !u)),
                  (c.dataset.variantOptionAccessible = u),
                  (c.dataset.variantOptionAvailable = d),
                  (!r || u || p) && i.insertBefore(n, i.firstElementChild);
              }
              (n.innerHTML = ""), n.appendChild(i);
              const c = a.find((t) => t.selected || t.checked);
              n.dataset.variantOptionChosenValue =
                !(!c || "not-selected" === c.value) && c.value;
            }
          }
        }
        class a extends HTMLElement {
          static get observedAttributes() {
            return [
              "variant-selection",
              "disable-unavailable",
              "remove-unavailable",
            ];
          }
          static synchronize(t) {
            const e = t.getVariantSelection();
            return e
              ? t
                  .getSelectedOptions()
                  .then((i) => {
                    document
                      .querySelectorAll("options-selection")
                      .forEach((n) => {
                        n !== t &&
                          n.getVariantSelection() === e &&
                          n.setSelectedOptions(i);
                      });
                  })
                  .then(() => !0)
              : Promise.resolve(!1);
          }
          constructor() {
            super(),
              (this.style.display = ""),
              (this._events = []),
              (this._onChangeFn = this._onOptionChange.bind(this)),
              (this._optionsEls = this.querySelectorAll(
                "[data-variant-option]"
              )),
              ({ select: this._selectOptions, radio: this._radioOptions } = n(
                this._optionsEls
              )),
              this._associateVariantSelection(
                this.getAttribute("variant-selection")
              );
          }
          set variantSelection(t) {
            t
              ? this.setAttribute("variant-selection", t)
              : this.removeAttribute("variant-selection");
          }
          get variantSelection() {
            return this.getAttribute("variant-selection");
          }
          connectedCallback() {
            (this._optionsEls = this.querySelectorAll("[data-variant-option]")),
              ({ select: this._selectOptions, radio: this._radioOptions } = n(
                this._optionsEls
              )),
              this._associateVariantSelection(
                this.getAttribute("variant-selection")
              ),
              this._selectOptions.forEach(({ option: t }) => {
                t.addEventListener("change", this._onChangeFn),
                  this._events.push({ el: t, fn: this._onChangeFn });
              }),
              this._radioOptions.forEach(({ values: t }) => {
                t.forEach((t) => {
                  t.addEventListener("change", this._onChangeFn),
                    this._events.push({ el: t, fn: this._onChangeFn });
                });
              }),
              this._onOptionChange();
          }
          disconnectedCallback() {
            this._resetOptions(),
              this._events.forEach(({ el: t, fn: e }) =>
                t.removeEventListener("change", e)
              ),
              (this._events = []);
          }
          attributeChangedCallback(t, e, i) {
            switch (t) {
              case "variant-selection":
                this._associateVariantSelection(i);
                break;
              case "disable-unavailable":
              case "remove-unavailable":
                this._updateOptions(
                  this.hasAttribute("disable-unavailable"),
                  this.hasAttribute("remove-unavailable")
                );
                break;
            }
          }
          getSelectedOptions() {
            return this._variantSelection
              ? this._variantSelection
                  .getProduct()
                  .then((t) =>
                    t ? s(t, this._selectOptions, this._radioOptions) : null
                  )
              : Promise.resolve(null);
          }
          getVariantSelection() {
            return this._variantSelection;
          }
          setSelectedOptions(t) {
            return (
              (function (t, e, i) {
                t.forEach(({ option: t }) => {
                  t.value = i[parseInt(t.dataset.variantOptionIndex, 10)];
                }),
                  e.forEach(({ values: t }) => {
                    t.forEach((t) => {
                      t.checked =
                        t.value ===
                        i[parseInt(t.dataset.variantOptionValueIndex, 10)];
                    });
                  });
              })(this._selectOptions, this._radioOptions, t),
              this._updateOptions(
                this.hasAttribute("disable-unavailable"),
                this.hasAttribute("remove-unavailable"),
                t
              )
            );
          }
          _associateVariantSelection(t) {
            this._variantSelection = t
              ? document.getElementById(t)
              : this.closest("variant-selection");
          }
          _updateLabels() {
            for (let t = 0; t < this._optionsEls.length; t++) {
              const e = this._optionsEls[t];
              let i = null,
                { parentElement: n } = e;
              for (; n && !i; ) {
                const t = n.querySelector("[data-variant-option-name]");
                t && (i = t), ({ parentElement: n } = n);
              }
              if (i)
                if (
                  ((i.dataset.variantOptionChosenValue =
                    e.dataset.variantOptionChosenValue),
                  "false" !== e.dataset.variantOptionChosenValue)
                ) {
                  i.innerHTML = i.dataset.variantOptionName;
                  const t = i.querySelector("span");
                  t && (t.innerHTML = e.dataset.variantOptionChosenValue);
                } else i.innerHTML = i.dataset.variantOptionChooseName;
            }
          }
          _resetOptions() {
            return this._updateOptions(!1, !1);
          }
          _updateOptions(t, e, i = null) {
            return this._variantSelection
              ? this._variantSelection
                  .getProduct()
                  .then((n) => {
                    r(
                      n,
                      this._selectOptions,
                      this._radioOptions,
                      i || s(n, this._selectOptions, this._radioOptions),
                      t,
                      e
                    ),
                      this._updateLabels();
                  })
                  .then(() => !0)
              : Promise.resolve(!1);
          }
          _updateVariantSelection(t, e) {
            if (!this._variantSelection) return;
            const i = (function (t, e) {
                for (let i = 0; i < t.length; i++) {
                  const n = t[i];
                  if (n.options.every((t, i) => t === e[i])) return n;
                }
                return !1;
              })(t.variants, e),
              n = e.some((t) => "not-selected" === t);
            this._variantSelection.variant = i
              ? i.id
              : n
              ? "not-selected"
              : "unavailable";
          }
          _onOptionChange() {
            this._variantSelection &&
              this._variantSelection.getProduct().then((t) => {
                if (!t) return;
                const e = s(t, this._selectOptions, this._radioOptions);
                this._updateOptions(
                  this.hasAttribute("disable-unavailable"),
                  this.hasAttribute("remove-unavailable"),
                  e
                ),
                  this._updateVariantSelection(t, e),
                  a.synchronize(this);
              });
          }
        }
        customElements.get("variant-selection") ||
          customElements.define("variant-selection", t),
          customElements.get("options-selection") ||
            customElements.define("options-selection", a);
      },
      741: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          "use strict";
          void 0 ===
            (s = "function" == typeof (n = r) ? n.call(e, i, e, t) : n) ||
            (t.exports = s);
        })(window, function () {
          "use strict";
          var t = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (
              var e = ["webkit", "moz", "ms", "o"], i = 0;
              i < e.length;
              i++
            ) {
              var n = e[i] + "MatchesSelector";
              if (t[n]) return n;
            }
          })();
          return function (e, i) {
            return e[t](i);
          };
        });
      },
      158: function (t, e, i) {
        var n, s;
        "undefined" != typeof window && window,
          void 0 ===
            (s =
              "function" ==
              typeof (n = function () {
                "use strict";
                function t() {}
                var e = t.prototype;
                return (
                  (e.on = function (t, e) {
                    if (t && e) {
                      var i = (this._events = this._events || {}),
                        n = (i[t] = i[t] || []);
                      return -1 == n.indexOf(e) && n.push(e), this;
                    }
                  }),
                  (e.once = function (t, e) {
                    if (t && e) {
                      this.on(t, e);
                      var i = (this._onceEvents = this._onceEvents || {});
                      return ((i[t] = i[t] || {})[e] = !0), this;
                    }
                  }),
                  (e.off = function (t, e) {
                    var i = this._events && this._events[t];
                    if (i && i.length) {
                      var n = i.indexOf(e);
                      return -1 != n && i.splice(n, 1), this;
                    }
                  }),
                  (e.emitEvent = function (t, e) {
                    var i = this._events && this._events[t];
                    if (i && i.length) {
                      (i = i.slice(0)), (e = e || []);
                      for (
                        var n = this._onceEvents && this._onceEvents[t], s = 0;
                        s < i.length;
                        s++
                      ) {
                        var o = i[s];
                        n && n[o] && (this.off(t, o), delete n[o]),
                          o.apply(this, e);
                      }
                      return this;
                    }
                  }),
                  (e.allOff = function () {
                    delete this._events, delete this._onceEvents;
                  }),
                  t
                );
              })
                ? n.call(e, i, e, t)
                : n) || (t.exports = s);
      },
      387: (t, e, i) => {
        var n;
        !(function (s) {
          var o = Array.isArray
            ? Array.isArray
            : function (t) {
                return "[object Array]" === Object.prototype.toString.call(t);
              };
          function r() {
            (this._events = {}), this._conf && a.call(this, this._conf);
          }
          function a(t) {
            t
              ? ((this._conf = t),
                t.delimiter && (this.delimiter = t.delimiter),
                (this._events.maxListeners =
                  t.maxListeners !== s ? t.maxListeners : 10),
                t.wildcard && (this.wildcard = t.wildcard),
                t.newListener && (this.newListener = t.newListener),
                t.verboseMemoryLeak &&
                  (this.verboseMemoryLeak = t.verboseMemoryLeak),
                this.wildcard && (this.listenerTree = {}))
              : (this._events.maxListeners = 10);
          }
          function l(t, e) {
            this.verboseMemoryLeak, console.trace;
          }
          function c(t) {
            (this._events = {}),
              (this.newListener = !1),
              (this.verboseMemoryLeak = !1),
              a.call(this, t);
          }
          function h(t, e, i, n) {
            if (!i) return [];
            var s,
              o,
              r,
              a,
              l,
              c,
              d,
              u = [],
              p = e.length,
              f = e[n],
              g = e[n + 1];
            if (n === p && i._listeners) {
              if ("function" == typeof i._listeners)
                return t && t.push(i._listeners), [i];
              for (s = 0, o = i._listeners.length; s < o; s++)
                t && t.push(i._listeners[s]);
              return [i];
            }
            if ("*" === f || "**" === f || i[f]) {
              if ("*" === f) {
                for (r in i)
                  "_listeners" !== r &&
                    i.hasOwnProperty(r) &&
                    (u = u.concat(h(t, e, i[r], n + 1)));
                return u;
              }
              if ("**" === f) {
                for (r in ((d = n + 1 === p || (n + 2 === p && "*" === g)) &&
                  i._listeners &&
                  (u = u.concat(h(t, e, i, p))),
                i))
                  "_listeners" !== r &&
                    i.hasOwnProperty(r) &&
                    ("*" === r || "**" === r
                      ? (i[r]._listeners &&
                          !d &&
                          (u = u.concat(h(t, e, i[r], p))),
                        (u = u.concat(h(t, e, i[r], n))))
                      : (u =
                          r === g
                            ? u.concat(h(t, e, i[r], n + 2))
                            : u.concat(h(t, e, i[r], n))));
                return u;
              }
              u = u.concat(h(t, e, i[f], n + 1));
            }
            if (((a = i["*"]) && h(t, e, a, n + 1), (l = i["**"])))
              if (n < p)
                for (r in (l._listeners && h(t, e, l, p), l))
                  "_listeners" !== r &&
                    l.hasOwnProperty(r) &&
                    (r === g
                      ? h(t, e, l[r], n + 2)
                      : r === f
                      ? h(t, e, l[r], n + 1)
                      : (((c = {})[r] = l[r]), h(t, e, { "**": c }, n + 1)));
              else
                l._listeners
                  ? h(t, e, l, p)
                  : l["*"] && l["*"]._listeners && h(t, e, l["*"], p);
            return u;
          }
          function d(t, e) {
            for (
              var i = 0,
                n = (t =
                  "string" == typeof t ? t.split(this.delimiter) : t.slice())
                  .length;
              i + 1 < n;
              i++
            )
              if ("**" === t[i] && "**" === t[i + 1]) return;
            for (var o = this.listenerTree, r = t.shift(); r !== s; ) {
              if ((o[r] || (o[r] = {}), (o = o[r]), 0 === t.length))
                return (
                  o._listeners
                    ? ("function" == typeof o._listeners &&
                        (o._listeners = [o._listeners]),
                      o._listeners.push(e),
                      !o._listeners.warned &&
                        this._events.maxListeners > 0 &&
                        o._listeners.length > this._events.maxListeners &&
                        ((o._listeners.warned = !0),
                        l.call(this, o._listeners.length, r)))
                    : (o._listeners = e),
                  !0
                );
              r = t.shift();
            }
            return !0;
          }
          (c.EventEmitter2 = c),
            (c.prototype.delimiter = "."),
            (c.prototype.setMaxListeners = function (t) {
              t !== s &&
                (this._events || r.call(this),
                (this._events.maxListeners = t),
                this._conf || (this._conf = {}),
                (this._conf.maxListeners = t));
            }),
            (c.prototype.event = ""),
            (c.prototype.once = function (t, e) {
              return this.many(t, 1, e), this;
            }),
            (c.prototype.many = function (t, e, i) {
              var n = this;
              if ("function" != typeof i)
                throw new Error("many only accepts instances of Function");
              function s() {
                return 0 == --e && n.off(t, s), i.apply(this, arguments);
              }
              return (s._origin = i), this.on(t, s), n;
            }),
            (c.prototype.emit = function () {
              this._events || r.call(this);
              var t = arguments[0];
              if (
                "newListener" === t &&
                !this.newListener &&
                !this._events.newListener
              )
                return !1;
              var e,
                i,
                n,
                s,
                o,
                a = arguments.length;
              if (this._all && this._all.length) {
                if (((o = this._all.slice()), a > 3))
                  for (e = new Array(a), s = 0; s < a; s++) e[s] = arguments[s];
                for (n = 0, i = o.length; n < i; n++)
                  switch (((this.event = t), a)) {
                    case 1:
                      o[n].call(this, t);
                      break;
                    case 2:
                      o[n].call(this, t, arguments[1]);
                      break;
                    case 3:
                      o[n].call(this, t, arguments[1], arguments[2]);
                      break;
                    default:
                      o[n].apply(this, e);
                  }
              }
              if (this.wildcard) {
                o = [];
                var l =
                  "string" == typeof t ? t.split(this.delimiter) : t.slice();
                h.call(this, o, l, this.listenerTree, 0);
              } else {
                if ("function" == typeof (o = this._events[t])) {
                  switch (((this.event = t), a)) {
                    case 1:
                      o.call(this);
                      break;
                    case 2:
                      o.call(this, arguments[1]);
                      break;
                    case 3:
                      o.call(this, arguments[1], arguments[2]);
                      break;
                    default:
                      for (e = new Array(a - 1), s = 1; s < a; s++)
                        e[s - 1] = arguments[s];
                      o.apply(this, e);
                  }
                  return !0;
                }
                o && (o = o.slice());
              }
              if (o && o.length) {
                if (a > 3)
                  for (e = new Array(a - 1), s = 1; s < a; s++)
                    e[s - 1] = arguments[s];
                for (n = 0, i = o.length; n < i; n++)
                  switch (((this.event = t), a)) {
                    case 1:
                      o[n].call(this);
                      break;
                    case 2:
                      o[n].call(this, arguments[1]);
                      break;
                    case 3:
                      o[n].call(this, arguments[1], arguments[2]);
                      break;
                    default:
                      o[n].apply(this, e);
                  }
                return !0;
              }
              if (!this._all && "error" === t) {
                throw arguments[1] instanceof Error
                  ? arguments[1]
                  : new Error("Uncaught, unspecified 'error' event.");
                return !1;
              }
              return !!this._all;
            }),
            (c.prototype.emitAsync = function () {
              this._events || r.call(this);
              var t = arguments[0];
              if (
                "newListener" === t &&
                !this.newListener &&
                !this._events.newListener
              )
                return Promise.resolve([!1]);
              var e,
                i,
                n,
                s,
                o,
                a = [],
                l = arguments.length;
              if (this._all) {
                if (l > 3)
                  for (e = new Array(l), s = 1; s < l; s++) e[s] = arguments[s];
                for (n = 0, i = this._all.length; n < i; n++)
                  switch (((this.event = t), l)) {
                    case 1:
                      a.push(this._all[n].call(this, t));
                      break;
                    case 2:
                      a.push(this._all[n].call(this, t, arguments[1]));
                      break;
                    case 3:
                      a.push(
                        this._all[n].call(this, t, arguments[1], arguments[2])
                      );
                      break;
                    default:
                      a.push(this._all[n].apply(this, e));
                  }
              }
              if (this.wildcard) {
                o = [];
                var c =
                  "string" == typeof t ? t.split(this.delimiter) : t.slice();
                h.call(this, o, c, this.listenerTree, 0);
              } else o = this._events[t];
              if ("function" == typeof o)
                switch (((this.event = t), l)) {
                  case 1:
                    a.push(o.call(this));
                    break;
                  case 2:
                    a.push(o.call(this, arguments[1]));
                    break;
                  case 3:
                    a.push(o.call(this, arguments[1], arguments[2]));
                    break;
                  default:
                    for (e = new Array(l - 1), s = 1; s < l; s++)
                      e[s - 1] = arguments[s];
                    a.push(o.apply(this, e));
                }
              else if (o && o.length) {
                if (((o = o.slice()), l > 3))
                  for (e = new Array(l - 1), s = 1; s < l; s++)
                    e[s - 1] = arguments[s];
                for (n = 0, i = o.length; n < i; n++)
                  switch (((this.event = t), l)) {
                    case 1:
                      a.push(o[n].call(this));
                      break;
                    case 2:
                      a.push(o[n].call(this, arguments[1]));
                      break;
                    case 3:
                      a.push(o[n].call(this, arguments[1], arguments[2]));
                      break;
                    default:
                      a.push(o[n].apply(this, e));
                  }
              } else if (!this._all && "error" === t)
                return arguments[1] instanceof Error
                  ? Promise.reject(arguments[1])
                  : Promise.reject("Uncaught, unspecified 'error' event.");
              return Promise.all(a);
            }),
            (c.prototype.on = function (t, e) {
              if ("function" == typeof t) return this.onAny(t), this;
              if ("function" != typeof e)
                throw new Error("on only accepts instances of Function");
              return (
                this._events || r.call(this),
                this.emit("newListener", t, e),
                this.wildcard
                  ? (d.call(this, t, e), this)
                  : (this._events[t]
                      ? ("function" == typeof this._events[t] &&
                          (this._events[t] = [this._events[t]]),
                        this._events[t].push(e),
                        !this._events[t].warned &&
                          this._events.maxListeners > 0 &&
                          this._events[t].length > this._events.maxListeners &&
                          ((this._events[t].warned = !0),
                          l.call(this, this._events[t].length, t)))
                      : (this._events[t] = e),
                    this)
              );
            }),
            (c.prototype.onAny = function (t) {
              if ("function" != typeof t)
                throw new Error("onAny only accepts instances of Function");
              return this._all || (this._all = []), this._all.push(t), this;
            }),
            (c.prototype.addListener = c.prototype.on),
            (c.prototype.off = function (t, e) {
              if ("function" != typeof e)
                throw new Error(
                  "removeListener only takes instances of Function"
                );
              var i,
                n = [];
              if (this.wildcard) {
                var r =
                  "string" == typeof t ? t.split(this.delimiter) : t.slice();
                n = h.call(this, null, r, this.listenerTree, 0);
              } else {
                if (!this._events[t]) return this;
                (i = this._events[t]), n.push({ _listeners: i });
              }
              for (var a = 0; a < n.length; a++) {
                var l = n[a];
                if (((i = l._listeners), o(i))) {
                  for (var c = -1, d = 0, u = i.length; d < u; d++)
                    if (
                      i[d] === e ||
                      (i[d].listener && i[d].listener === e) ||
                      (i[d]._origin && i[d]._origin === e)
                    ) {
                      c = d;
                      break;
                    }
                  if (c < 0) continue;
                  return (
                    this.wildcard
                      ? l._listeners.splice(c, 1)
                      : this._events[t].splice(c, 1),
                    0 === i.length &&
                      (this.wildcard
                        ? delete l._listeners
                        : delete this._events[t]),
                    this.emit("removeListener", t, e),
                    this
                  );
                }
                (i === e ||
                  (i.listener && i.listener === e) ||
                  (i._origin && i._origin === e)) &&
                  (this.wildcard ? delete l._listeners : delete this._events[t],
                  this.emit("removeListener", t, e));
              }
              return (
                (function t(e) {
                  if (e !== s) {
                    var i = Object.keys(e);
                    for (var n in i) {
                      var o = i[n],
                        r = e[o];
                      r instanceof Function ||
                        "object" != typeof r ||
                        null === r ||
                        (Object.keys(r).length > 0 && t(e[o]),
                        0 === Object.keys(r).length && delete e[o]);
                    }
                  }
                })(this.listenerTree),
                this
              );
            }),
            (c.prototype.offAny = function (t) {
              var e,
                i = 0,
                n = 0;
              if (t && this._all && this._all.length > 0) {
                for (i = 0, n = (e = this._all).length; i < n; i++)
                  if (t === e[i])
                    return (
                      e.splice(i, 1), this.emit("removeListenerAny", t), this
                    );
              } else {
                for (i = 0, n = (e = this._all).length; i < n; i++)
                  this.emit("removeListenerAny", e[i]);
                this._all = [];
              }
              return this;
            }),
            (c.prototype.removeListener = c.prototype.off),
            (c.prototype.removeAllListeners = function (t) {
              if (0 === arguments.length)
                return !this._events || r.call(this), this;
              if (this.wildcard)
                for (
                  var e =
                      "string" == typeof t
                        ? t.split(this.delimiter)
                        : t.slice(),
                    i = h.call(this, null, e, this.listenerTree, 0),
                    n = 0;
                  n < i.length;
                  n++
                ) {
                  var s = i[n];
                  s._listeners = null;
                }
              else this._events && (this._events[t] = null);
              return this;
            }),
            (c.prototype.listeners = function (t) {
              if (this.wildcard) {
                var e = [],
                  i =
                    "string" == typeof t ? t.split(this.delimiter) : t.slice();
                return h.call(this, e, i, this.listenerTree, 0), e;
              }
              return (
                this._events || r.call(this),
                this._events[t] || (this._events[t] = []),
                o(this._events[t]) || (this._events[t] = [this._events[t]]),
                this._events[t]
              );
            }),
            (c.prototype.listenerCount = function (t) {
              return this.listeners(t).length;
            }),
            (c.prototype.listenersAny = function () {
              return this._all ? this._all : [];
            }),
            (n = function () {
              return c;
            }.call(e, i, e, t)) === s || (t.exports = n);
        })();
      },
      729: (t) => {
        var e = [
            'iframe[src*="player.vimeo.com"]',
            'iframe[src*="youtube.com"]',
            'iframe[src*="youtube-nocookie.com"]',
            'iframe[src*="kickstarter.com"][src*="video.html"]',
            "object",
          ],
          i =
            ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";
        function n(t, e) {
          return (
            "string" == typeof t && ((e = t), (t = document)),
            Array.prototype.slice.call(t.querySelectorAll(e))
          );
        }
        function s(t) {
          return "string" == typeof t
            ? t.split(",").map(r).filter(o)
            : (function (t) {
                return "[object Array]" === Object.prototype.toString.call(t);
              })(t)
            ? (function (t) {
                return [].concat.apply([], t);
              })(t.map(s).filter(o))
            : t || [];
        }
        function o(t) {
          return t.length > 0;
        }
        function r(t) {
          return t.replace(/^\s+|\s+$/g, "");
        }
        t.exports = function (t, r) {
          var a;
          (r = r || {}),
            (a = t = t || "body"),
            "[object Object]" === Object.prototype.toString.call(a) &&
              ((r = t), (t = "body")),
            (r.ignore = r.ignore || ""),
            (r.players = r.players || "");
          var l = n(t);
          if (o(l)) {
            var c;
            if (!document.getElementById("fit-vids-style"))
              (
                document.head || document.getElementsByTagName("head")[0]
              ).appendChild(
                (((c = document.createElement("div")).innerHTML =
                  '<p>x</p><style id="fit-vids-style">' + i + "</style>"),
                c.childNodes[1])
              );
            var h = s(r.players),
              d = s(r.ignore),
              u = d.length > 0 ? d.join() : null,
              p = e.concat(h).join();
            o(p) &&
              l.forEach(function (t) {
                n(t, p).forEach(function (t) {
                  (u && t.matches(u)) ||
                    (function (t) {
                      if (
                        /fluid-width-video-wrapper/.test(t.parentNode.className)
                      )
                        return;
                      var e = parseInt(t.getAttribute("width"), 10),
                        i = parseInt(t.getAttribute("height"), 10),
                        n = isNaN(e) ? t.clientWidth : e,
                        s = (isNaN(i) ? t.clientHeight : i) / n;
                      t.removeAttribute("width"), t.removeAttribute("height");
                      var o = document.createElement("div");
                      t.parentNode.insertBefore(o, t),
                        (o.className = "fluid-width-video-wrapper"),
                        (o.style.paddingTop = 100 * s + "%"),
                        o.appendChild(t);
                    })(t);
                });
              });
          }
        };
      },
      47: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(741)]),
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                var i = {
                    extend: function (t, e) {
                      for (var i in e) t[i] = e[i];
                      return t;
                    },
                    modulo: function (t, e) {
                      return ((t % e) + e) % e;
                    },
                  },
                  n = Array.prototype.slice;
                (i.makeArray = function (t) {
                  return Array.isArray(t)
                    ? t
                    : null == t
                    ? []
                    : "object" == typeof t && "number" == typeof t.length
                    ? n.call(t)
                    : [t];
                }),
                  (i.removeFrom = function (t, e) {
                    var i = t.indexOf(e);
                    -1 != i && t.splice(i, 1);
                  }),
                  (i.getParent = function (t, i) {
                    for (; t.parentNode && t != document.body; )
                      if (((t = t.parentNode), e(t, i))) return t;
                  }),
                  (i.getQueryElement = function (t) {
                    return "string" == typeof t ? document.querySelector(t) : t;
                  }),
                  (i.handleEvent = function (t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t);
                  }),
                  (i.filterFindElements = function (t, n) {
                    t = i.makeArray(t);
                    var s = [];
                    return (
                      t.forEach(function (t) {
                        if (t instanceof HTMLElement)
                          if (n) {
                            e(t, n) && s.push(t);
                            for (
                              var i = t.querySelectorAll(n), o = 0;
                              o < i.length;
                              o++
                            )
                              s.push(i[o]);
                          } else s.push(t);
                      }),
                      s
                    );
                  }),
                  (i.debounceMethod = function (t, e, i) {
                    i = i || 100;
                    var n = t.prototype[e],
                      s = e + "Timeout";
                    t.prototype[e] = function () {
                      var t = this[s];
                      clearTimeout(t);
                      var e = arguments,
                        o = this;
                      this[s] = setTimeout(function () {
                        n.apply(o, e), delete o[s];
                      }, i);
                    };
                  }),
                  (i.docReady = function (t) {
                    var e = document.readyState;
                    "complete" == e || "interactive" == e
                      ? setTimeout(t)
                      : document.addEventListener("DOMContentLoaded", t);
                  }),
                  (i.toDashed = function (t) {
                    return t
                      .replace(/(.)([A-Z])/g, function (t, e, i) {
                        return e + "-" + i;
                      })
                      .toLowerCase();
                  });
                var s = t.console;
                return (
                  (i.htmlInit = function (e, n) {
                    i.docReady(function () {
                      var o = i.toDashed(n),
                        r = "data-" + o,
                        a = document.querySelectorAll("[" + r + "]"),
                        l = document.querySelectorAll(".js-" + o),
                        c = i.makeArray(a).concat(i.makeArray(l)),
                        h = r + "-options",
                        d = t.jQuery;
                      c.forEach(function (t) {
                        var i,
                          o = t.getAttribute(r) || t.getAttribute(h);
                        try {
                          i = o && JSON.parse(o);
                        } catch (e) {
                          return void (
                            s &&
                            s.error(
                              "Error parsing " +
                                r +
                                " on " +
                                t.className +
                                ": " +
                                e
                            )
                          );
                        }
                        var a = new e(t, i);
                        d && d.data(t, n, a);
                      });
                    });
                  }),
                  i
                );
              })(o, t);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      597: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(47)]),
          void 0 ===
            (s = function (t, e) {
              return (function (t, e, i) {
                "use strict";
                function n(t) {
                  var e = document.createDocumentFragment();
                  return (
                    t.forEach(function (t) {
                      e.appendChild(t.element);
                    }),
                    e
                  );
                }
                var s = e.prototype;
                return (
                  (s.insert = function (t, e) {
                    var i = this._makeCells(t);
                    if (i && i.length) {
                      var s = this.cells.length;
                      e = void 0 === e ? s : e;
                      var o = n(i),
                        r = e == s;
                      if (r) this.slider.appendChild(o);
                      else {
                        var a = this.cells[e].element;
                        this.slider.insertBefore(o, a);
                      }
                      if (0 === e) this.cells = i.concat(this.cells);
                      else if (r) this.cells = this.cells.concat(i);
                      else {
                        var l = this.cells.splice(e, s - e);
                        this.cells = this.cells.concat(i).concat(l);
                      }
                      this._sizeCells(i), this.cellChange(e, !0);
                    }
                  }),
                  (s.append = function (t) {
                    this.insert(t, this.cells.length);
                  }),
                  (s.prepend = function (t) {
                    this.insert(t, 0);
                  }),
                  (s.remove = function (t) {
                    var e = this.getCells(t);
                    if (e && e.length) {
                      var n = this.cells.length - 1;
                      e.forEach(function (t) {
                        t.remove();
                        var e = this.cells.indexOf(t);
                        (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                      }, this),
                        this.cellChange(n, !0);
                    }
                  }),
                  (s.cellSizeChange = function (t) {
                    var e = this.getCell(t);
                    if (e) {
                      e.getSize();
                      var i = this.cells.indexOf(e);
                      this.cellChange(i);
                    }
                  }),
                  (s.cellChange = function (t, e) {
                    var i = this.selectedElement;
                    this._positionCells(t),
                      this._getWrapShiftCells(),
                      this.setGallerySize();
                    var n = this.getCell(i);
                    n && (this.selectedIndex = this.getCellSlideIndex(n)),
                      (this.selectedIndex = Math.min(
                        this.slides.length - 1,
                        this.selectedIndex
                      )),
                      this.emitEvent("cellChange", [t]),
                      this.select(this.selectedIndex),
                      e && this.positionSliderAtSelected();
                  }),
                  e
                );
              })(0, t, e);
            }.apply(e, n)) || (t.exports = s);
      },
      880: (t, e, i) => {
        var n, s;
        window,
          (n = [i(47)]),
          void 0 ===
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                var i = {
                  startAnimation: function () {
                    this.isAnimating ||
                      ((this.isAnimating = !0),
                      (this.restingFrames = 0),
                      this.animate());
                  },
                  animate: function () {
                    this.applyDragForce(), this.applySelectedAttraction();
                    var t = this.x;
                    if (
                      (this.integratePhysics(),
                      this.positionSlider(),
                      this.settle(t),
                      this.isAnimating)
                    ) {
                      var e = this;
                      requestAnimationFrame(function () {
                        e.animate();
                      });
                    }
                  },
                  positionSlider: function () {
                    var t = this.x;
                    this.options.wrapAround &&
                      this.cells.length > 1 &&
                      ((t = e.modulo(t, this.slideableWidth)),
                      (t -= this.slideableWidth),
                      this.shiftWrapCells(t)),
                      this.setTranslateX(t, this.isAnimating),
                      this.dispatchScrollEvent();
                  },
                  setTranslateX: function (t, e) {
                    (t += this.cursorPosition),
                      (t = this.options.rightToLeft ? -t : t);
                    var i = this.getPositionValue(t);
                    this.slider.style.transform = e
                      ? "translate3d(" + i + ",0,0)"
                      : "translateX(" + i + ")";
                  },
                  dispatchScrollEvent: function () {
                    var t = this.slides[0];
                    if (t) {
                      var e = -this.x - t.target,
                        i = e / this.slidesWidth;
                      this.dispatchEvent("scroll", null, [i, e]);
                    }
                  },
                  positionSliderAtSelected: function () {
                    this.cells.length &&
                      ((this.x = -this.selectedSlide.target),
                      (this.velocity = 0),
                      this.positionSlider());
                  },
                  getPositionValue: function (t) {
                    return this.options.percentPosition
                      ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) +
                          "%"
                      : Math.round(t) + "px";
                  },
                  settle: function (t) {
                    this.isPointerDown ||
                      Math.round(100 * this.x) != Math.round(100 * t) ||
                      this.restingFrames++,
                      this.restingFrames > 2 &&
                        ((this.isAnimating = !1),
                        delete this.isFreeScrolling,
                        this.positionSlider(),
                        this.dispatchEvent("settle", null, [
                          this.selectedIndex,
                        ]));
                  },
                  shiftWrapCells: function (t) {
                    var e = this.cursorPosition + t;
                    this._shiftCells(this.beforeShiftCells, e, -1);
                    var i =
                      this.size.innerWidth -
                      (t + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, i, 1);
                  },
                  _shiftCells: function (t, e, i) {
                    for (var n = 0; n < t.length; n++) {
                      var s = t[n],
                        o = e > 0 ? i : 0;
                      s.wrapShift(o), (e -= s.size.outerWidth);
                    }
                  },
                  _unshiftCells: function (t) {
                    if (t && t.length)
                      for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
                  },
                  integratePhysics: function () {
                    (this.x += this.velocity),
                      (this.velocity *= this.getFrictionFactor());
                  },
                  applyForce: function (t) {
                    this.velocity += t;
                  },
                  getFrictionFactor: function () {
                    return (
                      1 -
                      this.options[
                        this.isFreeScrolling ? "freeScrollFriction" : "friction"
                      ]
                    );
                  },
                  getRestingPosition: function () {
                    return (
                      this.x + this.velocity / (1 - this.getFrictionFactor())
                    );
                  },
                  applyDragForce: function () {
                    if (this.isDraggable && this.isPointerDown) {
                      var t = this.dragX - this.x - this.velocity;
                      this.applyForce(t);
                    }
                  },
                  applySelectedAttraction: function () {
                    if (
                      (!this.isDraggable || !this.isPointerDown) &&
                      !this.isFreeScrolling &&
                      this.slides.length
                    ) {
                      var t =
                        (-1 * this.selectedSlide.target - this.x) *
                        this.options.selectedAttraction;
                      this.applyForce(t);
                    }
                  },
                };
                return i;
              })(0, t);
            }.apply(e, n)) || (t.exports = s);
      },
      229: (t, e, i) => {
        var n, s;
        window,
          (n = [i(131)]),
          void 0 ===
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                function i(t, e) {
                  (this.element = t), (this.parent = e), this.create();
                }
                var n = i.prototype;
                return (
                  (n.create = function () {
                    (this.element.style.position = "absolute"),
                      this.element.setAttribute("aria-hidden", "true"),
                      (this.x = 0),
                      (this.shift = 0);
                  }),
                  (n.destroy = function () {
                    this.unselect(), (this.element.style.position = "");
                    var t = this.parent.originSide;
                    this.element.style[t] = "";
                  }),
                  (n.getSize = function () {
                    this.size = e(this.element);
                  }),
                  (n.setPosition = function (t) {
                    (this.x = t), this.updateTarget(), this.renderPosition(t);
                  }),
                  (n.updateTarget = n.setDefaultTarget =
                    function () {
                      var t =
                        "left" == this.parent.originSide
                          ? "marginLeft"
                          : "marginRight";
                      this.target =
                        this.x +
                        this.size[t] +
                        this.size.width * this.parent.cellAlign;
                    }),
                  (n.renderPosition = function (t) {
                    var e = this.parent.originSide;
                    this.element.style[e] = this.parent.getPositionValue(t);
                  }),
                  (n.select = function () {
                    this.element.classList.add("is-selected"),
                      this.element.removeAttribute("aria-hidden");
                  }),
                  (n.unselect = function () {
                    this.element.classList.remove("is-selected"),
                      this.element.setAttribute("aria-hidden", "true");
                  }),
                  (n.wrapShift = function (t) {
                    (this.shift = t),
                      this.renderPosition(
                        this.x + this.parent.slideableWidth * t
                      );
                  }),
                  (n.remove = function () {
                    this.element.parentNode.removeChild(this.element);
                  }),
                  i
                );
              })(0, t);
            }.apply(e, n)) || (t.exports = s);
      },
      690: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(217), i(842), i(47)]),
            (s = function (t, e, i) {
              return (function (t, e, i, n) {
                "use strict";
                n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
                  e.createMethods.push("_createDrag");
                var s = e.prototype;
                n.extend(s, i.prototype), (s._touchActionValue = "pan-y");
                var o = "createTouch" in document,
                  r = !1;
                (s._createDrag = function () {
                  this.on("activate", this.onActivateDrag),
                    this.on("uiChange", this._uiChangeDrag),
                    this.on("deactivate", this.onDeactivateDrag),
                    this.on("cellChange", this.updateDraggable),
                    o &&
                      !r &&
                      (t.addEventListener("touchmove", function () {}),
                      (r = !0));
                }),
                  (s.onActivateDrag = function () {
                    (this.handles = [this.viewport]),
                      this.bindHandles(),
                      this.updateDraggable();
                  }),
                  (s.onDeactivateDrag = function () {
                    this.unbindHandles(),
                      this.element.classList.remove("is-draggable");
                  }),
                  (s.updateDraggable = function () {
                    ">1" == this.options.draggable
                      ? (this.isDraggable = this.slides.length > 1)
                      : (this.isDraggable = this.options.draggable),
                      this.isDraggable
                        ? this.element.classList.add("is-draggable")
                        : this.element.classList.remove("is-draggable");
                  }),
                  (s.bindDrag = function () {
                    (this.options.draggable = !0), this.updateDraggable();
                  }),
                  (s.unbindDrag = function () {
                    (this.options.draggable = !1), this.updateDraggable();
                  }),
                  (s._uiChangeDrag = function () {
                    delete this.isFreeScrolling;
                  }),
                  (s.pointerDown = function (e, i) {
                    this.isDraggable
                      ? this.okayPointerDown(e) &&
                        (this._pointerDownPreventDefault(e),
                        this.pointerDownFocus(e),
                        document.activeElement != this.element &&
                          this.pointerDownBlur(),
                        (this.dragX = this.x),
                        this.viewport.classList.add("is-pointer-down"),
                        (this.pointerDownScroll = l()),
                        t.addEventListener("scroll", this),
                        this._pointerDownDefault(e, i))
                      : this._pointerDownDefault(e, i);
                  }),
                  (s._pointerDownDefault = function (t, e) {
                    (this.pointerDownPointer = {
                      pageX: e.pageX,
                      pageY: e.pageY,
                    }),
                      this._bindPostStartEvents(t),
                      this.dispatchEvent("pointerDown", t, [e]);
                  });
                var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
                function l() {
                  return { x: t.pageXOffset, y: t.pageYOffset };
                }
                return (
                  (s.pointerDownFocus = function (t) {
                    a[t.target.nodeName] || this.focus();
                  }),
                  (s._pointerDownPreventDefault = function (t) {
                    var e = "touchstart" == t.type,
                      i = "touch" == t.pointerType,
                      n = a[t.target.nodeName];
                    e || i || n || t.preventDefault();
                  }),
                  (s.hasDragStarted = function (t) {
                    return Math.abs(t.x) > this.options.dragThreshold;
                  }),
                  (s.pointerUp = function (t, e) {
                    delete this.isTouchScrolling,
                      this.viewport.classList.remove("is-pointer-down"),
                      this.dispatchEvent("pointerUp", t, [e]),
                      this._dragPointerUp(t, e);
                  }),
                  (s.pointerDone = function () {
                    t.removeEventListener("scroll", this),
                      delete this.pointerDownScroll;
                  }),
                  (s.dragStart = function (e, i) {
                    this.isDraggable &&
                      ((this.dragStartPosition = this.x),
                      this.startAnimation(),
                      t.removeEventListener("scroll", this),
                      this.dispatchEvent("dragStart", e, [i]));
                  }),
                  (s.pointerMove = function (t, e) {
                    var i = this._dragPointerMove(t, e);
                    this.dispatchEvent("pointerMove", t, [e, i]),
                      this._dragMove(t, e, i);
                  }),
                  (s.dragMove = function (t, e, i) {
                    if (this.isDraggable) {
                      t.preventDefault(), (this.previousDragX = this.dragX);
                      var n = this.options.rightToLeft ? -1 : 1;
                      this.options.wrapAround &&
                        (i.x = i.x % this.slideableWidth);
                      var s = this.dragStartPosition + i.x * n;
                      if (!this.options.wrapAround && this.slides.length) {
                        var o = Math.max(
                          -this.slides[0].target,
                          this.dragStartPosition
                        );
                        s = s > o ? 0.5 * (s + o) : s;
                        var r = Math.min(
                          -this.getLastSlide().target,
                          this.dragStartPosition
                        );
                        s = s < r ? 0.5 * (s + r) : s;
                      }
                      (this.dragX = s),
                        (this.dragMoveTime = new Date()),
                        this.dispatchEvent("dragMove", t, [e, i]);
                    }
                  }),
                  (s.dragEnd = function (t, e) {
                    if (this.isDraggable) {
                      this.options.freeScroll && (this.isFreeScrolling = !0);
                      var i = this.dragEndRestingSelect();
                      if (this.options.freeScroll && !this.options.wrapAround) {
                        var n = this.getRestingPosition();
                        this.isFreeScrolling =
                          -n > this.slides[0].target &&
                          -n < this.getLastSlide().target;
                      } else
                        this.options.freeScroll ||
                          i != this.selectedIndex ||
                          (i += this.dragEndBoostSelect());
                      delete this.previousDragX,
                        (this.isDragSelect = this.options.wrapAround),
                        this.select(i),
                        delete this.isDragSelect,
                        this.dispatchEvent("dragEnd", t, [e]);
                    }
                  }),
                  (s.dragEndRestingSelect = function () {
                    var t = this.getRestingPosition(),
                      e = Math.abs(
                        this.getSlideDistance(-t, this.selectedIndex)
                      ),
                      i = this._getClosestResting(t, e, 1),
                      n = this._getClosestResting(t, e, -1);
                    return i.distance < n.distance ? i.index : n.index;
                  }),
                  (s._getClosestResting = function (t, e, i) {
                    for (
                      var n = this.selectedIndex,
                        s = 1 / 0,
                        o =
                          this.options.contain && !this.options.wrapAround
                            ? function (t, e) {
                                return t <= e;
                              }
                            : function (t, e) {
                                return t < e;
                              };
                      o(e, s) &&
                      ((n += i),
                      (s = e),
                      null !== (e = this.getSlideDistance(-t, n)));

                    )
                      e = Math.abs(e);
                    return { distance: s, index: n - i };
                  }),
                  (s.getSlideDistance = function (t, e) {
                    var i = this.slides.length,
                      s = this.options.wrapAround && i > 1,
                      o = s ? n.modulo(e, i) : e,
                      r = this.slides[o];
                    if (!r) return null;
                    var a = s ? this.slideableWidth * Math.floor(e / i) : 0;
                    return t - (r.target + a);
                  }),
                  (s.dragEndBoostSelect = function () {
                    if (
                      void 0 === this.previousDragX ||
                      !this.dragMoveTime ||
                      new Date() - this.dragMoveTime > 100
                    )
                      return 0;
                    var t = this.getSlideDistance(
                        -this.dragX,
                        this.selectedIndex
                      ),
                      e = this.previousDragX - this.dragX;
                    return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                  }),
                  (s.staticClick = function (t, e) {
                    var i = this.getParentCell(t.target),
                      n = i && i.element,
                      s = i && this.cells.indexOf(i);
                    this.dispatchEvent("staticClick", t, [e, n, s]);
                  }),
                  (s.onscroll = function () {
                    var t = l(),
                      e = this.pointerDownScroll.x - t.x,
                      i = this.pointerDownScroll.y - t.y;
                    (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
                  }),
                  e
                );
              })(o, t, e, i);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      217: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          if (1)
            (n = [i(158), i(131), i(47), i(229), i(714), i(880)]),
              (s = function (t, e, i, n, s, r) {
                return (function (t, e, i, n, s, o, r) {
                  "use strict";
                  var a = t.jQuery,
                    l = t.getComputedStyle,
                    c = t.console;
                  function h(t, e) {
                    for (t = n.makeArray(t); t.length; )
                      e.appendChild(t.shift());
                  }
                  var d = 0,
                    u = {};
                  function p(t, e) {
                    var i = n.getQueryElement(t);
                    if (i) {
                      if (((this.element = i), this.element.flickityGUID)) {
                        var s = u[this.element.flickityGUID];
                        return s.option(e), s;
                      }
                      a && (this.$element = a(this.element)),
                        (this.options = n.extend(
                          {},
                          this.constructor.defaults
                        )),
                        this.option(e),
                        this._create();
                    } else
                      c && c.error("Bad element for Flickity: " + (i || t));
                  }
                  (p.defaults = {
                    accessibility: !0,
                    cellAlign: "center",
                    freeScrollFriction: 0.075,
                    friction: 0.28,
                    namespaceJQueryEvents: !0,
                    percentPosition: !0,
                    resize: !0,
                    selectedAttraction: 0.025,
                    setGallerySize: !0,
                  }),
                    (p.createMethods = []);
                  var f = p.prototype;
                  n.extend(f, e.prototype),
                    (f._create = function () {
                      var e = (this.guid = ++d);
                      for (var i in ((this.element.flickityGUID = e),
                      (u[e] = this),
                      (this.selectedIndex = 0),
                      (this.restingFrames = 0),
                      (this.x = 0),
                      (this.velocity = 0),
                      (this.originSide = this.options.rightToLeft
                        ? "right"
                        : "left"),
                      (this.viewport = document.createElement("div")),
                      (this.viewport.className = "flickity-viewport"),
                      this._createSlider(),
                      (this.options.resize || this.options.watchCSS) &&
                        t.addEventListener("resize", this),
                      this.options.on)) {
                        var n = this.options.on[i];
                        this.on(i, n);
                      }
                      p.createMethods.forEach(function (t) {
                        this[t]();
                      }, this),
                        this.options.watchCSS
                          ? this.watchCSS()
                          : this.activate();
                    }),
                    (f.option = function (t) {
                      n.extend(this.options, t);
                    }),
                    (f.activate = function () {
                      this.isActive ||
                        ((this.isActive = !0),
                        this.element.classList.add("flickity-enabled"),
                        this.options.rightToLeft &&
                          this.element.classList.add("flickity-rtl"),
                        this.getSize(),
                        h(
                          this._filterFindCellElements(this.element.children),
                          this.slider
                        ),
                        this.viewport.appendChild(this.slider),
                        this.element.appendChild(this.viewport),
                        this.reloadCells(),
                        this.options.accessibility &&
                          ((this.element.tabIndex = 0),
                          this.element.addEventListener("keydown", this)),
                        this.emitEvent("activate"),
                        this.selectInitialIndex(),
                        (this.isInitActivated = !0),
                        this.dispatchEvent("ready"));
                    }),
                    (f._createSlider = function () {
                      var t = document.createElement("div");
                      (t.className = "flickity-slider"),
                        (t.style[this.originSide] = 0),
                        (this.slider = t);
                    }),
                    (f._filterFindCellElements = function (t) {
                      return n.filterFindElements(t, this.options.cellSelector);
                    }),
                    (f.reloadCells = function () {
                      (this.cells = this._makeCells(this.slider.children)),
                        this.positionCells(),
                        this._getWrapShiftCells(),
                        this.setGallerySize();
                    }),
                    (f._makeCells = function (t) {
                      return this._filterFindCellElements(t).map(function (t) {
                        return new s(t, this);
                      }, this);
                    }),
                    (f.getLastCell = function () {
                      return this.cells[this.cells.length - 1];
                    }),
                    (f.getLastSlide = function () {
                      return this.slides[this.slides.length - 1];
                    }),
                    (f.positionCells = function () {
                      this._sizeCells(this.cells), this._positionCells(0);
                    }),
                    (f._positionCells = function (t) {
                      (t = t || 0),
                        (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                      var e = 0;
                      if (t > 0) {
                        var i = this.cells[t - 1];
                        e = i.x + i.size.outerWidth;
                      }
                      for (var n = this.cells.length, s = t; s < n; s++) {
                        var o = this.cells[s];
                        o.setPosition(e),
                          (e += o.size.outerWidth),
                          (this.maxCellHeight = Math.max(
                            o.size.outerHeight,
                            this.maxCellHeight
                          ));
                      }
                      (this.slideableWidth = e),
                        this.updateSlides(),
                        this._containSlides(),
                        (this.slidesWidth = n
                          ? this.getLastSlide().target - this.slides[0].target
                          : 0);
                    }),
                    (f._sizeCells = function (t) {
                      t.forEach(function (t) {
                        t.getSize();
                      });
                    }),
                    (f.updateSlides = function () {
                      if (((this.slides = []), this.cells.length)) {
                        var t = new o(this);
                        this.slides.push(t);
                        var e =
                            "left" == this.originSide
                              ? "marginRight"
                              : "marginLeft",
                          i = this._getCanCellFit();
                        this.cells.forEach(function (n, s) {
                          if (t.cells.length) {
                            var r =
                              t.outerWidth -
                              t.firstMargin +
                              (n.size.outerWidth - n.size[e]);
                            i.call(this, s, r) ||
                              (t.updateTarget(),
                              (t = new o(this)),
                              this.slides.push(t)),
                              t.addCell(n);
                          } else t.addCell(n);
                        }, this),
                          t.updateTarget(),
                          this.updateSelectedSlide();
                      }
                    }),
                    (f._getCanCellFit = function () {
                      var t = this.options.groupCells;
                      if (!t)
                        return function () {
                          return !1;
                        };
                      if ("number" == typeof t) {
                        var e = parseInt(t, 10);
                        return function (t) {
                          return t % e != 0;
                        };
                      }
                      var i = "string" == typeof t && t.match(/^(\d+)%$/),
                        n = i ? parseInt(i[1], 10) / 100 : 1;
                      return function (t, e) {
                        return e <= (this.size.innerWidth + 1) * n;
                      };
                    }),
                    (f._init = f.reposition =
                      function () {
                        this.positionCells(), this.positionSliderAtSelected();
                      }),
                    (f.getSize = function () {
                      (this.size = i(this.element)),
                        this.setCellAlign(),
                        (this.cursorPosition =
                          this.size.innerWidth * this.cellAlign);
                    });
                  var g = {
                    center: { left: 0.5, right: 0.5 },
                    left: { left: 0, right: 1 },
                    right: { right: 0, left: 1 },
                  };
                  (f.setCellAlign = function () {
                    var t = g[this.options.cellAlign];
                    this.cellAlign = t
                      ? t[this.originSide]
                      : this.options.cellAlign;
                  }),
                    (f.setGallerySize = function () {
                      if (this.options.setGallerySize) {
                        var t =
                          this.options.adaptiveHeight && this.selectedSlide
                            ? this.selectedSlide.height
                            : this.maxCellHeight;
                        this.viewport.style.height = t + "px";
                      }
                    }),
                    (f._getWrapShiftCells = function () {
                      if (this.options.wrapAround) {
                        this._unshiftCells(this.beforeShiftCells),
                          this._unshiftCells(this.afterShiftCells);
                        var t = this.cursorPosition,
                          e = this.cells.length - 1;
                        (this.beforeShiftCells = this._getGapCells(t, e, -1)),
                          (t = this.size.innerWidth - this.cursorPosition),
                          (this.afterShiftCells = this._getGapCells(t, 0, 1));
                      }
                    }),
                    (f._getGapCells = function (t, e, i) {
                      for (var n = []; t > 0; ) {
                        var s = this.cells[e];
                        if (!s) break;
                        n.push(s), (e += i), (t -= s.size.outerWidth);
                      }
                      return n;
                    }),
                    (f._containSlides = function () {
                      if (
                        this.options.contain &&
                        !this.options.wrapAround &&
                        this.cells.length
                      ) {
                        var t = this.options.rightToLeft,
                          e = t ? "marginRight" : "marginLeft",
                          i = t ? "marginLeft" : "marginRight",
                          n = this.slideableWidth - this.getLastCell().size[i],
                          s = n < this.size.innerWidth,
                          o = this.cursorPosition + this.cells[0].size[e],
                          r = n - this.size.innerWidth * (1 - this.cellAlign);
                        this.slides.forEach(function (t) {
                          s
                            ? (t.target = n * this.cellAlign)
                            : ((t.target = Math.max(t.target, o)),
                              (t.target = Math.min(t.target, r)));
                        }, this);
                      }
                    }),
                    (f.dispatchEvent = function (t, e, i) {
                      var n = e ? [e].concat(i) : i;
                      if ((this.emitEvent(t, n), a && this.$element)) {
                        var s = (t += this.options.namespaceJQueryEvents
                          ? ".flickity"
                          : "");
                        if (e) {
                          var o = a.Event(e);
                          (o.type = t), (s = o);
                        }
                        this.$element.trigger(s, i);
                      }
                    }),
                    (f.select = function (t, e, i) {
                      if (
                        this.isActive &&
                        ((t = parseInt(t, 10)),
                        this._wrapSelect(t),
                        (this.options.wrapAround || e) &&
                          (t = n.modulo(t, this.slides.length)),
                        this.slides[t])
                      ) {
                        var s = this.selectedIndex;
                        (this.selectedIndex = t),
                          this.updateSelectedSlide(),
                          i
                            ? this.positionSliderAtSelected()
                            : this.startAnimation(),
                          this.options.adaptiveHeight && this.setGallerySize(),
                          this.dispatchEvent("select", null, [t]),
                          t != s && this.dispatchEvent("change", null, [t]),
                          this.dispatchEvent("cellSelect");
                      }
                    }),
                    (f._wrapSelect = function (t) {
                      var e = this.slides.length;
                      if (!(this.options.wrapAround && e > 1)) return t;
                      var i = n.modulo(t, e),
                        s = Math.abs(i - this.selectedIndex),
                        o = Math.abs(i + e - this.selectedIndex),
                        r = Math.abs(i - e - this.selectedIndex);
                      !this.isDragSelect && o < s
                        ? (t += e)
                        : !this.isDragSelect && r < s && (t -= e),
                        t < 0
                          ? (this.x -= this.slideableWidth)
                          : t >= e && (this.x += this.slideableWidth);
                    }),
                    (f.previous = function (t, e) {
                      this.select(this.selectedIndex - 1, t, e);
                    }),
                    (f.next = function (t, e) {
                      this.select(this.selectedIndex + 1, t, e);
                    }),
                    (f.updateSelectedSlide = function () {
                      var t = this.slides[this.selectedIndex];
                      t &&
                        (this.unselectSelectedSlide(),
                        (this.selectedSlide = t),
                        t.select(),
                        (this.selectedCells = t.cells),
                        (this.selectedElements = t.getCellElements()),
                        (this.selectedCell = t.cells[0]),
                        (this.selectedElement = this.selectedElements[0]));
                    }),
                    (f.unselectSelectedSlide = function () {
                      this.selectedSlide && this.selectedSlide.unselect();
                    }),
                    (f.selectInitialIndex = function () {
                      var t = this.options.initialIndex;
                      if (this.isInitActivated)
                        this.select(this.selectedIndex, !1, !0);
                      else {
                        if (t && "string" == typeof t)
                          if (this.queryCell(t))
                            return void this.selectCell(t, !1, !0);
                        var e = 0;
                        t && this.slides[t] && (e = t), this.select(e, !1, !0);
                      }
                    }),
                    (f.selectCell = function (t, e, i) {
                      var n = this.queryCell(t);
                      if (n) {
                        var s = this.getCellSlideIndex(n);
                        this.select(s, e, i);
                      }
                    }),
                    (f.getCellSlideIndex = function (t) {
                      for (var e = 0; e < this.slides.length; e++) {
                        if (-1 != this.slides[e].cells.indexOf(t)) return e;
                      }
                    }),
                    (f.getCell = function (t) {
                      for (var e = 0; e < this.cells.length; e++) {
                        var i = this.cells[e];
                        if (i.element == t) return i;
                      }
                    }),
                    (f.getCells = function (t) {
                      t = n.makeArray(t);
                      var e = [];
                      return (
                        t.forEach(function (t) {
                          var i = this.getCell(t);
                          i && e.push(i);
                        }, this),
                        e
                      );
                    }),
                    (f.getCellElements = function () {
                      return this.cells.map(function (t) {
                        return t.element;
                      });
                    }),
                    (f.getParentCell = function (t) {
                      var e = this.getCell(t);
                      return (
                        e ||
                        ((t = n.getParent(t, ".flickity-slider > *")),
                        this.getCell(t))
                      );
                    }),
                    (f.getAdjacentCellElements = function (t, e) {
                      if (!t) return this.selectedSlide.getCellElements();
                      e = void 0 === e ? this.selectedIndex : e;
                      var i = this.slides.length;
                      if (1 + 2 * t >= i) return this.getCellElements();
                      for (var s = [], o = e - t; o <= e + t; o++) {
                        var r = this.options.wrapAround ? n.modulo(o, i) : o,
                          a = this.slides[r];
                        a && (s = s.concat(a.getCellElements()));
                      }
                      return s;
                    }),
                    (f.queryCell = function (t) {
                      if ("number" == typeof t) return this.cells[t];
                      if ("string" == typeof t) {
                        if (t.match(/^[#\.]?[\d\/]/)) return;
                        t = this.element.querySelector(t);
                      }
                      return this.getCell(t);
                    }),
                    (f.uiChange = function () {
                      this.emitEvent("uiChange");
                    }),
                    (f.childUIPointerDown = function (t) {
                      "touchstart" != t.type && t.preventDefault(),
                        this.focus();
                    }),
                    (f.onresize = function () {
                      this.watchCSS(), this.resize();
                    }),
                    n.debounceMethod(p, "onresize", 150),
                    (f.resize = function () {
                      if (this.isActive) {
                        this.getSize(),
                          this.options.wrapAround &&
                            (this.x = n.modulo(this.x, this.slideableWidth)),
                          this.positionCells(),
                          this._getWrapShiftCells(),
                          this.setGallerySize(),
                          this.emitEvent("resize");
                        var t =
                          this.selectedElements && this.selectedElements[0];
                        this.selectCell(t, !1, !0);
                      }
                    }),
                    (f.watchCSS = function () {
                      this.options.watchCSS &&
                        (-1 !=
                        l(this.element, ":after").content.indexOf("flickity")
                          ? this.activate()
                          : this.deactivate());
                    }),
                    (f.onkeydown = function (t) {
                      var e =
                        document.activeElement &&
                        document.activeElement != this.element;
                      if (this.options.accessibility && !e) {
                        var i = p.keyboardHandlers[t.keyCode];
                        i && i.call(this);
                      }
                    }),
                    (p.keyboardHandlers = {
                      37: function () {
                        var t = this.options.rightToLeft ? "next" : "previous";
                        this.uiChange(), this[t]();
                      },
                      39: function () {
                        var t = this.options.rightToLeft ? "previous" : "next";
                        this.uiChange(), this[t]();
                      },
                    }),
                    (f.focus = function () {
                      var e = t.pageYOffset;
                      this.element.focus({ preventScroll: !0 }),
                        t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
                    }),
                    (f.deactivate = function () {
                      this.isActive &&
                        (this.element.classList.remove("flickity-enabled"),
                        this.element.classList.remove("flickity-rtl"),
                        this.unselectSelectedSlide(),
                        this.cells.forEach(function (t) {
                          t.destroy();
                        }),
                        this.element.removeChild(this.viewport),
                        h(this.slider.children, this.element),
                        this.options.accessibility &&
                          (this.element.removeAttribute("tabIndex"),
                          this.element.removeEventListener("keydown", this)),
                        (this.isActive = !1),
                        this.emitEvent("deactivate"));
                    }),
                    (f.destroy = function () {
                      this.deactivate(),
                        t.removeEventListener("resize", this),
                        this.allOff(),
                        this.emitEvent("destroy"),
                        a &&
                          this.$element &&
                          a.removeData(this.element, "flickity"),
                        delete this.element.flickityGUID,
                        delete u[this.guid];
                    }),
                    n.extend(f, r),
                    (p.data = function (t) {
                      var e = (t = n.getQueryElement(t)) && t.flickityGUID;
                      return e && u[e];
                    }),
                    n.htmlInit(p, "flickity"),
                    a && a.bridget && a.bridget("flickity", p);
                  return (
                    (p.setJQuery = function (t) {
                      a = t;
                    }),
                    (p.Cell = s),
                    (p.Slide = o),
                    p
                  );
                })(o, t, e, i, n, s, r);
              }.apply(e, n)),
              void 0 === s || (t.exports = s);
          else;
        })(window);
      },
      442: (t, e, i) => {
        var n, s, o;
        window,
          (s = [i(217), i(690), i(410), i(573), i(516), i(597), i(227)]),
          void 0 ===
            (o =
              "function" ==
              typeof (n = function (t) {
                return t;
              })
                ? n.apply(e, s)
                : n) || (t.exports = o);
      },
      227: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(47)]),
          void 0 ===
            (s = function (t, e) {
              return (function (t, e, i) {
                "use strict";
                e.createMethods.push("_createLazyload");
                var n = e.prototype;
                function s(t) {
                  if ("IMG" == t.nodeName) {
                    var e = t.getAttribute("data-flickity-lazyload"),
                      n = t.getAttribute("data-flickity-lazyload-src"),
                      s = t.getAttribute("data-flickity-lazyload-srcset");
                    if (e || n || s) return [t];
                  }
                  var o =
                      "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                    r = t.querySelectorAll(o);
                  return i.makeArray(r);
                }
                function o(t, e) {
                  (this.img = t), (this.flickity = e), this.load();
                }
                return (
                  (n._createLazyload = function () {
                    this.on("select", this.lazyLoad);
                  }),
                  (n.lazyLoad = function () {
                    var t = this.options.lazyLoad;
                    if (t) {
                      var e = "number" == typeof t ? t : 0,
                        i = this.getAdjacentCellElements(e),
                        n = [];
                      i.forEach(function (t) {
                        var e = s(t);
                        n = n.concat(e);
                      }),
                        n.forEach(function (t) {
                          new o(t, this);
                        }, this);
                    }
                  }),
                  (o.prototype.handleEvent = i.handleEvent),
                  (o.prototype.load = function () {
                    this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this);
                    var t =
                        this.img.getAttribute("data-flickity-lazyload") ||
                        this.img.getAttribute("data-flickity-lazyload-src"),
                      e = this.img.getAttribute(
                        "data-flickity-lazyload-srcset"
                      );
                    (this.img.src = t),
                      e && this.img.setAttribute("srcset", e),
                      this.img.removeAttribute("data-flickity-lazyload"),
                      this.img.removeAttribute("data-flickity-lazyload-src"),
                      this.img.removeAttribute("data-flickity-lazyload-srcset");
                  }),
                  (o.prototype.onload = function (t) {
                    this.complete(t, "flickity-lazyloaded");
                  }),
                  (o.prototype.onerror = function (t) {
                    this.complete(t, "flickity-lazyerror");
                  }),
                  (o.prototype.complete = function (t, e) {
                    this.img.removeEventListener("load", this),
                      this.img.removeEventListener("error", this);
                    var i = this.flickity.getParentCell(this.img),
                      n = i && i.element;
                    this.flickity.cellSizeChange(n),
                      this.img.classList.add(e),
                      this.flickity.dispatchEvent("lazyLoad", t, n);
                  }),
                  (e.LazyLoader = o),
                  e
                );
              })(0, t, e);
            }.apply(e, n)) || (t.exports = s);
      },
      573: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(704), i(47)]),
          void 0 ===
            (s = function (t, e, i) {
              return (function (t, e, i, n) {
                "use strict";
                function s(t) {
                  (this.parent = t), this._create();
                }
                (s.prototype = Object.create(i.prototype)),
                  (s.prototype._create = function () {
                    (this.holder = document.createElement("ol")),
                      (this.holder.className = "flickity-page-dots"),
                      (this.dots = []),
                      (this.handleClick = this.onClick.bind(this)),
                      this.on(
                        "pointerDown",
                        this.parent.childUIPointerDown.bind(this.parent)
                      );
                  }),
                  (s.prototype.activate = function () {
                    this.setDots(),
                      this.holder.addEventListener("click", this.handleClick),
                      this.bindStartEvent(this.holder),
                      this.parent.element.appendChild(this.holder);
                  }),
                  (s.prototype.deactivate = function () {
                    this.holder.removeEventListener("click", this.handleClick),
                      this.unbindStartEvent(this.holder),
                      this.parent.element.removeChild(this.holder);
                  }),
                  (s.prototype.setDots = function () {
                    var t = this.parent.slides.length - this.dots.length;
                    t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
                  }),
                  (s.prototype.addDots = function (t) {
                    for (
                      var e = document.createDocumentFragment(),
                        i = [],
                        n = this.dots.length,
                        s = n + t,
                        o = n;
                      o < s;
                      o++
                    ) {
                      var r = document.createElement("li");
                      (r.className = "dot"),
                        r.setAttribute("aria-label", "Page dot " + (o + 1)),
                        e.appendChild(r),
                        i.push(r);
                    }
                    this.holder.appendChild(e),
                      (this.dots = this.dots.concat(i));
                  }),
                  (s.prototype.removeDots = function (t) {
                    this.dots
                      .splice(this.dots.length - t, t)
                      .forEach(function (t) {
                        this.holder.removeChild(t);
                      }, this);
                  }),
                  (s.prototype.updateSelected = function () {
                    this.selectedDot &&
                      ((this.selectedDot.className = "dot"),
                      this.selectedDot.removeAttribute("aria-current")),
                      this.dots.length &&
                        ((this.selectedDot =
                          this.dots[this.parent.selectedIndex]),
                        (this.selectedDot.className = "dot is-selected"),
                        this.selectedDot.setAttribute("aria-current", "step"));
                  }),
                  (s.prototype.onTap = s.prototype.onClick =
                    function (t) {
                      var e = t.target;
                      if ("LI" == e.nodeName) {
                        this.parent.uiChange();
                        var i = this.dots.indexOf(e);
                        this.parent.select(i);
                      }
                    }),
                  (s.prototype.destroy = function () {
                    this.deactivate(), this.allOff();
                  }),
                  (e.PageDots = s),
                  n.extend(e.defaults, { pageDots: !0 }),
                  e.createMethods.push("_createPageDots");
                var o = e.prototype;
                return (
                  (o._createPageDots = function () {
                    this.options.pageDots &&
                      ((this.pageDots = new s(this)),
                      this.on("activate", this.activatePageDots),
                      this.on("select", this.updateSelectedPageDots),
                      this.on("cellChange", this.updatePageDots),
                      this.on("resize", this.updatePageDots),
                      this.on("deactivate", this.deactivatePageDots));
                  }),
                  (o.activatePageDots = function () {
                    this.pageDots.activate();
                  }),
                  (o.updateSelectedPageDots = function () {
                    this.pageDots.updateSelected();
                  }),
                  (o.updatePageDots = function () {
                    this.pageDots.setDots();
                  }),
                  (o.deactivatePageDots = function () {
                    this.pageDots.deactivate();
                  }),
                  (e.PageDots = s),
                  e
                );
              })(0, t, e, i);
            }.apply(e, n)) || (t.exports = s);
      },
      516: (t, e, i) => {
        var n, s;
        window,
          (n = [i(158), i(47), i(217)]),
          void 0 ===
            (s = function (t, e, i) {
              return (function (t, e, i) {
                "use strict";
                function n(t) {
                  (this.parent = t),
                    (this.state = "stopped"),
                    (this.onVisibilityChange =
                      this.visibilityChange.bind(this)),
                    (this.onVisibilityPlay = this.visibilityPlay.bind(this));
                }
                (n.prototype = Object.create(t.prototype)),
                  (n.prototype.play = function () {
                    "playing" != this.state &&
                      (document.hidden
                        ? document.addEventListener(
                            "visibilitychange",
                            this.onVisibilityPlay
                          )
                        : ((this.state = "playing"),
                          document.addEventListener(
                            "visibilitychange",
                            this.onVisibilityChange
                          ),
                          this.tick()));
                  }),
                  (n.prototype.tick = function () {
                    if ("playing" == this.state) {
                      var t = this.parent.options.autoPlay;
                      t = "number" == typeof t ? t : 3e3;
                      var e = this;
                      this.clear(),
                        (this.timeout = setTimeout(function () {
                          e.parent.next(!0), e.tick();
                        }, t));
                    }
                  }),
                  (n.prototype.stop = function () {
                    (this.state = "stopped"),
                      this.clear(),
                      document.removeEventListener(
                        "visibilitychange",
                        this.onVisibilityChange
                      );
                  }),
                  (n.prototype.clear = function () {
                    clearTimeout(this.timeout);
                  }),
                  (n.prototype.pause = function () {
                    "playing" == this.state &&
                      ((this.state = "paused"), this.clear());
                  }),
                  (n.prototype.unpause = function () {
                    "paused" == this.state && this.play();
                  }),
                  (n.prototype.visibilityChange = function () {
                    this[document.hidden ? "pause" : "unpause"]();
                  }),
                  (n.prototype.visibilityPlay = function () {
                    this.play(),
                      document.removeEventListener(
                        "visibilitychange",
                        this.onVisibilityPlay
                      );
                  }),
                  e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                  i.createMethods.push("_createPlayer");
                var s = i.prototype;
                return (
                  (s._createPlayer = function () {
                    (this.player = new n(this)),
                      this.on("activate", this.activatePlayer),
                      this.on("uiChange", this.stopPlayer),
                      this.on("pointerDown", this.stopPlayer),
                      this.on("deactivate", this.deactivatePlayer);
                  }),
                  (s.activatePlayer = function () {
                    this.options.autoPlay &&
                      (this.player.play(),
                      this.element.addEventListener("mouseenter", this));
                  }),
                  (s.playPlayer = function () {
                    this.player.play();
                  }),
                  (s.stopPlayer = function () {
                    this.player.stop();
                  }),
                  (s.pausePlayer = function () {
                    this.player.pause();
                  }),
                  (s.unpausePlayer = function () {
                    this.player.unpause();
                  }),
                  (s.deactivatePlayer = function () {
                    this.player.stop(),
                      this.element.removeEventListener("mouseenter", this);
                  }),
                  (s.onmouseenter = function () {
                    this.options.pauseAutoPlayOnHover &&
                      (this.player.pause(),
                      this.element.addEventListener("mouseleave", this));
                  }),
                  (s.onmouseleave = function () {
                    this.player.unpause(),
                      this.element.removeEventListener("mouseleave", this);
                  }),
                  (i.Player = n),
                  i
                );
              })(t, e, i);
            }.apply(e, n)) || (t.exports = s);
      },
      410: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(704), i(47)]),
          void 0 ===
            (s = function (t, e, i) {
              return (function (t, e, i, n) {
                "use strict";
                var s = "http://www.w3.org/2000/svg";
                function o(t, e) {
                  (this.direction = t), (this.parent = e), this._create();
                }
                function r(t) {
                  return "string" == typeof t
                    ? t
                    : "M " +
                        t.x0 +
                        ",50 L " +
                        t.x1 +
                        "," +
                        (t.y1 + 50) +
                        " L " +
                        t.x2 +
                        "," +
                        (t.y2 + 50) +
                        " L " +
                        t.x3 +
                        ",50  L " +
                        t.x2 +
                        "," +
                        (50 - t.y2) +
                        " L " +
                        t.x1 +
                        "," +
                        (50 - t.y1) +
                        " Z";
                }
                (o.prototype = Object.create(i.prototype)),
                  (o.prototype._create = function () {
                    (this.isEnabled = !0),
                      (this.isPrevious = -1 == this.direction);
                    var t = this.parent.options.rightToLeft ? 1 : -1;
                    this.isLeft = this.direction == t;
                    var e = (this.element = document.createElement("button"));
                    (e.className = "flickity-button flickity-prev-next-button"),
                      (e.className += this.isPrevious ? " previous" : " next"),
                      e.setAttribute("type", "button"),
                      this.disable(),
                      e.setAttribute(
                        "aria-label",
                        this.isPrevious ? "Previous" : "Next"
                      );
                    var i = this.createSVG();
                    e.appendChild(i),
                      this.parent.on("select", this.update.bind(this)),
                      this.on(
                        "pointerDown",
                        this.parent.childUIPointerDown.bind(this.parent)
                      );
                  }),
                  (o.prototype.activate = function () {
                    this.bindStartEvent(this.element),
                      this.element.addEventListener("click", this),
                      this.parent.element.appendChild(this.element);
                  }),
                  (o.prototype.deactivate = function () {
                    this.parent.element.removeChild(this.element),
                      this.unbindStartEvent(this.element),
                      this.element.removeEventListener("click", this);
                  }),
                  (o.prototype.createSVG = function () {
                    var t = document.createElementNS(s, "svg");
                    t.setAttribute("class", "flickity-button-icon"),
                      t.setAttribute("viewBox", "0 0 100 100");
                    var e = document.createElementNS(s, "path"),
                      i = r(this.parent.options.arrowShape);
                    return (
                      e.setAttribute("d", i),
                      e.setAttribute("class", "arrow"),
                      this.isLeft ||
                        e.setAttribute(
                          "transform",
                          "translate(100, 100) rotate(180) "
                        ),
                      t.appendChild(e),
                      t
                    );
                  }),
                  (o.prototype.handleEvent = n.handleEvent),
                  (o.prototype.onclick = function () {
                    if (this.isEnabled) {
                      this.parent.uiChange();
                      var t = this.isPrevious ? "previous" : "next";
                      this.parent[t]();
                    }
                  }),
                  (o.prototype.enable = function () {
                    this.isEnabled ||
                      ((this.element.disabled = !1), (this.isEnabled = !0));
                  }),
                  (o.prototype.disable = function () {
                    this.isEnabled &&
                      ((this.element.disabled = !0), (this.isEnabled = !1));
                  }),
                  (o.prototype.update = function () {
                    var t = this.parent.slides;
                    if (this.parent.options.wrapAround && t.length > 1)
                      this.enable();
                    else {
                      var e = t.length ? t.length - 1 : 0,
                        i = this.isPrevious ? 0 : e;
                      this[
                        this.parent.selectedIndex == i ? "disable" : "enable"
                      ]();
                    }
                  }),
                  (o.prototype.destroy = function () {
                    this.deactivate(), this.allOff();
                  }),
                  n.extend(e.defaults, {
                    prevNextButtons: !0,
                    arrowShape: {
                      x0: 10,
                      x1: 60,
                      y1: 50,
                      x2: 70,
                      y2: 40,
                      x3: 30,
                    },
                  }),
                  e.createMethods.push("_createPrevNextButtons");
                var a = e.prototype;
                return (
                  (a._createPrevNextButtons = function () {
                    this.options.prevNextButtons &&
                      ((this.prevButton = new o(-1, this)),
                      (this.nextButton = new o(1, this)),
                      this.on("activate", this.activatePrevNextButtons));
                  }),
                  (a.activatePrevNextButtons = function () {
                    this.prevButton.activate(),
                      this.nextButton.activate(),
                      this.on("deactivate", this.deactivatePrevNextButtons);
                  }),
                  (a.deactivatePrevNextButtons = function () {
                    this.prevButton.deactivate(),
                      this.nextButton.deactivate(),
                      this.off("deactivate", this.deactivatePrevNextButtons);
                  }),
                  (e.PrevNextButton = o),
                  e
                );
              })(0, t, e, i);
            }.apply(e, n)) || (t.exports = s);
      },
      714: (t, e, i) => {
        var n, s;
        window,
          void 0 ===
            (s =
              "function" ==
              typeof (n = function () {
                "use strict";
                function t(t) {
                  (this.parent = t),
                    (this.isOriginLeft = "left" == t.originSide),
                    (this.cells = []),
                    (this.outerWidth = 0),
                    (this.height = 0);
                }
                var e = t.prototype;
                return (
                  (e.addCell = function (t) {
                    if (
                      (this.cells.push(t),
                      (this.outerWidth += t.size.outerWidth),
                      (this.height = Math.max(t.size.outerHeight, this.height)),
                      1 == this.cells.length)
                    ) {
                      this.x = t.x;
                      var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                      this.firstMargin = t.size[e];
                    }
                  }),
                  (e.updateTarget = function () {
                    var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                      e = this.getLastCell(),
                      i = e ? e.size[t] : 0,
                      n = this.outerWidth - (this.firstMargin + i);
                    this.target =
                      this.x + this.firstMargin + n * this.parent.cellAlign;
                  }),
                  (e.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                  }),
                  (e.select = function () {
                    this.cells.forEach(function (t) {
                      t.select();
                    });
                  }),
                  (e.unselect = function () {
                    this.cells.forEach(function (t) {
                      t.unselect();
                    });
                  }),
                  (e.getCellElements = function () {
                    return this.cells.map(function (t) {
                      return t.element;
                    });
                  }),
                  t
                );
              })
                ? n.call(e, i, e, t)
                : n) || (t.exports = s);
      },
      131: (t, e, i) => {
        var n, s;
        window,
          void 0 ===
            (s =
              "function" ==
              typeof (n = function () {
                "use strict";
                function t(t) {
                  var e = parseFloat(t);
                  return -1 == t.indexOf("%") && !isNaN(e) && e;
                }
                function e() {}
                var i = "undefined" == typeof console ? e : function (t) {},
                  n = [
                    "paddingLeft",
                    "paddingRight",
                    "paddingTop",
                    "paddingBottom",
                    "marginLeft",
                    "marginRight",
                    "marginTop",
                    "marginBottom",
                    "borderLeftWidth",
                    "borderRightWidth",
                    "borderTopWidth",
                    "borderBottomWidth",
                  ],
                  s = n.length;
                function o() {
                  for (
                    var t = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0,
                      },
                      e = 0;
                    e < s;
                    e++
                  )
                    t[n[e]] = 0;
                  return t;
                }
                function r(t) {
                  var e = getComputedStyle(t);
                  return (
                    e ||
                      i(
                        "Style returned " +
                          e +
                          ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                      ),
                    e
                  );
                }
                var a,
                  l = !1;
                function c() {
                  if (!l) {
                    l = !0;
                    var e = document.createElement("div");
                    (e.style.width = "200px"),
                      (e.style.padding = "1px 2px 3px 4px"),
                      (e.style.borderStyle = "solid"),
                      (e.style.borderWidth = "1px 2px 3px 4px"),
                      (e.style.boxSizing = "border-box");
                    var i = document.body || document.documentElement;
                    i.appendChild(e);
                    var n = r(e);
                    (a = 200 == Math.round(t(n.width))),
                      (h.isBoxSizeOuter = a),
                      i.removeChild(e);
                  }
                }
                function h(e) {
                  if (
                    (c(),
                    "string" == typeof e && (e = document.querySelector(e)),
                    e && "object" == typeof e && e.nodeType)
                  ) {
                    var i = r(e);
                    if ("none" == i.display) return o();
                    var l = {};
                    (l.width = e.offsetWidth), (l.height = e.offsetHeight);
                    for (
                      var h = (l.isBorderBox = "border-box" == i.boxSizing),
                        d = 0;
                      d < s;
                      d++
                    ) {
                      var u = n[d],
                        p = i[u],
                        f = parseFloat(p);
                      l[u] = isNaN(f) ? 0 : f;
                    }
                    var g = l.paddingLeft + l.paddingRight,
                      m = l.paddingTop + l.paddingBottom,
                      v = l.marginLeft + l.marginRight,
                      y = l.marginTop + l.marginBottom,
                      b = l.borderLeftWidth + l.borderRightWidth,
                      w = l.borderTopWidth + l.borderBottomWidth,
                      _ = h && a,
                      S = t(i.width);
                    !1 !== S && (l.width = S + (_ ? 0 : g + b));
                    var C = t(i.height);
                    return (
                      !1 !== C && (l.height = C + (_ ? 0 : m + w)),
                      (l.innerWidth = l.width - (g + b)),
                      (l.innerHeight = l.height - (m + w)),
                      (l.outerWidth = l.width + v),
                      (l.outerHeight = l.height + y),
                      l
                    );
                  }
                }
                return h;
              })
                ? n.call(e, i, e, t)
                : n) || (t.exports = s);
      },
      414: (t) => {
        "use strict";
        function e(t, e, i) {
          var n = 0;
          for (n = 0; n < t.length; n += 1) e.call(i, t[n], n);
        }
        function i(t, e) {
          var i = new RegExp("^" + e + "| +" + e, "g");
          return t.className.match(i);
        }
        function n(t, e) {
          i(t, e) || (t.className += " " + e);
        }
        function s(t, e) {
          if (i(t, e)) {
            var n = new RegExp("^" + e + "| +" + e, "g");
            t.className = t.className.replace(n, "");
          }
        }
        function o(t, e) {
          i(t, e) ? s(t, e) : n(t, e);
        }
        function r(t, i) {
          var n = null;
          return (
            e(t, function (t) {
              t.trigger === i && (n = t);
            }),
            n
          );
        }
        function a() {
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (t) {
              var e = (16 * Math.random()) | 0;
              return ("x" === t ? e : (3 & e) | 8).toString(16);
            }
          );
        }
        var l = {
            init: function (t) {
              var n = t.triggers,
                s = t.pairings;
              n.setAttribute("role", "tablist"),
                e(s, function (n, s) {
                  n.trigger.setAttribute("role", "tab"),
                    n.trigger.setAttribute(
                      "aria-controls",
                      t.namespace + "-" + t.id + "-" + s + "-content"
                    ),
                    n.trigger.children.length > 0 &&
                      e(n.trigger.children, function (t) {
                        t.setAttribute("tabIndex", "-1");
                      }),
                    i(n.trigger, "active")
                      ? (n.trigger.setAttribute("aria-selected", "true"),
                        n.trigger.setAttribute("tabIndex", "0"))
                      : n.trigger.setAttribute("tabIndex", "-1"),
                    (n.content.id =
                      t.namespace + "-" + t.id + "-" + s + "-content"),
                    n.content.setAttribute("role", "tabpanel"),
                    i(n.content, "active") ||
                      n.content.setAttribute("aria-hidden", "true");
                });
            },
            update: function (t) {
              e(t.pairings, function (t) {
                t.trigger.removeAttribute("aria-selected"),
                  t.content.removeAttribute("aria-hidden"),
                  i(t.trigger, "active")
                    ? (t.trigger.setAttribute("aria-selected", "true"),
                      t.trigger.setAttribute("tabIndex", "0"))
                    : t.trigger.setAttribute("tabIndex", "-1"),
                  i(t.content, "active") ||
                    t.content.setAttribute("aria-hidden", "true");
              });
            },
          },
          c =
            ((function () {
              function t(t) {
                this.value = t;
              }
              function e(e) {
                var i, n;
                function s(i, n) {
                  try {
                    var r = e[i](n),
                      a = r.value;
                    a instanceof t
                      ? Promise.resolve(a.value).then(
                          function (t) {
                            s("next", t);
                          },
                          function (t) {
                            s("throw", t);
                          }
                        )
                      : o(r.done ? "return" : "normal", r.value);
                  } catch (t) {
                    o("throw", t);
                  }
                }
                function o(t, e) {
                  switch (t) {
                    case "return":
                      i.resolve({ value: e, done: !0 });
                      break;
                    case "throw":
                      i.reject(e);
                      break;
                    default:
                      i.resolve({ value: e, done: !1 });
                      break;
                  }
                  (i = i.next) ? s(i.key, i.arg) : (n = null);
                }
                (this._invoke = function (t, e) {
                  return new Promise(function (o, r) {
                    var a = {
                      key: t,
                      arg: e,
                      resolve: o,
                      reject: r,
                      next: null,
                    };
                    n ? (n = n.next = a) : ((i = n = a), s(t, e));
                  });
                }),
                  "function" != typeof e.return && (this.return = void 0);
              }
              "function" == typeof Symbol &&
                Symbol.asyncIterator &&
                (e.prototype[Symbol.asyncIterator] = function () {
                  return this;
                }),
                (e.prototype.next = function (t) {
                  return this._invoke("next", t);
                }),
                (e.prototype.throw = function (t) {
                  return this._invoke("throw", t);
                }),
                (e.prototype.return = function (t) {
                  return this._invoke("return", t);
                });
            })(),
            function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            }),
          h = (function () {
            function t(t, e) {
              for (var i = 0; i < e.length; i++) {
                var n = e[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(t, n.key, n);
              }
            }
            return function (e, i, n) {
              return i && t(e.prototype, i), n && t(e, n), e;
            };
          })(),
          d = (function () {
            function t(e) {
              c(this, t),
                (this.groupedContent = e),
                (this.pairings = e.pairings),
                (this.events = []),
                (this._handleKeydown = this._handleKeydown.bind(this)),
                (this._handleClick = this._handleClick.bind(this)),
                this._init(),
                l.init(this.groupedContent);
            }
            return (
              h(t, [
                {
                  key: "unload",
                  value: function () {
                    e(this.events, function (t) {
                      t.trigger.removeEventListener(t.type, t.fn);
                    });
                  },
                },
                {
                  key: "_init",
                  value: function () {
                    var t = this,
                      s = !1;
                    e(this.pairings, function (e) {
                      var n = e.trigger;
                      i(n, "active") && (s = !0),
                        n.addEventListener("keydown", t._handleKeydown),
                        n.addEventListener("click", t._handleClick),
                        t.events.push({
                          trigger: n,
                          type: "keydown",
                          fn: t._handleKeydown,
                        }),
                        t.events.push({
                          trigger: n,
                          type: "click",
                          fn: t._handleClick,
                        });
                    }),
                      s ||
                        (n(this.pairings[0].trigger, "active"),
                        n(this.pairings[0].content, "active"));
                  },
                },
                {
                  key: "_handleKeydown",
                  value: function (t) {
                    var i = t.currentTarget,
                      o = r(this.pairings, i),
                      a = this.pairings.indexOf(o),
                      c = a - 1 < 0 ? this.pairings.length - 1 : a - 1,
                      h = a + 1 >= this.pairings.length ? 0 : a + 1,
                      d = null;
                    switch (t.key) {
                      case "ArrowLeft":
                        d = this.pairings[c];
                        break;
                      case "ArrowRight":
                        d = this.pairings[h];
                        break;
                      default:
                        d = null;
                        break;
                    }
                    null !== d &&
                      (t.preventDefault(),
                      e(this.pairings, function (t) {
                        s(t.trigger, "active"), s(t.content, "active");
                      }),
                      n(d.trigger, "active"),
                      n(d.content, "active"),
                      d.trigger.focus(),
                      l.update(this.groupedContent));
                  },
                },
                {
                  key: "_handleClick",
                  value: function (t) {
                    var i = t.currentTarget,
                      o = r(this.pairings, i);
                    null !== o &&
                      (t.preventDefault(),
                      e(this.pairings, function (t) {
                        s(t.trigger, "active"), s(t.content, "active");
                      }),
                      n(o.trigger, "active"),
                      n(o.content, "active"),
                      l.update(this.groupedContent));
                  },
                },
              ]),
              t
            );
          })();
        var u = {
            init: function (t) {
              e(t.pairings, function (n, s) {
                n.trigger.setAttribute("role", "button"),
                  n.trigger.setAttribute(
                    "aria-controls",
                    t.namespace + "-" + t.id + "-" + s + "-content"
                  ),
                  n.trigger.setAttribute("tabIndex", "0"),
                  n.trigger.children.length > 0 &&
                    e(n.trigger.children, function (t) {
                      t.setAttribute("tabIndex", "-1");
                    }),
                  i(n.trigger, "active")
                    ? n.trigger.setAttribute("aria-expanded", "true")
                    : n.trigger.setAttribute("aria-expanded", "false"),
                  (n.content.id =
                    t.namespace + "-" + t.id + "-" + s + "-content"),
                  i(n.content, "active") ||
                    n.content.setAttribute("aria-hidden", "true");
              });
            },
            update: function (t) {
              e(t.pairings, function (t) {
                t.content.removeAttribute("aria-hidden"),
                  i(t.trigger, "active")
                    ? t.trigger.setAttribute("aria-expanded", "true")
                    : t.trigger.setAttribute("aria-expanded", "false"),
                  i(t.content, "active") ||
                    t.content.setAttribute("aria-hidden", "true");
              });
            },
          },
          p = (function () {
            function t(e) {
              c(this, t),
                (this.groupedContent = e),
                (this.pairings = e.pairings),
                (this.events = []),
                (this._handleKeydown = this._handleKeydown.bind(this)),
                (this._handleClick = this._handleClick.bind(this)),
                this._init(this.pairings),
                u.init(this.groupedContent);
            }
            return (
              h(t, [
                {
                  key: "unload",
                  value: function () {
                    e(this.events, function (t) {
                      t.trigger.removeEventListener(t.type, t.fn);
                    });
                  },
                },
                {
                  key: "_init",
                  value: function () {
                    var t = this;
                    e(this.pairings, function (e) {
                      var i = e.trigger,
                        n = e.content;
                      i.parentNode.insertBefore(n, i.nextSibling),
                        i.addEventListener("keydown", t._handleKeydown),
                        i.addEventListener("click", t._handleClick),
                        t.events.push({
                          trigger: i,
                          type: "keydown",
                          fn: t._handleKeydown,
                        }),
                        t.events.push({
                          trigger: i,
                          type: "click",
                          fn: t._handleClick,
                        });
                    }),
                      this.groupedContent.contents.remove();
                  },
                },
                {
                  key: "_handleKeydown",
                  value: function (t) {
                    var e = t.currentTarget,
                      i = r(this.pairings, e);
                    "Enter" === t.key &&
                      null !== i &&
                      (t.preventDefault(),
                      o(i.trigger, "active"),
                      o(i.content, "active"),
                      u.update(this.groupedContent));
                  },
                },
                {
                  key: "_handleClick",
                  value: function (t) {
                    var e = t.currentTarget,
                      i = r(this.pairings, e);
                    null !== i &&
                      (t.preventDefault(),
                      o(i.trigger, "active"),
                      o(i.content, "active"),
                      u.update(this.groupedContent));
                  },
                },
              ]),
              t
            );
          })();
        function f(t) {
          for (
            var e = ["H1", "H2", "H3", "H4", "H5", "H6"],
              i = e.indexOf(t.tagName),
              n = [],
              s = t.nextElementSibling;
            null !== s &&
            (-1 === e.indexOf(s.tagName) || e.indexOf(s.tagName) > i);

          )
            n.push(s), (s = s.nextElementSibling);
          return n;
        }
        function g(t, e) {
          for (
            var i =
                arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              n = ["H1", "H2", "H3", "H4", "H5", "H6"],
              s = n.indexOf(t.tagName),
              o = [],
              r = 5,
              a = 0;
            a < e.length;
            a += 1
          ) {
            var l = e[a],
              c = n.indexOf(l.tagName);
            if (
              (-1 !== c && c < r && (r = c),
              (i && -1 !== c && c <= r) || (!i && -1 !== c && c === s + 1))
            ) {
              var h = f(l),
                d = { el: l, content: h, children: g(l, h) };
              o.push(d);
            }
          }
          return o;
        }
        function m(t) {
          var e = [],
            i = t[0].el,
            n = document.createElement("div"),
            s = document.createElement("div");
          (s = i.parentNode.insertBefore(s, i.nextSibling)),
            (n = i.parentNode.insertBefore(n, i.nextSibling));
          for (var o = 0; o < t.length; o += 1) {
            var r = t[o],
              a = r.el,
              l = document.createElement("div");
            (a = n.appendChild(a)), (l = s.appendChild(l));
            for (var c = 0; c < r.content.length; c += 1)
              l.appendChild(r.content[c]);
            e.push({ trigger: a, content: l });
          }
          return { triggers: n, contents: s, pairings: e };
        }
        function v(t) {
          var e = t.children,
            i = [],
            n = [];
          if (0 === e.length) return [];
          for (var s = 0; s < e.length; s += 1) {
            var o = v(e[s]);
            o.length > 0 && (i.push(s), (n = n.concat(o)));
          }
          for (
            var r = (function (t, e, i) {
                for (var n = [], s = [], o = 0, r = 0; r < t.length; r += 1)
                  -1 === e.indexOf(r) &&
                    (s.push(t[r]),
                    (o += 1),
                    r !== t.length - 1 &&
                    t[r].el.tagName !== t[r + 1].el.tagName &&
                    e.indexOf(r + 1)
                      ? ((s = []), (o = 0))
                      : 0 !== r &&
                        t[r].el.tagName !== t[r - 1].el.tagName &&
                        (s.pop(),
                        (o -= 1) >= i && n.push(s),
                        (s = [t[r]]),
                        (o = 1)));
                return o >= i && n.push(s), n;
              })(e, i, 3),
              a = 0;
            a < r.length;
            a += 1
          )
            n.push(m(r[a]));
          return n;
        }
        function y(t) {
          var e = t.children,
            i = t.querySelector("h1, h2, h3, h4, h5, h6");
          return 0 === e.length
            ? []
            : v({ el: t, content: null, children: g(i, e, !0) });
        }
        function b(t) {
          for (
            var e = [], i = t.querySelectorAll(".tabs"), n = 0;
            n < i.length;
            n += 1
          ) {
            var s = i[n].children,
              o = i[n].nextElementSibling.children;
            if (s.length === o.length)
              for (
                var r =
                    e.push({
                      triggers: i[n],
                      contents: i[n].nextElementSibling,
                      pairings: [],
                    }) - 1,
                  a = 0;
                a < s.length;
                a += 1
              ) {
                var l = { trigger: s[a], content: o[a] };
                e[r].pairings.push(l);
              }
          }
          return e;
        }
        function w(t) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            i = e ? y(t) : b(t);
          return i;
        }
        var _ = (function () {
          function t(i) {
            var s = this,
              o =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            c(this, t),
              (this.namespace = "grouped-content"),
              (this.el = i),
              (this.groupedContentInstances = []);
            var r = o.layout || "tabs",
              l = !!o.intelliparse;
            e(w(i, l), function (t) {
              var i = a(),
                o = null,
                l = document.createElement("div");
              switch (
                (n(
                  (l = t.triggers.parentNode.insertBefore(
                    l,
                    t.triggers.nextSibling
                  )),
                  s.namespace
                ),
                n(l, s.namespace + "-layout-" + r),
                l.appendChild(t.triggers),
                l.appendChild(t.contents),
                (t.namespace = s.namespace),
                (t.id = i),
                (t.triggers.id = s.namespace + "-" + i + "-triggers"),
                (t.contents.id = s.namespace + "-" + i + "-contents"),
                n(t.triggers, s.namespace + "-triggers"),
                n(t.contents, s.namespace + "-contents"),
                e(t.pairings, function (t) {
                  n(t.trigger, s.namespace + "-trigger"),
                    n(t.content, s.namespace + "-content");
                }),
                r)
              ) {
                case "accordion":
                  o = new p(t);
                  break;
                case "tabs":
                default:
                  o = new d(t);
                  break;
              }
              s.groupedContentInstances.push({
                groupedContent: t,
                instance: o,
              });
            });
          }
          return (
            h(t, [
              {
                key: "unload",
                value: function () {
                  e(this.groupedContentInstances, function (t) {
                    t.instance.unload();
                  });
                },
              },
            ]),
            t
          );
        })();
        t.exports = _;
      },
      220: () => {
        !(function (t) {
          t.event.special.trend;
          var e =
              window.requestAnimationFrame ||
              window.mozRequestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              function (t) {
                window.setTimeout(t, 1e3 / 60);
              },
            i = {
              isVisible: function (t) {
                return !!t.data("revealer-visible");
              },
              show: function (t, n) {
                return i.isVisible(t)
                  ? (t.removeClass("animating animating-in"),
                    void t.off("revealer-animating revealer-show"))
                  : (t.data("revealer-visible", !0),
                    t.off("trend"),
                    n
                      ? (t.addClass("visible"),
                        void e(function () {
                          t.trigger("revealer-animating"),
                            t.trigger("revealer-show");
                        }))
                      : void e(function () {
                          t.addClass("animating animating-in"),
                            t.trigger("revealer-animating"),
                            e(function () {
                              t.addClass("visible"),
                                t.one("trend", function () {
                                  t.removeClass("animating animating-in"),
                                    t.trigger("revealer-show");
                                });
                            });
                        }));
              },
              hide: function (t, n) {
                return i.isVisible(t)
                  ? (t.data("revealer-visible", !1),
                    t.off("trend"),
                    n
                      ? (t.removeClass("visible"),
                        void e(function () {
                          t.trigger("revealer-animating"),
                            t.trigger("revealer-hide");
                        }))
                      : void e(function () {
                          t.addClass("animating animating-out"),
                            t.trigger("revealer-animating"),
                            e(function () {
                              t.removeClass("visible"),
                                t.one("trend", function () {
                                  t.removeClass(
                                    "animating animating-in animating-out"
                                  ),
                                    t.trigger("revealer-hide");
                                });
                            });
                        }))
                  : (t.removeClass("animating animating-out visible"),
                    void t.off("revealer-animating revealer-hide"));
              },
              toggle: function (t, e) {
                i.isVisible(t) ? i.hide(t, e) : i.show(t, e);
              },
            };
          t.fn.revealer = function (e, n) {
            var s = i[e || "toggle"];
            return s
              ? "isVisible" === e
                ? s(this)
                : this.each(function () {
                    s(t(this), n);
                  })
              : this;
          };
        })(jQuery);
      },
      72: () => {
        !(function (t) {
          var e =
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
            i = [
              "transition-duration",
              "-moz-transition-duration",
              "-webkit-transition-duration",
              "-ms-transition-duration",
              "-o-transition-duration",
              "-khtml-transition-duration",
            ],
            n = [
              "transition-delay",
              "-moz-transition-delay",
              "-webkit-transition-delay",
              "-ms-transition-delay",
              "-o-transition-delay",
              "-khtml-transition-delay",
            ],
            s = function (t) {
              t = t.replace(/\s/, "");
              var e = window.parseFloat(t);
              return t.match(/[^m]s$/i) ? 1e3 * e : e;
            },
            o = function (t, e) {
              for (var i = 0, n = 0; n < e.length; n++) {
                var o = t.css(e[n]);
                if (o) {
                  if (-1 !== o.indexOf(",")) {
                    var r = o.split(","),
                      a = (function () {
                        for (var t = [], e = 0; e < r.length; e++) {
                          var i = s(r[e]);
                          t.push(i);
                        }
                        return t;
                      })();
                    i = Math.max.apply(Math, a);
                  } else i = s(o);
                  break;
                }
              }
              return i;
            };
          t.event.special.trend = {
            add: function (s) {
              var r = t(this),
                a = !1;
              r.data("trend", !0);
              var l = o(r, i) + o(r, n) + 20,
                c = function (t) {
                  a ||
                    (t && t.srcElement !== r[0]) ||
                    (r.data("trend", !1), (a = !0), s.handler && s.handler());
                };
              r.one(e, c), r.data("trend-timeout", window.setTimeout(c, l));
            },
            remove: function (i) {
              var n = t(this);
              n.off(e), window.clearTimeout(n.data("trend-timeout"));
            },
          };
        })(jQuery);
      },
      755: function (t, e) {
        var i;
        !(function (e, i) {
          "use strict";
          "object" == typeof t.exports
            ? (t.exports = e.document
                ? i(e, !0)
                : function (t) {
                    if (!t.document)
                      throw new Error(
                        "jQuery requires a window with a document"
                      );
                    return i(t);
                  })
            : i(e);
        })("undefined" != typeof window ? window : this, function (n, s) {
          "use strict";
          var o = [],
            r = Object.getPrototypeOf,
            a = o.slice,
            l = o.flat
              ? function (t) {
                  return o.flat.call(t);
                }
              : function (t) {
                  return o.concat.apply([], t);
                },
            c = o.push,
            h = o.indexOf,
            d = {},
            u = d.toString,
            p = d.hasOwnProperty,
            f = p.toString,
            g = f.call(Object),
            m = {},
            v = function (t) {
              return "function" == typeof t && "number" != typeof t.nodeType;
            },
            y = function (t) {
              return null != t && t === t.window;
            },
            b = n.document,
            w = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function _(t, e, i) {
            var n,
              s,
              o = (i = i || b).createElement("script");
            if (((o.text = t), e))
              for (n in w)
                (s = e[n] || (e.getAttribute && e.getAttribute(n))) &&
                  o.setAttribute(n, s);
            i.head.appendChild(o).parentNode.removeChild(o);
          }
          function S(t) {
            return null == t
              ? t + ""
              : "object" == typeof t || "function" == typeof t
              ? d[u.call(t)] || "object"
              : typeof t;
          }
          var C = "3.5.1",
            x = function (t, e) {
              return new x.fn.init(t, e);
            };
          function k(t) {
            var e = !!t && "length" in t && t.length,
              i = S(t);
            return (
              !v(t) &&
              !y(t) &&
              ("array" === i ||
                0 === e ||
                ("number" == typeof e && e > 0 && e - 1 in t))
            );
          }
          (x.fn = x.prototype =
            {
              jquery: C,
              constructor: x,
              length: 0,
              toArray: function () {
                return a.call(this);
              },
              get: function (t) {
                return null == t
                  ? a.call(this)
                  : t < 0
                  ? this[t + this.length]
                  : this[t];
              },
              pushStack: function (t) {
                var e = x.merge(this.constructor(), t);
                return (e.prevObject = this), e;
              },
              each: function (t) {
                return x.each(this, t);
              },
              map: function (t) {
                return this.pushStack(
                  x.map(this, function (e, i) {
                    return t.call(e, i, e);
                  })
                );
              },
              slice: function () {
                return this.pushStack(a.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  x.grep(this, function (t, e) {
                    return (e + 1) % 2;
                  })
                );
              },
              odd: function () {
                return this.pushStack(
                  x.grep(this, function (t, e) {
                    return e % 2;
                  })
                );
              },
              eq: function (t) {
                var e = this.length,
                  i = +t + (t < 0 ? e : 0);
                return this.pushStack(i >= 0 && i < e ? [this[i]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: c,
              sort: o.sort,
              splice: o.splice,
            }),
            (x.extend = x.fn.extend =
              function () {
                var t,
                  e,
                  i,
                  n,
                  s,
                  o,
                  r = arguments[0] || {},
                  a = 1,
                  l = arguments.length,
                  c = !1;
                for (
                  "boolean" == typeof r &&
                    ((c = r), (r = arguments[a] || {}), a++),
                    "object" == typeof r || v(r) || (r = {}),
                    a === l && ((r = this), a--);
                  a < l;
                  a++
                )
                  if (null != (t = arguments[a]))
                    for (e in t)
                      (n = t[e]),
                        "__proto__" !== e &&
                          r !== n &&
                          (c &&
                          n &&
                          (x.isPlainObject(n) || (s = Array.isArray(n)))
                            ? ((i = r[e]),
                              (o =
                                s && !Array.isArray(i)
                                  ? []
                                  : s || x.isPlainObject(i)
                                  ? i
                                  : {}),
                              (s = !1),
                              (r[e] = x.extend(c, o, n)))
                            : void 0 !== n && (r[e] = n));
                return r;
              }),
            x.extend({
              expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
              isReady: !0,
              error: function (t) {
                throw new Error(t);
              },
              noop: function () {},
              isPlainObject: function (t) {
                var e, i;
                return (
                  !(!t || "[object Object]" !== u.call(t)) &&
                  (!(e = r(t)) ||
                    ("function" ==
                      typeof (i = p.call(e, "constructor") && e.constructor) &&
                      f.call(i) === g))
                );
              },
              isEmptyObject: function (t) {
                var e;
                for (e in t) return !1;
                return !0;
              },
              globalEval: function (t, e, i) {
                _(t, { nonce: e && e.nonce }, i);
              },
              each: function (t, e) {
                var i,
                  n = 0;
                if (k(t))
                  for (
                    i = t.length;
                    n < i && !1 !== e.call(t[n], n, t[n]);
                    n++
                  );
                else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
                return t;
              },
              makeArray: function (t, e) {
                var i = e || [];
                return (
                  null != t &&
                    (k(Object(t))
                      ? x.merge(i, "string" == typeof t ? [t] : t)
                      : c.call(i, t)),
                  i
                );
              },
              inArray: function (t, e, i) {
                return null == e ? -1 : h.call(e, t, i);
              },
              merge: function (t, e) {
                for (var i = +e.length, n = 0, s = t.length; n < i; n++)
                  t[s++] = e[n];
                return (t.length = s), t;
              },
              grep: function (t, e, i) {
                for (var n = [], s = 0, o = t.length, r = !i; s < o; s++)
                  !e(t[s], s) !== r && n.push(t[s]);
                return n;
              },
              map: function (t, e, i) {
                var n,
                  s,
                  o = 0,
                  r = [];
                if (k(t))
                  for (n = t.length; o < n; o++)
                    null != (s = e(t[o], o, i)) && r.push(s);
                else for (o in t) null != (s = e(t[o], o, i)) && r.push(s);
                return l(r);
              },
              guid: 1,
              support: m,
            }),
            "function" == typeof Symbol &&
              (x.fn[Symbol.iterator] = o[Symbol.iterator]),
            x.each(
              "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
                " "
              ),
              function (t, e) {
                d["[object " + e + "]"] = e.toLowerCase();
              }
            );
          var E = (function (t) {
            var e,
              i,
              n,
              s,
              o,
              r,
              a,
              l,
              c,
              h,
              d,
              u,
              p,
              f,
              g,
              m,
              v,
              y,
              b,
              w = "sizzle" + 1 * new Date(),
              _ = t.document,
              S = 0,
              C = 0,
              x = lt(),
              k = lt(),
              E = lt(),
              T = lt(),
              A = function (t, e) {
                return t === e && (d = !0), 0;
              },
              L = {}.hasOwnProperty,
              I = [],
              D = I.pop,
              P = I.push,
              $ = I.push,
              M = I.slice,
              O = function (t, e) {
                for (var i = 0, n = t.length; i < n; i++)
                  if (t[i] === e) return i;
                return -1;
              },
              q =
                "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
              F = "[\\x20\\t\\r\\n\\f]",
              B =
                "(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
              N =
                "\\[[\\x20\\t\\r\\n\\f]*(" +
                B +
                ")(?:" +
                F +
                "*([*^$|!~]?=)" +
                F +
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                B +
                "))|)" +
                F +
                "*\\]",
              R =
                ":(" +
                B +
                ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                N +
                ")*)|.*)\\)|)",
              H = new RegExp(F + "+", "g"),
              z = new RegExp(
                "^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$",
                "g"
              ),
              j = new RegExp("^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*"),
              U = new RegExp(
                "^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*"
              ),
              W = new RegExp(F + "|>"),
              V = new RegExp(R),
              G = new RegExp("^" + B + "$"),
              X = {
                ID: new RegExp("^#(" + B + ")"),
                CLASS: new RegExp("^\\.(" + B + ")"),
                TAG: new RegExp("^(" + B + "|[*])"),
                ATTR: new RegExp("^" + N),
                PSEUDO: new RegExp("^" + R),
                CHILD: new RegExp(
                  "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)",
                  "i"
                ),
                bool: new RegExp("^(?:" + q + ")$", "i"),
                needsContext: new RegExp(
                  "^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)",
                  "i"
                ),
              },
              Z = /HTML$/i,
              Q = /^(?:input|select|textarea|button)$/i,
              K = /^h\d$/i,
              Y = /^[^{]+\{\s*\[native \w/,
              J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              tt = /[+~]/,
              et = new RegExp(
                "\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])",
                "g"
              ),
              it = function (t, e) {
                var i = "0x" + t.slice(1) - 65536;
                return (
                  e ||
                  (i < 0
                    ? String.fromCharCode(i + 65536)
                    : String.fromCharCode(
                        (i >> 10) | 55296,
                        (1023 & i) | 56320
                      ))
                );
              },
              nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
              st = function (t, e) {
                return e
                  ? "\0" === t
                    ? "�"
                    : t.slice(0, -1) +
                      "\\" +
                      t.charCodeAt(t.length - 1).toString(16) +
                      " "
                  : "\\" + t;
              },
              ot = function () {
                u();
              },
              rt = wt(
                function (t) {
                  return (
                    !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
                  );
                },
                { dir: "parentNode", next: "legend" }
              );
            try {
              $.apply((I = M.call(_.childNodes)), _.childNodes),
                I[_.childNodes.length].nodeType;
            } catch (t) {
              $ = {
                apply: I.length
                  ? function (t, e) {
                      P.apply(t, M.call(e));
                    }
                  : function (t, e) {
                      for (var i = t.length, n = 0; (t[i++] = e[n++]); );
                      t.length = i - 1;
                    },
              };
            }
            function at(t, e, n, s) {
              var o,
                a,
                c,
                h,
                d,
                f,
                v,
                y = e && e.ownerDocument,
                _ = e ? e.nodeType : 9;
              if (
                ((n = n || []),
                "string" != typeof t || !t || (1 !== _ && 9 !== _ && 11 !== _))
              )
                return n;
              if (!s && (u(e), (e = e || p), g)) {
                if (11 !== _ && (d = J.exec(t)))
                  if ((o = d[1])) {
                    if (9 === _) {
                      if (!(c = e.getElementById(o))) return n;
                      if (c.id === o) return n.push(c), n;
                    } else if (
                      y &&
                      (c = y.getElementById(o)) &&
                      b(e, c) &&
                      c.id === o
                    )
                      return n.push(c), n;
                  } else {
                    if (d[2]) return $.apply(n, e.getElementsByTagName(t)), n;
                    if (
                      (o = d[3]) &&
                      i.getElementsByClassName &&
                      e.getElementsByClassName
                    )
                      return $.apply(n, e.getElementsByClassName(o)), n;
                  }
                if (
                  i.qsa &&
                  !T[t + " "] &&
                  (!m || !m.test(t)) &&
                  (1 !== _ || "object" !== e.nodeName.toLowerCase())
                ) {
                  if (((v = t), (y = e), 1 === _ && (W.test(t) || U.test(t)))) {
                    for (
                      ((y = (tt.test(t) && vt(e.parentNode)) || e) === e &&
                        i.scope) ||
                        ((h = e.getAttribute("id"))
                          ? (h = h.replace(nt, st))
                          : e.setAttribute("id", (h = w))),
                        a = (f = r(t)).length;
                      a--;

                    )
                      f[a] = (h ? "#" + h : ":scope") + " " + bt(f[a]);
                    v = f.join(",");
                  }
                  try {
                    return $.apply(n, y.querySelectorAll(v)), n;
                  } catch (e) {
                    T(t, !0);
                  } finally {
                    h === w && e.removeAttribute("id");
                  }
                }
              }
              return l(t.replace(z, "$1"), e, n, s);
            }
            function lt() {
              var t = [];
              return function e(i, s) {
                return (
                  t.push(i + " ") > n.cacheLength && delete e[t.shift()],
                  (e[i + " "] = s)
                );
              };
            }
            function ct(t) {
              return (t[w] = !0), t;
            }
            function ht(t) {
              var e = p.createElement("fieldset");
              try {
                return !!t(e);
              } catch (t) {
                return !1;
              } finally {
                e.parentNode && e.parentNode.removeChild(e), (e = null);
              }
            }
            function dt(t, e) {
              for (var i = t.split("|"), s = i.length; s--; )
                n.attrHandle[i[s]] = e;
            }
            function ut(t, e) {
              var i = e && t,
                n =
                  i &&
                  1 === t.nodeType &&
                  1 === e.nodeType &&
                  t.sourceIndex - e.sourceIndex;
              if (n) return n;
              if (i) for (; (i = i.nextSibling); ) if (i === e) return -1;
              return t ? 1 : -1;
            }
            function pt(t) {
              return function (e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t;
              };
            }
            function ft(t) {
              return function (e) {
                var i = e.nodeName.toLowerCase();
                return ("input" === i || "button" === i) && e.type === t;
              };
            }
            function gt(t) {
              return function (e) {
                return "form" in e
                  ? e.parentNode && !1 === e.disabled
                    ? "label" in e
                      ? "label" in e.parentNode
                        ? e.parentNode.disabled === t
                        : e.disabled === t
                      : e.isDisabled === t ||
                        (e.isDisabled !== !t && rt(e) === t)
                    : e.disabled === t
                  : "label" in e && e.disabled === t;
              };
            }
            function mt(t) {
              return ct(function (e) {
                return (
                  (e = +e),
                  ct(function (i, n) {
                    for (var s, o = t([], i.length, e), r = o.length; r--; )
                      i[(s = o[r])] && (i[s] = !(n[s] = i[s]));
                  })
                );
              });
            }
            function vt(t) {
              return t && void 0 !== t.getElementsByTagName && t;
            }
            for (e in ((i = at.support = {}),
            (o = at.isXML =
              function (t) {
                var e = t.namespaceURI,
                  i = (t.ownerDocument || t).documentElement;
                return !Z.test(e || (i && i.nodeName) || "HTML");
              }),
            (u = at.setDocument =
              function (t) {
                var e,
                  s,
                  r = t ? t.ownerDocument || t : _;
                return r != p && 9 === r.nodeType && r.documentElement
                  ? ((f = (p = r).documentElement),
                    (g = !o(p)),
                    _ != p &&
                      (s = p.defaultView) &&
                      s.top !== s &&
                      (s.addEventListener
                        ? s.addEventListener("unload", ot, !1)
                        : s.attachEvent && s.attachEvent("onunload", ot)),
                    (i.scope = ht(function (t) {
                      return (
                        f.appendChild(t).appendChild(p.createElement("div")),
                        void 0 !== t.querySelectorAll &&
                          !t.querySelectorAll(":scope fieldset div").length
                      );
                    })),
                    (i.attributes = ht(function (t) {
                      return (t.className = "i"), !t.getAttribute("className");
                    })),
                    (i.getElementsByTagName = ht(function (t) {
                      return (
                        t.appendChild(p.createComment("")),
                        !t.getElementsByTagName("*").length
                      );
                    })),
                    (i.getElementsByClassName = Y.test(
                      p.getElementsByClassName
                    )),
                    (i.getById = ht(function (t) {
                      return (
                        (f.appendChild(t).id = w),
                        !p.getElementsByName || !p.getElementsByName(w).length
                      );
                    })),
                    i.getById
                      ? ((n.filter.ID = function (t) {
                          var e = t.replace(et, it);
                          return function (t) {
                            return t.getAttribute("id") === e;
                          };
                        }),
                        (n.find.ID = function (t, e) {
                          if (void 0 !== e.getElementById && g) {
                            var i = e.getElementById(t);
                            return i ? [i] : [];
                          }
                        }))
                      : ((n.filter.ID = function (t) {
                          var e = t.replace(et, it);
                          return function (t) {
                            var i =
                              void 0 !== t.getAttributeNode &&
                              t.getAttributeNode("id");
                            return i && i.value === e;
                          };
                        }),
                        (n.find.ID = function (t, e) {
                          if (void 0 !== e.getElementById && g) {
                            var i,
                              n,
                              s,
                              o = e.getElementById(t);
                            if (o) {
                              if (
                                (i = o.getAttributeNode("id")) &&
                                i.value === t
                              )
                                return [o];
                              for (
                                s = e.getElementsByName(t), n = 0;
                                (o = s[n++]);

                              )
                                if (
                                  (i = o.getAttributeNode("id")) &&
                                  i.value === t
                                )
                                  return [o];
                            }
                            return [];
                          }
                        })),
                    (n.find.TAG = i.getElementsByTagName
                      ? function (t, e) {
                          return void 0 !== e.getElementsByTagName
                            ? e.getElementsByTagName(t)
                            : i.qsa
                            ? e.querySelectorAll(t)
                            : void 0;
                        }
                      : function (t, e) {
                          var i,
                            n = [],
                            s = 0,
                            o = e.getElementsByTagName(t);
                          if ("*" === t) {
                            for (; (i = o[s++]); )
                              1 === i.nodeType && n.push(i);
                            return n;
                          }
                          return o;
                        }),
                    (n.find.CLASS =
                      i.getElementsByClassName &&
                      function (t, e) {
                        if (void 0 !== e.getElementsByClassName && g)
                          return e.getElementsByClassName(t);
                      }),
                    (v = []),
                    (m = []),
                    (i.qsa = Y.test(p.querySelectorAll)) &&
                      (ht(function (t) {
                        var e;
                        (f.appendChild(t).innerHTML =
                          "<a id='" +
                          w +
                          "'></a><select id='" +
                          w +
                          "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                          t.querySelectorAll("[msallowcapture^='']").length &&
                            m.push("[*^$]=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),
                          t.querySelectorAll("[selected]").length ||
                            m.push(
                              "\\[[\\x20\\t\\r\\n\\f]*(?:value|" + q + ")"
                            ),
                          t.querySelectorAll("[id~=" + w + "-]").length ||
                            m.push("~="),
                          (e = p.createElement("input")).setAttribute(
                            "name",
                            ""
                          ),
                          t.appendChild(e),
                          t.querySelectorAll("[name='']").length ||
                            m.push(
                              "\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"
                            ),
                          t.querySelectorAll(":checked").length ||
                            m.push(":checked"),
                          t.querySelectorAll("a#" + w + "+*").length ||
                            m.push(".#.+[+~]"),
                          t.querySelectorAll("\\\f"),
                          m.push("[\\r\\n\\f]");
                      }),
                      ht(function (t) {
                        t.innerHTML =
                          "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var e = p.createElement("input");
                        e.setAttribute("type", "hidden"),
                          t.appendChild(e).setAttribute("name", "D"),
                          t.querySelectorAll("[name=d]").length &&
                            m.push("name[\\x20\\t\\r\\n\\f]*[*^$|!~]?="),
                          2 !== t.querySelectorAll(":enabled").length &&
                            m.push(":enabled", ":disabled"),
                          (f.appendChild(t).disabled = !0),
                          2 !== t.querySelectorAll(":disabled").length &&
                            m.push(":enabled", ":disabled"),
                          t.querySelectorAll("*,:x"),
                          m.push(",.*:");
                      })),
                    (i.matchesSelector = Y.test(
                      (y =
                        f.matches ||
                        f.webkitMatchesSelector ||
                        f.mozMatchesSelector ||
                        f.oMatchesSelector ||
                        f.msMatchesSelector)
                    )) &&
                      ht(function (t) {
                        (i.disconnectedMatch = y.call(t, "*")),
                          y.call(t, "[s!='']:x"),
                          v.push("!=", R);
                      }),
                    (m = m.length && new RegExp(m.join("|"))),
                    (v = v.length && new RegExp(v.join("|"))),
                    (e = Y.test(f.compareDocumentPosition)),
                    (b =
                      e || Y.test(f.contains)
                        ? function (t, e) {
                            var i = 9 === t.nodeType ? t.documentElement : t,
                              n = e && e.parentNode;
                            return (
                              t === n ||
                              !(
                                !n ||
                                1 !== n.nodeType ||
                                !(i.contains
                                  ? i.contains(n)
                                  : t.compareDocumentPosition &&
                                    16 & t.compareDocumentPosition(n))
                              )
                            );
                          }
                        : function (t, e) {
                            if (e)
                              for (; (e = e.parentNode); )
                                if (e === t) return !0;
                            return !1;
                          }),
                    (A = e
                      ? function (t, e) {
                          if (t === e) return (d = !0), 0;
                          var n =
                            !t.compareDocumentPosition -
                            !e.compareDocumentPosition;
                          return (
                            n ||
                            (1 &
                              (n =
                                (t.ownerDocument || t) == (e.ownerDocument || e)
                                  ? t.compareDocumentPosition(e)
                                  : 1) ||
                            (!i.sortDetached &&
                              e.compareDocumentPosition(t) === n)
                              ? t == p || (t.ownerDocument == _ && b(_, t))
                                ? -1
                                : e == p || (e.ownerDocument == _ && b(_, e))
                                ? 1
                                : h
                                ? O(h, t) - O(h, e)
                                : 0
                              : 4 & n
                              ? -1
                              : 1)
                          );
                        }
                      : function (t, e) {
                          if (t === e) return (d = !0), 0;
                          var i,
                            n = 0,
                            s = t.parentNode,
                            o = e.parentNode,
                            r = [t],
                            a = [e];
                          if (!s || !o)
                            return t == p
                              ? -1
                              : e == p
                              ? 1
                              : s
                              ? -1
                              : o
                              ? 1
                              : h
                              ? O(h, t) - O(h, e)
                              : 0;
                          if (s === o) return ut(t, e);
                          for (i = t; (i = i.parentNode); ) r.unshift(i);
                          for (i = e; (i = i.parentNode); ) a.unshift(i);
                          for (; r[n] === a[n]; ) n++;
                          return n
                            ? ut(r[n], a[n])
                            : r[n] == _
                            ? -1
                            : a[n] == _
                            ? 1
                            : 0;
                        }),
                    p)
                  : p;
              }),
            (at.matches = function (t, e) {
              return at(t, null, null, e);
            }),
            (at.matchesSelector = function (t, e) {
              if (
                (u(t),
                i.matchesSelector &&
                  g &&
                  !T[e + " "] &&
                  (!v || !v.test(e)) &&
                  (!m || !m.test(e)))
              )
                try {
                  var n = y.call(t, e);
                  if (
                    n ||
                    i.disconnectedMatch ||
                    (t.document && 11 !== t.document.nodeType)
                  )
                    return n;
                } catch (t) {
                  T(e, !0);
                }
              return at(e, p, null, [t]).length > 0;
            }),
            (at.contains = function (t, e) {
              return (t.ownerDocument || t) != p && u(t), b(t, e);
            }),
            (at.attr = function (t, e) {
              (t.ownerDocument || t) != p && u(t);
              var s = n.attrHandle[e.toLowerCase()],
                o =
                  s && L.call(n.attrHandle, e.toLowerCase())
                    ? s(t, e, !g)
                    : void 0;
              return void 0 !== o
                ? o
                : i.attributes || !g
                ? t.getAttribute(e)
                : (o = t.getAttributeNode(e)) && o.specified
                ? o.value
                : null;
            }),
            (at.escape = function (t) {
              return (t + "").replace(nt, st);
            }),
            (at.error = function (t) {
              throw new Error("Syntax error, unrecognized expression: " + t);
            }),
            (at.uniqueSort = function (t) {
              var e,
                n = [],
                s = 0,
                o = 0;
              if (
                ((d = !i.detectDuplicates),
                (h = !i.sortStable && t.slice(0)),
                t.sort(A),
                d)
              ) {
                for (; (e = t[o++]); ) e === t[o] && (s = n.push(o));
                for (; s--; ) t.splice(n[s], 1);
              }
              return (h = null), t;
            }),
            (s = at.getText =
              function (t) {
                var e,
                  i = "",
                  n = 0,
                  o = t.nodeType;
                if (o) {
                  if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof t.textContent) return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling) i += s(t);
                  } else if (3 === o || 4 === o) return t.nodeValue;
                } else for (; (e = t[n++]); ) i += s(e);
                return i;
              }),
            (n = at.selectors =
              {
                cacheLength: 50,
                createPseudo: ct,
                match: X,
                attrHandle: {},
                find: {},
                relative: {
                  ">": { dir: "parentNode", first: !0 },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: !0 },
                  "~": { dir: "previousSibling" },
                },
                preFilter: {
                  ATTR: function (t) {
                    return (
                      (t[1] = t[1].replace(et, it)),
                      (t[3] = (t[3] || t[4] || t[5] || "").replace(et, it)),
                      "~=" === t[2] && (t[3] = " " + t[3] + " "),
                      t.slice(0, 4)
                    );
                  },
                  CHILD: function (t) {
                    return (
                      (t[1] = t[1].toLowerCase()),
                      "nth" === t[1].slice(0, 3)
                        ? (t[3] || at.error(t[0]),
                          (t[4] = +(t[4]
                            ? t[5] + (t[6] || 1)
                            : 2 * ("even" === t[3] || "odd" === t[3]))),
                          (t[5] = +(t[7] + t[8] || "odd" === t[3])))
                        : t[3] && at.error(t[0]),
                      t
                    );
                  },
                  PSEUDO: function (t) {
                    var e,
                      i = !t[6] && t[2];
                    return X.CHILD.test(t[0])
                      ? null
                      : (t[3]
                          ? (t[2] = t[4] || t[5] || "")
                          : i &&
                            V.test(i) &&
                            (e = r(i, !0)) &&
                            (e = i.indexOf(")", i.length - e) - i.length) &&
                            ((t[0] = t[0].slice(0, e)), (t[2] = i.slice(0, e))),
                        t.slice(0, 3));
                  },
                },
                filter: {
                  TAG: function (t) {
                    var e = t.replace(et, it).toLowerCase();
                    return "*" === t
                      ? function () {
                          return !0;
                        }
                      : function (t) {
                          return t.nodeName && t.nodeName.toLowerCase() === e;
                        };
                  },
                  CLASS: function (t) {
                    var e = x[t + " "];
                    return (
                      e ||
                      ((e = new RegExp(
                        "(^|[\\x20\\t\\r\\n\\f])" + t + "(" + F + "|$)"
                      )) &&
                        x(t, function (t) {
                          return e.test(
                            ("string" == typeof t.className && t.className) ||
                              (void 0 !== t.getAttribute &&
                                t.getAttribute("class")) ||
                              ""
                          );
                        }))
                    );
                  },
                  ATTR: function (t, e, i) {
                    return function (n) {
                      var s = at.attr(n, t);
                      return null == s
                        ? "!=" === e
                        : !e ||
                            ((s += ""),
                            "=" === e
                              ? s === i
                              : "!=" === e
                              ? s !== i
                              : "^=" === e
                              ? i && 0 === s.indexOf(i)
                              : "*=" === e
                              ? i && s.indexOf(i) > -1
                              : "$=" === e
                              ? i && s.slice(-i.length) === i
                              : "~=" === e
                              ? (" " + s.replace(H, " ") + " ").indexOf(i) > -1
                              : "|=" === e &&
                                (s === i ||
                                  s.slice(0, i.length + 1) === i + "-"));
                    };
                  },
                  CHILD: function (t, e, i, n, s) {
                    var o = "nth" !== t.slice(0, 3),
                      r = "last" !== t.slice(-4),
                      a = "of-type" === e;
                    return 1 === n && 0 === s
                      ? function (t) {
                          return !!t.parentNode;
                        }
                      : function (e, i, l) {
                          var c,
                            h,
                            d,
                            u,
                            p,
                            f,
                            g = o !== r ? "nextSibling" : "previousSibling",
                            m = e.parentNode,
                            v = a && e.nodeName.toLowerCase(),
                            y = !l && !a,
                            b = !1;
                          if (m) {
                            if (o) {
                              for (; g; ) {
                                for (u = e; (u = u[g]); )
                                  if (
                                    a
                                      ? u.nodeName.toLowerCase() === v
                                      : 1 === u.nodeType
                                  )
                                    return !1;
                                f = g = "only" === t && !f && "nextSibling";
                              }
                              return !0;
                            }
                            if (
                              ((f = [r ? m.firstChild : m.lastChild]), r && y)
                            ) {
                              for (
                                b =
                                  (p =
                                    (c =
                                      (h =
                                        (d = (u = m)[w] || (u[w] = {}))[
                                          u.uniqueID
                                        ] || (d[u.uniqueID] = {}))[t] ||
                                      [])[0] === S && c[1]) && c[2],
                                  u = p && m.childNodes[p];
                                (u =
                                  (++p && u && u[g]) || (b = p = 0) || f.pop());

                              )
                                if (1 === u.nodeType && ++b && u === e) {
                                  h[t] = [S, p, b];
                                  break;
                                }
                            } else if (
                              (y &&
                                (b = p =
                                  (c =
                                    (h =
                                      (d = (u = e)[w] || (u[w] = {}))[
                                        u.uniqueID
                                      ] || (d[u.uniqueID] = {}))[t] ||
                                    [])[0] === S && c[1]),
                              !1 === b)
                            )
                              for (
                                ;
                                (u =
                                  (++p && u && u[g]) ||
                                  (b = p = 0) ||
                                  f.pop()) &&
                                ((a
                                  ? u.nodeName.toLowerCase() !== v
                                  : 1 !== u.nodeType) ||
                                  !++b ||
                                  (y &&
                                    ((h =
                                      (d = u[w] || (u[w] = {}))[u.uniqueID] ||
                                      (d[u.uniqueID] = {}))[t] = [S, b]),
                                  u !== e));

                              );
                            return (b -= s) === n || (b % n == 0 && b / n >= 0);
                          }
                        };
                  },
                  PSEUDO: function (t, e) {
                    var i,
                      s =
                        n.pseudos[t] ||
                        n.setFilters[t.toLowerCase()] ||
                        at.error("unsupported pseudo: " + t);
                    return s[w]
                      ? s(e)
                      : s.length > 1
                      ? ((i = [t, t, "", e]),
                        n.setFilters.hasOwnProperty(t.toLowerCase())
                          ? ct(function (t, i) {
                              for (var n, o = s(t, e), r = o.length; r--; )
                                t[(n = O(t, o[r]))] = !(i[n] = o[r]);
                            })
                          : function (t) {
                              return s(t, 0, i);
                            })
                      : s;
                  },
                },
                pseudos: {
                  not: ct(function (t) {
                    var e = [],
                      i = [],
                      n = a(t.replace(z, "$1"));
                    return n[w]
                      ? ct(function (t, e, i, s) {
                          for (
                            var o, r = n(t, null, s, []), a = t.length;
                            a--;

                          )
                            (o = r[a]) && (t[a] = !(e[a] = o));
                        })
                      : function (t, s, o) {
                          return (
                            (e[0] = t),
                            n(e, null, o, i),
                            (e[0] = null),
                            !i.pop()
                          );
                        };
                  }),
                  has: ct(function (t) {
                    return function (e) {
                      return at(t, e).length > 0;
                    };
                  }),
                  contains: ct(function (t) {
                    return (
                      (t = t.replace(et, it)),
                      function (e) {
                        return (e.textContent || s(e)).indexOf(t) > -1;
                      }
                    );
                  }),
                  lang: ct(function (t) {
                    return (
                      G.test(t || "") || at.error("unsupported lang: " + t),
                      (t = t.replace(et, it).toLowerCase()),
                      function (e) {
                        var i;
                        do {
                          if (
                            (i = g
                              ? e.lang
                              : e.getAttribute("xml:lang") ||
                                e.getAttribute("lang"))
                          )
                            return (
                              (i = i.toLowerCase()) === t ||
                              0 === i.indexOf(t + "-")
                            );
                        } while ((e = e.parentNode) && 1 === e.nodeType);
                        return !1;
                      }
                    );
                  }),
                  target: function (e) {
                    var i = t.location && t.location.hash;
                    return i && i.slice(1) === e.id;
                  },
                  root: function (t) {
                    return t === f;
                  },
                  focus: function (t) {
                    return (
                      t === p.activeElement &&
                      (!p.hasFocus || p.hasFocus()) &&
                      !!(t.type || t.href || ~t.tabIndex)
                    );
                  },
                  enabled: gt(!1),
                  disabled: gt(!0),
                  checked: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return (
                      ("input" === e && !!t.checked) ||
                      ("option" === e && !!t.selected)
                    );
                  },
                  selected: function (t) {
                    return (
                      t.parentNode && t.parentNode.selectedIndex,
                      !0 === t.selected
                    );
                  },
                  empty: function (t) {
                    for (t = t.firstChild; t; t = t.nextSibling)
                      if (t.nodeType < 6) return !1;
                    return !0;
                  },
                  parent: function (t) {
                    return !n.pseudos.empty(t);
                  },
                  header: function (t) {
                    return K.test(t.nodeName);
                  },
                  input: function (t) {
                    return Q.test(t.nodeName);
                  },
                  button: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return (
                      ("input" === e && "button" === t.type) || "button" === e
                    );
                  },
                  text: function (t) {
                    var e;
                    return (
                      "input" === t.nodeName.toLowerCase() &&
                      "text" === t.type &&
                      (null == (e = t.getAttribute("type")) ||
                        "text" === e.toLowerCase())
                    );
                  },
                  first: mt(function () {
                    return [0];
                  }),
                  last: mt(function (t, e) {
                    return [e - 1];
                  }),
                  eq: mt(function (t, e, i) {
                    return [i < 0 ? i + e : i];
                  }),
                  even: mt(function (t, e) {
                    for (var i = 0; i < e; i += 2) t.push(i);
                    return t;
                  }),
                  odd: mt(function (t, e) {
                    for (var i = 1; i < e; i += 2) t.push(i);
                    return t;
                  }),
                  lt: mt(function (t, e, i) {
                    for (var n = i < 0 ? i + e : i > e ? e : i; --n >= 0; )
                      t.push(n);
                    return t;
                  }),
                  gt: mt(function (t, e, i) {
                    for (var n = i < 0 ? i + e : i; ++n < e; ) t.push(n);
                    return t;
                  }),
                },
              }),
            (n.pseudos.nth = n.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              n.pseudos[e] = pt(e);
            for (e in { submit: !0, reset: !0 }) n.pseudos[e] = ft(e);
            function yt() {}
            function bt(t) {
              for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
              return n;
            }
            function wt(t, e, i) {
              var n = e.dir,
                s = e.next,
                o = s || n,
                r = i && "parentNode" === o,
                a = C++;
              return e.first
                ? function (e, i, s) {
                    for (; (e = e[n]); )
                      if (1 === e.nodeType || r) return t(e, i, s);
                    return !1;
                  }
                : function (e, i, l) {
                    var c,
                      h,
                      d,
                      u = [S, a];
                    if (l) {
                      for (; (e = e[n]); )
                        if ((1 === e.nodeType || r) && t(e, i, l)) return !0;
                    } else
                      for (; (e = e[n]); )
                        if (1 === e.nodeType || r)
                          if (
                            ((h =
                              (d = e[w] || (e[w] = {}))[e.uniqueID] ||
                              (d[e.uniqueID] = {})),
                            s && s === e.nodeName.toLowerCase())
                          )
                            e = e[n] || e;
                          else {
                            if ((c = h[o]) && c[0] === S && c[1] === a)
                              return (u[2] = c[2]);
                            if (((h[o] = u), (u[2] = t(e, i, l)))) return !0;
                          }
                    return !1;
                  };
            }
            function _t(t) {
              return t.length > 1
                ? function (e, i, n) {
                    for (var s = t.length; s--; ) if (!t[s](e, i, n)) return !1;
                    return !0;
                  }
                : t[0];
            }
            function St(t, e, i, n, s) {
              for (
                var o, r = [], a = 0, l = t.length, c = null != e;
                a < l;
                a++
              )
                (o = t[a]) &&
                  ((i && !i(o, n, s)) || (r.push(o), c && e.push(a)));
              return r;
            }
            function Ct(t, e, i, n, s, o) {
              return (
                n && !n[w] && (n = Ct(n)),
                s && !s[w] && (s = Ct(s, o)),
                ct(function (o, r, a, l) {
                  var c,
                    h,
                    d,
                    u = [],
                    p = [],
                    f = r.length,
                    g =
                      o ||
                      (function (t, e, i) {
                        for (var n = 0, s = e.length; n < s; n++)
                          at(t, e[n], i);
                        return i;
                      })(e || "*", a.nodeType ? [a] : a, []),
                    m = !t || (!o && e) ? g : St(g, u, t, a, l),
                    v = i ? (s || (o ? t : f || n) ? [] : r) : m;
                  if ((i && i(m, v, a, l), n))
                    for (c = St(v, p), n(c, [], a, l), h = c.length; h--; )
                      (d = c[h]) && (v[p[h]] = !(m[p[h]] = d));
                  if (o) {
                    if (s || t) {
                      if (s) {
                        for (c = [], h = v.length; h--; )
                          (d = v[h]) && c.push((m[h] = d));
                        s(null, (v = []), c, l);
                      }
                      for (h = v.length; h--; )
                        (d = v[h]) &&
                          (c = s ? O(o, d) : u[h]) > -1 &&
                          (o[c] = !(r[c] = d));
                    }
                  } else (v = St(v === r ? v.splice(f, v.length) : v)), s ? s(null, r, v, l) : $.apply(r, v);
                })
              );
            }
            function xt(t) {
              for (
                var e,
                  i,
                  s,
                  o = t.length,
                  r = n.relative[t[0].type],
                  a = r || n.relative[" "],
                  l = r ? 1 : 0,
                  h = wt(
                    function (t) {
                      return t === e;
                    },
                    a,
                    !0
                  ),
                  d = wt(
                    function (t) {
                      return O(e, t) > -1;
                    },
                    a,
                    !0
                  ),
                  u = [
                    function (t, i, n) {
                      var s =
                        (!r && (n || i !== c)) ||
                        ((e = i).nodeType ? h(t, i, n) : d(t, i, n));
                      return (e = null), s;
                    },
                  ];
                l < o;
                l++
              )
                if ((i = n.relative[t[l].type])) u = [wt(_t(u), i)];
                else {
                  if ((i = n.filter[t[l].type].apply(null, t[l].matches))[w]) {
                    for (s = ++l; s < o && !n.relative[t[s].type]; s++);
                    return Ct(
                      l > 1 && _t(u),
                      l > 1 &&
                        bt(
                          t
                            .slice(0, l - 1)
                            .concat({ value: " " === t[l - 2].type ? "*" : "" })
                        ).replace(z, "$1"),
                      i,
                      l < s && xt(t.slice(l, s)),
                      s < o && xt((t = t.slice(s))),
                      s < o && bt(t)
                    );
                  }
                  u.push(i);
                }
              return _t(u);
            }
            return (
              (yt.prototype = n.filters = n.pseudos),
              (n.setFilters = new yt()),
              (r = at.tokenize =
                function (t, e) {
                  var i,
                    s,
                    o,
                    r,
                    a,
                    l,
                    c,
                    h = k[t + " "];
                  if (h) return e ? 0 : h.slice(0);
                  for (a = t, l = [], c = n.preFilter; a; ) {
                    for (r in ((i && !(s = j.exec(a))) ||
                      (s && (a = a.slice(s[0].length) || a), l.push((o = []))),
                    (i = !1),
                    (s = U.exec(a)) &&
                      ((i = s.shift()),
                      o.push({ value: i, type: s[0].replace(z, " ") }),
                      (a = a.slice(i.length))),
                    n.filter))
                      !(s = X[r].exec(a)) ||
                        (c[r] && !(s = c[r](s))) ||
                        ((i = s.shift()),
                        o.push({ value: i, type: r, matches: s }),
                        (a = a.slice(i.length)));
                    if (!i) break;
                  }
                  return e ? a.length : a ? at.error(t) : k(t, l).slice(0);
                }),
              (a = at.compile =
                function (t, e) {
                  var i,
                    s = [],
                    o = [],
                    a = E[t + " "];
                  if (!a) {
                    for (e || (e = r(t)), i = e.length; i--; )
                      (a = xt(e[i]))[w] ? s.push(a) : o.push(a);
                    (a = E(
                      t,
                      (function (t, e) {
                        var i = e.length > 0,
                          s = t.length > 0,
                          o = function (o, r, a, l, h) {
                            var d,
                              f,
                              m,
                              v = 0,
                              y = "0",
                              b = o && [],
                              w = [],
                              _ = c,
                              C = o || (s && n.find.TAG("*", h)),
                              x = (S += null == _ ? 1 : Math.random() || 0.1),
                              k = C.length;
                            for (
                              h && (c = r == p || r || h);
                              y !== k && null != (d = C[y]);
                              y++
                            ) {
                              if (s && d) {
                                for (
                                  f = 0,
                                    r ||
                                      d.ownerDocument == p ||
                                      (u(d), (a = !g));
                                  (m = t[f++]);

                                )
                                  if (m(d, r || p, a)) {
                                    l.push(d);
                                    break;
                                  }
                                h && (S = x);
                              }
                              i && ((d = !m && d) && v--, o && b.push(d));
                            }
                            if (((v += y), i && y !== v)) {
                              for (f = 0; (m = e[f++]); ) m(b, w, r, a);
                              if (o) {
                                if (v > 0)
                                  for (; y--; )
                                    b[y] || w[y] || (w[y] = D.call(l));
                                w = St(w);
                              }
                              $.apply(l, w),
                                h &&
                                  !o &&
                                  w.length > 0 &&
                                  v + e.length > 1 &&
                                  at.uniqueSort(l);
                            }
                            return h && ((S = x), (c = _)), b;
                          };
                        return i ? ct(o) : o;
                      })(o, s)
                    )),
                      (a.selector = t);
                  }
                  return a;
                }),
              (l = at.select =
                function (t, e, i, s) {
                  var o,
                    l,
                    c,
                    h,
                    d,
                    u = "function" == typeof t && t,
                    p = !s && r((t = u.selector || t));
                  if (((i = i || []), 1 === p.length)) {
                    if (
                      (l = p[0] = p[0].slice(0)).length > 2 &&
                      "ID" === (c = l[0]).type &&
                      9 === e.nodeType &&
                      g &&
                      n.relative[l[1].type]
                    ) {
                      if (
                        !(e = (n.find.ID(c.matches[0].replace(et, it), e) ||
                          [])[0])
                      )
                        return i;
                      u && (e = e.parentNode),
                        (t = t.slice(l.shift().value.length));
                    }
                    for (
                      o = X.needsContext.test(t) ? 0 : l.length;
                      o-- && ((c = l[o]), !n.relative[(h = c.type)]);

                    )
                      if (
                        (d = n.find[h]) &&
                        (s = d(
                          c.matches[0].replace(et, it),
                          (tt.test(l[0].type) && vt(e.parentNode)) || e
                        ))
                      ) {
                        if ((l.splice(o, 1), !(t = s.length && bt(l))))
                          return $.apply(i, s), i;
                        break;
                      }
                  }
                  return (
                    (u || a(t, p))(
                      s,
                      e,
                      !g,
                      i,
                      !e || (tt.test(t) && vt(e.parentNode)) || e
                    ),
                    i
                  );
                }),
              (i.sortStable = w.split("").sort(A).join("") === w),
              (i.detectDuplicates = !!d),
              u(),
              (i.sortDetached = ht(function (t) {
                return (
                  1 & t.compareDocumentPosition(p.createElement("fieldset"))
                );
              })),
              ht(function (t) {
                return (
                  (t.innerHTML = "<a href='#'></a>"),
                  "#" === t.firstChild.getAttribute("href")
                );
              }) ||
                dt("type|href|height|width", function (t, e, i) {
                  if (!i)
                    return t.getAttribute(
                      e,
                      "type" === e.toLowerCase() ? 1 : 2
                    );
                }),
              (i.attributes &&
                ht(function (t) {
                  return (
                    (t.innerHTML = "<input/>"),
                    t.firstChild.setAttribute("value", ""),
                    "" === t.firstChild.getAttribute("value")
                  );
                })) ||
                dt("value", function (t, e, i) {
                  if (!i && "input" === t.nodeName.toLowerCase())
                    return t.defaultValue;
                }),
              ht(function (t) {
                return null == t.getAttribute("disabled");
              }) ||
                dt(q, function (t, e, i) {
                  var n;
                  if (!i)
                    return !0 === t[e]
                      ? e.toLowerCase()
                      : (n = t.getAttributeNode(e)) && n.specified
                      ? n.value
                      : null;
                }),
              at
            );
          })(n);
          (x.find = E),
            (x.expr = E.selectors),
            (x.expr[":"] = x.expr.pseudos),
            (x.uniqueSort = x.unique = E.uniqueSort),
            (x.text = E.getText),
            (x.isXMLDoc = E.isXML),
            (x.contains = E.contains),
            (x.escapeSelector = E.escape);
          var T = function (t, e, i) {
              for (
                var n = [], s = void 0 !== i;
                (t = t[e]) && 9 !== t.nodeType;

              )
                if (1 === t.nodeType) {
                  if (s && x(t).is(i)) break;
                  n.push(t);
                }
              return n;
            },
            A = function (t, e) {
              for (var i = []; t; t = t.nextSibling)
                1 === t.nodeType && t !== e && i.push(t);
              return i;
            },
            L = x.expr.match.needsContext;
          function I(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
          }
          var D =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function P(t, e, i) {
            return v(e)
              ? x.grep(t, function (t, n) {
                  return !!e.call(t, n, t) !== i;
                })
              : e.nodeType
              ? x.grep(t, function (t) {
                  return (t === e) !== i;
                })
              : "string" != typeof e
              ? x.grep(t, function (t) {
                  return h.call(e, t) > -1 !== i;
                })
              : x.filter(e, t, i);
          }
          (x.filter = function (t, e, i) {
            var n = e[0];
            return (
              i && (t = ":not(" + t + ")"),
              1 === e.length && 1 === n.nodeType
                ? x.find.matchesSelector(n, t)
                  ? [n]
                  : []
                : x.find.matches(
                    t,
                    x.grep(e, function (t) {
                      return 1 === t.nodeType;
                    })
                  )
            );
          }),
            x.fn.extend({
              find: function (t) {
                var e,
                  i,
                  n = this.length,
                  s = this;
                if ("string" != typeof t)
                  return this.pushStack(
                    x(t).filter(function () {
                      for (e = 0; e < n; e++)
                        if (x.contains(s[e], this)) return !0;
                    })
                  );
                for (i = this.pushStack([]), e = 0; e < n; e++)
                  x.find(t, s[e], i);
                return n > 1 ? x.uniqueSort(i) : i;
              },
              filter: function (t) {
                return this.pushStack(P(this, t || [], !1));
              },
              not: function (t) {
                return this.pushStack(P(this, t || [], !0));
              },
              is: function (t) {
                return !!P(
                  this,
                  "string" == typeof t && L.test(t) ? x(t) : t || [],
                  !1
                ).length;
              },
            });
          var $,
            M = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((x.fn.init = function (t, e, i) {
            var n, s;
            if (!t) return this;
            if (((i = i || $), "string" == typeof t)) {
              if (
                !(n =
                  "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3
                    ? [null, t, null]
                    : M.exec(t)) ||
                (!n[1] && e)
              )
                return !e || e.jquery
                  ? (e || i).find(t)
                  : this.constructor(e).find(t);
              if (n[1]) {
                if (
                  ((e = e instanceof x ? e[0] : e),
                  x.merge(
                    this,
                    x.parseHTML(
                      n[1],
                      e && e.nodeType ? e.ownerDocument || e : b,
                      !0
                    )
                  ),
                  D.test(n[1]) && x.isPlainObject(e))
                )
                  for (n in e) v(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this;
              }
              return (
                (s = b.getElementById(n[2])) &&
                  ((this[0] = s), (this.length = 1)),
                this
              );
            }
            return t.nodeType
              ? ((this[0] = t), (this.length = 1), this)
              : v(t)
              ? void 0 !== i.ready
                ? i.ready(t)
                : t(x)
              : x.makeArray(t, this);
          }).prototype = x.fn),
            ($ = x(b));
          var O = /^(?:parents|prev(?:Until|All))/,
            q = { children: !0, contents: !0, next: !0, prev: !0 };
          function F(t, e) {
            for (; (t = t[e]) && 1 !== t.nodeType; );
            return t;
          }
          x.fn.extend({
            has: function (t) {
              var e = x(t, this),
                i = e.length;
              return this.filter(function () {
                for (var t = 0; t < i; t++)
                  if (x.contains(this, e[t])) return !0;
              });
            },
            closest: function (t, e) {
              var i,
                n = 0,
                s = this.length,
                o = [],
                r = "string" != typeof t && x(t);
              if (!L.test(t))
                for (; n < s; n++)
                  for (i = this[n]; i && i !== e; i = i.parentNode)
                    if (
                      i.nodeType < 11 &&
                      (r
                        ? r.index(i) > -1
                        : 1 === i.nodeType && x.find.matchesSelector(i, t))
                    ) {
                      o.push(i);
                      break;
                    }
              return this.pushStack(o.length > 1 ? x.uniqueSort(o) : o);
            },
            index: function (t) {
              return t
                ? "string" == typeof t
                  ? h.call(x(t), this[0])
                  : h.call(this, t.jquery ? t[0] : t)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (t, e) {
              return this.pushStack(x.uniqueSort(x.merge(this.get(), x(t, e))));
            },
            addBack: function (t) {
              return this.add(
                null == t ? this.prevObject : this.prevObject.filter(t)
              );
            },
          }),
            x.each(
              {
                parent: function (t) {
                  var e = t.parentNode;
                  return e && 11 !== e.nodeType ? e : null;
                },
                parents: function (t) {
                  return T(t, "parentNode");
                },
                parentsUntil: function (t, e, i) {
                  return T(t, "parentNode", i);
                },
                next: function (t) {
                  return F(t, "nextSibling");
                },
                prev: function (t) {
                  return F(t, "previousSibling");
                },
                nextAll: function (t) {
                  return T(t, "nextSibling");
                },
                prevAll: function (t) {
                  return T(t, "previousSibling");
                },
                nextUntil: function (t, e, i) {
                  return T(t, "nextSibling", i);
                },
                prevUntil: function (t, e, i) {
                  return T(t, "previousSibling", i);
                },
                siblings: function (t) {
                  return A((t.parentNode || {}).firstChild, t);
                },
                children: function (t) {
                  return A(t.firstChild);
                },
                contents: function (t) {
                  return null != t.contentDocument && r(t.contentDocument)
                    ? t.contentDocument
                    : (I(t, "template") && (t = t.content || t),
                      x.merge([], t.childNodes));
                },
              },
              function (t, e) {
                x.fn[t] = function (i, n) {
                  var s = x.map(this, e, i);
                  return (
                    "Until" !== t.slice(-5) && (n = i),
                    n && "string" == typeof n && (s = x.filter(n, s)),
                    this.length > 1 &&
                      (q[t] || x.uniqueSort(s), O.test(t) && s.reverse()),
                    this.pushStack(s)
                  );
                };
              }
            );
          var B = /[^\x20\t\r\n\f]+/g;
          function N(t) {
            return t;
          }
          function R(t) {
            throw t;
          }
          function H(t, e, i, n) {
            var s;
            try {
              t && v((s = t.promise))
                ? s.call(t).done(e).fail(i)
                : t && v((s = t.then))
                ? s.call(t, e, i)
                : e.apply(void 0, [t].slice(n));
            } catch (t) {
              i.apply(void 0, [t]);
            }
          }
          (x.Callbacks = function (t) {
            t =
              "string" == typeof t
                ? (function (t) {
                    var e = {};
                    return (
                      x.each(t.match(B) || [], function (t, i) {
                        e[i] = !0;
                      }),
                      e
                    );
                  })(t)
                : x.extend({}, t);
            var e,
              i,
              n,
              s,
              o = [],
              r = [],
              a = -1,
              l = function () {
                for (s = s || t.once, n = e = !0; r.length; a = -1)
                  for (i = r.shift(); ++a < o.length; )
                    !1 === o[a].apply(i[0], i[1]) &&
                      t.stopOnFalse &&
                      ((a = o.length), (i = !1));
                t.memory || (i = !1), (e = !1), s && (o = i ? [] : "");
              },
              c = {
                add: function () {
                  return (
                    o &&
                      (i && !e && ((a = o.length - 1), r.push(i)),
                      (function e(i) {
                        x.each(i, function (i, n) {
                          v(n)
                            ? (t.unique && c.has(n)) || o.push(n)
                            : n && n.length && "string" !== S(n) && e(n);
                        });
                      })(arguments),
                      i && !e && l()),
                    this
                  );
                },
                remove: function () {
                  return (
                    x.each(arguments, function (t, e) {
                      for (var i; (i = x.inArray(e, o, i)) > -1; )
                        o.splice(i, 1), i <= a && a--;
                    }),
                    this
                  );
                },
                has: function (t) {
                  return t ? x.inArray(t, o) > -1 : o.length > 0;
                },
                empty: function () {
                  return o && (o = []), this;
                },
                disable: function () {
                  return (s = r = []), (o = i = ""), this;
                },
                disabled: function () {
                  return !o;
                },
                lock: function () {
                  return (s = r = []), i || e || (o = i = ""), this;
                },
                locked: function () {
                  return !!s;
                },
                fireWith: function (t, i) {
                  return (
                    s ||
                      ((i = [t, (i = i || []).slice ? i.slice() : i]),
                      r.push(i),
                      e || l()),
                    this
                  );
                },
                fire: function () {
                  return c.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!n;
                },
              };
            return c;
          }),
            x.extend({
              Deferred: function (t) {
                var e = [
                    [
                      "notify",
                      "progress",
                      x.Callbacks("memory"),
                      x.Callbacks("memory"),
                      2,
                    ],
                    [
                      "resolve",
                      "done",
                      x.Callbacks("once memory"),
                      x.Callbacks("once memory"),
                      0,
                      "resolved",
                    ],
                    [
                      "reject",
                      "fail",
                      x.Callbacks("once memory"),
                      x.Callbacks("once memory"),
                      1,
                      "rejected",
                    ],
                  ],
                  i = "pending",
                  s = {
                    state: function () {
                      return i;
                    },
                    always: function () {
                      return o.done(arguments).fail(arguments), this;
                    },
                    catch: function (t) {
                      return s.then(null, t);
                    },
                    pipe: function () {
                      var t = arguments;
                      return x
                        .Deferred(function (i) {
                          x.each(e, function (e, n) {
                            var s = v(t[n[4]]) && t[n[4]];
                            o[n[1]](function () {
                              var t = s && s.apply(this, arguments);
                              t && v(t.promise)
                                ? t
                                    .promise()
                                    .progress(i.notify)
                                    .done(i.resolve)
                                    .fail(i.reject)
                                : i[n[0] + "With"](this, s ? [t] : arguments);
                            });
                          }),
                            (t = null);
                        })
                        .promise();
                    },
                    then: function (t, i, s) {
                      var o = 0;
                      function r(t, e, i, s) {
                        return function () {
                          var a = this,
                            l = arguments,
                            c = function () {
                              var n, c;
                              if (!(t < o)) {
                                if ((n = i.apply(a, l)) === e.promise())
                                  throw new TypeError(
                                    "Thenable self-resolution"
                                  );
                                (c =
                                  n &&
                                  ("object" == typeof n ||
                                    "function" == typeof n) &&
                                  n.then),
                                  v(c)
                                    ? s
                                      ? c.call(n, r(o, e, N, s), r(o, e, R, s))
                                      : (o++,
                                        c.call(
                                          n,
                                          r(o, e, N, s),
                                          r(o, e, R, s),
                                          r(o, e, N, e.notifyWith)
                                        ))
                                    : (i !== N && ((a = void 0), (l = [n])),
                                      (s || e.resolveWith)(a, l));
                              }
                            },
                            h = s
                              ? c
                              : function () {
                                  try {
                                    c();
                                  } catch (n) {
                                    x.Deferred.exceptionHook &&
                                      x.Deferred.exceptionHook(n, h.stackTrace),
                                      t + 1 >= o &&
                                        (i !== R && ((a = void 0), (l = [n])),
                                        e.rejectWith(a, l));
                                  }
                                };
                          t
                            ? h()
                            : (x.Deferred.getStackHook &&
                                (h.stackTrace = x.Deferred.getStackHook()),
                              n.setTimeout(h));
                        };
                      }
                      return x
                        .Deferred(function (n) {
                          e[0][3].add(r(0, n, v(s) ? s : N, n.notifyWith)),
                            e[1][3].add(r(0, n, v(t) ? t : N)),
                            e[2][3].add(r(0, n, v(i) ? i : R));
                        })
                        .promise();
                    },
                    promise: function (t) {
                      return null != t ? x.extend(t, s) : s;
                    },
                  },
                  o = {};
                return (
                  x.each(e, function (t, n) {
                    var r = n[2],
                      a = n[5];
                    (s[n[1]] = r.add),
                      a &&
                        r.add(
                          function () {
                            i = a;
                          },
                          e[3 - t][2].disable,
                          e[3 - t][3].disable,
                          e[0][2].lock,
                          e[0][3].lock
                        ),
                      r.add(n[3].fire),
                      (o[n[0]] = function () {
                        return (
                          o[n[0] + "With"](
                            this === o ? void 0 : this,
                            arguments
                          ),
                          this
                        );
                      }),
                      (o[n[0] + "With"] = r.fireWith);
                  }),
                  s.promise(o),
                  t && t.call(o, o),
                  o
                );
              },
              when: function (t) {
                var e = arguments.length,
                  i = e,
                  n = Array(i),
                  s = a.call(arguments),
                  o = x.Deferred(),
                  r = function (t) {
                    return function (i) {
                      (n[t] = this),
                        (s[t] = arguments.length > 1 ? a.call(arguments) : i),
                        --e || o.resolveWith(n, s);
                    };
                  };
                if (
                  e <= 1 &&
                  (H(t, o.done(r(i)).resolve, o.reject, !e),
                  "pending" === o.state() || v(s[i] && s[i].then))
                )
                  return o.then();
                for (; i--; ) H(s[i], r(i), o.reject);
                return o.promise();
              },
            });
          var z = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (x.Deferred.exceptionHook = function (t, e) {
            n.console &&
              n.console.warn &&
              t &&
              z.test(t.name) &&
              n.console.warn(
                "jQuery.Deferred exception: " + t.message,
                t.stack,
                e
              );
          }),
            (x.readyException = function (t) {
              n.setTimeout(function () {
                throw t;
              });
            });
          var j = x.Deferred();
          function U() {
            b.removeEventListener("DOMContentLoaded", U),
              n.removeEventListener("load", U),
              x.ready();
          }
          (x.fn.ready = function (t) {
            return (
              j.then(t).catch(function (t) {
                x.readyException(t);
              }),
              this
            );
          }),
            x.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (t) {
                (!0 === t ? --x.readyWait : x.isReady) ||
                  ((x.isReady = !0),
                  (!0 !== t && --x.readyWait > 0) || j.resolveWith(b, [x]));
              },
            }),
            (x.ready.then = j.then),
            "complete" === b.readyState ||
            ("loading" !== b.readyState && !b.documentElement.doScroll)
              ? n.setTimeout(x.ready)
              : (b.addEventListener("DOMContentLoaded", U),
                n.addEventListener("load", U));
          var W = function (t, e, i, n, s, o, r) {
              var a = 0,
                l = t.length,
                c = null == i;
              if ("object" === S(i))
                for (a in ((s = !0), i)) W(t, e, a, i[a], !0, o, r);
              else if (
                void 0 !== n &&
                ((s = !0),
                v(n) || (r = !0),
                c &&
                  (r
                    ? (e.call(t, n), (e = null))
                    : ((c = e),
                      (e = function (t, e, i) {
                        return c.call(x(t), i);
                      }))),
                e)
              )
                for (; a < l; a++)
                  e(t[a], i, r ? n : n.call(t[a], a, e(t[a], i)));
              return s ? t : c ? e.call(t) : l ? e(t[0], i) : o;
            },
            V = /^-ms-/,
            G = /-([a-z])/g;
          function X(t, e) {
            return e.toUpperCase();
          }
          function Z(t) {
            return t.replace(V, "ms-").replace(G, X);
          }
          var Q = function (t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
          };
          function K() {
            this.expando = x.expando + K.uid++;
          }
          (K.uid = 1),
            (K.prototype = {
              cache: function (t) {
                var e = t[this.expando];
                return (
                  e ||
                    ((e = {}),
                    Q(t) &&
                      (t.nodeType
                        ? (t[this.expando] = e)
                        : Object.defineProperty(t, this.expando, {
                            value: e,
                            configurable: !0,
                          }))),
                  e
                );
              },
              set: function (t, e, i) {
                var n,
                  s = this.cache(t);
                if ("string" == typeof e) s[Z(e)] = i;
                else for (n in e) s[Z(n)] = e[n];
                return s;
              },
              get: function (t, e) {
                return void 0 === e
                  ? this.cache(t)
                  : t[this.expando] && t[this.expando][Z(e)];
              },
              access: function (t, e, i) {
                return void 0 === e ||
                  (e && "string" == typeof e && void 0 === i)
                  ? this.get(t, e)
                  : (this.set(t, e, i), void 0 !== i ? i : e);
              },
              remove: function (t, e) {
                var i,
                  n = t[this.expando];
                if (void 0 !== n) {
                  if (void 0 !== e) {
                    i = (e = Array.isArray(e)
                      ? e.map(Z)
                      : (e = Z(e)) in n
                      ? [e]
                      : e.match(B) || []).length;
                    for (; i--; ) delete n[e[i]];
                  }
                  (void 0 === e || x.isEmptyObject(n)) &&
                    (t.nodeType
                      ? (t[this.expando] = void 0)
                      : delete t[this.expando]);
                }
              },
              hasData: function (t) {
                var e = t[this.expando];
                return void 0 !== e && !x.isEmptyObject(e);
              },
            });
          var Y = new K(),
            J = new K(),
            tt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            et = /[A-Z]/g;
          function it(t, e, i) {
            var n;
            if (void 0 === i && 1 === t.nodeType)
              if (
                ((n = "data-" + e.replace(et, "-$&").toLowerCase()),
                "string" == typeof (i = t.getAttribute(n)))
              ) {
                try {
                  i = (function (t) {
                    return (
                      "true" === t ||
                      ("false" !== t &&
                        ("null" === t
                          ? null
                          : t === +t + ""
                          ? +t
                          : tt.test(t)
                          ? JSON.parse(t)
                          : t))
                    );
                  })(i);
                } catch (t) {}
                J.set(t, e, i);
              } else i = void 0;
            return i;
          }
          x.extend({
            hasData: function (t) {
              return J.hasData(t) || Y.hasData(t);
            },
            data: function (t, e, i) {
              return J.access(t, e, i);
            },
            removeData: function (t, e) {
              J.remove(t, e);
            },
            _data: function (t, e, i) {
              return Y.access(t, e, i);
            },
            _removeData: function (t, e) {
              Y.remove(t, e);
            },
          }),
            x.fn.extend({
              data: function (t, e) {
                var i,
                  n,
                  s,
                  o = this[0],
                  r = o && o.attributes;
                if (void 0 === t) {
                  if (
                    this.length &&
                    ((s = J.get(o)),
                    1 === o.nodeType && !Y.get(o, "hasDataAttrs"))
                  ) {
                    for (i = r.length; i--; )
                      r[i] &&
                        0 === (n = r[i].name).indexOf("data-") &&
                        ((n = Z(n.slice(5))), it(o, n, s[n]));
                    Y.set(o, "hasDataAttrs", !0);
                  }
                  return s;
                }
                return "object" == typeof t
                  ? this.each(function () {
                      J.set(this, t);
                    })
                  : W(
                      this,
                      function (e) {
                        var i;
                        if (o && void 0 === e)
                          return void 0 !== (i = J.get(o, t)) ||
                            void 0 !== (i = it(o, t))
                            ? i
                            : void 0;
                        this.each(function () {
                          J.set(this, t, e);
                        });
                      },
                      null,
                      e,
                      arguments.length > 1,
                      null,
                      !0
                    );
              },
              removeData: function (t) {
                return this.each(function () {
                  J.remove(this, t);
                });
              },
            }),
            x.extend({
              queue: function (t, e, i) {
                var n;
                if (t)
                  return (
                    (e = (e || "fx") + "queue"),
                    (n = Y.get(t, e)),
                    i &&
                      (!n || Array.isArray(i)
                        ? (n = Y.access(t, e, x.makeArray(i)))
                        : n.push(i)),
                    n || []
                  );
              },
              dequeue: function (t, e) {
                e = e || "fx";
                var i = x.queue(t, e),
                  n = i.length,
                  s = i.shift(),
                  o = x._queueHooks(t, e);
                "inprogress" === s && ((s = i.shift()), n--),
                  s &&
                    ("fx" === e && i.unshift("inprogress"),
                    delete o.stop,
                    s.call(
                      t,
                      function () {
                        x.dequeue(t, e);
                      },
                      o
                    )),
                  !n && o && o.empty.fire();
              },
              _queueHooks: function (t, e) {
                var i = e + "queueHooks";
                return (
                  Y.get(t, i) ||
                  Y.access(t, i, {
                    empty: x.Callbacks("once memory").add(function () {
                      Y.remove(t, [e + "queue", i]);
                    }),
                  })
                );
              },
            }),
            x.fn.extend({
              queue: function (t, e) {
                var i = 2;
                return (
                  "string" != typeof t && ((e = t), (t = "fx"), i--),
                  arguments.length < i
                    ? x.queue(this[0], t)
                    : void 0 === e
                    ? this
                    : this.each(function () {
                        var i = x.queue(this, t, e);
                        x._queueHooks(this, t),
                          "fx" === t &&
                            "inprogress" !== i[0] &&
                            x.dequeue(this, t);
                      })
                );
              },
              dequeue: function (t) {
                return this.each(function () {
                  x.dequeue(this, t);
                });
              },
              clearQueue: function (t) {
                return this.queue(t || "fx", []);
              },
              promise: function (t, e) {
                var i,
                  n = 1,
                  s = x.Deferred(),
                  o = this,
                  r = this.length,
                  a = function () {
                    --n || s.resolveWith(o, [o]);
                  };
                for (
                  "string" != typeof t && ((e = t), (t = void 0)),
                    t = t || "fx";
                  r--;

                )
                  (i = Y.get(o[r], t + "queueHooks")) &&
                    i.empty &&
                    (n++, i.empty.add(a));
                return a(), s.promise(e);
              },
            });
          var nt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            st = new RegExp("^(?:([+-])=|)(" + nt + ")([a-z%]*)$", "i"),
            ot = ["Top", "Right", "Bottom", "Left"],
            rt = b.documentElement,
            at = function (t) {
              return x.contains(t.ownerDocument, t);
            },
            lt = { composed: !0 };
          rt.getRootNode &&
            (at = function (t) {
              return (
                x.contains(t.ownerDocument, t) ||
                t.getRootNode(lt) === t.ownerDocument
              );
            });
          var ct = function (t, e) {
            return (
              "none" === (t = e || t).style.display ||
              ("" === t.style.display &&
                at(t) &&
                "none" === x.css(t, "display"))
            );
          };
          function ht(t, e, i, n) {
            var s,
              o,
              r = 20,
              a = n
                ? function () {
                    return n.cur();
                  }
                : function () {
                    return x.css(t, e, "");
                  },
              l = a(),
              c = (i && i[3]) || (x.cssNumber[e] ? "" : "px"),
              h =
                t.nodeType &&
                (x.cssNumber[e] || ("px" !== c && +l)) &&
                st.exec(x.css(t, e));
            if (h && h[3] !== c) {
              for (l /= 2, c = c || h[3], h = +l || 1; r--; )
                x.style(t, e, h + c),
                  (1 - o) * (1 - (o = a() / l || 0.5)) <= 0 && (r = 0),
                  (h /= o);
              (h *= 2), x.style(t, e, h + c), (i = i || []);
            }
            return (
              i &&
                ((h = +h || +l || 0),
                (s = i[1] ? h + (i[1] + 1) * i[2] : +i[2]),
                n && ((n.unit = c), (n.start = h), (n.end = s))),
              s
            );
          }
          var dt = {};
          function ut(t) {
            var e,
              i = t.ownerDocument,
              n = t.nodeName,
              s = dt[n];
            return (
              s ||
              ((e = i.body.appendChild(i.createElement(n))),
              (s = x.css(e, "display")),
              e.parentNode.removeChild(e),
              "none" === s && (s = "block"),
              (dt[n] = s),
              s)
            );
          }
          function pt(t, e) {
            for (var i, n, s = [], o = 0, r = t.length; o < r; o++)
              (n = t[o]).style &&
                ((i = n.style.display),
                e
                  ? ("none" === i &&
                      ((s[o] = Y.get(n, "display") || null),
                      s[o] || (n.style.display = "")),
                    "" === n.style.display && ct(n) && (s[o] = ut(n)))
                  : "none" !== i && ((s[o] = "none"), Y.set(n, "display", i)));
            for (o = 0; o < r; o++) null != s[o] && (t[o].style.display = s[o]);
            return t;
          }
          x.fn.extend({
            show: function () {
              return pt(this, !0);
            },
            hide: function () {
              return pt(this);
            },
            toggle: function (t) {
              return "boolean" == typeof t
                ? t
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ct(this) ? x(this).show() : x(this).hide();
                  });
            },
          });
          var ft,
            gt,
            mt = /^(?:checkbox|radio)$/i,
            vt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            yt = /^$|^module$|\/(?:java|ecma)script/i;
          (ft = b.createDocumentFragment().appendChild(b.createElement("div"))),
            (gt = b.createElement("input")).setAttribute("type", "radio"),
            gt.setAttribute("checked", "checked"),
            gt.setAttribute("name", "t"),
            ft.appendChild(gt),
            (m.checkClone = ft.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (ft.innerHTML = "<textarea>x</textarea>"),
            (m.noCloneChecked = !!ft.cloneNode(!0).lastChild.defaultValue),
            (ft.innerHTML = "<option></option>"),
            (m.option = !!ft.lastChild);
          var bt = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
          };
          function wt(t, e) {
            var i;
            return (
              (i =
                void 0 !== t.getElementsByTagName
                  ? t.getElementsByTagName(e || "*")
                  : void 0 !== t.querySelectorAll
                  ? t.querySelectorAll(e || "*")
                  : []),
              void 0 === e || (e && I(t, e)) ? x.merge([t], i) : i
            );
          }
          function _t(t, e) {
            for (var i = 0, n = t.length; i < n; i++)
              Y.set(t[i], "globalEval", !e || Y.get(e[i], "globalEval"));
          }
          (bt.tbody = bt.tfoot = bt.colgroup = bt.caption = bt.thead),
            (bt.th = bt.td),
            m.option ||
              (bt.optgroup = bt.option =
                [1, "<select multiple='multiple'>", "</select>"]);
          var St = /<|&#?\w+;/;
          function Ct(t, e, i, n, s) {
            for (
              var o,
                r,
                a,
                l,
                c,
                h,
                d = e.createDocumentFragment(),
                u = [],
                p = 0,
                f = t.length;
              p < f;
              p++
            )
              if ((o = t[p]) || 0 === o)
                if ("object" === S(o)) x.merge(u, o.nodeType ? [o] : o);
                else if (St.test(o)) {
                  for (
                    r = r || d.appendChild(e.createElement("div")),
                      a = (vt.exec(o) || ["", ""])[1].toLowerCase(),
                      l = bt[a] || bt._default,
                      r.innerHTML = l[1] + x.htmlPrefilter(o) + l[2],
                      h = l[0];
                    h--;

                  )
                    r = r.lastChild;
                  x.merge(u, r.childNodes),
                    ((r = d.firstChild).textContent = "");
                } else u.push(e.createTextNode(o));
            for (d.textContent = "", p = 0; (o = u[p++]); )
              if (n && x.inArray(o, n) > -1) s && s.push(o);
              else if (
                ((c = at(o)),
                (r = wt(d.appendChild(o), "script")),
                c && _t(r),
                i)
              )
                for (h = 0; (o = r[h++]); ) yt.test(o.type || "") && i.push(o);
            return d;
          }
          var xt = /^key/,
            kt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            Et = /^([^.]*)(?:\.(.+)|)/;
          function Tt() {
            return !0;
          }
          function At() {
            return !1;
          }
          function Lt(t, e) {
            return (
              (t ===
                (function () {
                  try {
                    return b.activeElement;
                  } catch (t) {}
                })()) ==
              ("focus" === e)
            );
          }
          function It(t, e, i, n, s, o) {
            var r, a;
            if ("object" == typeof e) {
              for (a in ("string" != typeof i && ((n = n || i), (i = void 0)),
              e))
                It(t, a, i, n, e[a], o);
              return t;
            }
            if (
              (null == n && null == s
                ? ((s = i), (n = i = void 0))
                : null == s &&
                  ("string" == typeof i
                    ? ((s = n), (n = void 0))
                    : ((s = n), (n = i), (i = void 0))),
              !1 === s)
            )
              s = At;
            else if (!s) return t;
            return (
              1 === o &&
                ((r = s),
                (s = function (t) {
                  return x().off(t), r.apply(this, arguments);
                }),
                (s.guid = r.guid || (r.guid = x.guid++))),
              t.each(function () {
                x.event.add(this, e, s, n, i);
              })
            );
          }
          function Dt(t, e, i) {
            i
              ? (Y.set(t, e, !1),
                x.event.add(t, e, {
                  namespace: !1,
                  handler: function (t) {
                    var n,
                      s,
                      o = Y.get(this, e);
                    if (1 & t.isTrigger && this[e]) {
                      if (o.length)
                        (x.event.special[e] || {}).delegateType &&
                          t.stopPropagation();
                      else if (
                        ((o = a.call(arguments)),
                        Y.set(this, e, o),
                        (n = i(this, e)),
                        this[e](),
                        o !== (s = Y.get(this, e)) || n
                          ? Y.set(this, e, !1)
                          : (s = {}),
                        o !== s)
                      )
                        return (
                          t.stopImmediatePropagation(),
                          t.preventDefault(),
                          s.value
                        );
                    } else
                      o.length &&
                        (Y.set(this, e, {
                          value: x.event.trigger(
                            x.extend(o[0], x.Event.prototype),
                            o.slice(1),
                            this
                          ),
                        }),
                        t.stopImmediatePropagation());
                  },
                }))
              : void 0 === Y.get(t, e) && x.event.add(t, e, Tt);
          }
          (x.event = {
            global: {},
            add: function (t, e, i, n, s) {
              var o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                p,
                f,
                g,
                m = Y.get(t);
              if (Q(t))
                for (
                  i.handler && ((i = (o = i).handler), (s = o.selector)),
                    s && x.find.matchesSelector(rt, s),
                    i.guid || (i.guid = x.guid++),
                    (l = m.events) || (l = m.events = Object.create(null)),
                    (r = m.handle) ||
                      (r = m.handle =
                        function (e) {
                          return void 0 !== x && x.event.triggered !== e.type
                            ? x.event.dispatch.apply(t, arguments)
                            : void 0;
                        }),
                    c = (e = (e || "").match(B) || [""]).length;
                  c--;

                )
                  (p = g = (a = Et.exec(e[c]) || [])[1]),
                    (f = (a[2] || "").split(".").sort()),
                    p &&
                      ((d = x.event.special[p] || {}),
                      (p = (s ? d.delegateType : d.bindType) || p),
                      (d = x.event.special[p] || {}),
                      (h = x.extend(
                        {
                          type: p,
                          origType: g,
                          data: n,
                          handler: i,
                          guid: i.guid,
                          selector: s,
                          needsContext: s && x.expr.match.needsContext.test(s),
                          namespace: f.join("."),
                        },
                        o
                      )),
                      (u = l[p]) ||
                        (((u = l[p] = []).delegateCount = 0),
                        (d.setup && !1 !== d.setup.call(t, n, f, r)) ||
                          (t.addEventListener && t.addEventListener(p, r))),
                      d.add &&
                        (d.add.call(t, h),
                        h.handler.guid || (h.handler.guid = i.guid)),
                      s ? u.splice(u.delegateCount++, 0, h) : u.push(h),
                      (x.event.global[p] = !0));
            },
            remove: function (t, e, i, n, s) {
              var o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                p,
                f,
                g,
                m = Y.hasData(t) && Y.get(t);
              if (m && (l = m.events)) {
                for (c = (e = (e || "").match(B) || [""]).length; c--; )
                  if (
                    ((p = g = (a = Et.exec(e[c]) || [])[1]),
                    (f = (a[2] || "").split(".").sort()),
                    p)
                  ) {
                    for (
                      d = x.event.special[p] || {},
                        u =
                          l[(p = (n ? d.delegateType : d.bindType) || p)] || [],
                        a =
                          a[2] &&
                          new RegExp(
                            "(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"
                          ),
                        r = o = u.length;
                      o--;

                    )
                      (h = u[o]),
                        (!s && g !== h.origType) ||
                          (i && i.guid !== h.guid) ||
                          (a && !a.test(h.namespace)) ||
                          (n &&
                            n !== h.selector &&
                            ("**" !== n || !h.selector)) ||
                          (u.splice(o, 1),
                          h.selector && u.delegateCount--,
                          d.remove && d.remove.call(t, h));
                    r &&
                      !u.length &&
                      ((d.teardown && !1 !== d.teardown.call(t, f, m.handle)) ||
                        x.removeEvent(t, p, m.handle),
                      delete l[p]);
                  } else for (p in l) x.event.remove(t, p + e[c], i, n, !0);
                x.isEmptyObject(l) && Y.remove(t, "handle events");
              }
            },
            dispatch: function (t) {
              var e,
                i,
                n,
                s,
                o,
                r,
                a = new Array(arguments.length),
                l = x.event.fix(t),
                c =
                  (Y.get(this, "events") || Object.create(null))[l.type] || [],
                h = x.event.special[l.type] || {};
              for (a[0] = l, e = 1; e < arguments.length; e++)
                a[e] = arguments[e];
              if (
                ((l.delegateTarget = this),
                !h.preDispatch || !1 !== h.preDispatch.call(this, l))
              ) {
                for (
                  r = x.event.handlers.call(this, l, c), e = 0;
                  (s = r[e++]) && !l.isPropagationStopped();

                )
                  for (
                    l.currentTarget = s.elem, i = 0;
                    (o = s.handlers[i++]) && !l.isImmediatePropagationStopped();

                  )
                    (l.rnamespace &&
                      !1 !== o.namespace &&
                      !l.rnamespace.test(o.namespace)) ||
                      ((l.handleObj = o),
                      (l.data = o.data),
                      void 0 !==
                        (n = (
                          (x.event.special[o.origType] || {}).handle ||
                          o.handler
                        ).apply(s.elem, a)) &&
                        !1 === (l.result = n) &&
                        (l.preventDefault(), l.stopPropagation()));
                return h.postDispatch && h.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function (t, e) {
              var i,
                n,
                s,
                o,
                r,
                a = [],
                l = e.delegateCount,
                c = t.target;
              if (l && c.nodeType && !("click" === t.type && t.button >= 1))
                for (; c !== this; c = c.parentNode || this)
                  if (
                    1 === c.nodeType &&
                    ("click" !== t.type || !0 !== c.disabled)
                  ) {
                    for (o = [], r = {}, i = 0; i < l; i++)
                      void 0 === r[(s = (n = e[i]).selector + " ")] &&
                        (r[s] = n.needsContext
                          ? x(s, this).index(c) > -1
                          : x.find(s, this, null, [c]).length),
                        r[s] && o.push(n);
                    o.length && a.push({ elem: c, handlers: o });
                  }
              return (
                (c = this),
                l < e.length && a.push({ elem: c, handlers: e.slice(l) }),
                a
              );
            },
            addProp: function (t, e) {
              Object.defineProperty(x.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: v(e)
                  ? function () {
                      if (this.originalEvent) return e(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[t];
                    },
                set: function (e) {
                  Object.defineProperty(this, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: e,
                  });
                },
              });
            },
            fix: function (t) {
              return t[x.expando] ? t : new x.Event(t);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (t) {
                  var e = this || t;
                  return (
                    mt.test(e.type) &&
                      e.click &&
                      I(e, "input") &&
                      Dt(e, "click", Tt),
                    !1
                  );
                },
                trigger: function (t) {
                  var e = this || t;
                  return (
                    mt.test(e.type) &&
                      e.click &&
                      I(e, "input") &&
                      Dt(e, "click"),
                    !0
                  );
                },
                _default: function (t) {
                  var e = t.target;
                  return (
                    (mt.test(e.type) &&
                      e.click &&
                      I(e, "input") &&
                      Y.get(e, "click")) ||
                    I(e, "a")
                  );
                },
              },
              beforeunload: {
                postDispatch: function (t) {
                  void 0 !== t.result &&
                    t.originalEvent &&
                    (t.originalEvent.returnValue = t.result);
                },
              },
            },
          }),
            (x.removeEvent = function (t, e, i) {
              t.removeEventListener && t.removeEventListener(e, i);
            }),
            (x.Event = function (t, e) {
              if (!(this instanceof x.Event)) return new x.Event(t, e);
              t && t.type
                ? ((this.originalEvent = t),
                  (this.type = t.type),
                  (this.isDefaultPrevented =
                    t.defaultPrevented ||
                    (void 0 === t.defaultPrevented && !1 === t.returnValue)
                      ? Tt
                      : At),
                  (this.target =
                    t.target && 3 === t.target.nodeType
                      ? t.target.parentNode
                      : t.target),
                  (this.currentTarget = t.currentTarget),
                  (this.relatedTarget = t.relatedTarget))
                : (this.type = t),
                e && x.extend(this, e),
                (this.timeStamp = (t && t.timeStamp) || Date.now()),
                (this[x.expando] = !0);
            }),
            (x.Event.prototype = {
              constructor: x.Event,
              isDefaultPrevented: At,
              isPropagationStopped: At,
              isImmediatePropagationStopped: At,
              isSimulated: !1,
              preventDefault: function () {
                var t = this.originalEvent;
                (this.isDefaultPrevented = Tt),
                  t && !this.isSimulated && t.preventDefault();
              },
              stopPropagation: function () {
                var t = this.originalEvent;
                (this.isPropagationStopped = Tt),
                  t && !this.isSimulated && t.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var t = this.originalEvent;
                (this.isImmediatePropagationStopped = Tt),
                  t && !this.isSimulated && t.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            x.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (t) {
                  var e = t.button;
                  return null == t.which && xt.test(t.type)
                    ? null != t.charCode
                      ? t.charCode
                      : t.keyCode
                    : !t.which && void 0 !== e && kt.test(t.type)
                    ? 1 & e
                      ? 1
                      : 2 & e
                      ? 3
                      : 4 & e
                      ? 2
                      : 0
                    : t.which;
                },
              },
              x.event.addProp
            ),
            x.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
              x.event.special[t] = {
                setup: function () {
                  return Dt(this, t, Lt), !1;
                },
                trigger: function () {
                  return Dt(this, t), !0;
                },
                delegateType: e,
              };
            }),
            x.each(
              {
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout",
              },
              function (t, e) {
                x.event.special[t] = {
                  delegateType: e,
                  bindType: e,
                  handle: function (t) {
                    var i,
                      n = this,
                      s = t.relatedTarget,
                      o = t.handleObj;
                    return (
                      (s && (s === n || x.contains(n, s))) ||
                        ((t.type = o.origType),
                        (i = o.handler.apply(this, arguments)),
                        (t.type = e)),
                      i
                    );
                  },
                };
              }
            ),
            x.fn.extend({
              on: function (t, e, i, n) {
                return It(this, t, e, i, n);
              },
              one: function (t, e, i, n) {
                return It(this, t, e, i, n, 1);
              },
              off: function (t, e, i) {
                var n, s;
                if (t && t.preventDefault && t.handleObj)
                  return (
                    (n = t.handleObj),
                    x(t.delegateTarget).off(
                      n.namespace ? n.origType + "." + n.namespace : n.origType,
                      n.selector,
                      n.handler
                    ),
                    this
                  );
                if ("object" == typeof t) {
                  for (s in t) this.off(s, e, t[s]);
                  return this;
                }
                return (
                  (!1 !== e && "function" != typeof e) ||
                    ((i = e), (e = void 0)),
                  !1 === i && (i = At),
                  this.each(function () {
                    x.event.remove(this, t, i, e);
                  })
                );
              },
            });
          var Pt = /<script|<style|<link/i,
            $t = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Mt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
          function Ot(t, e) {
            return (
              (I(t, "table") &&
                I(11 !== e.nodeType ? e : e.firstChild, "tr") &&
                x(t).children("tbody")[0]) ||
              t
            );
          }
          function qt(t) {
            return (
              (t.type = (null !== t.getAttribute("type")) + "/" + t.type), t
            );
          }
          function Ft(t) {
            return (
              "true/" === (t.type || "").slice(0, 5)
                ? (t.type = t.type.slice(5))
                : t.removeAttribute("type"),
              t
            );
          }
          function Bt(t, e) {
            var i, n, s, o, r, a;
            if (1 === e.nodeType) {
              if (Y.hasData(t) && (a = Y.get(t).events))
                for (s in (Y.remove(e, "handle events"), a))
                  for (i = 0, n = a[s].length; i < n; i++)
                    x.event.add(e, s, a[s][i]);
              J.hasData(t) &&
                ((o = J.access(t)), (r = x.extend({}, o)), J.set(e, r));
            }
          }
          function Nt(t, e) {
            var i = e.nodeName.toLowerCase();
            "input" === i && mt.test(t.type)
              ? (e.checked = t.checked)
              : ("input" !== i && "textarea" !== i) ||
                (e.defaultValue = t.defaultValue);
          }
          function Rt(t, e, i, n) {
            e = l(e);
            var s,
              o,
              r,
              a,
              c,
              h,
              d = 0,
              u = t.length,
              p = u - 1,
              f = e[0],
              g = v(f);
            if (
              g ||
              (u > 1 && "string" == typeof f && !m.checkClone && $t.test(f))
            )
              return t.each(function (s) {
                var o = t.eq(s);
                g && (e[0] = f.call(this, s, o.html())), Rt(o, e, i, n);
              });
            if (
              u &&
              ((o = (s = Ct(e, t[0].ownerDocument, !1, t, n)).firstChild),
              1 === s.childNodes.length && (s = o),
              o || n)
            ) {
              for (a = (r = x.map(wt(s, "script"), qt)).length; d < u; d++)
                (c = s),
                  d !== p &&
                    ((c = x.clone(c, !0, !0)),
                    a && x.merge(r, wt(c, "script"))),
                  i.call(t[d], c, d);
              if (a)
                for (
                  h = r[r.length - 1].ownerDocument, x.map(r, Ft), d = 0;
                  d < a;
                  d++
                )
                  (c = r[d]),
                    yt.test(c.type || "") &&
                      !Y.access(c, "globalEval") &&
                      x.contains(h, c) &&
                      (c.src && "module" !== (c.type || "").toLowerCase()
                        ? x._evalUrl &&
                          !c.noModule &&
                          x._evalUrl(
                            c.src,
                            { nonce: c.nonce || c.getAttribute("nonce") },
                            h
                          )
                        : _(c.textContent.replace(Mt, ""), c, h));
            }
            return t;
          }
          function Ht(t, e, i) {
            for (
              var n, s = e ? x.filter(e, t) : t, o = 0;
              null != (n = s[o]);
              o++
            )
              i || 1 !== n.nodeType || x.cleanData(wt(n)),
                n.parentNode &&
                  (i && at(n) && _t(wt(n, "script")),
                  n.parentNode.removeChild(n));
            return t;
          }
          x.extend({
            htmlPrefilter: function (t) {
              return t;
            },
            clone: function (t, e, i) {
              var n,
                s,
                o,
                r,
                a = t.cloneNode(!0),
                l = at(t);
              if (
                !(
                  m.noCloneChecked ||
                  (1 !== t.nodeType && 11 !== t.nodeType) ||
                  x.isXMLDoc(t)
                )
              )
                for (r = wt(a), n = 0, s = (o = wt(t)).length; n < s; n++)
                  Nt(o[n], r[n]);
              if (e)
                if (i)
                  for (
                    o = o || wt(t), r = r || wt(a), n = 0, s = o.length;
                    n < s;
                    n++
                  )
                    Bt(o[n], r[n]);
                else Bt(t, a);
              return (
                (r = wt(a, "script")).length > 0 &&
                  _t(r, !l && wt(t, "script")),
                a
              );
            },
            cleanData: function (t) {
              for (
                var e, i, n, s = x.event.special, o = 0;
                void 0 !== (i = t[o]);
                o++
              )
                if (Q(i)) {
                  if ((e = i[Y.expando])) {
                    if (e.events)
                      for (n in e.events)
                        s[n]
                          ? x.event.remove(i, n)
                          : x.removeEvent(i, n, e.handle);
                    i[Y.expando] = void 0;
                  }
                  i[J.expando] && (i[J.expando] = void 0);
                }
            },
          }),
            x.fn.extend({
              detach: function (t) {
                return Ht(this, t, !0);
              },
              remove: function (t) {
                return Ht(this, t);
              },
              text: function (t) {
                return W(
                  this,
                  function (t) {
                    return void 0 === t
                      ? x.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType &&
                            11 !== this.nodeType &&
                            9 !== this.nodeType) ||
                            (this.textContent = t);
                        });
                  },
                  null,
                  t,
                  arguments.length
                );
              },
              append: function () {
                return Rt(this, arguments, function (t) {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    Ot(this, t).appendChild(t);
                });
              },
              prepend: function () {
                return Rt(this, arguments, function (t) {
                  if (
                    1 === this.nodeType ||
                    11 === this.nodeType ||
                    9 === this.nodeType
                  ) {
                    var e = Ot(this, t);
                    e.insertBefore(t, e.firstChild);
                  }
                });
              },
              before: function () {
                return Rt(this, arguments, function (t) {
                  this.parentNode && this.parentNode.insertBefore(t, this);
                });
              },
              after: function () {
                return Rt(this, arguments, function (t) {
                  this.parentNode &&
                    this.parentNode.insertBefore(t, this.nextSibling);
                });
              },
              empty: function () {
                for (var t, e = 0; null != (t = this[e]); e++)
                  1 === t.nodeType &&
                    (x.cleanData(wt(t, !1)), (t.textContent = ""));
                return this;
              },
              clone: function (t, e) {
                return (
                  (t = null != t && t),
                  (e = null == e ? t : e),
                  this.map(function () {
                    return x.clone(this, t, e);
                  })
                );
              },
              html: function (t) {
                return W(
                  this,
                  function (t) {
                    var e = this[0] || {},
                      i = 0,
                      n = this.length;
                    if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                    if (
                      "string" == typeof t &&
                      !Pt.test(t) &&
                      !bt[(vt.exec(t) || ["", ""])[1].toLowerCase()]
                    ) {
                      t = x.htmlPrefilter(t);
                      try {
                        for (; i < n; i++)
                          1 === (e = this[i] || {}).nodeType &&
                            (x.cleanData(wt(e, !1)), (e.innerHTML = t));
                        e = 0;
                      } catch (t) {}
                    }
                    e && this.empty().append(t);
                  },
                  null,
                  t,
                  arguments.length
                );
              },
              replaceWith: function () {
                var t = [];
                return Rt(
                  this,
                  arguments,
                  function (e) {
                    var i = this.parentNode;
                    x.inArray(this, t) < 0 &&
                      (x.cleanData(wt(this)), i && i.replaceChild(e, this));
                  },
                  t
                );
              },
            }),
            x.each(
              {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
              },
              function (t, e) {
                x.fn[t] = function (t) {
                  for (
                    var i, n = [], s = x(t), o = s.length - 1, r = 0;
                    r <= o;
                    r++
                  )
                    (i = r === o ? this : this.clone(!0)),
                      x(s[r])[e](i),
                      c.apply(n, i.get());
                  return this.pushStack(n);
                };
              }
            );
          var zt = new RegExp("^(" + nt + ")(?!px)[a-z%]+$", "i"),
            jt = function (t) {
              var e = t.ownerDocument.defaultView;
              return (e && e.opener) || (e = n), e.getComputedStyle(t);
            },
            Ut = function (t, e, i) {
              var n,
                s,
                o = {};
              for (s in e) (o[s] = t.style[s]), (t.style[s] = e[s]);
              for (s in ((n = i.call(t)), e)) t.style[s] = o[s];
              return n;
            },
            Wt = new RegExp(ot.join("|"), "i");
          function Vt(t, e, i) {
            var n,
              s,
              o,
              r,
              a = t.style;
            return (
              (i = i || jt(t)) &&
                ("" !== (r = i.getPropertyValue(e) || i[e]) ||
                  at(t) ||
                  (r = x.style(t, e)),
                !m.pixelBoxStyles() &&
                  zt.test(r) &&
                  Wt.test(e) &&
                  ((n = a.width),
                  (s = a.minWidth),
                  (o = a.maxWidth),
                  (a.minWidth = a.maxWidth = a.width = r),
                  (r = i.width),
                  (a.width = n),
                  (a.minWidth = s),
                  (a.maxWidth = o))),
              void 0 !== r ? r + "" : r
            );
          }
          function Gt(t, e) {
            return {
              get: function () {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function t() {
              if (h) {
                (c.style.cssText =
                  "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                  (h.style.cssText =
                    "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                  rt.appendChild(c).appendChild(h);
                var t = n.getComputedStyle(h);
                (i = "1%" !== t.top),
                  (l = 12 === e(t.marginLeft)),
                  (h.style.right = "60%"),
                  (r = 36 === e(t.right)),
                  (s = 36 === e(t.width)),
                  (h.style.position = "absolute"),
                  (o = 12 === e(h.offsetWidth / 3)),
                  rt.removeChild(c),
                  (h = null);
              }
            }
            function e(t) {
              return Math.round(parseFloat(t));
            }
            var i,
              s,
              o,
              r,
              a,
              l,
              c = b.createElement("div"),
              h = b.createElement("div");
            h.style &&
              ((h.style.backgroundClip = "content-box"),
              (h.cloneNode(!0).style.backgroundClip = ""),
              (m.clearCloneStyle = "content-box" === h.style.backgroundClip),
              x.extend(m, {
                boxSizingReliable: function () {
                  return t(), s;
                },
                pixelBoxStyles: function () {
                  return t(), r;
                },
                pixelPosition: function () {
                  return t(), i;
                },
                reliableMarginLeft: function () {
                  return t(), l;
                },
                scrollboxSize: function () {
                  return t(), o;
                },
                reliableTrDimensions: function () {
                  var t, e, i, s;
                  return (
                    null == a &&
                      ((t = b.createElement("table")),
                      (e = b.createElement("tr")),
                      (i = b.createElement("div")),
                      (t.style.cssText = "position:absolute;left:-11111px"),
                      (e.style.height = "1px"),
                      (i.style.height = "9px"),
                      rt.appendChild(t).appendChild(e).appendChild(i),
                      (s = n.getComputedStyle(e)),
                      (a = parseInt(s.height) > 3),
                      rt.removeChild(t)),
                    a
                  );
                },
              }));
          })();
          var Xt = ["Webkit", "Moz", "ms"],
            Zt = b.createElement("div").style,
            Qt = {};
          function Kt(t) {
            var e = x.cssProps[t] || Qt[t];
            return (
              e ||
              (t in Zt
                ? t
                : (Qt[t] =
                    (function (t) {
                      for (
                        var e = t[0].toUpperCase() + t.slice(1), i = Xt.length;
                        i--;

                      )
                        if ((t = Xt[i] + e) in Zt) return t;
                    })(t) || t))
            );
          }
          var Yt = /^(none|table(?!-c[ea]).+)/,
            Jt = /^--/,
            te = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            ee = { letterSpacing: "0", fontWeight: "400" };
          function ie(t, e, i) {
            var n = st.exec(e);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e;
          }
          function ne(t, e, i, n, s, o) {
            var r = "width" === e ? 1 : 0,
              a = 0,
              l = 0;
            if (i === (n ? "border" : "content")) return 0;
            for (; r < 4; r += 2)
              "margin" === i && (l += x.css(t, i + ot[r], !0, s)),
                n
                  ? ("content" === i &&
                      (l -= x.css(t, "padding" + ot[r], !0, s)),
                    "margin" !== i &&
                      (l -= x.css(t, "border" + ot[r] + "Width", !0, s)))
                  : ((l += x.css(t, "padding" + ot[r], !0, s)),
                    "padding" !== i
                      ? (l += x.css(t, "border" + ot[r] + "Width", !0, s))
                      : (a += x.css(t, "border" + ot[r] + "Width", !0, s)));
            return (
              !n &&
                o >= 0 &&
                (l +=
                  Math.max(
                    0,
                    Math.ceil(
                      t["offset" + e[0].toUpperCase() + e.slice(1)] -
                        o -
                        l -
                        a -
                        0.5
                    )
                  ) || 0),
              l
            );
          }
          function se(t, e, i) {
            var n = jt(t),
              s =
                (!m.boxSizingReliable() || i) &&
                "border-box" === x.css(t, "boxSizing", !1, n),
              o = s,
              r = Vt(t, e, n),
              a = "offset" + e[0].toUpperCase() + e.slice(1);
            if (zt.test(r)) {
              if (!i) return r;
              r = "auto";
            }
            return (
              ((!m.boxSizingReliable() && s) ||
                (!m.reliableTrDimensions() && I(t, "tr")) ||
                "auto" === r ||
                (!parseFloat(r) && "inline" === x.css(t, "display", !1, n))) &&
                t.getClientRects().length &&
                ((s = "border-box" === x.css(t, "boxSizing", !1, n)),
                (o = a in t) && (r = t[a])),
              (r = parseFloat(r) || 0) +
                ne(t, e, i || (s ? "border" : "content"), o, n, r) +
                "px"
            );
          }
          function oe(t, e, i, n, s) {
            return new oe.prototype.init(t, e, i, n, s);
          }
          x.extend({
            cssHooks: {
              opacity: {
                get: function (t, e) {
                  if (e) {
                    var i = Vt(t, "opacity");
                    return "" === i ? "1" : i;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
            },
            cssProps: {},
            style: function (t, e, i, n) {
              if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var s,
                  o,
                  r,
                  a = Z(e),
                  l = Jt.test(e),
                  c = t.style;
                if (
                  (l || (e = Kt(a)),
                  (r = x.cssHooks[e] || x.cssHooks[a]),
                  void 0 === i)
                )
                  return r && "get" in r && void 0 !== (s = r.get(t, !1, n))
                    ? s
                    : c[e];
                "string" === (o = typeof i) &&
                  (s = st.exec(i)) &&
                  s[1] &&
                  ((i = ht(t, e, s)), (o = "number")),
                  null != i &&
                    i == i &&
                    ("number" !== o ||
                      l ||
                      (i += (s && s[3]) || (x.cssNumber[a] ? "" : "px")),
                    m.clearCloneStyle ||
                      "" !== i ||
                      0 !== e.indexOf("background") ||
                      (c[e] = "inherit"),
                    (r && "set" in r && void 0 === (i = r.set(t, i, n))) ||
                      (l ? c.setProperty(e, i) : (c[e] = i)));
              }
            },
            css: function (t, e, i, n) {
              var s,
                o,
                r,
                a = Z(e);
              return (
                Jt.test(e) || (e = Kt(a)),
                (r = x.cssHooks[e] || x.cssHooks[a]) &&
                  "get" in r &&
                  (s = r.get(t, !0, i)),
                void 0 === s && (s = Vt(t, e, n)),
                "normal" === s && e in ee && (s = ee[e]),
                "" === i || i
                  ? ((o = parseFloat(s)), !0 === i || isFinite(o) ? o || 0 : s)
                  : s
              );
            },
          }),
            x.each(["height", "width"], function (t, e) {
              x.cssHooks[e] = {
                get: function (t, i, n) {
                  if (i)
                    return !Yt.test(x.css(t, "display")) ||
                      (t.getClientRects().length &&
                        t.getBoundingClientRect().width)
                      ? se(t, e, n)
                      : Ut(t, te, function () {
                          return se(t, e, n);
                        });
                },
                set: function (t, i, n) {
                  var s,
                    o = jt(t),
                    r = !m.scrollboxSize() && "absolute" === o.position,
                    a =
                      (r || n) && "border-box" === x.css(t, "boxSizing", !1, o),
                    l = n ? ne(t, e, n, a, o) : 0;
                  return (
                    a &&
                      r &&
                      (l -= Math.ceil(
                        t["offset" + e[0].toUpperCase() + e.slice(1)] -
                          parseFloat(o[e]) -
                          ne(t, e, "border", !1, o) -
                          0.5
                      )),
                    l &&
                      (s = st.exec(i)) &&
                      "px" !== (s[3] || "px") &&
                      ((t.style[e] = i), (i = x.css(t, e))),
                    ie(0, i, l)
                  );
                },
              };
            }),
            (x.cssHooks.marginLeft = Gt(m.reliableMarginLeft, function (t, e) {
              if (e)
                return (
                  (parseFloat(Vt(t, "marginLeft")) ||
                    t.getBoundingClientRect().left -
                      Ut(t, { marginLeft: 0 }, function () {
                        return t.getBoundingClientRect().left;
                      })) + "px"
                );
            })),
            x.each(
              { margin: "", padding: "", border: "Width" },
              function (t, e) {
                (x.cssHooks[t + e] = {
                  expand: function (i) {
                    for (
                      var n = 0,
                        s = {},
                        o = "string" == typeof i ? i.split(" ") : [i];
                      n < 4;
                      n++
                    )
                      s[t + ot[n] + e] = o[n] || o[n - 2] || o[0];
                    return s;
                  },
                }),
                  "margin" !== t && (x.cssHooks[t + e].set = ie);
              }
            ),
            x.fn.extend({
              css: function (t, e) {
                return W(
                  this,
                  function (t, e, i) {
                    var n,
                      s,
                      o = {},
                      r = 0;
                    if (Array.isArray(e)) {
                      for (n = jt(t), s = e.length; r < s; r++)
                        o[e[r]] = x.css(t, e[r], !1, n);
                      return o;
                    }
                    return void 0 !== i ? x.style(t, e, i) : x.css(t, e);
                  },
                  t,
                  e,
                  arguments.length > 1
                );
              },
            }),
            (x.Tween = oe),
            (oe.prototype = {
              constructor: oe,
              init: function (t, e, i, n, s, o) {
                (this.elem = t),
                  (this.prop = i),
                  (this.easing = s || x.easing._default),
                  (this.options = e),
                  (this.start = this.now = this.cur()),
                  (this.end = n),
                  (this.unit = o || (x.cssNumber[i] ? "" : "px"));
              },
              cur: function () {
                var t = oe.propHooks[this.prop];
                return t && t.get
                  ? t.get(this)
                  : oe.propHooks._default.get(this);
              },
              run: function (t) {
                var e,
                  i = oe.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = e =
                        x.easing[this.easing](
                          t,
                          this.options.duration * t,
                          0,
                          1,
                          this.options.duration
                        ))
                    : (this.pos = e = t),
                  (this.now = (this.end - this.start) * e + this.start),
                  this.options.step &&
                    this.options.step.call(this.elem, this.now, this),
                  i && i.set ? i.set(this) : oe.propHooks._default.set(this),
                  this
                );
              },
            }),
            (oe.prototype.init.prototype = oe.prototype),
            (oe.propHooks = {
              _default: {
                get: function (t) {
                  var e;
                  return 1 !== t.elem.nodeType ||
                    (null != t.elem[t.prop] && null == t.elem.style[t.prop])
                    ? t.elem[t.prop]
                    : (e = x.css(t.elem, t.prop, "")) && "auto" !== e
                    ? e
                    : 0;
                },
                set: function (t) {
                  x.fx.step[t.prop]
                    ? x.fx.step[t.prop](t)
                    : 1 !== t.elem.nodeType ||
                      (!x.cssHooks[t.prop] && null == t.elem.style[Kt(t.prop)])
                    ? (t.elem[t.prop] = t.now)
                    : x.style(t.elem, t.prop, t.now + t.unit);
                },
              },
            }),
            (oe.propHooks.scrollTop = oe.propHooks.scrollLeft =
              {
                set: function (t) {
                  t.elem.nodeType &&
                    t.elem.parentNode &&
                    (t.elem[t.prop] = t.now);
                },
              }),
            (x.easing = {
              linear: function (t) {
                return t;
              },
              swing: function (t) {
                return 0.5 - Math.cos(t * Math.PI) / 2;
              },
              _default: "swing",
            }),
            (x.fx = oe.prototype.init),
            (x.fx.step = {});
          var re,
            ae,
            le = /^(?:toggle|show|hide)$/,
            ce = /queueHooks$/;
          function he() {
            ae &&
              (!1 === b.hidden && n.requestAnimationFrame
                ? n.requestAnimationFrame(he)
                : n.setTimeout(he, x.fx.interval),
              x.fx.tick());
          }
          function de() {
            return (
              n.setTimeout(function () {
                re = void 0;
              }),
              (re = Date.now())
            );
          }
          function ue(t, e) {
            var i,
              n = 0,
              s = { height: t };
            for (e = e ? 1 : 0; n < 4; n += 2 - e)
              s["margin" + (i = ot[n])] = s["padding" + i] = t;
            return e && (s.opacity = s.width = t), s;
          }
          function pe(t, e, i) {
            for (
              var n,
                s = (fe.tweeners[e] || []).concat(fe.tweeners["*"]),
                o = 0,
                r = s.length;
              o < r;
              o++
            )
              if ((n = s[o].call(i, e, t))) return n;
          }
          function fe(t, e, i) {
            var n,
              s,
              o = 0,
              r = fe.prefilters.length,
              a = x.Deferred().always(function () {
                delete l.elem;
              }),
              l = function () {
                if (s) return !1;
                for (
                  var e = re || de(),
                    i = Math.max(0, c.startTime + c.duration - e),
                    n = 1 - (i / c.duration || 0),
                    o = 0,
                    r = c.tweens.length;
                  o < r;
                  o++
                )
                  c.tweens[o].run(n);
                return (
                  a.notifyWith(t, [c, n, i]),
                  n < 1 && r
                    ? i
                    : (r || a.notifyWith(t, [c, 1, 0]),
                      a.resolveWith(t, [c]),
                      !1)
                );
              },
              c = a.promise({
                elem: t,
                props: x.extend({}, e),
                opts: x.extend(
                  !0,
                  { specialEasing: {}, easing: x.easing._default },
                  i
                ),
                originalProperties: e,
                originalOptions: i,
                startTime: re || de(),
                duration: i.duration,
                tweens: [],
                createTween: function (e, i) {
                  var n = x.Tween(
                    t,
                    c.opts,
                    e,
                    i,
                    c.opts.specialEasing[e] || c.opts.easing
                  );
                  return c.tweens.push(n), n;
                },
                stop: function (e) {
                  var i = 0,
                    n = e ? c.tweens.length : 0;
                  if (s) return this;
                  for (s = !0; i < n; i++) c.tweens[i].run(1);
                  return (
                    e
                      ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e]))
                      : a.rejectWith(t, [c, e]),
                    this
                  );
                },
              }),
              h = c.props;
            for (
              !(function (t, e) {
                var i, n, s, o, r;
                for (i in t)
                  if (
                    ((s = e[(n = Z(i))]),
                    (o = t[i]),
                    Array.isArray(o) && ((s = o[1]), (o = t[i] = o[0])),
                    i !== n && ((t[n] = o), delete t[i]),
                    (r = x.cssHooks[n]) && ("expand" in r))
                  )
                    for (i in ((o = r.expand(o)), delete t[n], o))
                      (i in t) || ((t[i] = o[i]), (e[i] = s));
                  else e[n] = s;
              })(h, c.opts.specialEasing);
              o < r;
              o++
            )
              if ((n = fe.prefilters[o].call(c, t, h, c.opts)))
                return (
                  v(n.stop) &&
                    (x._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
                  n
                );
            return (
              x.map(h, pe, c),
              v(c.opts.start) && c.opts.start.call(t, c),
              c
                .progress(c.opts.progress)
                .done(c.opts.done, c.opts.complete)
                .fail(c.opts.fail)
                .always(c.opts.always),
              x.fx.timer(
                x.extend(l, { elem: t, anim: c, queue: c.opts.queue })
              ),
              c
            );
          }
          (x.Animation = x.extend(fe, {
            tweeners: {
              "*": [
                function (t, e) {
                  var i = this.createTween(t, e);
                  return ht(i.elem, t, st.exec(e), i), i;
                },
              ],
            },
            tweener: function (t, e) {
              v(t) ? ((e = t), (t = ["*"])) : (t = t.match(B));
              for (var i, n = 0, s = t.length; n < s; n++)
                (i = t[n]),
                  (fe.tweeners[i] = fe.tweeners[i] || []),
                  fe.tweeners[i].unshift(e);
            },
            prefilters: [
              function (t, e, i) {
                var n,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c,
                  h,
                  d = "width" in e || "height" in e,
                  u = this,
                  p = {},
                  f = t.style,
                  g = t.nodeType && ct(t),
                  m = Y.get(t, "fxshow");
                for (n in (i.queue ||
                  (null == (r = x._queueHooks(t, "fx")).unqueued &&
                    ((r.unqueued = 0),
                    (a = r.empty.fire),
                    (r.empty.fire = function () {
                      r.unqueued || a();
                    })),
                  r.unqueued++,
                  u.always(function () {
                    u.always(function () {
                      r.unqueued--, x.queue(t, "fx").length || r.empty.fire();
                    });
                  })),
                e))
                  if (((s = e[n]), le.test(s))) {
                    if (
                      (delete e[n],
                      (o = o || "toggle" === s),
                      s === (g ? "hide" : "show"))
                    ) {
                      if ("show" !== s || !m || void 0 === m[n]) continue;
                      g = !0;
                    }
                    p[n] = (m && m[n]) || x.style(t, n);
                  }
                if ((l = !x.isEmptyObject(e)) || !x.isEmptyObject(p))
                  for (n in (d &&
                    1 === t.nodeType &&
                    ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
                    null == (c = m && m.display) && (c = Y.get(t, "display")),
                    "none" === (h = x.css(t, "display")) &&
                      (c
                        ? (h = c)
                        : (pt([t], !0),
                          (c = t.style.display || c),
                          (h = x.css(t, "display")),
                          pt([t]))),
                    ("inline" === h || ("inline-block" === h && null != c)) &&
                      "none" === x.css(t, "float") &&
                      (l ||
                        (u.done(function () {
                          f.display = c;
                        }),
                        null == c &&
                          ((h = f.display), (c = "none" === h ? "" : h))),
                      (f.display = "inline-block"))),
                  i.overflow &&
                    ((f.overflow = "hidden"),
                    u.always(function () {
                      (f.overflow = i.overflow[0]),
                        (f.overflowX = i.overflow[1]),
                        (f.overflowY = i.overflow[2]);
                    })),
                  (l = !1),
                  p))
                    l ||
                      (m
                        ? "hidden" in m && (g = m.hidden)
                        : (m = Y.access(t, "fxshow", { display: c })),
                      o && (m.hidden = !g),
                      g && pt([t], !0),
                      u.done(function () {
                        for (n in (g || pt([t]), Y.remove(t, "fxshow"), p))
                          x.style(t, n, p[n]);
                      })),
                      (l = pe(g ? m[n] : 0, n, u)),
                      n in m ||
                        ((m[n] = l.start),
                        g && ((l.end = l.start), (l.start = 0)));
              },
            ],
            prefilter: function (t, e) {
              e ? fe.prefilters.unshift(t) : fe.prefilters.push(t);
            },
          })),
            (x.speed = function (t, e, i) {
              var n =
                t && "object" == typeof t
                  ? x.extend({}, t)
                  : {
                      complete: i || (!i && e) || (v(t) && t),
                      duration: t,
                      easing: (i && e) || (e && !v(e) && e),
                    };
              return (
                x.fx.off
                  ? (n.duration = 0)
                  : "number" != typeof n.duration &&
                    (n.duration in x.fx.speeds
                      ? (n.duration = x.fx.speeds[n.duration])
                      : (n.duration = x.fx.speeds._default)),
                (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
                (n.old = n.complete),
                (n.complete = function () {
                  v(n.old) && n.old.call(this),
                    n.queue && x.dequeue(this, n.queue);
                }),
                n
              );
            }),
            x.fn.extend({
              fadeTo: function (t, e, i, n) {
                return this.filter(ct)
                  .css("opacity", 0)
                  .show()
                  .end()
                  .animate({ opacity: e }, t, i, n);
              },
              animate: function (t, e, i, n) {
                var s = x.isEmptyObject(t),
                  o = x.speed(e, i, n),
                  r = function () {
                    var e = fe(this, x.extend({}, t), o);
                    (s || Y.get(this, "finish")) && e.stop(!0);
                  };
                return (
                  (r.finish = r),
                  s || !1 === o.queue ? this.each(r) : this.queue(o.queue, r)
                );
              },
              stop: function (t, e, i) {
                var n = function (t) {
                  var e = t.stop;
                  delete t.stop, e(i);
                };
                return (
                  "string" != typeof t && ((i = e), (e = t), (t = void 0)),
                  e && this.queue(t || "fx", []),
                  this.each(function () {
                    var e = !0,
                      s = null != t && t + "queueHooks",
                      o = x.timers,
                      r = Y.get(this);
                    if (s) r[s] && r[s].stop && n(r[s]);
                    else
                      for (s in r) r[s] && r[s].stop && ce.test(s) && n(r[s]);
                    for (s = o.length; s--; )
                      o[s].elem !== this ||
                        (null != t && o[s].queue !== t) ||
                        (o[s].anim.stop(i), (e = !1), o.splice(s, 1));
                    (!e && i) || x.dequeue(this, t);
                  })
                );
              },
              finish: function (t) {
                return (
                  !1 !== t && (t = t || "fx"),
                  this.each(function () {
                    var e,
                      i = Y.get(this),
                      n = i[t + "queue"],
                      s = i[t + "queueHooks"],
                      o = x.timers,
                      r = n ? n.length : 0;
                    for (
                      i.finish = !0,
                        x.queue(this, t, []),
                        s && s.stop && s.stop.call(this, !0),
                        e = o.length;
                      e--;

                    )
                      o[e].elem === this &&
                        o[e].queue === t &&
                        (o[e].anim.stop(!0), o.splice(e, 1));
                    for (e = 0; e < r; e++)
                      n[e] && n[e].finish && n[e].finish.call(this);
                    delete i.finish;
                  })
                );
              },
            }),
            x.each(["toggle", "show", "hide"], function (t, e) {
              var i = x.fn[e];
              x.fn[e] = function (t, n, s) {
                return null == t || "boolean" == typeof t
                  ? i.apply(this, arguments)
                  : this.animate(ue(e, !0), t, n, s);
              };
            }),
            x.each(
              {
                slideDown: ue("show"),
                slideUp: ue("hide"),
                slideToggle: ue("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
              },
              function (t, e) {
                x.fn[t] = function (t, i, n) {
                  return this.animate(e, t, i, n);
                };
              }
            ),
            (x.timers = []),
            (x.fx.tick = function () {
              var t,
                e = 0,
                i = x.timers;
              for (re = Date.now(); e < i.length; e++)
                (t = i[e])() || i[e] !== t || i.splice(e--, 1);
              i.length || x.fx.stop(), (re = void 0);
            }),
            (x.fx.timer = function (t) {
              x.timers.push(t), x.fx.start();
            }),
            (x.fx.interval = 13),
            (x.fx.start = function () {
              ae || ((ae = !0), he());
            }),
            (x.fx.stop = function () {
              ae = null;
            }),
            (x.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (x.fn.delay = function (t, e) {
              return (
                (t = (x.fx && x.fx.speeds[t]) || t),
                (e = e || "fx"),
                this.queue(e, function (e, i) {
                  var s = n.setTimeout(e, t);
                  i.stop = function () {
                    n.clearTimeout(s);
                  };
                })
              );
            }),
            (function () {
              var t = b.createElement("input"),
                e = b
                  .createElement("select")
                  .appendChild(b.createElement("option"));
              (t.type = "checkbox"),
                (m.checkOn = "" !== t.value),
                (m.optSelected = e.selected),
                ((t = b.createElement("input")).value = "t"),
                (t.type = "radio"),
                (m.radioValue = "t" === t.value);
            })();
          var ge,
            me = x.expr.attrHandle;
          x.fn.extend({
            attr: function (t, e) {
              return W(this, x.attr, t, e, arguments.length > 1);
            },
            removeAttr: function (t) {
              return this.each(function () {
                x.removeAttr(this, t);
              });
            },
          }),
            x.extend({
              attr: function (t, e, i) {
                var n,
                  s,
                  o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return void 0 === t.getAttribute
                    ? x.prop(t, e, i)
                    : ((1 === o && x.isXMLDoc(t)) ||
                        (s =
                          x.attrHooks[e.toLowerCase()] ||
                          (x.expr.match.bool.test(e) ? ge : void 0)),
                      void 0 !== i
                        ? null === i
                          ? void x.removeAttr(t, e)
                          : s && "set" in s && void 0 !== (n = s.set(t, i, e))
                          ? n
                          : (t.setAttribute(e, i + ""), i)
                        : s && "get" in s && null !== (n = s.get(t, e))
                        ? n
                        : null == (n = x.find.attr(t, e))
                        ? void 0
                        : n);
              },
              attrHooks: {
                type: {
                  set: function (t, e) {
                    if (!m.radioValue && "radio" === e && I(t, "input")) {
                      var i = t.value;
                      return t.setAttribute("type", e), i && (t.value = i), e;
                    }
                  },
                },
              },
              removeAttr: function (t, e) {
                var i,
                  n = 0,
                  s = e && e.match(B);
                if (s && 1 === t.nodeType)
                  for (; (i = s[n++]); ) t.removeAttribute(i);
              },
            }),
            (ge = {
              set: function (t, e, i) {
                return !1 === e ? x.removeAttr(t, i) : t.setAttribute(i, i), i;
              },
            }),
            x.each(x.expr.match.bool.source.match(/\w+/g), function (t, e) {
              var i = me[e] || x.find.attr;
              me[e] = function (t, e, n) {
                var s,
                  o,
                  r = e.toLowerCase();
                return (
                  n ||
                    ((o = me[r]),
                    (me[r] = s),
                    (s = null != i(t, e, n) ? r : null),
                    (me[r] = o)),
                  s
                );
              };
            });
          var ve = /^(?:input|select|textarea|button)$/i,
            ye = /^(?:a|area)$/i;
          function be(t) {
            return (t.match(B) || []).join(" ");
          }
          function we(t) {
            return (t.getAttribute && t.getAttribute("class")) || "";
          }
          function _e(t) {
            return Array.isArray(t)
              ? t
              : ("string" == typeof t && t.match(B)) || [];
          }
          x.fn.extend({
            prop: function (t, e) {
              return W(this, x.prop, t, e, arguments.length > 1);
            },
            removeProp: function (t) {
              return this.each(function () {
                delete this[x.propFix[t] || t];
              });
            },
          }),
            x.extend({
              prop: function (t, e, i) {
                var n,
                  s,
                  o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return (
                    (1 === o && x.isXMLDoc(t)) ||
                      ((e = x.propFix[e] || e), (s = x.propHooks[e])),
                    void 0 !== i
                      ? s && "set" in s && void 0 !== (n = s.set(t, i, e))
                        ? n
                        : (t[e] = i)
                      : s && "get" in s && null !== (n = s.get(t, e))
                      ? n
                      : t[e]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (t) {
                    var e = x.find.attr(t, "tabindex");
                    return e
                      ? parseInt(e, 10)
                      : ve.test(t.nodeName) || (ye.test(t.nodeName) && t.href)
                      ? 0
                      : -1;
                  },
                },
              },
              propFix: { for: "htmlFor", class: "className" },
            }),
            m.optSelected ||
              (x.propHooks.selected = {
                get: function (t) {
                  var e = t.parentNode;
                  return e && e.parentNode && e.parentNode.selectedIndex, null;
                },
                set: function (t) {
                  var e = t.parentNode;
                  e &&
                    (e.selectedIndex,
                    e.parentNode && e.parentNode.selectedIndex);
                },
              }),
            x.each(
              [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable",
              ],
              function () {
                x.propFix[this.toLowerCase()] = this;
              }
            ),
            x.fn.extend({
              addClass: function (t) {
                var e,
                  i,
                  n,
                  s,
                  o,
                  r,
                  a,
                  l = 0;
                if (v(t))
                  return this.each(function (e) {
                    x(this).addClass(t.call(this, e, we(this)));
                  });
                if ((e = _e(t)).length)
                  for (; (i = this[l++]); )
                    if (
                      ((s = we(i)), (n = 1 === i.nodeType && " " + be(s) + " "))
                    ) {
                      for (r = 0; (o = e[r++]); )
                        n.indexOf(" " + o + " ") < 0 && (n += o + " ");
                      s !== (a = be(n)) && i.setAttribute("class", a);
                    }
                return this;
              },
              removeClass: function (t) {
                var e,
                  i,
                  n,
                  s,
                  o,
                  r,
                  a,
                  l = 0;
                if (v(t))
                  return this.each(function (e) {
                    x(this).removeClass(t.call(this, e, we(this)));
                  });
                if (!arguments.length) return this.attr("class", "");
                if ((e = _e(t)).length)
                  for (; (i = this[l++]); )
                    if (
                      ((s = we(i)), (n = 1 === i.nodeType && " " + be(s) + " "))
                    ) {
                      for (r = 0; (o = e[r++]); )
                        for (; n.indexOf(" " + o + " ") > -1; )
                          n = n.replace(" " + o + " ", " ");
                      s !== (a = be(n)) && i.setAttribute("class", a);
                    }
                return this;
              },
              toggleClass: function (t, e) {
                var i = typeof t,
                  n = "string" === i || Array.isArray(t);
                return "boolean" == typeof e && n
                  ? e
                    ? this.addClass(t)
                    : this.removeClass(t)
                  : v(t)
                  ? this.each(function (i) {
                      x(this).toggleClass(t.call(this, i, we(this), e), e);
                    })
                  : this.each(function () {
                      var e, s, o, r;
                      if (n)
                        for (s = 0, o = x(this), r = _e(t); (e = r[s++]); )
                          o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                      else
                        (void 0 !== t && "boolean" !== i) ||
                          ((e = we(this)) && Y.set(this, "__className__", e),
                          this.setAttribute &&
                            this.setAttribute(
                              "class",
                              e || !1 === t
                                ? ""
                                : Y.get(this, "__className__") || ""
                            ));
                    });
              },
              hasClass: function (t) {
                var e,
                  i,
                  n = 0;
                for (e = " " + t + " "; (i = this[n++]); )
                  if (
                    1 === i.nodeType &&
                    (" " + be(we(i)) + " ").indexOf(e) > -1
                  )
                    return !0;
                return !1;
              },
            });
          var Se = /\r/g;
          x.fn.extend({
            val: function (t) {
              var e,
                i,
                n,
                s = this[0];
              return arguments.length
                ? ((n = v(t)),
                  this.each(function (i) {
                    var s;
                    1 === this.nodeType &&
                      (null == (s = n ? t.call(this, i, x(this).val()) : t)
                        ? (s = "")
                        : "number" == typeof s
                        ? (s += "")
                        : Array.isArray(s) &&
                          (s = x.map(s, function (t) {
                            return null == t ? "" : t + "";
                          })),
                      ((e =
                        x.valHooks[this.type] ||
                        x.valHooks[this.nodeName.toLowerCase()]) &&
                        "set" in e &&
                        void 0 !== e.set(this, s, "value")) ||
                        (this.value = s));
                  }))
                : s
                ? (e =
                    x.valHooks[s.type] ||
                    x.valHooks[s.nodeName.toLowerCase()]) &&
                  "get" in e &&
                  void 0 !== (i = e.get(s, "value"))
                  ? i
                  : "string" == typeof (i = s.value)
                  ? i.replace(Se, "")
                  : null == i
                  ? ""
                  : i
                : void 0;
            },
          }),
            x.extend({
              valHooks: {
                option: {
                  get: function (t) {
                    var e = x.find.attr(t, "value");
                    return null != e ? e : be(x.text(t));
                  },
                },
                select: {
                  get: function (t) {
                    var e,
                      i,
                      n,
                      s = t.options,
                      o = t.selectedIndex,
                      r = "select-one" === t.type,
                      a = r ? null : [],
                      l = r ? o + 1 : s.length;
                    for (n = o < 0 ? l : r ? o : 0; n < l; n++)
                      if (
                        ((i = s[n]).selected || n === o) &&
                        !i.disabled &&
                        (!i.parentNode.disabled || !I(i.parentNode, "optgroup"))
                      ) {
                        if (((e = x(i).val()), r)) return e;
                        a.push(e);
                      }
                    return a;
                  },
                  set: function (t, e) {
                    for (
                      var i, n, s = t.options, o = x.makeArray(e), r = s.length;
                      r--;

                    )
                      ((n = s[r]).selected =
                        x.inArray(x.valHooks.option.get(n), o) > -1) &&
                        (i = !0);
                    return i || (t.selectedIndex = -1), o;
                  },
                },
              },
            }),
            x.each(["radio", "checkbox"], function () {
              (x.valHooks[this] = {
                set: function (t, e) {
                  if (Array.isArray(e))
                    return (t.checked = x.inArray(x(t).val(), e) > -1);
                },
              }),
                m.checkOn ||
                  (x.valHooks[this].get = function (t) {
                    return null === t.getAttribute("value") ? "on" : t.value;
                  });
            }),
            (m.focusin = "onfocusin" in n);
          var Ce = /^(?:focusinfocus|focusoutblur)$/,
            xe = function (t) {
              t.stopPropagation();
            };
          x.extend(x.event, {
            trigger: function (t, e, i, s) {
              var o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                f = [i || b],
                g = p.call(t, "type") ? t.type : t,
                m = p.call(t, "namespace") ? t.namespace.split(".") : [];
              if (
                ((r = u = a = i = i || b),
                3 !== i.nodeType &&
                  8 !== i.nodeType &&
                  !Ce.test(g + x.event.triggered) &&
                  (g.indexOf(".") > -1 &&
                    ((m = g.split(".")), (g = m.shift()), m.sort()),
                  (c = g.indexOf(":") < 0 && "on" + g),
                  ((t = t[x.expando]
                    ? t
                    : new x.Event(g, "object" == typeof t && t)).isTrigger = s
                    ? 2
                    : 3),
                  (t.namespace = m.join(".")),
                  (t.rnamespace = t.namespace
                    ? new RegExp(
                        "(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)"
                      )
                    : null),
                  (t.result = void 0),
                  t.target || (t.target = i),
                  (e = null == e ? [t] : x.makeArray(e, [t])),
                  (d = x.event.special[g] || {}),
                  s || !d.trigger || !1 !== d.trigger.apply(i, e)))
              ) {
                if (!s && !d.noBubble && !y(i)) {
                  for (
                    l = d.delegateType || g,
                      Ce.test(l + g) || (r = r.parentNode);
                    r;
                    r = r.parentNode
                  )
                    f.push(r), (a = r);
                  a === (i.ownerDocument || b) &&
                    f.push(a.defaultView || a.parentWindow || n);
                }
                for (o = 0; (r = f[o++]) && !t.isPropagationStopped(); )
                  (u = r),
                    (t.type = o > 1 ? l : d.bindType || g),
                    (h =
                      (Y.get(r, "events") || Object.create(null))[t.type] &&
                      Y.get(r, "handle")) && h.apply(r, e),
                    (h = c && r[c]) &&
                      h.apply &&
                      Q(r) &&
                      ((t.result = h.apply(r, e)),
                      !1 === t.result && t.preventDefault());
                return (
                  (t.type = g),
                  s ||
                    t.isDefaultPrevented() ||
                    (d._default && !1 !== d._default.apply(f.pop(), e)) ||
                    !Q(i) ||
                    (c &&
                      v(i[g]) &&
                      !y(i) &&
                      ((a = i[c]) && (i[c] = null),
                      (x.event.triggered = g),
                      t.isPropagationStopped() && u.addEventListener(g, xe),
                      i[g](),
                      t.isPropagationStopped() && u.removeEventListener(g, xe),
                      (x.event.triggered = void 0),
                      a && (i[c] = a))),
                  t.result
                );
              }
            },
            simulate: function (t, e, i) {
              var n = x.extend(new x.Event(), i, { type: t, isSimulated: !0 });
              x.event.trigger(n, null, e);
            },
          }),
            x.fn.extend({
              trigger: function (t, e) {
                return this.each(function () {
                  x.event.trigger(t, e, this);
                });
              },
              triggerHandler: function (t, e) {
                var i = this[0];
                if (i) return x.event.trigger(t, e, i, !0);
              },
            }),
            m.focusin ||
              x.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
                var i = function (t) {
                  x.event.simulate(e, t.target, x.event.fix(t));
                };
                x.event.special[e] = {
                  setup: function () {
                    var n = this.ownerDocument || this.document || this,
                      s = Y.access(n, e);
                    s || n.addEventListener(t, i, !0),
                      Y.access(n, e, (s || 0) + 1);
                  },
                  teardown: function () {
                    var n = this.ownerDocument || this.document || this,
                      s = Y.access(n, e) - 1;
                    s
                      ? Y.access(n, e, s)
                      : (n.removeEventListener(t, i, !0), Y.remove(n, e));
                  },
                };
              });
          var ke = n.location,
            Ee = { guid: Date.now() },
            Te = /\?/;
          x.parseXML = function (t) {
            var e;
            if (!t || "string" != typeof t) return null;
            try {
              e = new n.DOMParser().parseFromString(t, "text/xml");
            } catch (t) {
              e = void 0;
            }
            return (
              (e && !e.getElementsByTagName("parsererror").length) ||
                x.error("Invalid XML: " + t),
              e
            );
          };
          var Ae = /\[\]$/,
            Le = /\r?\n/g,
            Ie = /^(?:submit|button|image|reset|file)$/i,
            De = /^(?:input|select|textarea|keygen)/i;
          function Pe(t, e, i, n) {
            var s;
            if (Array.isArray(e))
              x.each(e, function (e, s) {
                i || Ae.test(t)
                  ? n(t, s)
                  : Pe(
                      t +
                        "[" +
                        ("object" == typeof s && null != s ? e : "") +
                        "]",
                      s,
                      i,
                      n
                    );
              });
            else if (i || "object" !== S(e)) n(t, e);
            else for (s in e) Pe(t + "[" + s + "]", e[s], i, n);
          }
          (x.param = function (t, e) {
            var i,
              n = [],
              s = function (t, e) {
                var i = v(e) ? e() : e;
                n[n.length] =
                  encodeURIComponent(t) +
                  "=" +
                  encodeURIComponent(null == i ? "" : i);
              };
            if (null == t) return "";
            if (Array.isArray(t) || (t.jquery && !x.isPlainObject(t)))
              x.each(t, function () {
                s(this.name, this.value);
              });
            else for (i in t) Pe(i, t[i], e, s);
            return n.join("&");
          }),
            x.fn.extend({
              serialize: function () {
                return x.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var t = x.prop(this, "elements");
                  return t ? x.makeArray(t) : this;
                })
                  .filter(function () {
                    var t = this.type;
                    return (
                      this.name &&
                      !x(this).is(":disabled") &&
                      De.test(this.nodeName) &&
                      !Ie.test(t) &&
                      (this.checked || !mt.test(t))
                    );
                  })
                  .map(function (t, e) {
                    var i = x(this).val();
                    return null == i
                      ? null
                      : Array.isArray(i)
                      ? x.map(i, function (t) {
                          return { name: e.name, value: t.replace(Le, "\r\n") };
                        })
                      : { name: e.name, value: i.replace(Le, "\r\n") };
                  })
                  .get();
              },
            });
          var $e = /%20/g,
            Me = /#.*$/,
            Oe = /([?&])_=[^&]*/,
            qe = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Fe = /^(?:GET|HEAD)$/,
            Be = /^\/\//,
            Ne = {},
            Re = {},
            He = "*/".concat("*"),
            ze = b.createElement("a");
          function je(t) {
            return function (e, i) {
              "string" != typeof e && ((i = e), (e = "*"));
              var n,
                s = 0,
                o = e.toLowerCase().match(B) || [];
              if (v(i))
                for (; (n = o[s++]); )
                  "+" === n[0]
                    ? ((n = n.slice(1) || "*"), (t[n] = t[n] || []).unshift(i))
                    : (t[n] = t[n] || []).push(i);
            };
          }
          function Ue(t, e, i, n) {
            var s = {},
              o = t === Re;
            function r(a) {
              var l;
              return (
                (s[a] = !0),
                x.each(t[a] || [], function (t, a) {
                  var c = a(e, i, n);
                  return "string" != typeof c || o || s[c]
                    ? o
                      ? !(l = c)
                      : void 0
                    : (e.dataTypes.unshift(c), r(c), !1);
                }),
                l
              );
            }
            return r(e.dataTypes[0]) || (!s["*"] && r("*"));
          }
          function We(t, e) {
            var i,
              n,
              s = x.ajaxSettings.flatOptions || {};
            for (i in e)
              void 0 !== e[i] && ((s[i] ? t : n || (n = {}))[i] = e[i]);
            return n && x.extend(!0, t, n), t;
          }
          (ze.href = ke.href),
            x.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: ke.href,
                type: "GET",
                isLocal:
                  /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                    ke.protocol
                  ),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                  "*": He,
                  text: "text/plain",
                  html: "text/html",
                  xml: "application/xml, text/xml",
                  json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: {
                  xml: "responseXML",
                  text: "responseText",
                  json: "responseJSON",
                },
                converters: {
                  "* text": String,
                  "text html": !0,
                  "text json": JSON.parse,
                  "text xml": x.parseXML,
                },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (t, e) {
                return e ? We(We(t, x.ajaxSettings), e) : We(x.ajaxSettings, t);
              },
              ajaxPrefilter: je(Ne),
              ajaxTransport: je(Re),
              ajax: function (t, e) {
                "object" == typeof t && ((e = t), (t = void 0)), (e = e || {});
                var i,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c,
                  h,
                  d,
                  u,
                  p = x.ajaxSetup({}, e),
                  f = p.context || p,
                  g = p.context && (f.nodeType || f.jquery) ? x(f) : x.event,
                  m = x.Deferred(),
                  v = x.Callbacks("once memory"),
                  y = p.statusCode || {},
                  w = {},
                  _ = {},
                  S = "canceled",
                  C = {
                    readyState: 0,
                    getResponseHeader: function (t) {
                      var e;
                      if (c) {
                        if (!r)
                          for (r = {}; (e = qe.exec(o)); )
                            r[e[1].toLowerCase() + " "] = (
                              r[e[1].toLowerCase() + " "] || []
                            ).concat(e[2]);
                        e = r[t.toLowerCase() + " "];
                      }
                      return null == e ? null : e.join(", ");
                    },
                    getAllResponseHeaders: function () {
                      return c ? o : null;
                    },
                    setRequestHeader: function (t, e) {
                      return (
                        null == c &&
                          ((t = _[t.toLowerCase()] = _[t.toLowerCase()] || t),
                          (w[t] = e)),
                        this
                      );
                    },
                    overrideMimeType: function (t) {
                      return null == c && (p.mimeType = t), this;
                    },
                    statusCode: function (t) {
                      var e;
                      if (t)
                        if (c) C.always(t[C.status]);
                        else for (e in t) y[e] = [y[e], t[e]];
                      return this;
                    },
                    abort: function (t) {
                      var e = t || S;
                      return i && i.abort(e), k(0, e), this;
                    },
                  };
                if (
                  (m.promise(C),
                  (p.url = ((t || p.url || ke.href) + "").replace(
                    Be,
                    ke.protocol + "//"
                  )),
                  (p.type = e.method || e.type || p.method || p.type),
                  (p.dataTypes = (p.dataType || "*").toLowerCase().match(B) || [
                    "",
                  ]),
                  null == p.crossDomain)
                ) {
                  l = b.createElement("a");
                  try {
                    (l.href = p.url),
                      (l.href = l.href),
                      (p.crossDomain =
                        ze.protocol + "//" + ze.host !=
                        l.protocol + "//" + l.host);
                  } catch (t) {
                    p.crossDomain = !0;
                  }
                }
                if (
                  (p.data &&
                    p.processData &&
                    "string" != typeof p.data &&
                    (p.data = x.param(p.data, p.traditional)),
                  Ue(Ne, p, e, C),
                  c)
                )
                  return C;
                for (d in ((h = x.event && p.global) &&
                  0 == x.active++ &&
                  x.event.trigger("ajaxStart"),
                (p.type = p.type.toUpperCase()),
                (p.hasContent = !Fe.test(p.type)),
                (s = p.url.replace(Me, "")),
                p.hasContent
                  ? p.data &&
                    p.processData &&
                    0 ===
                      (p.contentType || "").indexOf(
                        "application/x-www-form-urlencoded"
                      ) &&
                    (p.data = p.data.replace($e, "+"))
                  : ((u = p.url.slice(s.length)),
                    p.data &&
                      (p.processData || "string" == typeof p.data) &&
                      ((s += (Te.test(s) ? "&" : "?") + p.data), delete p.data),
                    !1 === p.cache &&
                      ((s = s.replace(Oe, "$1")),
                      (u = (Te.test(s) ? "&" : "?") + "_=" + Ee.guid++ + u)),
                    (p.url = s + u)),
                p.ifModified &&
                  (x.lastModified[s] &&
                    C.setRequestHeader("If-Modified-Since", x.lastModified[s]),
                  x.etag[s] && C.setRequestHeader("If-None-Match", x.etag[s])),
                ((p.data && p.hasContent && !1 !== p.contentType) ||
                  e.contentType) &&
                  C.setRequestHeader("Content-Type", p.contentType),
                C.setRequestHeader(
                  "Accept",
                  p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                    ? p.accepts[p.dataTypes[0]] +
                        ("*" !== p.dataTypes[0] ? ", " + He + "; q=0.01" : "")
                    : p.accepts["*"]
                ),
                p.headers))
                  C.setRequestHeader(d, p.headers[d]);
                if (p.beforeSend && (!1 === p.beforeSend.call(f, C, p) || c))
                  return C.abort();
                if (
                  ((S = "abort"),
                  v.add(p.complete),
                  C.done(p.success),
                  C.fail(p.error),
                  (i = Ue(Re, p, e, C)))
                ) {
                  if (
                    ((C.readyState = 1), h && g.trigger("ajaxSend", [C, p]), c)
                  )
                    return C;
                  p.async &&
                    p.timeout > 0 &&
                    (a = n.setTimeout(function () {
                      C.abort("timeout");
                    }, p.timeout));
                  try {
                    (c = !1), i.send(w, k);
                  } catch (t) {
                    if (c) throw t;
                    k(-1, t);
                  }
                } else k(-1, "No Transport");
                function k(t, e, r, l) {
                  var d,
                    u,
                    b,
                    w,
                    _,
                    S = e;
                  c ||
                    ((c = !0),
                    a && n.clearTimeout(a),
                    (i = void 0),
                    (o = l || ""),
                    (C.readyState = t > 0 ? 4 : 0),
                    (d = (t >= 200 && t < 300) || 304 === t),
                    r &&
                      (w = (function (t, e, i) {
                        for (
                          var n, s, o, r, a = t.contents, l = t.dataTypes;
                          "*" === l[0];

                        )
                          l.shift(),
                            void 0 === n &&
                              (n =
                                t.mimeType ||
                                e.getResponseHeader("Content-Type"));
                        if (n)
                          for (s in a)
                            if (a[s] && a[s].test(n)) {
                              l.unshift(s);
                              break;
                            }
                        if (l[0] in i) o = l[0];
                        else {
                          for (s in i) {
                            if (!l[0] || t.converters[s + " " + l[0]]) {
                              o = s;
                              break;
                            }
                            r || (r = s);
                          }
                          o = o || r;
                        }
                        if (o) return o !== l[0] && l.unshift(o), i[o];
                      })(p, C, r)),
                    !d &&
                      x.inArray("script", p.dataTypes) > -1 &&
                      (p.converters["text script"] = function () {}),
                    (w = (function (t, e, i, n) {
                      var s,
                        o,
                        r,
                        a,
                        l,
                        c = {},
                        h = t.dataTypes.slice();
                      if (h[1])
                        for (r in t.converters)
                          c[r.toLowerCase()] = t.converters[r];
                      for (o = h.shift(); o; )
                        if (
                          (t.responseFields[o] && (i[t.responseFields[o]] = e),
                          !l &&
                            n &&
                            t.dataFilter &&
                            (e = t.dataFilter(e, t.dataType)),
                          (l = o),
                          (o = h.shift()))
                        )
                          if ("*" === o) o = l;
                          else if ("*" !== l && l !== o) {
                            if (!(r = c[l + " " + o] || c["* " + o]))
                              for (s in c)
                                if (
                                  (a = s.split(" "))[1] === o &&
                                  (r = c[l + " " + a[0]] || c["* " + a[0]])
                                ) {
                                  !0 === r
                                    ? (r = c[s])
                                    : !0 !== c[s] &&
                                      ((o = a[0]), h.unshift(a[1]));
                                  break;
                                }
                            if (!0 !== r)
                              if (r && t.throws) e = r(e);
                              else
                                try {
                                  e = r(e);
                                } catch (t) {
                                  return {
                                    state: "parsererror",
                                    error: r
                                      ? t
                                      : "No conversion from " + l + " to " + o,
                                  };
                                }
                          }
                      return { state: "success", data: e };
                    })(p, w, C, d)),
                    d
                      ? (p.ifModified &&
                          ((_ = C.getResponseHeader("Last-Modified")) &&
                            (x.lastModified[s] = _),
                          (_ = C.getResponseHeader("etag")) && (x.etag[s] = _)),
                        204 === t || "HEAD" === p.type
                          ? (S = "nocontent")
                          : 304 === t
                          ? (S = "notmodified")
                          : ((S = w.state), (u = w.data), (d = !(b = w.error))))
                      : ((b = S),
                        (!t && S) || ((S = "error"), t < 0 && (t = 0))),
                    (C.status = t),
                    (C.statusText = (e || S) + ""),
                    d
                      ? m.resolveWith(f, [u, S, C])
                      : m.rejectWith(f, [C, S, b]),
                    C.statusCode(y),
                    (y = void 0),
                    h &&
                      g.trigger(d ? "ajaxSuccess" : "ajaxError", [
                        C,
                        p,
                        d ? u : b,
                      ]),
                    v.fireWith(f, [C, S]),
                    h &&
                      (g.trigger("ajaxComplete", [C, p]),
                      --x.active || x.event.trigger("ajaxStop")));
                }
                return C;
              },
              getJSON: function (t, e, i) {
                return x.get(t, e, i, "json");
              },
              getScript: function (t, e) {
                return x.get(t, void 0, e, "script");
              },
            }),
            x.each(["get", "post"], function (t, e) {
              x[e] = function (t, i, n, s) {
                return (
                  v(i) && ((s = s || n), (n = i), (i = void 0)),
                  x.ajax(
                    x.extend(
                      { url: t, type: e, dataType: s, data: i, success: n },
                      x.isPlainObject(t) && t
                    )
                  )
                );
              };
            }),
            x.ajaxPrefilter(function (t) {
              var e;
              for (e in t.headers)
                "content-type" === e.toLowerCase() &&
                  (t.contentType = t.headers[e] || "");
            }),
            (x._evalUrl = function (t, e, i) {
              return x.ajax({
                url: t,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (t) {
                  x.globalEval(t, e, i);
                },
              });
            }),
            x.fn.extend({
              wrapAll: function (t) {
                var e;
                return (
                  this[0] &&
                    (v(t) && (t = t.call(this[0])),
                    (e = x(t, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && e.insertBefore(this[0]),
                    e
                      .map(function () {
                        for (var t = this; t.firstElementChild; )
                          t = t.firstElementChild;
                        return t;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (t) {
                return v(t)
                  ? this.each(function (e) {
                      x(this).wrapInner(t.call(this, e));
                    })
                  : this.each(function () {
                      var e = x(this),
                        i = e.contents();
                      i.length ? i.wrapAll(t) : e.append(t);
                    });
              },
              wrap: function (t) {
                var e = v(t);
                return this.each(function (i) {
                  x(this).wrapAll(e ? t.call(this, i) : t);
                });
              },
              unwrap: function (t) {
                return (
                  this.parent(t)
                    .not("body")
                    .each(function () {
                      x(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (x.expr.pseudos.hidden = function (t) {
              return !x.expr.pseudos.visible(t);
            }),
            (x.expr.pseudos.visible = function (t) {
              return !!(
                t.offsetWidth ||
                t.offsetHeight ||
                t.getClientRects().length
              );
            }),
            (x.ajaxSettings.xhr = function () {
              try {
                return new n.XMLHttpRequest();
              } catch (t) {}
            });
          var Ve = { 0: 200, 1223: 204 },
            Ge = x.ajaxSettings.xhr();
          (m.cors = !!Ge && "withCredentials" in Ge),
            (m.ajax = Ge = !!Ge),
            x.ajaxTransport(function (t) {
              var e, i;
              if (m.cors || (Ge && !t.crossDomain))
                return {
                  send: function (s, o) {
                    var r,
                      a = t.xhr();
                    if (
                      (a.open(t.type, t.url, t.async, t.username, t.password),
                      t.xhrFields)
                    )
                      for (r in t.xhrFields) a[r] = t.xhrFields[r];
                    for (r in (t.mimeType &&
                      a.overrideMimeType &&
                      a.overrideMimeType(t.mimeType),
                    t.crossDomain ||
                      s["X-Requested-With"] ||
                      (s["X-Requested-With"] = "XMLHttpRequest"),
                    s))
                      a.setRequestHeader(r, s[r]);
                    (e = function (t) {
                      return function () {
                        e &&
                          ((e =
                            i =
                            a.onload =
                            a.onerror =
                            a.onabort =
                            a.ontimeout =
                            a.onreadystatechange =
                              null),
                          "abort" === t
                            ? a.abort()
                            : "error" === t
                            ? "number" != typeof a.status
                              ? o(0, "error")
                              : o(a.status, a.statusText)
                            : o(
                                Ve[a.status] || a.status,
                                a.statusText,
                                "text" !== (a.responseType || "text") ||
                                  "string" != typeof a.responseText
                                  ? { binary: a.response }
                                  : { text: a.responseText },
                                a.getAllResponseHeaders()
                              ));
                      };
                    }),
                      (a.onload = e()),
                      (i = a.onerror = a.ontimeout = e("error")),
                      void 0 !== a.onabort
                        ? (a.onabort = i)
                        : (a.onreadystatechange = function () {
                            4 === a.readyState &&
                              n.setTimeout(function () {
                                e && i();
                              });
                          }),
                      (e = e("abort"));
                    try {
                      a.send((t.hasContent && t.data) || null);
                    } catch (t) {
                      if (e) throw t;
                    }
                  },
                  abort: function () {
                    e && e();
                  },
                };
            }),
            x.ajaxPrefilter(function (t) {
              t.crossDomain && (t.contents.script = !1);
            }),
            x.ajaxSetup({
              accepts: {
                script:
                  "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                "text script": function (t) {
                  return x.globalEval(t), t;
                },
              },
            }),
            x.ajaxPrefilter("script", function (t) {
              void 0 === t.cache && (t.cache = !1),
                t.crossDomain && (t.type = "GET");
            }),
            x.ajaxTransport("script", function (t) {
              var e, i;
              if (t.crossDomain || t.scriptAttrs)
                return {
                  send: function (n, s) {
                    (e = x("<script>")
                      .attr(t.scriptAttrs || {})
                      .prop({ charset: t.scriptCharset, src: t.url })
                      .on(
                        "load error",
                        (i = function (t) {
                          e.remove(),
                            (i = null),
                            t && s("error" === t.type ? 404 : 200, t.type);
                        })
                      )),
                      b.head.appendChild(e[0]);
                  },
                  abort: function () {
                    i && i();
                  },
                };
            });
          var Xe,
            Ze = [],
            Qe = /(=)\?(?=&|$)|\?\?/;
          x.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var t = Ze.pop() || x.expando + "_" + Ee.guid++;
              return (this[t] = !0), t;
            },
          }),
            x.ajaxPrefilter("json jsonp", function (t, e, i) {
              var s,
                o,
                r,
                a =
                  !1 !== t.jsonp &&
                  (Qe.test(t.url)
                    ? "url"
                    : "string" == typeof t.data &&
                      0 ===
                        (t.contentType || "").indexOf(
                          "application/x-www-form-urlencoded"
                        ) &&
                      Qe.test(t.data) &&
                      "data");
              if (a || "jsonp" === t.dataTypes[0])
                return (
                  (s = t.jsonpCallback =
                    v(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                  a
                    ? (t[a] = t[a].replace(Qe, "$1" + s))
                    : !1 !== t.jsonp &&
                      (t.url +=
                        (Te.test(t.url) ? "&" : "?") + t.jsonp + "=" + s),
                  (t.converters["script json"] = function () {
                    return r || x.error(s + " was not called"), r[0];
                  }),
                  (t.dataTypes[0] = "json"),
                  (o = n[s]),
                  (n[s] = function () {
                    r = arguments;
                  }),
                  i.always(function () {
                    void 0 === o ? x(n).removeProp(s) : (n[s] = o),
                      t[s] && ((t.jsonpCallback = e.jsonpCallback), Ze.push(s)),
                      r && v(o) && o(r[0]),
                      (r = o = void 0);
                  }),
                  "script"
                );
            }),
            (m.createHTMLDocument =
              (((Xe = b.implementation.createHTMLDocument("").body).innerHTML =
                "<form></form><form></form>"),
              2 === Xe.childNodes.length)),
            (x.parseHTML = function (t, e, i) {
              return "string" != typeof t
                ? []
                : ("boolean" == typeof e && ((i = e), (e = !1)),
                  e ||
                    (m.createHTMLDocument
                      ? (((n = (e =
                          b.implementation.createHTMLDocument(
                            ""
                          )).createElement("base")).href = b.location.href),
                        e.head.appendChild(n))
                      : (e = b)),
                  (o = !i && []),
                  (s = D.exec(t))
                    ? [e.createElement(s[1])]
                    : ((s = Ct([t], e, o)),
                      o && o.length && x(o).remove(),
                      x.merge([], s.childNodes)));
              var n, s, o;
            }),
            (x.fn.load = function (t, e, i) {
              var n,
                s,
                o,
                r = this,
                a = t.indexOf(" ");
              return (
                a > -1 && ((n = be(t.slice(a))), (t = t.slice(0, a))),
                v(e)
                  ? ((i = e), (e = void 0))
                  : e && "object" == typeof e && (s = "POST"),
                r.length > 0 &&
                  x
                    .ajax({
                      url: t,
                      type: s || "GET",
                      dataType: "html",
                      data: e,
                    })
                    .done(function (t) {
                      (o = arguments),
                        r.html(
                          n ? x("<div>").append(x.parseHTML(t)).find(n) : t
                        );
                    })
                    .always(
                      i &&
                        function (t, e) {
                          r.each(function () {
                            i.apply(this, o || [t.responseText, e, t]);
                          });
                        }
                    ),
                this
              );
            }),
            (x.expr.pseudos.animated = function (t) {
              return x.grep(x.timers, function (e) {
                return t === e.elem;
              }).length;
            }),
            (x.offset = {
              setOffset: function (t, e, i) {
                var n,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c = x.css(t, "position"),
                  h = x(t),
                  d = {};
                "static" === c && (t.style.position = "relative"),
                  (a = h.offset()),
                  (o = x.css(t, "top")),
                  (l = x.css(t, "left")),
                  ("absolute" === c || "fixed" === c) &&
                  (o + l).indexOf("auto") > -1
                    ? ((r = (n = h.position()).top), (s = n.left))
                    : ((r = parseFloat(o) || 0), (s = parseFloat(l) || 0)),
                  v(e) && (e = e.call(t, i, x.extend({}, a))),
                  null != e.top && (d.top = e.top - a.top + r),
                  null != e.left && (d.left = e.left - a.left + s),
                  "using" in e
                    ? e.using.call(t, d)
                    : ("number" == typeof d.top && (d.top += "px"),
                      "number" == typeof d.left && (d.left += "px"),
                      h.css(d));
              },
            }),
            x.fn.extend({
              offset: function (t) {
                if (arguments.length)
                  return void 0 === t
                    ? this
                    : this.each(function (e) {
                        x.offset.setOffset(this, t, e);
                      });
                var e,
                  i,
                  n = this[0];
                return n
                  ? n.getClientRects().length
                    ? ((e = n.getBoundingClientRect()),
                      (i = n.ownerDocument.defaultView),
                      {
                        top: e.top + i.pageYOffset,
                        left: e.left + i.pageXOffset,
                      })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var t,
                    e,
                    i,
                    n = this[0],
                    s = { top: 0, left: 0 };
                  if ("fixed" === x.css(n, "position"))
                    e = n.getBoundingClientRect();
                  else {
                    for (
                      e = this.offset(),
                        i = n.ownerDocument,
                        t = n.offsetParent || i.documentElement;
                      t &&
                      (t === i.body || t === i.documentElement) &&
                      "static" === x.css(t, "position");

                    )
                      t = t.parentNode;
                    t &&
                      t !== n &&
                      1 === t.nodeType &&
                      (((s = x(t).offset()).top += x.css(
                        t,
                        "borderTopWidth",
                        !0
                      )),
                      (s.left += x.css(t, "borderLeftWidth", !0)));
                  }
                  return {
                    top: e.top - s.top - x.css(n, "marginTop", !0),
                    left: e.left - s.left - x.css(n, "marginLeft", !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (
                    var t = this.offsetParent;
                    t && "static" === x.css(t, "position");

                  )
                    t = t.offsetParent;
                  return t || rt;
                });
              },
            }),
            x.each(
              { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
              function (t, e) {
                var i = "pageYOffset" === e;
                x.fn[t] = function (n) {
                  return W(
                    this,
                    function (t, n, s) {
                      var o;
                      if (
                        (y(t)
                          ? (o = t)
                          : 9 === t.nodeType && (o = t.defaultView),
                        void 0 === s)
                      )
                        return o ? o[e] : t[n];
                      o
                        ? o.scrollTo(
                            i ? o.pageXOffset : s,
                            i ? s : o.pageYOffset
                          )
                        : (t[n] = s);
                    },
                    t,
                    n,
                    arguments.length
                  );
                };
              }
            ),
            x.each(["top", "left"], function (t, e) {
              x.cssHooks[e] = Gt(m.pixelPosition, function (t, i) {
                if (i)
                  return (
                    (i = Vt(t, e)), zt.test(i) ? x(t).position()[e] + "px" : i
                  );
              });
            }),
            x.each({ Height: "height", Width: "width" }, function (t, e) {
              x.each(
                { padding: "inner" + t, content: e, "": "outer" + t },
                function (i, n) {
                  x.fn[n] = function (s, o) {
                    var r = arguments.length && (i || "boolean" != typeof s),
                      a = i || (!0 === s || !0 === o ? "margin" : "border");
                    return W(
                      this,
                      function (e, i, s) {
                        var o;
                        return y(e)
                          ? 0 === n.indexOf("outer")
                            ? e["inner" + t]
                            : e.document.documentElement["client" + t]
                          : 9 === e.nodeType
                          ? ((o = e.documentElement),
                            Math.max(
                              e.body["scroll" + t],
                              o["scroll" + t],
                              e.body["offset" + t],
                              o["offset" + t],
                              o["client" + t]
                            ))
                          : void 0 === s
                          ? x.css(e, i, a)
                          : x.style(e, i, s, a);
                      },
                      e,
                      r ? s : void 0,
                      r
                    );
                  };
                }
              );
            }),
            x.each(
              [
                "ajaxStart",
                "ajaxStop",
                "ajaxComplete",
                "ajaxError",
                "ajaxSuccess",
                "ajaxSend",
              ],
              function (t, e) {
                x.fn[e] = function (t) {
                  return this.on(e, t);
                };
              }
            ),
            x.fn.extend({
              bind: function (t, e, i) {
                return this.on(t, null, e, i);
              },
              unbind: function (t, e) {
                return this.off(t, null, e);
              },
              delegate: function (t, e, i, n) {
                return this.on(e, t, i, n);
              },
              undelegate: function (t, e, i) {
                return 1 === arguments.length
                  ? this.off(t, "**")
                  : this.off(e, t || "**", i);
              },
              hover: function (t, e) {
                return this.mouseenter(t).mouseleave(e || t);
              },
            }),
            x.each(
              "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " "
              ),
              function (t, e) {
                x.fn[e] = function (t, i) {
                  return arguments.length > 0
                    ? this.on(e, null, t, i)
                    : this.trigger(e);
                };
              }
            );
          var Ke = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          (x.proxy = function (t, e) {
            var i, n, s;
            if (("string" == typeof e && ((i = t[e]), (e = t), (t = i)), v(t)))
              return (
                (n = a.call(arguments, 2)),
                (s = function () {
                  return t.apply(e || this, n.concat(a.call(arguments)));
                }),
                (s.guid = t.guid = t.guid || x.guid++),
                s
              );
          }),
            (x.holdReady = function (t) {
              t ? x.readyWait++ : x.ready(!0);
            }),
            (x.isArray = Array.isArray),
            (x.parseJSON = JSON.parse),
            (x.nodeName = I),
            (x.isFunction = v),
            (x.isWindow = y),
            (x.camelCase = Z),
            (x.type = S),
            (x.now = Date.now),
            (x.isNumeric = function (t) {
              var e = x.type(t);
              return (
                ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
              );
            }),
            (x.trim = function (t) {
              return null == t ? "" : (t + "").replace(Ke, "");
            }),
            void 0 ===
              (i = function () {
                return x;
              }.apply(e, [])) || (t.exports = i);
          var Ye = n.jQuery,
            Je = n.$;
          return (
            (x.noConflict = function (t) {
              return (
                n.$ === x && (n.$ = Je),
                t && n.jQuery === x && (n.jQuery = Ye),
                x
              );
            }),
            void 0 === s && (n.jQuery = n.$ = x),
            x
          );
        });
      },
      405: (t) => {
        t.exports = function (t, e, i, n) {
          var s, o, r;
          return function () {
            if (
              ((r = this),
              (o = Array.prototype.slice.call(arguments)),
              !s || (!i && !n))
            ) {
              if (!i) return l(), (s = setTimeout(a, e));
              (s = setTimeout(l, e)), t.apply(r, o);
            }
            function a() {
              l(), t.apply(r, o);
            }
            function l() {
              clearTimeout(s), (s = null);
            }
          };
        };
      },
      411: function (t, e, i) {
        var n, s;
        void 0 ===
          (s =
            "function" ==
            typeof (n = function () {
              "use strict";
              return function (t, e) {
                var i,
                  n,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c,
                  h,
                  d,
                  u,
                  p,
                  f,
                  g,
                  m,
                  v,
                  y,
                  b,
                  w = this,
                  _ = !1,
                  S = !0,
                  C = !0,
                  x = {
                    barsSize: { top: 44, bottom: "auto" },
                    closeElClasses: [
                      "item",
                      "caption",
                      "zoom-wrap",
                      "ui",
                      "top-bar",
                    ],
                    timeToIdle: 4e3,
                    timeToIdleOutside: 1e3,
                    loadingIndicatorDelay: 1e3,
                    addCaptionHTMLFn: function (t, e) {
                      return t.title
                        ? ((e.children[0].innerHTML = t.title), !0)
                        : ((e.children[0].innerHTML = ""), !1);
                    },
                    closeEl: !0,
                    captionEl: !0,
                    fullscreenEl: !0,
                    zoomEl: !0,
                    shareEl: !0,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                    tapToClose: !1,
                    tapToToggleControls: !0,
                    clickToCloseNonZoomable: !0,
                    shareButtons: [
                      {
                        id: "facebook",
                        label: "Share on Facebook",
                        url: "https://www.facebook.com/sharer/sharer.php?u=",
                      },
                      {
                        id: "twitter",
                        label: "Tweet",
                        url: "https://twitter.com/intent/tweet?text=&url=",
                      },
                      {
                        id: "pinterest",
                        label: "Pin it",
                        url: "http://www.pinterest.com/pin/create/button/?url=&media=&description=",
                      },
                      {
                        id: "download",
                        label: "Download image",
                        url: "",
                        download: !0,
                      },
                    ],
                    getImageURLForShare: function () {
                      return t.currItem.src || "";
                    },
                    getPageURLForShare: function () {
                      return window.location.href;
                    },
                    getTextForShare: function () {
                      return t.currItem.title || "";
                    },
                    indexIndicatorSep: " / ",
                    fitControlsWidth: 1200,
                  },
                  k = function (t) {
                    if (v) return !0;
                    (t = t || window.event),
                      m.timeToIdle && m.mouseUsed && !h && O();
                    for (
                      var i,
                        n,
                        s =
                          (t.target || t.srcElement).getAttribute("class") ||
                          "",
                        o = 0;
                      o < j.length;
                      o++
                    )
                      (i = j[o]).onTap &&
                        s.indexOf("pswp__" + i.name) > -1 &&
                        (i.onTap(), (n = !0));
                    if (n) {
                      t.stopPropagation && t.stopPropagation(), (v = !0);
                      var r = e.features.isOldAndroid ? 600 : 30;
                      setTimeout(function () {
                        v = !1;
                      }, r);
                    }
                  },
                  E = function () {
                    return (
                      !t.likelyTouchDevice ||
                      m.mouseUsed ||
                      screen.width > m.fitControlsWidth
                    );
                  },
                  T = function (t, i, n) {
                    e[(n ? "add" : "remove") + "Class"](t, "pswp__" + i);
                  },
                  A = function () {
                    var t = 1 === m.getNumItemsFn();
                    t !== g && (T(n, "ui--one-slide", t), (g = t));
                  },
                  L = function () {
                    T(l, "share-modal--hidden", C);
                  },
                  I = function () {
                    return (
                      (C = !C)
                        ? (e.removeClass(l, "pswp__share-modal--fade-in"),
                          setTimeout(function () {
                            C && L();
                          }, 300))
                        : (L(),
                          setTimeout(function () {
                            C || e.addClass(l, "pswp__share-modal--fade-in");
                          }, 30)),
                      C || P(),
                      !1
                    );
                  },
                  D = function (e) {
                    var i = (e = e || window.event).target || e.srcElement;
                    return (
                      t.shout("shareLinkClick", e, i),
                      !(
                        !i.href ||
                        (!i.hasAttribute("download") &&
                          (window.open(
                            i.href,
                            "pswp_share",
                            "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                              (window.screen
                                ? Math.round(screen.width / 2 - 275)
                                : 100)
                          ),
                          C || I(),
                          1))
                      )
                    );
                  },
                  P = function () {
                    for (
                      var t, e, i, n, s = "", o = 0;
                      o < m.shareButtons.length;
                      o++
                    )
                      (t = m.shareButtons[o]),
                        (e = m.getImageURLForShare(t)),
                        (i = m.getPageURLForShare(t)),
                        (n = m.getTextForShare(t)),
                        (s +=
                          '<a href="' +
                          t.url
                            .replace("", encodeURIComponent(i))
                            .replace("", encodeURIComponent(e))
                            .replace("", e)
                            .replace("", encodeURIComponent(n)) +
                          '" target="_blank" class="pswp__share--' +
                          t.id +
                          '"' +
                          (t.download ? "download" : "") +
                          ">" +
                          t.label +
                          "</a>"),
                        m.parseShareButtonOut &&
                          (s = m.parseShareButtonOut(t, s));
                    (l.children[0].innerHTML = s), (l.children[0].onclick = D);
                  },
                  $ = function (t) {
                    for (var i = 0; i < m.closeElClasses.length; i++)
                      if (e.hasClass(t, "pswp__" + m.closeElClasses[i]))
                        return !0;
                  },
                  M = 0,
                  O = function () {
                    clearTimeout(b), (M = 0), h && w.setIdle(!1);
                  },
                  q = function (t) {
                    var e =
                      (t = t || window.event).relatedTarget || t.toElement;
                    (e && "HTML" !== e.nodeName) ||
                      (clearTimeout(b),
                      (b = setTimeout(function () {
                        w.setIdle(!0);
                      }, m.timeToIdleOutside)));
                  },
                  F = function () {
                    m.fullscreenEl &&
                      !e.features.isOldAndroid &&
                      (i || (i = w.getFullscreenAPI()),
                      i
                        ? (e.bind(document, i.eventK, w.updateFullscreen),
                          w.updateFullscreen(),
                          e.addClass(t.template, "pswp--supports-fs"))
                        : e.removeClass(t.template, "pswp--supports-fs"));
                  },
                  B = function () {
                    m.preloaderEl &&
                      (N(!0),
                      d("beforeChange", function () {
                        clearTimeout(f),
                          (f = setTimeout(function () {
                            t.currItem && t.currItem.loading
                              ? (!t.allowProgressiveImg() ||
                                  (t.currItem.img &&
                                    !t.currItem.img.naturalWidth)) &&
                                N(!1)
                              : N(!0);
                          }, m.loadingIndicatorDelay));
                      }),
                      d("imageLoadComplete", function (e, i) {
                        t.currItem === i && N(!0);
                      }));
                  },
                  N = function (t) {
                    p !== t && (T(u, "preloader--active", !t), (p = t));
                  },
                  R = function (t) {
                    var i = t.vGap;
                    if (E()) {
                      var r = m.barsSize;
                      if (m.captionEl && "auto" === r.bottom)
                        if (
                          (o ||
                            ((o = e.createEl(
                              "pswp__caption pswp__caption--fake"
                            )).appendChild(e.createEl("pswp__caption__center")),
                            n.insertBefore(o, s),
                            e.addClass(n, "pswp__ui--fit")),
                          m.addCaptionHTMLFn(t, o, !0))
                        ) {
                          var a = o.clientHeight;
                          i.bottom = parseInt(a, 10) || 44;
                        } else i.bottom = r.top;
                      else i.bottom = "auto" === r.bottom ? 0 : r.bottom;
                      i.top = r.top;
                    } else i.top = i.bottom = 0;
                  },
                  H = function () {
                    m.timeToIdle &&
                      d("mouseUsed", function () {
                        e.bind(document, "mousemove", O),
                          e.bind(document, "mouseout", q),
                          (y = setInterval(function () {
                            2 == ++M && w.setIdle(!0);
                          }, m.timeToIdle / 2));
                      });
                  },
                  z = function () {
                    var t;
                    d("onVerticalDrag", function (t) {
                      S && t < 0.95
                        ? w.hideControls()
                        : !S && t >= 0.95 && w.showControls();
                    }),
                      d("onPinchClose", function (e) {
                        S && e < 0.9
                          ? (w.hideControls(), (t = !0))
                          : t && !S && e > 0.9 && w.showControls();
                      }),
                      d("zoomGestureEnded", function () {
                        (t = !1) && !S && w.showControls();
                      });
                  },
                  j = [
                    {
                      name: "caption",
                      option: "captionEl",
                      onInit: function (t) {
                        s = t;
                      },
                    },
                    {
                      name: "share-modal",
                      option: "shareEl",
                      onInit: function (t) {
                        l = t;
                      },
                      onTap: function () {
                        I();
                      },
                    },
                    {
                      name: "button--share",
                      option: "shareEl",
                      onInit: function (t) {
                        a = t;
                      },
                      onTap: function () {
                        I();
                      },
                    },
                    {
                      name: "button--zoom",
                      option: "zoomEl",
                      onTap: t.toggleDesktopZoom,
                    },
                    {
                      name: "counter",
                      option: "counterEl",
                      onInit: function (t) {
                        r = t;
                      },
                    },
                    {
                      name: "button--close",
                      option: "closeEl",
                      onTap: t.close,
                    },
                    {
                      name: "button--arrow--left",
                      option: "arrowEl",
                      onTap: t.prev,
                    },
                    {
                      name: "button--arrow--right",
                      option: "arrowEl",
                      onTap: t.next,
                    },
                    {
                      name: "button--fs",
                      option: "fullscreenEl",
                      onTap: function () {
                        i.isFullscreen() ? i.exit() : i.enter();
                      },
                    },
                    {
                      name: "preloader",
                      option: "preloaderEl",
                      onInit: function (t) {
                        u = t;
                      },
                    },
                  ],
                  U = function () {
                    var t,
                      i,
                      s,
                      o = function (n) {
                        if (n)
                          for (var o = n.length, r = 0; r < o; r++) {
                            (t = n[r]), (i = t.className);
                            for (var a = 0; a < j.length; a++)
                              (s = j[a]),
                                i.indexOf("pswp__" + s.name) > -1 &&
                                  (m[s.option]
                                    ? (e.removeClass(
                                        t,
                                        "pswp__element--disabled"
                                      ),
                                      s.onInit && s.onInit(t))
                                    : e.addClass(t, "pswp__element--disabled"));
                          }
                      };
                    o(n.children);
                    var r = e.getChildByClass(n, "pswp__top-bar");
                    r && o(r.children);
                  };
                (w.init = function () {
                  e.extend(t.options, x, !0),
                    (m = t.options),
                    (n = e.getChildByClass(t.scrollWrap, "pswp__ui")),
                    (d = t.listen),
                    z(),
                    d("beforeChange", w.update),
                    d("doubleTap", function (e) {
                      var i = t.currItem.initialZoomLevel;
                      t.getZoomLevel() !== i
                        ? t.zoomTo(i, e, 333)
                        : t.zoomTo(m.getDoubleTapZoom(!1, t.currItem), e, 333);
                    }),
                    d("preventDragEvent", function (t, e, i) {
                      var n = t.target || t.srcElement;
                      n &&
                        n.getAttribute("class") &&
                        t.type.indexOf("mouse") > -1 &&
                        (n.getAttribute("class").indexOf("__caption") > 0 ||
                          /(SMALL|STRONG|EM)/i.test(n.tagName)) &&
                        (i.prevent = !1);
                    }),
                    d("bindEvents", function () {
                      e.bind(n, "pswpTap click", k),
                        e.bind(t.scrollWrap, "pswpTap", w.onGlobalTap),
                        t.likelyTouchDevice ||
                          e.bind(t.scrollWrap, "mouseover", w.onMouseOver);
                    }),
                    d("unbindEvents", function () {
                      C || I(),
                        y && clearInterval(y),
                        e.unbind(document, "mouseout", q),
                        e.unbind(document, "mousemove", O),
                        e.unbind(n, "pswpTap click", k),
                        e.unbind(t.scrollWrap, "pswpTap", w.onGlobalTap),
                        e.unbind(t.scrollWrap, "mouseover", w.onMouseOver),
                        i &&
                          (e.unbind(document, i.eventK, w.updateFullscreen),
                          i.isFullscreen() &&
                            ((m.hideAnimationDuration = 0), i.exit()),
                          (i = null));
                    }),
                    d("destroy", function () {
                      m.captionEl &&
                        (o && n.removeChild(o),
                        e.removeClass(s, "pswp__caption--empty")),
                        l && (l.children[0].onclick = null),
                        e.removeClass(n, "pswp__ui--over-close"),
                        e.addClass(n, "pswp__ui--hidden"),
                        w.setIdle(!1);
                    }),
                    m.showAnimationDuration ||
                      e.removeClass(n, "pswp__ui--hidden"),
                    d("initialZoomIn", function () {
                      m.showAnimationDuration &&
                        e.removeClass(n, "pswp__ui--hidden");
                    }),
                    d("initialZoomOut", function () {
                      e.addClass(n, "pswp__ui--hidden");
                    }),
                    d("parseVerticalMargin", R),
                    U(),
                    m.shareEl && a && l && (C = !0),
                    A(),
                    H(),
                    F(),
                    B();
                }),
                  (w.setIdle = function (t) {
                    (h = t), T(n, "ui--idle", t);
                  }),
                  (w.update = function () {
                    S && t.currItem
                      ? (w.updateIndexIndicator(),
                        m.captionEl &&
                          (m.addCaptionHTMLFn(t.currItem, s),
                          T(s, "caption--empty", !t.currItem.title)),
                        (_ = !0))
                      : (_ = !1),
                      C || I(),
                      A();
                  }),
                  (w.updateFullscreen = function (n) {
                    n &&
                      setTimeout(function () {
                        t.setScrollOffset(0, e.getScrollY());
                      }, 50),
                      e[(i.isFullscreen() ? "add" : "remove") + "Class"](
                        t.template,
                        "pswp--fs"
                      );
                  }),
                  (w.updateIndexIndicator = function () {
                    m.counterEl &&
                      (r.innerHTML =
                        t.getCurrentIndex() +
                        1 +
                        m.indexIndicatorSep +
                        m.getNumItemsFn());
                  }),
                  (w.onGlobalTap = function (i) {
                    var n = (i = i || window.event).target || i.srcElement;
                    if (!v)
                      if (i.detail && "mouse" === i.detail.pointerType) {
                        if ($(n)) return void t.close();
                        e.hasClass(n, "pswp__img") &&
                          (1 === t.getZoomLevel() &&
                          t.getZoomLevel() <= t.currItem.fitRatio
                            ? m.clickToCloseNonZoomable && t.close()
                            : t.toggleDesktopZoom(i.detail.releasePoint));
                      } else if (
                        (m.tapToToggleControls &&
                          (S ? w.hideControls() : w.showControls()),
                        m.tapToClose && (e.hasClass(n, "pswp__img") || $(n)))
                      )
                        return void t.close();
                  }),
                  (w.onMouseOver = function (t) {
                    var e = (t = t || window.event).target || t.srcElement;
                    T(n, "ui--over-close", $(e));
                  }),
                  (w.hideControls = function () {
                    e.addClass(n, "pswp__ui--hidden"), (S = !1);
                  }),
                  (w.showControls = function () {
                    (S = !0),
                      _ || w.update(),
                      e.removeClass(n, "pswp__ui--hidden");
                  }),
                  (w.supportsFullscreen = function () {
                    var t = document;
                    return !!(
                      t.exitFullscreen ||
                      t.mozCancelFullScreen ||
                      t.webkitExitFullscreen ||
                      t.msExitFullscreen
                    );
                  }),
                  (w.getFullscreenAPI = function () {
                    var e,
                      i = document.documentElement,
                      n = "fullscreenchange";
                    return (
                      i.requestFullscreen
                        ? (e = {
                            enterK: "requestFullscreen",
                            exitK: "exitFullscreen",
                            elementK: "fullscreenElement",
                            eventK: n,
                          })
                        : i.mozRequestFullScreen
                        ? (e = {
                            enterK: "mozRequestFullScreen",
                            exitK: "mozCancelFullScreen",
                            elementK: "mozFullScreenElement",
                            eventK: "moz" + n,
                          })
                        : i.webkitRequestFullscreen
                        ? (e = {
                            enterK: "webkitRequestFullscreen",
                            exitK: "webkitExitFullscreen",
                            elementK: "webkitFullscreenElement",
                            eventK: "webkit" + n,
                          })
                        : i.msRequestFullscreen &&
                          (e = {
                            enterK: "msRequestFullscreen",
                            exitK: "msExitFullscreen",
                            elementK: "msFullscreenElement",
                            eventK: "MSFullscreenChange",
                          }),
                      e &&
                        ((e.enter = function () {
                          if (
                            ((c = m.closeOnScroll),
                            (m.closeOnScroll = !1),
                            "webkitRequestFullscreen" !== this.enterK)
                          )
                            return t.template[this.enterK]();
                          t.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                        }),
                        (e.exit = function () {
                          return (m.closeOnScroll = c), document[this.exitK]();
                        }),
                        (e.isFullscreen = function () {
                          return document[this.elementK];
                        })),
                      e
                    );
                  });
              };
            })
              ? n.call(e, i, e, t)
              : n) || (t.exports = s);
      },
      832: function (t, e, i) {
        var n, s;
        (n = function () {
          "use strict";
          var t = function (t, e, i, n) {
            var s = {
              features: null,
              bind: function (t, e, i, n) {
                var s = (n ? "remove" : "add") + "EventListener";
                e = e.split(" ");
                for (var o = 0; o < e.length; o++) e[o] && t[s](e[o], i, !1);
              },
              isArray: function (t) {
                return t instanceof Array;
              },
              createEl: function (t, e) {
                var i = document.createElement(e || "div");
                return t && (i.className = t), i;
              },
              getScrollY: function () {
                var t = window.pageYOffset;
                return void 0 !== t ? t : document.documentElement.scrollTop;
              },
              unbind: function (t, e, i) {
                s.bind(t, e, i, !0);
              },
              removeClass: function (t, e) {
                var i = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className
                  .replace(i, " ")
                  .replace(/^\s\s*/, "")
                  .replace(/\s\s*$/, "");
              },
              addClass: function (t, e) {
                s.hasClass(t, e) ||
                  (t.className += (t.className ? " " : "") + e);
              },
              hasClass: function (t, e) {
                return (
                  t.className &&
                  new RegExp("(^|\\s)" + e + "(\\s|$)").test(t.className)
                );
              },
              getChildByClass: function (t, e) {
                for (var i = t.firstChild; i; ) {
                  if (s.hasClass(i, e)) return i;
                  i = i.nextSibling;
                }
              },
              arraySearch: function (t, e, i) {
                for (var n = t.length; n--; ) if (t[n][i] === e) return n;
                return -1;
              },
              extend: function (t, e, i) {
                for (var n in e)
                  if (e.hasOwnProperty(n)) {
                    if (i && t.hasOwnProperty(n)) continue;
                    t[n] = e[n];
                  }
              },
              easing: {
                sine: {
                  out: function (t) {
                    return Math.sin(t * (Math.PI / 2));
                  },
                  inOut: function (t) {
                    return -(Math.cos(Math.PI * t) - 1) / 2;
                  },
                },
                cubic: {
                  out: function (t) {
                    return --t * t * t + 1;
                  },
                },
              },
              detectFeatures: function () {
                if (s.features) return s.features;
                var t = s.createEl().style,
                  e = "",
                  i = {};
                if (
                  ((i.oldIE = document.all && !document.addEventListener),
                  (i.touch = "ontouchstart" in window),
                  window.requestAnimationFrame &&
                    ((i.raf = window.requestAnimationFrame),
                    (i.caf = window.cancelAnimationFrame)),
                  (i.pointerEvent =
                    !!window.PointerEvent || navigator.msPointerEnabled),
                  !i.pointerEvent)
                ) {
                  var n = navigator.userAgent;
                  if (/iP(hone|od)/.test(navigator.platform)) {
                    var o = navigator.appVersion.match(
                      /OS (\d+)_(\d+)_?(\d+)?/
                    );
                    o &&
                      o.length > 0 &&
                      (o = parseInt(o[1], 10)) >= 1 &&
                      o < 8 &&
                      (i.isOldIOSPhone = !0);
                  }
                  var r = n.match(/Android\s([0-9\.]*)/),
                    a = r ? r[1] : 0;
                  (a = parseFloat(a)) >= 1 &&
                    (a < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = a)),
                    (i.isMobileOpera = /opera mini|opera mobi/i.test(n));
                }
                for (
                  var l,
                    c,
                    h = ["transform", "perspective", "animationName"],
                    d = ["", "webkit", "Moz", "ms", "O"],
                    u = 0;
                  u < 4;
                  u++
                ) {
                  e = d[u];
                  for (var p = 0; p < 3; p++)
                    (l = h[p]),
                      (c =
                        e + (e ? l.charAt(0).toUpperCase() + l.slice(1) : l)),
                      !i[l] && c in t && (i[l] = c);
                  e &&
                    !i.raf &&
                    ((e = e.toLowerCase()),
                    (i.raf = window[e + "RequestAnimationFrame"]),
                    i.raf &&
                      (i.caf =
                        window[e + "CancelAnimationFrame"] ||
                        window[e + "CancelRequestAnimationFrame"]));
                }
                if (!i.raf) {
                  var f = 0;
                  (i.raf = function (t) {
                    var e = new Date().getTime(),
                      i = Math.max(0, 16 - (e - f)),
                      n = window.setTimeout(function () {
                        t(e + i);
                      }, i);
                    return (f = e + i), n;
                  }),
                    (i.caf = function (t) {
                      clearTimeout(t);
                    });
                }
                return (
                  (i.svg =
                    !!document.createElementNS &&
                    !!document.createElementNS(
                      "http://www.w3.org/2000/svg",
                      "svg"
                    ).createSVGRect),
                  (s.features = i),
                  i
                );
              },
            };
            s.detectFeatures(),
              s.features.oldIE &&
                (s.bind = function (t, e, i, n) {
                  e = e.split(" ");
                  for (
                    var s,
                      o = (n ? "detach" : "attach") + "Event",
                      r = function () {
                        i.handleEvent.call(i);
                      },
                      a = 0;
                    a < e.length;
                    a++
                  )
                    if ((s = e[a]))
                      if ("object" == typeof i && i.handleEvent) {
                        if (n) {
                          if (!i["oldIE" + s]) return !1;
                        } else i["oldIE" + s] = r;
                        t[o]("on" + s, i["oldIE" + s]);
                      } else t[o]("on" + s, i);
                });
            var o = this,
              r = 25,
              a = 3,
              l = {
                allowPanToNext: !0,
                spacing: 0.12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: 0.75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: 0.35,
                panEndFriction: 0.35,
                isClickableElement: function (t) {
                  return "A" === t.tagName;
                },
                getDoubleTapZoom: function (t, e) {
                  return t || e.initialZoomLevel < 0.7 ? 1 : 1.33;
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit",
              };
            s.extend(l, n);
            var c,
              h,
              d,
              u,
              p,
              f,
              g,
              m,
              v,
              y,
              b,
              w,
              _,
              S,
              C,
              x,
              k,
              E,
              T,
              A,
              L,
              I,
              D,
              P,
              $,
              M,
              O,
              q,
              F,
              B,
              N,
              R,
              H,
              z,
              j,
              U,
              W,
              V,
              G,
              X,
              Z,
              Q,
              K,
              Y,
              J,
              tt,
              et,
              it,
              nt,
              st,
              ot,
              rt,
              at,
              lt,
              ct,
              ht,
              dt = function () {
                return { x: 0, y: 0 };
              },
              ut = dt(),
              pt = dt(),
              ft = dt(),
              gt = {},
              mt = 0,
              vt = {},
              yt = dt(),
              bt = 0,
              wt = !0,
              _t = [],
              St = {},
              Ct = !1,
              xt = function (t, e) {
                s.extend(o, e.publicMethods), _t.push(t);
              },
              kt = function (t) {
                var e = Je();
                return t > e - 1 ? t - e : t < 0 ? e + t : t;
              },
              Et = {},
              Tt = function (t, e) {
                return Et[t] || (Et[t] = []), Et[t].push(e);
              },
              At = function (t) {
                var e = Et[t];
                if (e) {
                  var i = Array.prototype.slice.call(arguments);
                  i.shift();
                  for (var n = 0; n < e.length; n++) e[n].apply(o, i);
                }
              },
              Lt = function () {
                return new Date().getTime();
              },
              It = function (t) {
                (lt = t), (o.bg.style.opacity = t * l.bgOpacity);
              },
              Dt = function (t, e, i, n, s) {
                (!Ct || (s && s !== o.currItem)) &&
                  (n /= s ? s.fitRatio : o.currItem.fitRatio),
                  (t[I] = w + e + "px, " + i + "px" + _ + " scale(" + n + ")");
              },
              Pt = function (t) {
                nt &&
                  (t &&
                    (y > o.currItem.fitRatio
                      ? Ct || (hi(o.currItem, !1, !0), (Ct = !0))
                      : Ct && (hi(o.currItem), (Ct = !1))),
                  Dt(nt, ft.x, ft.y, y));
              },
              $t = function (t) {
                t.container &&
                  Dt(
                    t.container.style,
                    t.initialPosition.x,
                    t.initialPosition.y,
                    t.initialZoomLevel,
                    t
                  );
              },
              Mt = function (t, e) {
                e[I] = w + t + "px, 0px" + _;
              },
              Ot = function (t, e) {
                if (!l.loop && e) {
                  var i = u + (yt.x * mt - t) / yt.x,
                    n = Math.round(t - ye.x);
                  ((i < 0 && n > 0) || (i >= Je() - 1 && n < 0)) &&
                    (t = ye.x + n * l.mainScrollEndFriction);
                }
                (ye.x = t), Mt(t, p);
              },
              qt = function (t, e) {
                var i = be[t] - vt[t];
                return pt[t] + ut[t] + i - i * (e / b);
              },
              Ft = function (t, e) {
                (t.x = e.x), (t.y = e.y), e.id && (t.id = e.id);
              },
              Bt = function (t) {
                (t.x = Math.round(t.x)), (t.y = Math.round(t.y));
              },
              Nt = null,
              Rt = function () {
                Nt &&
                  (s.unbind(document, "mousemove", Rt),
                  s.addClass(t, "pswp--has_mouse"),
                  (l.mouseUsed = !0),
                  At("mouseUsed")),
                  (Nt = setTimeout(function () {
                    Nt = null;
                  }, 100));
              },
              Ht = function () {
                s.bind(document, "keydown", o),
                  N.transform && s.bind(o.scrollWrap, "click", o),
                  l.mouseUsed || s.bind(document, "mousemove", Rt),
                  s.bind(window, "resize scroll orientationchange", o),
                  At("bindEvents");
              },
              zt = function () {
                s.unbind(window, "resize scroll orientationchange", o),
                  s.unbind(window, "scroll", v.scroll),
                  s.unbind(document, "keydown", o),
                  s.unbind(document, "mousemove", Rt),
                  N.transform && s.unbind(o.scrollWrap, "click", o),
                  G && s.unbind(window, g, o),
                  clearTimeout(R),
                  At("unbindEvents");
              },
              jt = function (t, e) {
                var i = ri(o.currItem, gt, t);
                return e && (it = i), i;
              },
              Ut = function (t) {
                return t || (t = o.currItem), t.initialZoomLevel;
              },
              Wt = function (t) {
                return t || (t = o.currItem), t.w > 0 ? l.maxSpreadZoom : 1;
              },
              Vt = function (t, e, i, n) {
                return n === o.currItem.initialZoomLevel
                  ? ((i[t] = o.currItem.initialPosition[t]), !0)
                  : ((i[t] = qt(t, n)),
                    i[t] > e.min[t]
                      ? ((i[t] = e.min[t]), !0)
                      : i[t] < e.max[t] && ((i[t] = e.max[t]), !0));
              },
              Gt = function () {
                if (I) {
                  var e = N.perspective && !P;
                  return (
                    (w = "translate" + (e ? "3d(" : "(")),
                    void (_ = N.perspective ? ", 0px)" : ")")
                  );
                }
                (I = "left"),
                  s.addClass(t, "pswp--ie"),
                  (Mt = function (t, e) {
                    e.left = t + "px";
                  }),
                  ($t = function (t) {
                    var e = t.fitRatio > 1 ? 1 : t.fitRatio,
                      i = t.container.style,
                      n = e * t.w,
                      s = e * t.h;
                    (i.width = n + "px"),
                      (i.height = s + "px"),
                      (i.left = t.initialPosition.x + "px"),
                      (i.top = t.initialPosition.y + "px");
                  }),
                  (Pt = function () {
                    if (nt) {
                      var t = nt,
                        e = o.currItem,
                        i = e.fitRatio > 1 ? 1 : e.fitRatio,
                        n = i * e.w,
                        s = i * e.h;
                      (t.width = n + "px"),
                        (t.height = s + "px"),
                        (t.left = ft.x + "px"),
                        (t.top = ft.y + "px");
                    }
                  });
              },
              Xt = function (t) {
                var e = "";
                l.escKey && 27 === t.keyCode
                  ? (e = "close")
                  : l.arrowKeys &&
                    (37 === t.keyCode
                      ? (e = "prev")
                      : 39 === t.keyCode && (e = "next")),
                  e &&
                    (t.ctrlKey ||
                      t.altKey ||
                      t.shiftKey ||
                      t.metaKey ||
                      (t.preventDefault
                        ? t.preventDefault()
                        : (t.returnValue = !1),
                      o[e]()));
              },
              Zt = function (t) {
                t &&
                  (Q || Z || st || W) &&
                  (t.preventDefault(), t.stopPropagation());
              },
              Qt = function () {
                o.setScrollOffset(0, s.getScrollY());
              },
              Kt = {},
              Yt = 0,
              Jt = function (t) {
                Kt[t] && (Kt[t].raf && M(Kt[t].raf), Yt--, delete Kt[t]);
              },
              te = function (t) {
                Kt[t] && Jt(t), Kt[t] || (Yt++, (Kt[t] = {}));
              },
              ee = function () {
                for (var t in Kt) Kt.hasOwnProperty(t) && Jt(t);
              },
              ie = function (t, e, i, n, s, o, r) {
                var a,
                  l = Lt();
                te(t);
                var c = function () {
                  if (Kt[t]) {
                    if ((a = Lt() - l) >= n)
                      return Jt(t), o(i), void (r && r());
                    o((i - e) * s(a / n) + e), (Kt[t].raf = $(c));
                  }
                };
                c();
              },
              ne = {
                shout: At,
                listen: Tt,
                viewportSize: gt,
                options: l,
                isMainScrollAnimating: function () {
                  return st;
                },
                getZoomLevel: function () {
                  return y;
                },
                getCurrentIndex: function () {
                  return u;
                },
                isDragging: function () {
                  return G;
                },
                isZooming: function () {
                  return tt;
                },
                setScrollOffset: function (t, e) {
                  (vt.x = t), (B = vt.y = e), At("updateScrollOffset", vt);
                },
                applyZoomPan: function (t, e, i, n) {
                  (ft.x = e), (ft.y = i), (y = t), Pt(n);
                },
                init: function () {
                  if (!c && !h) {
                    var i;
                    (o.framework = s),
                      (o.template = t),
                      (o.bg = s.getChildByClass(t, "pswp__bg")),
                      (O = t.className),
                      (c = !0),
                      (N = s.detectFeatures()),
                      ($ = N.raf),
                      (M = N.caf),
                      (I = N.transform),
                      (F = N.oldIE),
                      (o.scrollWrap = s.getChildByClass(
                        t,
                        "pswp__scroll-wrap"
                      )),
                      (o.container = s.getChildByClass(
                        o.scrollWrap,
                        "pswp__container"
                      )),
                      (p = o.container.style),
                      (o.itemHolders = x =
                        [
                          { el: o.container.children[0], wrap: 0, index: -1 },
                          { el: o.container.children[1], wrap: 0, index: -1 },
                          { el: o.container.children[2], wrap: 0, index: -1 },
                        ]),
                      (x[0].el.style.display = x[2].el.style.display = "none"),
                      Gt(),
                      (v = {
                        resize: o.updateSize,
                        orientationchange: function () {
                          clearTimeout(R),
                            (R = setTimeout(function () {
                              gt.x !== o.scrollWrap.clientWidth &&
                                o.updateSize();
                            }, 500));
                        },
                        scroll: Qt,
                        keydown: Xt,
                        click: Zt,
                      });
                    var n =
                      N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                    for (
                      (N.animationName && N.transform && !n) ||
                        (l.showAnimationDuration = l.hideAnimationDuration = 0),
                        i = 0;
                      i < _t.length;
                      i++
                    )
                      o["init" + _t[i]]();
                    e && (o.ui = new e(o, s)).init(),
                      At("firstUpdate"),
                      (u = u || l.index || 0),
                      (isNaN(u) || u < 0 || u >= Je()) && (u = 0),
                      (o.currItem = Ye(u)),
                      (N.isOldIOSPhone || N.isOldAndroid) && (wt = !1),
                      t.setAttribute("aria-hidden", "false"),
                      l.modal &&
                        (wt
                          ? (t.style.position = "fixed")
                          : ((t.style.position = "absolute"),
                            (t.style.top = s.getScrollY() + "px"))),
                      void 0 === B &&
                        (At("initialLayout"), (B = q = s.getScrollY()));
                    var r = "pswp--open ";
                    for (
                      l.mainClass && (r += l.mainClass + " "),
                        l.showHideOpacity && (r += "pswp--animate_opacity "),
                        r += P ? "pswp--touch" : "pswp--notouch",
                        r += N.animationName ? " pswp--css_animation" : "",
                        r += N.svg ? " pswp--svg" : "",
                        s.addClass(t, r),
                        o.updateSize(),
                        f = -1,
                        bt = null,
                        i = 0;
                      i < a;
                      i++
                    )
                      Mt((i + f) * yt.x, x[i].el.style);
                    F || s.bind(o.scrollWrap, m, o),
                      Tt("initialZoomInEnd", function () {
                        o.setContent(x[0], u - 1),
                          o.setContent(x[2], u + 1),
                          (x[0].el.style.display = x[2].el.style.display =
                            "block"),
                          l.focus && t.focus(),
                          Ht();
                      }),
                      o.setContent(x[1], u),
                      o.updateCurrItem(),
                      At("afterInit"),
                      wt ||
                        (S = setInterval(function () {
                          Yt ||
                            G ||
                            tt ||
                            y !== o.currItem.initialZoomLevel ||
                            o.updateSize();
                        }, 1e3)),
                      s.addClass(t, "pswp--visible");
                  }
                },
                close: function () {
                  c &&
                    ((c = !1),
                    (h = !0),
                    At("close"),
                    zt(),
                    ti(o.currItem, null, !0, o.destroy));
                },
                destroy: function () {
                  At("destroy"),
                    Xe && clearTimeout(Xe),
                    t.setAttribute("aria-hidden", "true"),
                    (t.className = O),
                    S && clearInterval(S),
                    s.unbind(o.scrollWrap, m, o),
                    s.unbind(window, "scroll", o),
                    xe(),
                    ee(),
                    (Et = null);
                },
                panTo: function (t, e, i) {
                  i ||
                    (t > it.min.x
                      ? (t = it.min.x)
                      : t < it.max.x && (t = it.max.x),
                    e > it.min.y
                      ? (e = it.min.y)
                      : e < it.max.y && (e = it.max.y)),
                    (ft.x = t),
                    (ft.y = e),
                    Pt();
                },
                handleEvent: function (t) {
                  (t = t || window.event), v[t.type] && v[t.type](t);
                },
                goTo: function (t) {
                  var e = (t = kt(t)) - u;
                  (bt = e),
                    (u = t),
                    (o.currItem = Ye(u)),
                    (mt -= e),
                    Ot(yt.x * mt),
                    ee(),
                    (st = !1),
                    o.updateCurrItem();
                },
                next: function () {
                  o.goTo(u + 1);
                },
                prev: function () {
                  o.goTo(u - 1);
                },
                updateCurrZoomItem: function (t) {
                  if ((t && At("beforeChange", 0), x[1].el.children.length)) {
                    var e = x[1].el.children[0];
                    nt = s.hasClass(e, "pswp__zoom-wrap") ? e.style : null;
                  } else nt = null;
                  (it = o.currItem.bounds),
                    (b = y = o.currItem.initialZoomLevel),
                    (ft.x = it.center.x),
                    (ft.y = it.center.y),
                    t && At("afterChange");
                },
                invalidateCurrItems: function () {
                  C = !0;
                  for (var t = 0; t < a; t++)
                    x[t].item && (x[t].item.needsUpdate = !0);
                },
                updateCurrItem: function (t) {
                  if (0 !== bt) {
                    var e,
                      i = Math.abs(bt);
                    if (!(t && i < 2)) {
                      (o.currItem = Ye(u)),
                        (Ct = !1),
                        At("beforeChange", bt),
                        i >= a && ((f += bt + (bt > 0 ? -a : a)), (i = a));
                      for (var n = 0; n < i; n++)
                        bt > 0
                          ? ((e = x.shift()),
                            (x[a - 1] = e),
                            f++,
                            Mt((f + 2) * yt.x, e.el.style),
                            o.setContent(e, u - i + n + 1 + 1))
                          : ((e = x.pop()),
                            x.unshift(e),
                            f--,
                            Mt(f * yt.x, e.el.style),
                            o.setContent(e, u + i - n - 1 - 1));
                      if (nt && 1 === Math.abs(bt)) {
                        var s = Ye(k);
                        s.initialZoomLevel !== y && (ri(s, gt), hi(s), $t(s));
                      }
                      (bt = 0),
                        o.updateCurrZoomItem(),
                        (k = u),
                        At("afterChange");
                    }
                  }
                },
                updateSize: function (e) {
                  if (!wt && l.modal) {
                    var i = s.getScrollY();
                    if (
                      (B !== i && ((t.style.top = i + "px"), (B = i)),
                      !e &&
                        St.x === window.innerWidth &&
                        St.y === window.innerHeight)
                    )
                      return;
                    (St.x = window.innerWidth),
                      (St.y = window.innerHeight),
                      (t.style.height = St.y + "px");
                  }
                  if (
                    ((gt.x = o.scrollWrap.clientWidth),
                    (gt.y = o.scrollWrap.clientHeight),
                    Qt(),
                    (yt.x = gt.x + Math.round(gt.x * l.spacing)),
                    (yt.y = gt.y),
                    Ot(yt.x * mt),
                    At("beforeResize"),
                    void 0 !== f)
                  ) {
                    for (var n, r, c, h = 0; h < a; h++)
                      (n = x[h]),
                        Mt((h + f) * yt.x, n.el.style),
                        (c = u + h - 1),
                        l.loop && Je() > 2 && (c = kt(c)),
                        (r = Ye(c)) && (C || r.needsUpdate || !r.bounds)
                          ? (o.cleanSlide(r),
                            o.setContent(n, c),
                            1 === h &&
                              ((o.currItem = r), o.updateCurrZoomItem(!0)),
                            (r.needsUpdate = !1))
                          : -1 === n.index && c >= 0 && o.setContent(n, c),
                        r && r.container && (ri(r, gt), hi(r), $t(r));
                    C = !1;
                  }
                  (b = y = o.currItem.initialZoomLevel),
                    (it = o.currItem.bounds) &&
                      ((ft.x = it.center.x), (ft.y = it.center.y), Pt(!0)),
                    At("resize");
                },
                zoomTo: function (t, e, i, n, o) {
                  e &&
                    ((b = y),
                    (be.x = Math.abs(e.x) - ft.x),
                    (be.y = Math.abs(e.y) - ft.y),
                    Ft(pt, ft));
                  var r = jt(t, !1),
                    a = {};
                  Vt("x", r, a, t), Vt("y", r, a, t);
                  var l = y,
                    c = { x: ft.x, y: ft.y };
                  Bt(a);
                  var h = function (e) {
                    1 === e
                      ? ((y = t), (ft.x = a.x), (ft.y = a.y))
                      : ((y = (t - l) * e + l),
                        (ft.x = (a.x - c.x) * e + c.x),
                        (ft.y = (a.y - c.y) * e + c.y)),
                      o && o(e),
                      Pt(1 === e);
                  };
                  i
                    ? ie("customZoomTo", 0, 1, i, n || s.easing.sine.inOut, h)
                    : h(1);
                },
              },
              se = 30,
              oe = 10,
              re = {},
              ae = {},
              le = {},
              ce = {},
              he = {},
              de = [],
              ue = {},
              pe = [],
              fe = {},
              ge = 0,
              me = dt(),
              ve = 0,
              ye = dt(),
              be = dt(),
              we = dt(),
              _e = function (t, e) {
                return t.x === e.x && t.y === e.y;
              },
              Se = function (t, e) {
                return Math.abs(t.x - e.x) < r && Math.abs(t.y - e.y) < r;
              },
              Ce = function (t, e) {
                return (
                  (fe.x = Math.abs(t.x - e.x)),
                  (fe.y = Math.abs(t.y - e.y)),
                  Math.sqrt(fe.x * fe.x + fe.y * fe.y)
                );
              },
              xe = function () {
                K && (M(K), (K = null));
              },
              ke = function () {
                G && ((K = $(ke)), He());
              },
              Ee = function () {
                return !(
                  "fit" === l.scaleMode && y === o.currItem.initialZoomLevel
                );
              },
              Te = function (t, e) {
                return (
                  !(!t || t === document) &&
                  !(
                    t.getAttribute("class") &&
                    t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1
                  ) &&
                  (e(t) ? t : Te(t.parentNode, e))
                );
              },
              Ae = {},
              Le = function (t, e) {
                return (
                  (Ae.prevent = !Te(t.target, l.isClickableElement)),
                  At("preventDragEvent", t, e, Ae),
                  Ae.prevent
                );
              },
              Ie = function (t, e) {
                return (
                  (e.x = t.pageX), (e.y = t.pageY), (e.id = t.identifier), e
                );
              },
              De = function (t, e, i) {
                (i.x = 0.5 * (t.x + e.x)), (i.y = 0.5 * (t.y + e.y));
              },
              Pe = function (t, e, i) {
                if (t - z > 50) {
                  var n = pe.length > 2 ? pe.shift() : {};
                  (n.x = e), (n.y = i), pe.push(n), (z = t);
                }
              },
              $e = function () {
                var t = ft.y - o.currItem.initialPosition.y;
                return 1 - Math.abs(t / (gt.y / 2));
              },
              Me = {},
              Oe = {},
              qe = [],
              Fe = function (t) {
                for (; qe.length > 0; ) qe.pop();
                return (
                  D
                    ? ((ht = 0),
                      de.forEach(function (t) {
                        0 === ht ? (qe[0] = t) : 1 === ht && (qe[1] = t), ht++;
                      }))
                    : t.type.indexOf("touch") > -1
                    ? t.touches &&
                      t.touches.length > 0 &&
                      ((qe[0] = Ie(t.touches[0], Me)),
                      t.touches.length > 1 && (qe[1] = Ie(t.touches[1], Oe)))
                    : ((Me.x = t.pageX),
                      (Me.y = t.pageY),
                      (Me.id = ""),
                      (qe[0] = Me)),
                  qe
                );
              },
              Be = function (t, e) {
                var i,
                  n,
                  s,
                  r,
                  a = ft[t] + e[t],
                  c = e[t] > 0,
                  h = ye.x + e.x,
                  d = ye.x - ue.x;
                if (
                  ((i = a > it.min[t] || a < it.max[t] ? l.panEndFriction : 1),
                  (a = ft[t] + e[t] * i),
                  (l.allowPanToNext || y === o.currItem.initialZoomLevel) &&
                    (nt
                      ? "h" !== ot ||
                        "x" !== t ||
                        Z ||
                        (c
                          ? (a > it.min[t] &&
                              ((i = l.panEndFriction),
                              it.min[t],
                              (n = it.min[t] - pt[t])),
                            (n <= 0 || d < 0) && Je() > 1
                              ? ((r = h), d < 0 && h > ue.x && (r = ue.x))
                              : it.min.x !== it.max.x && (s = a))
                          : (a < it.max[t] &&
                              ((i = l.panEndFriction),
                              it.max[t],
                              (n = pt[t] - it.max[t])),
                            (n <= 0 || d > 0) && Je() > 1
                              ? ((r = h), d > 0 && h < ue.x && (r = ue.x))
                              : it.min.x !== it.max.x && (s = a)))
                      : (r = h),
                    "x" === t))
                )
                  return (
                    void 0 !== r && (Ot(r, !0), (Y = r !== ue.x)),
                    it.min.x !== it.max.x &&
                      (void 0 !== s ? (ft.x = s) : Y || (ft.x += e.x * i)),
                    void 0 !== r
                  );
                st || Y || (y > o.currItem.fitRatio && (ft[t] += e[t] * i));
              },
              Ne = function (t) {
                if (!("mousedown" === t.type && t.button > 0))
                  if (Ke) t.preventDefault();
                  else if (!V || "mousedown" !== t.type) {
                    if (
                      (Le(t, !0) && t.preventDefault(), At("pointerDown"), D)
                    ) {
                      var e = s.arraySearch(de, t.pointerId, "id");
                      e < 0 && (e = de.length),
                        (de[e] = { x: t.pageX, y: t.pageY, id: t.pointerId });
                    }
                    var i = Fe(t),
                      n = i.length;
                    (J = null),
                      ee(),
                      (G && 1 !== n) ||
                        ((G = rt = !0),
                        s.bind(window, g, o),
                        (U = ct = at = W = Y = Q = X = Z = !1),
                        (ot = null),
                        At("firstTouchStart", i),
                        Ft(pt, ft),
                        (ut.x = ut.y = 0),
                        Ft(ce, i[0]),
                        Ft(he, ce),
                        (ue.x = yt.x * mt),
                        (pe = [{ x: ce.x, y: ce.y }]),
                        (z = H = Lt()),
                        jt(y, !0),
                        xe(),
                        ke()),
                      !tt &&
                        n > 1 &&
                        !st &&
                        !Y &&
                        ((b = y),
                        (Z = !1),
                        (tt = X = !0),
                        (ut.y = ut.x = 0),
                        Ft(pt, ft),
                        Ft(re, i[0]),
                        Ft(ae, i[1]),
                        De(re, ae, we),
                        (be.x = Math.abs(we.x) - ft.x),
                        (be.y = Math.abs(we.y) - ft.y),
                        (et = Ce(re, ae)));
                  }
              },
              Re = function (t) {
                if ((t.preventDefault(), D)) {
                  var e = s.arraySearch(de, t.pointerId, "id");
                  if (e > -1) {
                    var i = de[e];
                    (i.x = t.pageX), (i.y = t.pageY);
                  }
                }
                if (G) {
                  var n = Fe(t);
                  if (ot || Q || tt) J = n;
                  else if (ye.x !== yt.x * mt) ot = "h";
                  else {
                    var o = Math.abs(n[0].x - ce.x) - Math.abs(n[0].y - ce.y);
                    Math.abs(o) >= oe && ((ot = o > 0 ? "h" : "v"), (J = n));
                  }
                }
              },
              He = function () {
                if (J) {
                  var t = J.length;
                  if (0 !== t)
                    if (
                      (Ft(re, J[0]),
                      (le.x = re.x - ce.x),
                      (le.y = re.y - ce.y),
                      tt && t > 1)
                    ) {
                      if (
                        ((ce.x = re.x),
                        (ce.y = re.y),
                        !le.x && !le.y && _e(J[1], ae))
                      )
                        return;
                      Ft(ae, J[1]), Z || ((Z = !0), At("zoomGestureStarted"));
                      var e = Ce(re, ae),
                        i = Ve(e);
                      i >
                        o.currItem.initialZoomLevel +
                          o.currItem.initialZoomLevel / 15 && (ct = !0);
                      var n = 1,
                        s = Ut(),
                        r = Wt();
                      if (i < s)
                        if (
                          l.pinchToClose &&
                          !ct &&
                          b <= o.currItem.initialZoomLevel
                        ) {
                          var a = 1 - (s - i) / (s / 1.2);
                          It(a), At("onPinchClose", a), (at = !0);
                        } else
                          (n = (s - i) / s) > 1 && (n = 1),
                            (i = s - n * (s / 3));
                      else
                        i > r &&
                          ((n = (i - r) / (6 * s)) > 1 && (n = 1),
                          (i = r + n * s));
                      n < 0 && (n = 0),
                        De(re, ae, me),
                        (ut.x += me.x - we.x),
                        (ut.y += me.y - we.y),
                        Ft(we, me),
                        (ft.x = qt("x", i)),
                        (ft.y = qt("y", i)),
                        (U = i > y),
                        (y = i),
                        Pt();
                    } else {
                      if (!ot) return;
                      if (
                        (rt &&
                          ((rt = !1),
                          Math.abs(le.x) >= oe && (le.x -= J[0].x - he.x),
                          Math.abs(le.y) >= oe && (le.y -= J[0].y - he.y)),
                        (ce.x = re.x),
                        (ce.y = re.y),
                        0 === le.x && 0 === le.y)
                      )
                        return;
                      if ("v" === ot && l.closeOnVerticalDrag && !Ee()) {
                        (ut.y += le.y), (ft.y += le.y);
                        var c = $e();
                        return (
                          (W = !0), At("onVerticalDrag", c), It(c), void Pt()
                        );
                      }
                      Pe(Lt(), re.x, re.y),
                        (Q = !0),
                        (it = o.currItem.bounds),
                        Be("x", le) || (Be("y", le), Bt(ft), Pt());
                    }
                }
              },
              ze = function (t) {
                if (N.isOldAndroid) {
                  if (V && "mouseup" === t.type) return;
                  t.type.indexOf("touch") > -1 &&
                    (clearTimeout(V),
                    (V = setTimeout(function () {
                      V = 0;
                    }, 600)));
                }
                var e;
                if ((At("pointerUp"), Le(t, !1) && t.preventDefault(), D)) {
                  var i = s.arraySearch(de, t.pointerId, "id");
                  if (i > -1)
                    if (
                      ((e = de.splice(i, 1)[0]), navigator.msPointerEnabled)
                    ) {
                      var n = { 4: "mouse", 2: "touch", 3: "pen" };
                      (e.type = n[t.pointerType]),
                        e.type || (e.type = t.pointerType || "mouse");
                    } else e.type = t.pointerType || "mouse";
                }
                var r,
                  a = Fe(t),
                  c = a.length;
                if (("mouseup" === t.type && (c = 0), 2 === c))
                  return (J = null), !0;
                1 === c && Ft(he, a[0]),
                  0 !== c ||
                    ot ||
                    st ||
                    (e ||
                      ("mouseup" === t.type
                        ? (e = { x: t.pageX, y: t.pageY, type: "mouse" })
                        : t.changedTouches &&
                          t.changedTouches[0] &&
                          (e = {
                            x: t.changedTouches[0].pageX,
                            y: t.changedTouches[0].pageY,
                            type: "touch",
                          })),
                    At("touchRelease", t, e));
                var h = -1;
                if (
                  (0 === c &&
                    ((G = !1),
                    s.unbind(window, g, o),
                    xe(),
                    tt ? (h = 0) : -1 !== ve && (h = Lt() - ve)),
                  (ve = 1 === c ? Lt() : -1),
                  (r = -1 !== h && h < 150 ? "zoom" : "swipe"),
                  tt &&
                    c < 2 &&
                    ((tt = !1),
                    1 === c && (r = "zoomPointerUp"),
                    At("zoomGestureEnded")),
                  (J = null),
                  Q || Z || st || W)
                )
                  if ((ee(), j || (j = je()), j.calculateSwipeSpeed("x"), W))
                    if ($e() < l.verticalDragRange) o.close();
                    else {
                      var d = ft.y,
                        u = lt;
                      ie(
                        "verticalDrag",
                        0,
                        1,
                        300,
                        s.easing.cubic.out,
                        function (t) {
                          (ft.y = (o.currItem.initialPosition.y - d) * t + d),
                            It((1 - u) * t + u),
                            Pt();
                        }
                      ),
                        At("onVerticalDrag", 1);
                    }
                  else {
                    if ((Y || st) && 0 === c) {
                      if (We(r, j)) return;
                      r = "zoomPointerUp";
                    }
                    st ||
                      ("swipe" === r
                        ? !Y && y > o.currItem.fitRatio && Ue(j)
                        : Ge());
                  }
              },
              je = function () {
                var t,
                  e,
                  i = {
                    lastFlickOffset: {},
                    lastFlickDist: {},
                    lastFlickSpeed: {},
                    slowDownRatio: {},
                    slowDownRatioReverse: {},
                    speedDecelerationRatio: {},
                    speedDecelerationRatioAbs: {},
                    distanceOffset: {},
                    backAnimDestination: {},
                    backAnimStarted: {},
                    calculateSwipeSpeed: function (n) {
                      pe.length > 1
                        ? ((t = Lt() - z + 50), (e = pe[pe.length - 2][n]))
                        : ((t = Lt() - H), (e = he[n])),
                        (i.lastFlickOffset[n] = ce[n] - e),
                        (i.lastFlickDist[n] = Math.abs(i.lastFlickOffset[n])),
                        i.lastFlickDist[n] > 20
                          ? (i.lastFlickSpeed[n] = i.lastFlickOffset[n] / t)
                          : (i.lastFlickSpeed[n] = 0),
                        Math.abs(i.lastFlickSpeed[n]) < 0.1 &&
                          (i.lastFlickSpeed[n] = 0),
                        (i.slowDownRatio[n] = 0.95),
                        (i.slowDownRatioReverse[n] = 1 - i.slowDownRatio[n]),
                        (i.speedDecelerationRatio[n] = 1);
                    },
                    calculateOverBoundsAnimOffset: function (t, e) {
                      i.backAnimStarted[t] ||
                        (ft[t] > it.min[t]
                          ? (i.backAnimDestination[t] = it.min[t])
                          : ft[t] < it.max[t] &&
                            (i.backAnimDestination[t] = it.max[t]),
                        void 0 !== i.backAnimDestination[t] &&
                          ((i.slowDownRatio[t] = 0.7),
                          (i.slowDownRatioReverse[t] = 1 - i.slowDownRatio[t]),
                          i.speedDecelerationRatioAbs[t] < 0.05 &&
                            ((i.lastFlickSpeed[t] = 0),
                            (i.backAnimStarted[t] = !0),
                            ie(
                              "bounceZoomPan" + t,
                              ft[t],
                              i.backAnimDestination[t],
                              e || 300,
                              s.easing.sine.out,
                              function (e) {
                                (ft[t] = e), Pt();
                              }
                            ))));
                    },
                    calculateAnimOffset: function (t) {
                      i.backAnimStarted[t] ||
                        ((i.speedDecelerationRatio[t] =
                          i.speedDecelerationRatio[t] *
                          (i.slowDownRatio[t] +
                            i.slowDownRatioReverse[t] -
                            (i.slowDownRatioReverse[t] * i.timeDiff) / 10)),
                        (i.speedDecelerationRatioAbs[t] = Math.abs(
                          i.lastFlickSpeed[t] * i.speedDecelerationRatio[t]
                        )),
                        (i.distanceOffset[t] =
                          i.lastFlickSpeed[t] *
                          i.speedDecelerationRatio[t] *
                          i.timeDiff),
                        (ft[t] += i.distanceOffset[t]));
                    },
                    panAnimLoop: function () {
                      if (
                        Kt.zoomPan &&
                        ((Kt.zoomPan.raf = $(i.panAnimLoop)),
                        (i.now = Lt()),
                        (i.timeDiff = i.now - i.lastNow),
                        (i.lastNow = i.now),
                        i.calculateAnimOffset("x"),
                        i.calculateAnimOffset("y"),
                        Pt(),
                        i.calculateOverBoundsAnimOffset("x"),
                        i.calculateOverBoundsAnimOffset("y"),
                        i.speedDecelerationRatioAbs.x < 0.05 &&
                          i.speedDecelerationRatioAbs.y < 0.05)
                      )
                        return (
                          (ft.x = Math.round(ft.x)),
                          (ft.y = Math.round(ft.y)),
                          Pt(),
                          void Jt("zoomPan")
                        );
                    },
                  };
                return i;
              },
              Ue = function (t) {
                if (
                  (t.calculateSwipeSpeed("y"),
                  (it = o.currItem.bounds),
                  (t.backAnimDestination = {}),
                  (t.backAnimStarted = {}),
                  Math.abs(t.lastFlickSpeed.x) <= 0.05 &&
                    Math.abs(t.lastFlickSpeed.y) <= 0.05)
                )
                  return (
                    (t.speedDecelerationRatioAbs.x =
                      t.speedDecelerationRatioAbs.y =
                        0),
                    t.calculateOverBoundsAnimOffset("x"),
                    t.calculateOverBoundsAnimOffset("y"),
                    !0
                  );
                te("zoomPan"), (t.lastNow = Lt()), t.panAnimLoop();
              },
              We = function (t, e) {
                var i, n, r;
                if ((st || (ge = u), "swipe" === t)) {
                  var a = ce.x - he.x,
                    c = e.lastFlickDist.x < 10;
                  a > se && (c || e.lastFlickOffset.x > 20)
                    ? (n = -1)
                    : a < -se && (c || e.lastFlickOffset.x < -20) && (n = 1);
                }
                n &&
                  ((u += n) < 0
                    ? ((u = l.loop ? Je() - 1 : 0), (r = !0))
                    : u >= Je() && ((u = l.loop ? 0 : Je() - 1), (r = !0)),
                  (r && !l.loop) || ((bt += n), (mt -= n), (i = !0)));
                var h,
                  d = yt.x * mt,
                  p = Math.abs(d - ye.x);
                return (
                  i || d > ye.x == e.lastFlickSpeed.x > 0
                    ? ((h =
                        Math.abs(e.lastFlickSpeed.x) > 0
                          ? p / Math.abs(e.lastFlickSpeed.x)
                          : 333),
                      (h = Math.min(h, 400)),
                      (h = Math.max(h, 250)))
                    : (h = 333),
                  ge === u && (i = !1),
                  (st = !0),
                  At("mainScrollAnimStart"),
                  ie(
                    "mainScroll",
                    ye.x,
                    d,
                    h,
                    s.easing.cubic.out,
                    Ot,
                    function () {
                      ee(),
                        (st = !1),
                        (ge = -1),
                        (i || ge !== u) && o.updateCurrItem(),
                        At("mainScrollAnimComplete");
                    }
                  ),
                  i && o.updateCurrItem(!0),
                  i
                );
              },
              Ve = function (t) {
                return (1 / et) * t * b;
              },
              Ge = function () {
                var t = y,
                  e = Ut(),
                  i = Wt();
                y < e ? (t = e) : y > i && (t = i);
                var n,
                  r = 1,
                  a = lt;
                return at && !U && !ct && y < e
                  ? (o.close(), !0)
                  : (at &&
                      (n = function (t) {
                        It((r - a) * t + a);
                      }),
                    o.zoomTo(t, 0, 200, s.easing.cubic.out, n),
                    !0);
              };
            xt("Gestures", {
              publicMethods: {
                initGestures: function () {
                  var t = function (t, e, i, n, s) {
                    (E = t + e), (T = t + i), (A = t + n), (L = s ? t + s : "");
                  };
                  (D = N.pointerEvent) && N.touch && (N.touch = !1),
                    D
                      ? navigator.msPointerEnabled
                        ? t("MSPointer", "Down", "Move", "Up", "Cancel")
                        : t("pointer", "down", "move", "up", "cancel")
                      : N.touch
                      ? (t("touch", "start", "move", "end", "cancel"), (P = !0))
                      : t("mouse", "down", "move", "up"),
                    (g = T + " " + A + " " + L),
                    (m = E),
                    D &&
                      !P &&
                      (P =
                        navigator.maxTouchPoints > 1 ||
                        navigator.msMaxTouchPoints > 1),
                    (o.likelyTouchDevice = P),
                    (v[E] = Ne),
                    (v[T] = Re),
                    (v[A] = ze),
                    L && (v[L] = v[A]),
                    N.touch &&
                      ((m += " mousedown"),
                      (g += " mousemove mouseup"),
                      (v.mousedown = v[E]),
                      (v.mousemove = v[T]),
                      (v.mouseup = v[A])),
                    P || (l.allowPanToNext = !1);
                },
              },
            });
            var Xe,
              Ze,
              Qe,
              Ke,
              Ye,
              Je,
              ti = function (e, i, n, r) {
                var a;
                Xe && clearTimeout(Xe),
                  (Ke = !0),
                  (Qe = !0),
                  e.initialLayout
                    ? ((a = e.initialLayout), (e.initialLayout = null))
                    : (a = l.getThumbBoundsFn && l.getThumbBoundsFn(u));
                var c,
                  h,
                  p = n ? l.hideAnimationDuration : l.showAnimationDuration,
                  f = function () {
                    Jt("initialZoom"),
                      n
                        ? (o.template.removeAttribute("style"),
                          o.bg.removeAttribute("style"))
                        : (It(1),
                          i && (i.style.display = "block"),
                          s.addClass(t, "pswp--animated-in"),
                          At("initialZoom" + (n ? "OutEnd" : "InEnd"))),
                      r && r(),
                      (Ke = !1);
                  };
                if (!p || !a || void 0 === a.x)
                  return (
                    At("initialZoom" + (n ? "Out" : "In")),
                    (y = e.initialZoomLevel),
                    Ft(ft, e.initialPosition),
                    Pt(),
                    (t.style.opacity = n ? 0 : 1),
                    It(1),
                    void (p
                      ? setTimeout(function () {
                          f();
                        }, p)
                      : f())
                  );
                (c = d),
                  (h =
                    !o.currItem.src ||
                    o.currItem.loadError ||
                    l.showHideOpacity),
                  e.miniImg &&
                    (e.miniImg.style.webkitBackfaceVisibility = "hidden"),
                  n ||
                    ((y = a.w / e.w),
                    (ft.x = a.x),
                    (ft.y = a.y - q),
                    (o[h ? "template" : "bg"].style.opacity = 0.001),
                    Pt()),
                  te("initialZoom"),
                  n && !c && s.removeClass(t, "pswp--animated-in"),
                  h &&
                    (n
                      ? s[(c ? "remove" : "add") + "Class"](
                          t,
                          "pswp--animate_opacity"
                        )
                      : setTimeout(function () {
                          s.addClass(t, "pswp--animate_opacity");
                        }, 30)),
                  (Xe = setTimeout(
                    function () {
                      if ((At("initialZoom" + (n ? "Out" : "In")), n)) {
                        var i = a.w / e.w,
                          o = { x: ft.x, y: ft.y },
                          r = y,
                          l = lt,
                          d = function (e) {
                            1 === e
                              ? ((y = i), (ft.x = a.x), (ft.y = a.y - B))
                              : ((y = (i - r) * e + r),
                                (ft.x = (a.x - o.x) * e + o.x),
                                (ft.y = (a.y - B - o.y) * e + o.y)),
                              Pt(),
                              h ? (t.style.opacity = 1 - e) : It(l - e * l);
                          };
                        c
                          ? ie("initialZoom", 0, 1, p, s.easing.cubic.out, d, f)
                          : (d(1), (Xe = setTimeout(f, p + 20)));
                      } else
                        (y = e.initialZoomLevel),
                          Ft(ft, e.initialPosition),
                          Pt(),
                          It(1),
                          h ? (t.style.opacity = 1) : It(1),
                          (Xe = setTimeout(f, p + 20));
                    },
                    n ? 25 : 90
                  ));
              },
              ei = {},
              ii = [],
              ni = {
                index: 0,
                errorMsg:
                  '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function () {
                  return Ze.length;
                },
              },
              si = function () {
                return {
                  center: { x: 0, y: 0 },
                  max: { x: 0, y: 0 },
                  min: { x: 0, y: 0 },
                };
              },
              oi = function (t, e, i) {
                var n = t.bounds;
                (n.center.x = Math.round((ei.x - e) / 2)),
                  (n.center.y = Math.round((ei.y - i) / 2) + t.vGap.top),
                  (n.max.x = e > ei.x ? Math.round(ei.x - e) : n.center.x),
                  (n.max.y =
                    i > ei.y ? Math.round(ei.y - i) + t.vGap.top : n.center.y),
                  (n.min.x = e > ei.x ? 0 : n.center.x),
                  (n.min.y = i > ei.y ? t.vGap.top : n.center.y);
              },
              ri = function (t, e, i) {
                if (t.src && !t.loadError) {
                  var n = !i;
                  if (
                    (n &&
                      (t.vGap || (t.vGap = { top: 0, bottom: 0 }),
                      At("parseVerticalMargin", t)),
                    (ei.x = e.x),
                    (ei.y = e.y - t.vGap.top - t.vGap.bottom),
                    n)
                  ) {
                    var s = ei.x / t.w,
                      o = ei.y / t.h;
                    t.fitRatio = s < o ? s : o;
                    var r = l.scaleMode;
                    "orig" === r ? (i = 1) : "fit" === r && (i = t.fitRatio),
                      i > 1 && (i = 1),
                      (t.initialZoomLevel = i),
                      t.bounds || (t.bounds = si());
                  }
                  if (!i) return;
                  return (
                    oi(t, t.w * i, t.h * i),
                    n &&
                      i === t.initialZoomLevel &&
                      (t.initialPosition = t.bounds.center),
                    t.bounds
                  );
                }
                return (
                  (t.w = t.h = 0),
                  (t.initialZoomLevel = t.fitRatio = 1),
                  (t.bounds = si()),
                  (t.initialPosition = t.bounds.center),
                  t.bounds
                );
              },
              ai = function (t, e, i, n, s, r) {
                e.loadError ||
                  (n &&
                    ((e.imageAppended = !0),
                    hi(e, n, e === o.currItem && Ct),
                    i.appendChild(n),
                    r &&
                      setTimeout(function () {
                        e &&
                          e.loaded &&
                          e.placeholder &&
                          ((e.placeholder.style.display = "none"),
                          (e.placeholder = null));
                      }, 500)));
              },
              li = function (t) {
                (t.loading = !0), (t.loaded = !1);
                var e = (t.img = s.createEl("pswp__img", "img")),
                  i = function () {
                    (t.loading = !1),
                      (t.loaded = !0),
                      t.loadComplete ? t.loadComplete(t) : (t.img = null),
                      (e.onload = e.onerror = null),
                      (e = null);
                  };
                return (
                  (e.onload = i),
                  (e.onerror = function () {
                    (t.loadError = !0), i();
                  }),
                  (e.src = t.src),
                  e
                );
              },
              ci = function (t, e) {
                if (t.src && t.loadError && t.container)
                  return (
                    e && (t.container.innerHTML = ""),
                    (t.container.innerHTML = l.errorMsg.replace(
                      "%url%",
                      t.src
                    )),
                    !0
                  );
              },
              hi = function (t, e, i) {
                if (t.src) {
                  e || (e = t.container.lastChild);
                  var n = i ? t.w : Math.round(t.w * t.fitRatio),
                    s = i ? t.h : Math.round(t.h * t.fitRatio);
                  t.placeholder &&
                    !t.loaded &&
                    ((t.placeholder.style.width = n + "px"),
                    (t.placeholder.style.height = s + "px")),
                    (e.style.width = n + "px"),
                    (e.style.height = s + "px");
                }
              },
              di = function () {
                if (ii.length) {
                  for (var t, e = 0; e < ii.length; e++)
                    (t = ii[e]).holder.index === t.index &&
                      ai(
                        t.index,
                        t.item,
                        t.baseDiv,
                        t.img,
                        !1,
                        t.clearPlaceholder
                      );
                  ii = [];
                }
              };
            xt("Controller", {
              publicMethods: {
                lazyLoadItem: function (t) {
                  t = kt(t);
                  var e = Ye(t);
                  e &&
                    ((!e.loaded && !e.loading) || C) &&
                    (At("gettingData", t, e), e.src && li(e));
                },
                initController: function () {
                  s.extend(l, ni, !0),
                    (o.items = Ze = i),
                    (Ye = o.getItemAt),
                    (Je = l.getNumItemsFn),
                    l.loop,
                    Je() < 3 && (l.loop = !1),
                    Tt("beforeChange", function (t) {
                      var e,
                        i = l.preload,
                        n = null === t || t >= 0,
                        s = Math.min(i[0], Je()),
                        r = Math.min(i[1], Je());
                      for (e = 1; e <= (n ? r : s); e++) o.lazyLoadItem(u + e);
                      for (e = 1; e <= (n ? s : r); e++) o.lazyLoadItem(u - e);
                    }),
                    Tt("initialLayout", function () {
                      o.currItem.initialLayout =
                        l.getThumbBoundsFn && l.getThumbBoundsFn(u);
                    }),
                    Tt("mainScrollAnimComplete", di),
                    Tt("initialZoomInEnd", di),
                    Tt("destroy", function () {
                      for (var t, e = 0; e < Ze.length; e++)
                        (t = Ze[e]).container && (t.container = null),
                          t.placeholder && (t.placeholder = null),
                          t.img && (t.img = null),
                          t.preloader && (t.preloader = null),
                          t.loadError && (t.loaded = t.loadError = !1);
                      ii = null;
                    });
                },
                getItemAt: function (t) {
                  return t >= 0 && void 0 !== Ze[t] && Ze[t];
                },
                allowProgressiveImg: function () {
                  return (
                    l.forceProgressiveLoading ||
                    !P ||
                    l.mouseUsed ||
                    screen.width > 1200
                  );
                },
                setContent: function (t, e) {
                  l.loop && (e = kt(e));
                  var i = o.getItemAt(t.index);
                  i && (i.container = null);
                  var n,
                    r = o.getItemAt(e);
                  if (r) {
                    At("gettingData", e, r), (t.index = e), (t.item = r);
                    var a = (r.container = s.createEl("pswp__zoom-wrap"));
                    if (
                      (!r.src &&
                        r.html &&
                        (r.html.tagName
                          ? a.appendChild(r.html)
                          : (a.innerHTML = r.html)),
                      ci(r),
                      ri(r, gt),
                      !r.src || r.loadError || r.loaded)
                    )
                      r.src &&
                        !r.loadError &&
                        (((n = s.createEl(
                          "pswp__img",
                          "img"
                        )).style.opacity = 1),
                        (n.src = r.src),
                        hi(r, n),
                        ai(e, r, a, n, !0));
                    else {
                      if (
                        ((r.loadComplete = function (i) {
                          if (c) {
                            if (t && t.index === e) {
                              if (ci(i, !0))
                                return (
                                  (i.loadComplete = i.img = null),
                                  ri(i, gt),
                                  $t(i),
                                  void (t.index === u && o.updateCurrZoomItem())
                                );
                              i.imageAppended
                                ? !Ke &&
                                  i.placeholder &&
                                  ((i.placeholder.style.display = "none"),
                                  (i.placeholder = null))
                                : N.transform && (st || Ke)
                                ? ii.push({
                                    item: i,
                                    baseDiv: a,
                                    img: i.img,
                                    index: e,
                                    holder: t,
                                    clearPlaceholder: !0,
                                  })
                                : ai(e, i, a, i.img, st || Ke, !0);
                            }
                            (i.loadComplete = null),
                              (i.img = null),
                              At("imageLoadComplete", e, i);
                          }
                        }),
                        s.features.transform)
                      ) {
                        var h = "pswp__img pswp__img--placeholder";
                        h += r.msrc ? "" : " pswp__img--placeholder--blank";
                        var d = s.createEl(h, r.msrc ? "img" : "");
                        r.msrc && (d.src = r.msrc),
                          hi(r, d),
                          a.appendChild(d),
                          (r.placeholder = d);
                      }
                      r.loading || li(r),
                        o.allowProgressiveImg() &&
                          (!Qe && N.transform
                            ? ii.push({
                                item: r,
                                baseDiv: a,
                                img: r.img,
                                index: e,
                                holder: t,
                              })
                            : ai(e, r, a, r.img, !0, !0));
                    }
                    Qe || e !== u ? $t(r) : ((nt = a.style), ti(r, n || r.img)),
                      (t.el.innerHTML = ""),
                      t.el.appendChild(a);
                  } else t.el.innerHTML = "";
                },
                cleanSlide: function (t) {
                  t.img && (t.img.onload = t.img.onerror = null),
                    (t.loaded = t.loading = t.img = t.imageAppended = !1);
                },
              },
            });
            var ui,
              pi,
              fi = {},
              gi = function (t, e, i) {
                var n = document.createEvent("CustomEvent"),
                  s = {
                    origEvent: t,
                    target: t.target,
                    releasePoint: e,
                    pointerType: i || "touch",
                  };
                n.initCustomEvent("pswpTap", !0, !0, s),
                  t.target.dispatchEvent(n);
              };
            xt("Tap", {
              publicMethods: {
                initTap: function () {
                  Tt("firstTouchStart", o.onTapStart),
                    Tt("touchRelease", o.onTapRelease),
                    Tt("destroy", function () {
                      (fi = {}), (ui = null);
                    });
                },
                onTapStart: function (t) {
                  t.length > 1 && (clearTimeout(ui), (ui = null));
                },
                onTapRelease: function (t, e) {
                  if (e && !Q && !X && !Yt) {
                    var i = e;
                    if (ui && (clearTimeout(ui), (ui = null), Se(i, fi)))
                      return void At("doubleTap", i);
                    if ("mouse" === e.type) return void gi(t, e, "mouse");
                    if (
                      "BUTTON" === t.target.tagName.toUpperCase() ||
                      s.hasClass(t.target, "pswp__single-tap")
                    )
                      return void gi(t, e);
                    Ft(fi, i),
                      (ui = setTimeout(function () {
                        gi(t, e), (ui = null);
                      }, 300));
                  }
                },
              },
            }),
              xt("DesktopZoom", {
                publicMethods: {
                  initDesktopZoom: function () {
                    F ||
                      (P
                        ? Tt("mouseUsed", function () {
                            o.setupDesktopZoom();
                          })
                        : o.setupDesktopZoom(!0));
                  },
                  setupDesktopZoom: function (e) {
                    pi = {};
                    var i = "wheel mousewheel DOMMouseScroll";
                    Tt("bindEvents", function () {
                      s.bind(t, i, o.handleMouseWheel);
                    }),
                      Tt("unbindEvents", function () {
                        pi && s.unbind(t, i, o.handleMouseWheel);
                      }),
                      (o.mouseZoomedIn = !1);
                    var n,
                      r = function () {
                        o.mouseZoomedIn &&
                          (s.removeClass(t, "pswp--zoomed-in"),
                          (o.mouseZoomedIn = !1)),
                          y < 1
                            ? s.addClass(t, "pswp--zoom-allowed")
                            : s.removeClass(t, "pswp--zoom-allowed"),
                          a();
                      },
                      a = function () {
                        n && (s.removeClass(t, "pswp--dragging"), (n = !1));
                      };
                    Tt("resize", r),
                      Tt("afterChange", r),
                      Tt("pointerDown", function () {
                        o.mouseZoomedIn &&
                          ((n = !0), s.addClass(t, "pswp--dragging"));
                      }),
                      Tt("pointerUp", a),
                      e || r();
                  },
                  handleMouseWheel: function (t) {
                    if (y <= o.currItem.fitRatio)
                      return (
                        l.modal &&
                          (!l.closeOnScroll || Yt || G
                            ? t.preventDefault()
                            : I &&
                              Math.abs(t.deltaY) > 2 &&
                              ((d = !0), o.close())),
                        !0
                      );
                    if ((t.stopPropagation(), (pi.x = 0), "deltaX" in t))
                      1 === t.deltaMode
                        ? ((pi.x = 18 * t.deltaX), (pi.y = 18 * t.deltaY))
                        : ((pi.x = t.deltaX), (pi.y = t.deltaY));
                    else if ("wheelDelta" in t)
                      t.wheelDeltaX && (pi.x = -0.16 * t.wheelDeltaX),
                        t.wheelDeltaY
                          ? (pi.y = -0.16 * t.wheelDeltaY)
                          : (pi.y = -0.16 * t.wheelDelta);
                    else {
                      if (!("detail" in t)) return;
                      pi.y = t.detail;
                    }
                    jt(y, !0);
                    var e = ft.x - pi.x,
                      i = ft.y - pi.y;
                    (l.modal ||
                      (e <= it.min.x &&
                        e >= it.max.x &&
                        i <= it.min.y &&
                        i >= it.max.y)) &&
                      t.preventDefault(),
                      o.panTo(e, i);
                  },
                  toggleDesktopZoom: function (e) {
                    e = e || { x: gt.x / 2 + vt.x, y: gt.y / 2 + vt.y };
                    var i = l.getDoubleTapZoom(!0, o.currItem),
                      n = y === i;
                    (o.mouseZoomedIn = !n),
                      o.zoomTo(n ? o.currItem.initialZoomLevel : i, e, 333),
                      s[(n ? "remove" : "add") + "Class"](t, "pswp--zoomed-in");
                  },
                },
              });
            var mi,
              vi,
              yi,
              bi,
              wi,
              _i,
              Si,
              Ci,
              xi,
              ki,
              Ei,
              Ti,
              Ai = { history: !0, galleryUID: 1 },
              Li = function () {
                return Ei.hash.substring(1);
              },
              Ii = function () {
                mi && clearTimeout(mi), yi && clearTimeout(yi);
              },
              Di = function () {
                var t = Li(),
                  e = {};
                if (t.length < 5) return e;
                var i,
                  n = t.split("&");
                for (i = 0; i < n.length; i++)
                  if (n[i]) {
                    var s = n[i].split("=");
                    s.length < 2 || (e[s[0]] = s[1]);
                  }
                if (l.galleryPIDs) {
                  var o = e.pid;
                  for (e.pid = 0, i = 0; i < Ze.length; i++)
                    if (Ze[i].pid === o) {
                      e.pid = i;
                      break;
                    }
                } else e.pid = parseInt(e.pid, 10) - 1;
                return e.pid < 0 && (e.pid = 0), e;
              },
              Pi = function () {
                if ((yi && clearTimeout(yi), Yt || G)) yi = setTimeout(Pi, 500);
                else {
                  bi ? clearTimeout(vi) : (bi = !0);
                  var t = u + 1,
                    e = Ye(u);
                  e.hasOwnProperty("pid") && (t = e.pid);
                  var i = Si + "&gid=" + l.galleryUID + "&pid=" + t;
                  Ci || (-1 === Ei.hash.indexOf(i) && (ki = !0));
                  var n = Ei.href.split("#")[0] + "#" + i;
                  Ti
                    ? "#" + i !== window.location.hash &&
                      history[Ci ? "replaceState" : "pushState"](
                        "",
                        document.title,
                        n
                      )
                    : Ci
                    ? Ei.replace(n)
                    : (Ei.hash = i),
                    (Ci = !0),
                    (vi = setTimeout(function () {
                      bi = !1;
                    }, 60));
                }
              };
            xt("History", {
              publicMethods: {
                initHistory: function () {
                  if ((s.extend(l, Ai, !0), l.history)) {
                    (Ei = window.location),
                      (ki = !1),
                      (xi = !1),
                      (Ci = !1),
                      (Si = Li()),
                      (Ti = "pushState" in history),
                      Si.indexOf("gid=") > -1 &&
                        (Si = (Si = Si.split("&gid=")[0]).split("?gid=")[0]),
                      Tt("afterChange", o.updateURL),
                      Tt("unbindEvents", function () {
                        s.unbind(window, "hashchange", o.onHashChange);
                      });
                    var t = function () {
                      (_i = !0),
                        xi ||
                          (ki
                            ? history.back()
                            : Si
                            ? (Ei.hash = Si)
                            : Ti
                            ? history.pushState(
                                "",
                                document.title,
                                Ei.pathname + Ei.search
                              )
                            : (Ei.hash = "")),
                        Ii();
                    };
                    Tt("unbindEvents", function () {
                      d && t();
                    }),
                      Tt("destroy", function () {
                        _i || t();
                      }),
                      Tt("firstUpdate", function () {
                        u = Di().pid;
                      });
                    var e = Si.indexOf("pid=");
                    e > -1 &&
                      "&" === (Si = Si.substring(0, e)).slice(-1) &&
                      (Si = Si.slice(0, -1)),
                      setTimeout(function () {
                        c && s.bind(window, "hashchange", o.onHashChange);
                      }, 40);
                  }
                },
                onHashChange: function () {
                  if (Li() === Si) return (xi = !0), void o.close();
                  bi || ((wi = !0), o.goTo(Di().pid), (wi = !1));
                },
                updateURL: function () {
                  Ii(), wi || (Ci ? (mi = setTimeout(Pi, 800)) : Pi());
                },
              },
            }),
              s.extend(o, ne);
          };
          return t;
        }),
          void 0 === (s = "function" == typeof n ? n.call(e, i, e, t) : n) ||
            (t.exports = s);
      },
      277: (t, e, i) => {
        var n, s, o;
        (o = function () {
          var t,
            e,
            i = document,
            n = i.getElementsByTagName("head")[0],
            s = {},
            o = {},
            r = {},
            a = {};
          function l(t, e) {
            for (var i = 0, n = t.length; i < n; ++i) if (!e(t[i])) return !1;
            return 1;
          }
          function c(t, e) {
            l(t, function (t) {
              return e(t), 1;
            });
          }
          function h(e, i, n) {
            e = e.push ? e : [e];
            var u = i && i.call,
              p = u ? i : n,
              f = u ? e.join("") : i,
              g = e.length;
            function m(t) {
              return t.call ? t() : s[t];
            }
            function v() {
              if (!--g)
                for (var t in ((s[f] = 1), p && p(), r))
                  l(t.split("|"), m) && !c(r[t], m) && (r[t] = []);
            }
            return (
              setTimeout(function () {
                c(e, function e(i, n) {
                  return null === i
                    ? v()
                    : (n ||
                        /^https?:\/\//.test(i) ||
                        !t ||
                        (i = -1 === i.indexOf(".js") ? t + i + ".js" : t + i),
                      a[i]
                        ? (f && (o[f] = 1),
                          2 == a[i]
                            ? v()
                            : setTimeout(function () {
                                e(i, !0);
                              }, 0))
                        : ((a[i] = 1), f && (o[f] = 1), void d(i, v)));
                });
              }, 0),
              h
            );
          }
          function d(t, s) {
            var o,
              r = i.createElement("script");
            (r.onload =
              r.onerror =
              r.onreadystatechange =
                function () {
                  (r.readyState && !/^c|loade/.test(r.readyState)) ||
                    o ||
                    ((r.onload = r.onreadystatechange = null),
                    (o = 1),
                    (a[t] = 2),
                    s());
                }),
              (r.async = 1),
              (r.src = e ? t + (-1 === t.indexOf("?") ? "?" : "&") + e : t),
              n.insertBefore(r, n.lastChild);
          }
          return (
            (h.get = d),
            (h.order = function (t, e, i) {
              !(function n(s) {
                (s = t.shift()), t.length ? h(s, n) : h(s, e, i);
              })();
            }),
            (h.path = function (e) {
              t = e;
            }),
            (h.urlArgs = function (t) {
              e = t;
            }),
            (h.ready = function (t, e, i) {
              t = t.push ? t : [t];
              var n,
                o = [];
              return (
                !c(t, function (t) {
                  s[t] || o.push(t);
                }) &&
                l(t, function (t) {
                  return s[t];
                })
                  ? e()
                  : ((n = t.join("|")),
                    (r[n] = r[n] || []),
                    r[n].push(e),
                    i && i(o)),
                h
              );
            }),
            (h.done = function (t) {
              h([null], t);
            }),
            h
          );
        }),
          t.exports
            ? (t.exports = o())
            : void 0 ===
                (s = "function" == typeof (n = o) ? n.call(e, i, e, t) : n) ||
              (t.exports = s);
      },
      637: (t, e) => {
        var i, n, s;
        (n = []),
          (i = function () {
            var t = "",
              e = 20,
              i = !0,
              n = [],
              s = !1,
              o = !0,
              r = !0,
              a = null,
              l = !0,
              c = !0,
              h = null,
              d = !0,
              u = !1,
              p = !1,
              f = !0,
              g = "en",
              m = !0,
              v = !1,
              y = null;
            function b(t) {
              return t
                .replace(/<b[^>]*>(.*?)<\/b>/gi, function (t, e) {
                  return e;
                })
                .replace(
                  /class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,
                  ""
                );
            }
            function w(t) {
              for (
                var e = t.getElementsByTagName("a"), i = e.length - 1;
                i >= 0;
                i--
              )
                e[i].setAttribute("target", "_blank");
            }
            function _(t, e) {
              for (
                var i = [],
                  n = new RegExp("(^| )" + e + "( |$)"),
                  s = t.getElementsByTagName("*"),
                  o = 0,
                  r = s.length;
                o < r;
                o++
              )
                n.test(s[o].className) && i.push(s[o]);
              return i;
            }
            function S(t) {
              if (void 0 !== t && t.innerHTML.indexOf("data-image") >= 0) {
                var e = t.innerHTML.split('data-image="')[1].split('"')[0];
                return decodeURIComponent(e) + ".jpg";
              }
            }
            var C = {
              fetch: function (l) {
                if (
                  (void 0 === l.maxTweets && (l.maxTweets = 20),
                  void 0 === l.enableLinks && (l.enableLinks = !0),
                  void 0 === l.showUser && (l.showUser = !0),
                  void 0 === l.showTime && (l.showTime = !0),
                  void 0 === l.dateFunction && (l.dateFunction = "default"),
                  void 0 === l.showRetweet && (l.showRetweet = !0),
                  void 0 === l.customCallback && (l.customCallback = null),
                  void 0 === l.showInteraction && (l.showInteraction = !0),
                  void 0 === l.showImages && (l.showImages = !1),
                  void 0 === l.useEmoji && (l.useEmoji = !1),
                  void 0 === l.linksInNewWindow && (l.linksInNewWindow = !0),
                  void 0 === l.showPermalinks && (l.showPermalinks = !0),
                  void 0 === l.dataOnly && (l.dataOnly = !1),
                  s)
                )
                  n.push(l);
                else {
                  (s = !0),
                    (t = l.domId),
                    (e = l.maxTweets),
                    (i = l.enableLinks),
                    (r = l.showUser),
                    (o = l.showTime),
                    (c = l.showRetweet),
                    (a = l.dateFunction),
                    (h = l.customCallback),
                    (d = l.showInteraction),
                    (u = l.showImages),
                    (p = l.useEmoji),
                    (f = l.linksInNewWindow),
                    (m = l.showPermalinks),
                    (v = l.dataOnly);
                  var b = document.getElementsByTagName("head")[0];
                  null !== y && b.removeChild(y),
                    ((y = document.createElement("script")).type =
                      "text/javascript"),
                    void 0 !== l.list
                      ? (y.src =
                          "https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" +
                          l.list.listSlug +
                          "&screen_name=" +
                          l.list.screenName +
                          "&suppress_response_codes=true&lang=" +
                          (l.lang || g) +
                          "&rnd=" +
                          Math.random())
                      : void 0 !== l.profile
                      ? (y.src =
                          "https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" +
                          l.profile.screenName +
                          "&suppress_response_codes=true&lang=" +
                          (l.lang || g) +
                          "&rnd=" +
                          Math.random())
                      : void 0 !== l.likes
                      ? (y.src =
                          "https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" +
                          l.likes.screenName +
                          "&suppress_response_codes=true&lang=" +
                          (l.lang || g) +
                          "&rnd=" +
                          Math.random())
                      : (y.src =
                          "https://cdn.syndication.twimg.com/widgets/timelines/" +
                          l.id +
                          "?&lang=" +
                          (l.lang || g) +
                          "&callback=__twttrf.callback&suppress_response_codes=true&rnd=" +
                          Math.random()),
                    b.appendChild(y);
                }
              },
              callback: function (g) {
                if (void 0 === g || void 0 === g.body)
                  return (
                    (s = !1),
                    void (n.length > 0 && (C.fetch(n[0]), n.splice(0, 1)))
                  );
                p ||
                  (g.body = g.body.replace(
                    /(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,
                    ""
                  )),
                  u ||
                    (g.body = g.body.replace(
                      /(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,
                      ""
                    )),
                  r ||
                    (g.body = g.body.replace(
                      /(<img[^c]*class="Avatar"[^>]*>)/g,
                      ""
                    ));
                var y = document.createElement("div");
                function x(t) {
                  var e = t.getElementsByTagName("img")[0];
                  return (
                    e && e.length && (e.src = e.getAttribute("data-src-2x")), t
                  );
                }
                (y.innerHTML = g.body),
                  void 0 === y.getElementsByClassName && (l = !1);
                var k = [],
                  E = [],
                  T = [],
                  A = [],
                  L = [],
                  I = [],
                  D = [],
                  P = 0;
                if (l)
                  for (
                    var $ = y.getElementsByClassName("timeline-Tweet");
                    P < $.length;

                  )
                    $[P].getElementsByClassName("timeline-Tweet-retweetCredit")
                      .length > 0
                      ? L.push(!0)
                      : L.push(!1),
                      (!L[P] || (L[P] && c)) &&
                        (k.push(
                          $[P].getElementsByClassName("timeline-Tweet-text")[0]
                        ),
                        I.push($[P].getAttribute("data-tweet-id")),
                        r &&
                          E.push(
                            x(
                              $[P].getElementsByClassName(
                                "timeline-Tweet-author"
                              )[0]
                            )
                          ),
                        T.push($[P].getElementsByClassName("dt-updated")[0]),
                        D.push(
                          $[P].getElementsByClassName(
                            "timeline-Tweet-timestamp"
                          )[0]
                        ),
                        void 0 !==
                        $[P].getElementsByClassName("timeline-Tweet-media")[0]
                          ? A.push(
                              $[P].getElementsByClassName(
                                "timeline-Tweet-media"
                              )[0]
                            )
                          : A.push(void 0)),
                      P++;
                else
                  for ($ = _(y, "timeline-Tweet"); P < $.length; )
                    _($[P], "timeline-Tweet-retweetCredit").length > 0
                      ? L.push(!0)
                      : L.push(!1),
                      (!L[P] || (L[P] && c)) &&
                        (k.push(_($[P], "timeline-Tweet-text")[0]),
                        I.push($[P].getAttribute("data-tweet-id")),
                        r && E.push(x(_($[P], "timeline-Tweet-author")[0])),
                        T.push(_($[P], "dt-updated")[0]),
                        D.push(_($[P], "timeline-Tweet-timestamp")[0]),
                        void 0 !== _($[P], "timeline-Tweet-media")[0]
                          ? A.push(_($[P], "timeline-Tweet-media")[0])
                          : A.push(void 0)),
                      P++;
                k.length > e &&
                  (k.splice(e, k.length - e),
                  E.splice(e, E.length - e),
                  T.splice(e, T.length - e),
                  L.splice(e, L.length - e),
                  A.splice(e, A.length - e),
                  D.splice(e, D.length - e));
                var M = [],
                  O = ((P = k.length), 0);
                if (v)
                  for (; O < P; )
                    M.push({
                      tweet: k[O].innerHTML,
                      author: E[O] ? E[O].innerHTML : "Unknown Author",
                      author_data: {
                        profile_url: E[O]
                          ? E[O].querySelector(
                              '[data-scribe="element:user_link"]'
                            ).href
                          : null,
                        profile_image: E[O]
                          ? E[O].querySelector(
                              '[data-scribe="element:avatar"]'
                            ).getAttribute("data-src-1x")
                          : null,
                        profile_image_2x: E[O]
                          ? E[O].querySelector(
                              '[data-scribe="element:avatar"]'
                            ).getAttribute("data-src-2x")
                          : null,
                        screen_name: E[O]
                          ? E[O].querySelector(
                              '[data-scribe="element:screen_name"]'
                            ).title
                          : null,
                        name: E[O]
                          ? E[O].querySelector('[data-scribe="element:name"]')
                              .title
                          : null,
                      },
                      time: T[O].textContent,
                      timestamp: T[O].getAttribute("datetime")
                        .replace("+0000", "Z")
                        .replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"),
                      image: S(A[O]),
                      rt: L[O],
                      tid: I[O],
                      permalinkURL: void 0 === D[O] ? "" : D[O].href,
                    }),
                      O++;
                else
                  for (; O < P; ) {
                    if ("string" != typeof a) {
                      var q = T[O].getAttribute("datetime"),
                        F = new Date(
                          T[O].getAttribute("datetime")
                            .replace(/-/g, "/")
                            .replace("T", " ")
                            .split("+")[0]
                        ),
                        B = a(F, q);
                      if (
                        (T[O].setAttribute("aria-label", B), k[O].textContent)
                      )
                        if (l) T[O].textContent = B;
                        else {
                          var N = document.createElement("p"),
                            R = document.createTextNode(B);
                          N.appendChild(R),
                            N.setAttribute("aria-label", B),
                            (T[O] = N);
                        }
                      else T[O].textContent = B;
                    }
                    var H = "";
                    i
                      ? (f && (w(k[O]), r && w(E[O])),
                        r &&
                          (H +=
                            '<div class="user">' +
                            b(E[O].innerHTML) +
                            "</div>"),
                        (H += '<p class="tweet">' + b(k[O].innerHTML) + "</p>"),
                        o &&
                          (H += m
                            ? '<p class="timePosted"><a href="' +
                              D[O] +
                              '">' +
                              T[O].getAttribute("aria-label") +
                              "</a></p>"
                            : '<p class="timePosted">' +
                              T[O].getAttribute("aria-label") +
                              "</p>"))
                      : (k[O].textContent,
                        r &&
                          (H += '<p class="user">' + E[O].textContent + "</p>"),
                        (H += '<p class="tweet">' + k[O].textContent + "</p>"),
                        o &&
                          (H +=
                            '<p class="timePosted">' +
                            T[O].textContent +
                            "</p>")),
                      d &&
                        (H +=
                          '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' +
                          I[O] +
                          '" class="twitter_reply_icon"' +
                          (f ? ' target="_blank">' : ">") +
                          'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' +
                          I[O] +
                          '" class="twitter_retweet_icon"' +
                          (f ? ' target="_blank">' : ">") +
                          'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' +
                          I[O] +
                          '" class="twitter_fav_icon"' +
                          (f ? ' target="_blank">' : ">") +
                          "Favorite</a></p>"),
                      u &&
                        void 0 !== A[O] &&
                        void 0 !== S(A[O]) &&
                        (H +=
                          '<div class="media"><img src="' +
                          S(A[O]) +
                          '" alt="Image from tweet" /></div>'),
                      (u || (!u && k[O].textContent.length)) && M.push(H),
                      O++;
                  }
                !(function (e) {
                  if (null === h) {
                    for (
                      var i = e.length,
                        n = 0,
                        s = document.getElementById(t),
                        o = "<ul>";
                      n < i;

                    )
                      (o += "<li>" + e[n] + "</li>"), n++;
                    (o += "</ul>"), (s.innerHTML = o);
                  } else h(e);
                })(M),
                  (s = !1),
                  n.length > 0 && (C.fetch(n[0]), n.splice(0, 1));
              },
            };
            return (window.__twttrf = C), (window.twitterFetcher = C), C;
          }),
          void 0 === (s = "function" == typeof i ? i.apply(e, n) : i) ||
            (t.exports = s);
      },
      842: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(704)]),
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                function i() {}
                var n = (i.prototype = Object.create(e.prototype));
                (n.bindHandles = function () {
                  this._bindHandles(!0);
                }),
                  (n.unbindHandles = function () {
                    this._bindHandles(!1);
                  }),
                  (n._bindHandles = function (e) {
                    for (
                      var i = (e = void 0 === e || e)
                          ? "addEventListener"
                          : "removeEventListener",
                        n = e ? this._touchActionValue : "",
                        s = 0;
                      s < this.handles.length;
                      s++
                    ) {
                      var o = this.handles[s];
                      this._bindStartEvent(o, e),
                        o[i]("click", this),
                        t.PointerEvent && (o.style.touchAction = n);
                    }
                  }),
                  (n._touchActionValue = "none"),
                  (n.pointerDown = function (t, e) {
                    this.okayPointerDown(t) &&
                      ((this.pointerDownPointer = e),
                      t.preventDefault(),
                      this.pointerDownBlur(),
                      this._bindPostStartEvents(t),
                      this.emitEvent("pointerDown", [t, e]));
                  });
                var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
                  o = {
                    radio: !0,
                    checkbox: !0,
                    button: !0,
                    submit: !0,
                    image: !0,
                    file: !0,
                  };
                return (
                  (n.okayPointerDown = function (t) {
                    var e = s[t.target.nodeName],
                      i = o[t.target.type],
                      n = !e || i;
                    return n || this._pointerReset(), n;
                  }),
                  (n.pointerDownBlur = function () {
                    var t = document.activeElement;
                    t && t.blur && t != document.body && t.blur();
                  }),
                  (n.pointerMove = function (t, e) {
                    var i = this._dragPointerMove(t, e);
                    this.emitEvent("pointerMove", [t, e, i]),
                      this._dragMove(t, e, i);
                  }),
                  (n._dragPointerMove = function (t, e) {
                    var i = {
                      x: e.pageX - this.pointerDownPointer.pageX,
                      y: e.pageY - this.pointerDownPointer.pageY,
                    };
                    return (
                      !this.isDragging &&
                        this.hasDragStarted(i) &&
                        this._dragStart(t, e),
                      i
                    );
                  }),
                  (n.hasDragStarted = function (t) {
                    return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
                  }),
                  (n.pointerUp = function (t, e) {
                    this.emitEvent("pointerUp", [t, e]),
                      this._dragPointerUp(t, e);
                  }),
                  (n._dragPointerUp = function (t, e) {
                    this.isDragging
                      ? this._dragEnd(t, e)
                      : this._staticClick(t, e);
                  }),
                  (n._dragStart = function (t, e) {
                    (this.isDragging = !0),
                      (this.isPreventingClicks = !0),
                      this.dragStart(t, e);
                  }),
                  (n.dragStart = function (t, e) {
                    this.emitEvent("dragStart", [t, e]);
                  }),
                  (n._dragMove = function (t, e, i) {
                    this.isDragging && this.dragMove(t, e, i);
                  }),
                  (n.dragMove = function (t, e, i) {
                    t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
                  }),
                  (n._dragEnd = function (t, e) {
                    (this.isDragging = !1),
                      setTimeout(
                        function () {
                          delete this.isPreventingClicks;
                        }.bind(this)
                      ),
                      this.dragEnd(t, e);
                  }),
                  (n.dragEnd = function (t, e) {
                    this.emitEvent("dragEnd", [t, e]);
                  }),
                  (n.onclick = function (t) {
                    this.isPreventingClicks && t.preventDefault();
                  }),
                  (n._staticClick = function (t, e) {
                    (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                      (this.staticClick(t, e),
                      "mouseup" != t.type &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                          function () {
                            delete this.isIgnoringMouseUp;
                          }.bind(this),
                          400
                        )));
                  }),
                  (n.staticClick = function (t, e) {
                    this.emitEvent("staticClick", [t, e]);
                  }),
                  (i.getPointerPoint = e.getPointerPoint),
                  i
                );
              })(o, t);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      704: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(158)]),
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                function i() {}
                function n() {}
                var s = (n.prototype = Object.create(e.prototype));
                (s.bindStartEvent = function (t) {
                  this._bindStartEvent(t, !0);
                }),
                  (s.unbindStartEvent = function (t) {
                    this._bindStartEvent(t, !1);
                  }),
                  (s._bindStartEvent = function (e, i) {
                    var n = (i = void 0 === i || i)
                        ? "addEventListener"
                        : "removeEventListener",
                      s = "mousedown";
                    t.PointerEvent
                      ? (s = "pointerdown")
                      : "ontouchstart" in t && (s = "touchstart"),
                      e[n](s, this);
                  }),
                  (s.handleEvent = function (t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t);
                  }),
                  (s.getTouch = function (t) {
                    for (var e = 0; e < t.length; e++) {
                      var i = t[e];
                      if (i.identifier == this.pointerIdentifier) return i;
                    }
                  }),
                  (s.onmousedown = function (t) {
                    var e = t.button;
                    (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
                  }),
                  (s.ontouchstart = function (t) {
                    this._pointerDown(t, t.changedTouches[0]);
                  }),
                  (s.onpointerdown = function (t) {
                    this._pointerDown(t, t);
                  }),
                  (s._pointerDown = function (t, e) {
                    t.button ||
                      this.isPointerDown ||
                      ((this.isPointerDown = !0),
                      (this.pointerIdentifier =
                        void 0 !== e.pointerId ? e.pointerId : e.identifier),
                      this.pointerDown(t, e));
                  }),
                  (s.pointerDown = function (t, e) {
                    this._bindPostStartEvents(t),
                      this.emitEvent("pointerDown", [t, e]);
                  });
                var o = {
                  mousedown: ["mousemove", "mouseup"],
                  touchstart: ["touchmove", "touchend", "touchcancel"],
                  pointerdown: ["pointermove", "pointerup", "pointercancel"],
                };
                return (
                  (s._bindPostStartEvents = function (e) {
                    if (e) {
                      var i = o[e.type];
                      i.forEach(function (e) {
                        t.addEventListener(e, this);
                      }, this),
                        (this._boundPointerEvents = i);
                    }
                  }),
                  (s._unbindPostStartEvents = function () {
                    this._boundPointerEvents &&
                      (this._boundPointerEvents.forEach(function (e) {
                        t.removeEventListener(e, this);
                      }, this),
                      delete this._boundPointerEvents);
                  }),
                  (s.onmousemove = function (t) {
                    this._pointerMove(t, t);
                  }),
                  (s.onpointermove = function (t) {
                    t.pointerId == this.pointerIdentifier &&
                      this._pointerMove(t, t);
                  }),
                  (s.ontouchmove = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    e && this._pointerMove(t, e);
                  }),
                  (s._pointerMove = function (t, e) {
                    this.pointerMove(t, e);
                  }),
                  (s.pointerMove = function (t, e) {
                    this.emitEvent("pointerMove", [t, e]);
                  }),
                  (s.onmouseup = function (t) {
                    this._pointerUp(t, t);
                  }),
                  (s.onpointerup = function (t) {
                    t.pointerId == this.pointerIdentifier &&
                      this._pointerUp(t, t);
                  }),
                  (s.ontouchend = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    e && this._pointerUp(t, e);
                  }),
                  (s._pointerUp = function (t, e) {
                    this._pointerDone(), this.pointerUp(t, e);
                  }),
                  (s.pointerUp = function (t, e) {
                    this.emitEvent("pointerUp", [t, e]);
                  }),
                  (s._pointerDone = function () {
                    this._pointerReset(),
                      this._unbindPostStartEvents(),
                      this.pointerDone();
                  }),
                  (s._pointerReset = function () {
                    (this.isPointerDown = !1), delete this.pointerIdentifier;
                  }),
                  (s.pointerDone = i),
                  (s.onpointercancel = function (t) {
                    t.pointerId == this.pointerIdentifier &&
                      this._pointerCancel(t, t);
                  }),
                  (s.ontouchcancel = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    e && this._pointerCancel(t, e);
                  }),
                  (s._pointerCancel = function (t, e) {
                    this._pointerDone(), this.pointerCancel(t, e);
                  }),
                  (s.pointerCancel = function (t, e) {
                    this.emitEvent("pointerCancel", [t, e]);
                  }),
                  (n.getPointerPoint = function (t) {
                    return { x: t.pageX, y: t.pageY };
                  }),
                  n
                );
              })(o, t);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      529: function (t, e) {
        var i, n, s;
        !(function (o, r) {
          if (1)
            (n = [e]),
              (i = function (t) {
                "use strict";
                function e(t, e) {
                  if (!(t instanceof e))
                    throw new TypeError("Cannot call a class as a function");
                }
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i = (function () {
                    function t(t, e) {
                      for (var i = 0; i < e.length; i++) {
                        var n = e[i];
                        (n.enumerable = n.enumerable || !1),
                          (n.configurable = !0),
                          "value" in n && (n.writable = !0),
                          Object.defineProperty(t, n.key, n);
                      }
                    }
                    return function (e, i, n) {
                      return i && t(e.prototype, i), n && t(e, n), e;
                    };
                  })(),
                  n =
                    Object.assign ||
                    function (t) {
                      for (var e = 1; e < arguments.length; e++) {
                        var i = arguments[e];
                        for (var n in i)
                          Object.prototype.hasOwnProperty.call(i, n) &&
                            (t[n] = i[n]);
                      }
                      return t;
                    },
                  s = {
                    modal: ".modal",
                    modalInner: ".modal-inner",
                    modalContent: ".modal-content",
                    open: "[data-modal-open]",
                    close: "[data-modal-close]",
                    page: "body",
                    class: "modal-visible",
                    loadClass: "vanilla-modal",
                    clickOutside: !0,
                    closeKeys: [27],
                    transitions: !0,
                    transitionEnd: null,
                    onBeforeOpen: null,
                    onBeforeClose: null,
                    onOpen: null,
                    onClose: null,
                  };
                function o(t) {}
                function r(t, e) {
                  return function (i) {
                    var n = t.filter(e);
                    return n[0] ? n[0][i] : void 0;
                  };
                }
                function a() {
                  var t = document.createElement("div");
                  return r(
                    [
                      { key: "transition", value: "transitionend" },
                      { key: "OTransition", value: "otransitionend" },
                      { key: "MozTransition", value: "transitionend" },
                      { key: "WebkitTransition", value: "webkitTransitionEnd" },
                    ],
                    function (e) {
                      var i = e.key;
                      return void 0 !== t.style[i];
                    }
                  )("value");
                }
                function l(t) {
                  return (
                    "[object Array]" === Object.prototype.toString.call(t) &&
                    t.length
                  );
                }
                function c(t, e) {
                  var i = (e || document).querySelector(t);
                  return i || o(t + " not found in document."), i;
                }
                function h(t, e) {
                  t instanceof HTMLElement || o("Not a valid HTML element."),
                    t.setAttribute(
                      "class",
                      t.className
                        .split(" ")
                        .filter(function (t) {
                          return t !== e;
                        })
                        .concat(e)
                        .join(" ")
                    );
                }
                function d(t, e) {
                  t instanceof HTMLElement || o("Not a valid HTML element."),
                    t.setAttribute(
                      "class",
                      t.className
                        .split(" ")
                        .filter(function (t) {
                          return t !== e;
                        })
                        .join(" ")
                    );
                }
                function u(t) {
                  return t && "string" == typeof t.hash
                    ? document.querySelector(t.hash)
                    : "string" == typeof t
                    ? document.querySelector(t)
                    : (o("No selector supplied to open()"), null);
                }
                function p(t) {
                  return n({}, s, t, { transitionEnd: a() });
                }
                function f(t, e) {
                  for (
                    var i = (
                        t.target.document || t.target.ownerDocument
                      ).querySelectorAll(e),
                      n = 0;
                    n < i.length;
                    n += 1
                  )
                    for (var s = t.target; s && s !== document.body; ) {
                      if (s === i[n]) return s;
                      s = s.parentNode;
                    }
                  return null;
                }
                var g = (function () {
                  function t(i) {
                    e(this, t),
                      (this.isOpen = !1),
                      (this.current = null),
                      (this.isListening = !1),
                      (this.settings = p(i)),
                      (this.dom = this.getDomNodes()),
                      (this.open = this.open.bind(this)),
                      (this.close = this.close.bind(this)),
                      (this.closeKeyHandler = this.closeKeyHandler.bind(this)),
                      (this.outsideClickHandler =
                        this.outsideClickHandler.bind(this)),
                      (this.delegateOpen = this.delegateOpen.bind(this)),
                      (this.delegateClose = this.delegateClose.bind(this)),
                      (this.listen = this.listen.bind(this)),
                      (this.destroy = this.destroy.bind(this)),
                      this.addLoadedCssClass(),
                      this.listen();
                  }
                  return (
                    i(t, [
                      {
                        key: "getDomNodes",
                        value: function () {
                          var t = this.settings,
                            e = t.modal,
                            i = t.page,
                            n = t.modalInner,
                            s = t.modalContent;
                          return {
                            modal: c(e),
                            page: c(i),
                            modalInner: c(n, c(e)),
                            modalContent: c(s, c(e)),
                          };
                        },
                      },
                      {
                        key: "addLoadedCssClass",
                        value: function () {
                          h(this.dom.page, this.settings.loadClass);
                        },
                      },
                      {
                        key: "setOpenId",
                        value: function (t) {
                          this.dom.page.setAttribute(
                            "data-current-modal",
                            t || "anonymous"
                          );
                        },
                      },
                      {
                        key: "removeOpenId",
                        value: function () {
                          this.dom.page.removeAttribute("data-current-modal");
                        },
                      },
                      {
                        key: "open",
                        value: function (t, e) {
                          var i = this.dom.page,
                            n = this.settings,
                            s = n.onBeforeOpen,
                            r = n.onOpen;
                          this.current instanceof HTMLElement == !1
                            ? (this.releaseNode(this.current),
                              (this.current = u(t)),
                              "function" == typeof s && s.call(this, e),
                              this.captureNode(this.current),
                              h(i, this.settings.class),
                              this.setOpenId(this.current.id),
                              (this.isOpen = !0),
                              "function" == typeof r && r.call(this, e))
                            : o("VanillaModal target must exist on page.");
                        },
                      },
                      {
                        key: "detectTransition",
                        value: function () {
                          var t = this.dom.modal,
                            e = window.getComputedStyle(t, null);
                          return Boolean(
                            [
                              "transitionDuration",
                              "oTransitionDuration",
                              "MozTransitionDuration",
                              "webkitTransitionDuration",
                            ].filter(function (t) {
                              return (
                                "string" == typeof e[t] && parseFloat(e[t]) > 0
                              );
                            }).length
                          );
                        },
                      },
                      {
                        key: "close",
                        value: function (t) {
                          var e = this.settings,
                            i = e.transitions,
                            n = e.transitionEnd,
                            s = e.onBeforeClose,
                            o = this.detectTransition();
                          this.isOpen &&
                            ((this.isOpen = !1),
                            "function" == typeof s && s.call(this, t),
                            d(this.dom.page, this.settings.class),
                            i && n && o
                              ? this.closeModalWithTransition(t)
                              : this.closeModal(t));
                        },
                      },
                      {
                        key: "closeModal",
                        value: function (t) {
                          var e = this.settings.onClose;
                          this.removeOpenId(this.dom.page),
                            this.releaseNode(this.current),
                            (this.isOpen = !1),
                            (this.current = null),
                            "function" == typeof e && e.call(this, t);
                        },
                      },
                      {
                        key: "closeModalWithTransition",
                        value: function (t) {
                          var e = this,
                            i = this.dom.modal,
                            n = this.settings.transitionEnd,
                            s = function s() {
                              i.removeEventListener(n, s), e.closeModal(t);
                            };
                          i.addEventListener(n, s);
                        },
                      },
                      {
                        key: "captureNode",
                        value: function (t) {
                          for (
                            var e = this.dom.modalContent;
                            t.childNodes.length;

                          )
                            e.appendChild(t.childNodes[0]);
                        },
                      },
                      {
                        key: "releaseNode",
                        value: function (t) {
                          for (
                            var e = this.dom.modalContent;
                            e.childNodes.length;

                          )
                            t.appendChild(e.childNodes[0]);
                        },
                      },
                      {
                        key: "closeKeyHandler",
                        value: function (t) {
                          var e = this.settings.closeKeys;
                          l(e) &&
                            e.indexOf(t.which) > -1 &&
                            !0 === this.isOpen &&
                            (t.preventDefault(), this.close(t));
                        },
                      },
                      {
                        key: "outsideClickHandler",
                        value: function (t) {
                          var e = this.settings.clickOutside,
                            i = this.dom.modalInner;
                          if (e) {
                            for (var n = t.target; n && n !== document.body; ) {
                              if (n === i) return;
                              n = n.parentNode;
                            }
                            this.close(t);
                          }
                        },
                      },
                      {
                        key: "delegateOpen",
                        value: function (t) {
                          var e = f(t, this.settings.open);
                          e && (t.preventDefault(), this.open(e, t));
                        },
                      },
                      {
                        key: "delegateClose",
                        value: function (t) {
                          f(t, this.settings.close) &&
                            (t.preventDefault(), this.close(t));
                        },
                      },
                      {
                        key: "listen",
                        value: function () {
                          var t = this.dom.modal;
                          this.isListening
                            ? o("Event listeners already applied.")
                            : (t.addEventListener(
                                "click",
                                this.outsideClickHandler,
                                !1
                              ),
                              document.addEventListener(
                                "keydown",
                                this.closeKeyHandler,
                                !1
                              ),
                              document.addEventListener(
                                "click",
                                this.delegateOpen,
                                !1
                              ),
                              document.addEventListener(
                                "click",
                                this.delegateClose,
                                !1
                              ),
                              (this.isListening = !0));
                        },
                      },
                      {
                        key: "destroy",
                        value: function () {
                          var t = this.dom.modal;
                          this.isListening
                            ? (this.close(),
                              t.removeEventListener(
                                "click",
                                this.outsideClickHandler
                              ),
                              document.removeEventListener(
                                "keydown",
                                this.closeKeyHandler
                              ),
                              document.removeEventListener(
                                "click",
                                this.delegateOpen
                              ),
                              document.removeEventListener(
                                "click",
                                this.delegateClose
                              ),
                              (this.isListening = !1))
                            : o("Event listeners already removed.");
                        },
                      },
                    ]),
                    t
                  );
                })();
                t.default = g;
              }),
              void 0 === (s = "function" == typeof i ? i.apply(e, n) : i) ||
                (t.exports = s);
          else;
        })();
      },
    },
    e = {};
  function i(n) {
    if (e[n]) return e[n].exports;
    var s = (e[n] = { exports: {} });
    return t[n].call(s.exports, s, s.exports, i), s.exports;
  }
  (i.n = (t) => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return i.d(e, { a: e }), e;
  }),
    (i.d = (t, e) => {
      for (var n in e)
        i.o(e, n) &&
          !i.o(t, n) &&
          Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }),
    (i.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
    (() => {
      "use strict";
      var t = i(755),
        e = i.n(t);
      (window.jQuery = e()), (window.$ = e());
      i(72), i(220);
      var n = i(277),
        s = i.n(n);
      var o = {
        scale: 1,
        template: !1,
        templateRender: function (t, e) {
          return t.replace("{size}", "".concat(e.width, "x").concat(e.height));
        },
        max: { width: 1 / 0, height: 1 / 0 },
        round: 32,
        placeholder: !1,
        crop: null,
      };
      function r(t, e, i, n) {
        var s = "data-rimg-".concat(e);
        if (!t.hasAttribute(s)) return i[e] || o[e];
        var r = t.getAttribute(s);
        return n ? n(r) : r;
      }
      function a(t) {
        return (
          (t = t.split("x")),
          { width: parseInt(t[0], 10), height: parseInt(t[1], 10) }
        );
      }
      function l(t) {
        switch (t) {
          case "top":
          case "center":
          case "bottom":
          case "left":
          case "right":
            return t;
          default:
            return null;
        }
      }
      function c(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = t.hasAttribute("data-rimg-template");
        return {
          el: t,
          isImage: i,
          isBackgroundImage: i && "IMG" !== t.tagName,
          scale: parseInt(r(t, "scale", e)),
          density: window.devicePixelRatio || 1,
          template: r(t, "template", e),
          templateRender: e.templateRender || o.templateRender,
          max: r(t, "max", e, a),
          round: r(t, "round", e),
          placeholder: r(t, "placeholder", e, a),
          crop: r(t, "crop", e, l),
        };
      }
      function h(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 32,
          i =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : 1 / 0;
        return 0 === t ? e : Math.min(Math.ceil(t / e) * e, i);
      }
      function d(t, e) {
        var i = document.createEvent("Event");
        return i.initEvent(e, !0, !0), !t.dispatchEvent(i);
      }
      function u(t, e, i, n) {
        var s,
          o = t.templateRender,
          r = i
            ? 1
            : (function (t, e) {
                return Math.min(
                  Math.min(Math.max(t.max.width / e.width, 1), t.density),
                  Math.min(Math.max(t.max.height / e.height, 1), t.density)
                ).toFixed(2);
              })(t, e),
          a = i ? 1 : t.round,
          l = e.width * r,
          c = e.height * r;
        if (t.crop)
          s = { width: h(l, a, t.max.width), height: h(c, a, t.max.height) };
        else {
          var d = e.width / e.height,
            u = t.max.width / t.max.height;
          s =
            d > u
              ? {
                  width: h(l, a, t.max.width),
                  height: h(l / u, a, t.max.height),
                }
              : {
                  width: h(c * u, a, t.max.width),
                  height: h(c, a, t.max.height),
                };
        }
        var p = o(t.template, s),
          f = new Image();
        (f.onload = n),
          (f.src = p),
          t.isBackgroundImage
            ? (t.el.style.backgroundImage = "url('".concat(p, "')"))
            : t.el.setAttribute("srcset", "".concat(p, " ").concat(r, "x"));
      }
      function p(t, e) {
        var i = t.el;
        u(t, e, !1, function (t) {
          "load" === t.type
            ? i.setAttribute("data-rimg", "loaded")
            : (i.setAttribute("data-rimg", "error"), d(i, "rimg:error")),
            d(i, "rimg:load");
        });
      }
      function f(t) {
        var e = t.el,
          i = e.getAttribute("data-rimg");
        if ("loading" !== i && "loaded" !== i)
          if (t.isBackgroundImage || (0 !== e.naturalWidth && e.complete)) {
            if (!d(e, "rimg:loading")) {
              e.setAttribute("data-rimg", "loading");
              var n = (function (t) {
                for (
                  var e = { width: 0, height: 0 };
                  t &&
                  ((e.width = t.offsetWidth),
                  (e.height = t.offsetHeight),
                  !(e.width > 20 && e.height > 20));

                )
                  t = t.parentNode;
                return e;
              })(t.el);
              (n.width *= t.scale),
                (n.height *= t.scale),
                t.placeholder
                  ? (t.isBackgroundImage ||
                      (e.setAttribute(
                        "width",
                        Math.min(Math.floor(t.max.width / t.density), n.width)
                      ),
                      e.setAttribute(
                        "height",
                        Math.min(Math.floor(t.max.height / t.density), n.height)
                      )),
                    u(t, t.placeholder, !0, function () {
                      return p(t, n);
                    }))
                  : p(t, n);
            }
          } else
            e.addEventListener("load", function i() {
              e.removeEventListener("load", i), f(t);
            });
      }
      function g(t, e) {
        if (t) {
          d(t, "rimg:enter");
          var i = c(t, e);
          i.isImage &&
            (i.isBackgroundImage ||
              t.setAttribute(
                "data-rimg-template-svg",
                t.getAttribute("srcset")
              ),
            f(i));
        }
      }
      function m(t, e) {
        if (t) {
          d(t, "rimg:update");
          var i = c(t, e);
          i.isImage &&
            (i.isBackgroundImage ||
              (t.setAttribute("data-rimg", "lazy"),
              t.setAttribute(
                "srcset",
                t.getAttribute("data-rimg-template-svg")
              )),
            f(i));
        }
      }
      function v(t) {
        if (!t.offsetWidth || !t.offsetHeight || !t.getClientRects().length)
          return !1;
        var e = document.documentElement,
          i = Math.min(e.clientWidth, window.innerWidth),
          n = Math.min(e.clientHeight, window.innerHeight),
          s = t.getBoundingClientRect();
        return s.bottom >= 0 && s.right >= 0 && s.top <= n && s.left <= i;
      }
      function y() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : '[data-rimg="lazy"]',
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = new IntersectionObserver(
            function (t) {
              t.forEach(function (t) {
                (t.isIntersecting || t.intersectionRatio > 0) &&
                  (i.unobserve(t.target), g(t.target, e));
              });
            },
            { rootMargin: "20% 0px" }
          ),
          n = {
            track: function () {
              for (
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : '[data-rimg="lazy"]',
                  n = b(t),
                  s = 0;
                s < n.length;
                s++
              )
                v(n[s]) ? g(n[s], e) : i.observe(n[s]);
            },
            update: function () {
              for (
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : '[data-rimg="loaded"]',
                  i = b(t),
                  n = 0;
                n < i.length;
                n++
              )
                m(i[n], e);
            },
            untrack: function () {
              for (
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "[data-rimg]",
                  e = b(t),
                  n = 0;
                n < e.length;
                n++
              )
                i.unobserve(e[n]);
            },
            load: function () {
              for (
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "[data-rimg]",
                  i = b(t),
                  n = 0;
                n < i.length;
                n++
              )
                g(i[n], e);
            },
            unload: function () {
              i.disconnect();
            },
          };
        return n.track(t), n;
      }
      function b(t) {
        return "string" == typeof t
          ? document.querySelectorAll(t)
          : t instanceof HTMLElement
          ? [t]
          : t instanceof NodeList
          ? t
          : [];
      }
      Element.prototype.matches ||
        (Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (t) {
            for (
              var e = (this.document || this.ownerDocument).querySelectorAll(t),
                i = e.length;
              --i >= 0 && e.item(i) !== this;

            );
            return i > -1;
          });
      var w = {
        init: function () {
          var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : '[data-rimg="lazy"]',
            e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
          (w.selector = t),
            (w.instance = y(t, e)),
            (w.loadedWidth = Math.max(
              document.documentElement.clientWidth,
              window.innerWidth || 0
            )),
            document.addEventListener("shopify:section:load", function (t) {
              return _(t.target);
            }),
            window.addEventListener("resize", function () {
              return C();
            }),
            document.addEventListener("shopify:section:unload", function (t) {
              return S(t.target);
            }),
            document.addEventListener("theme:rimg:watch", function (t) {
              return _(t.target);
            }),
            document.addEventListener("theme:rimg:unwatch", function (t) {
              return S(t.target);
            }),
            window.jQuery &&
              jQuery(document).on({
                "theme:rimg:watch": function (t) {
                  return _(t.target);
                },
                "theme:rimg:unwatch": function (t) {
                  return S(t.target);
                },
              });
        },
        watch: _,
        unwatch: S,
        load: function (t) {
          "function" == typeof t.matches &&
            t.matches(w.selector) &&
            w.instance.load(t);
          w.instance.load(t.querySelectorAll(w.selector));
        },
      };
      function _(t) {
        "function" == typeof t.matches &&
          t.matches(w.selector) &&
          w.instance.track(t),
          w.instance.track(t.querySelectorAll(w.selector));
      }
      function S(t) {
        w.instance.untrack(t.querySelectorAll(w.selector)),
          "function" == typeof t.matches &&
            t.matches(w.selector) &&
            w.instance.untrack(t);
      }
      function C() {
        var t = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        (t / w.loadedWidth > 0.5 && t / w.loadedWidth < 2) ||
          ((w.loadedWidth = t), w.instance.update());
      }
      const x = w;
      class k {
        constructor(t) {
          (this.callbacks = new WeakMap()),
            (this._observerCallback = this._observerCallback.bind(this)),
            (this.observer = new IntersectionObserver(this._observerCallback, {
              rootMargin: "30%",
              threshold: 0,
              ...t,
            }));
        }
        add(t, e) {
          this.callbacks.set(t, e), this.observer.observe(t);
        }
        remove(t) {
          this.observer.unobserve(t), this.callbacks.delete(t);
        }
        unload() {
          this.observer.disconnect();
        }
        _observerCallback(t, e) {
          t.forEach((t) => {
            let { isIntersecting: i, target: n } = t;
            if (!0 === i) {
              e.unobserve(n);
              const t = this.callbacks.get(n);
              "function" == typeof t && t(), this.callbacks.delete(n);
            }
          });
        }
      }
      class E {
        constructor() {
          (this.handlers = {}),
            (this.instances = {}),
            (this.options = {}),
            (this.imports = {}),
            (this.lazyLoader = null),
            (this._onSectionEvent = this._onSectionEvent.bind(this)),
            document.addEventListener(
              "shopify:section:load",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:section:unload",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:section:select",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:section:deselect",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:block:select",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:block:deselect",
              this._onSectionEvent
            );
        }
        unbind() {
          document.removeEventListener(
            "shopify:section:load",
            this._onSectionEvent
          ),
            document.removeEventListener(
              "shopify:section:unload",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:section:select",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:section:deselect",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:block:select",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:block:deselect",
              this._onSectionEvent
            );
          for (let t = 0; t < this.instances.length; t++)
            this._triggerInstanceEvent(this.instances[t], "onSectionUnload");
          (this.handlers = {}),
            (this.options = {}),
            this.lazyLoader.unload(),
            (this.lazyLoader = null),
            (this.instances = {});
        }
        register(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.handlers[t],
            (this.handlers[t] = e),
            (this.options[t] = i),
            this._initSections(t);
        }
        _initSections(t) {
          const e = document.querySelectorAll(`[data-section-type="${t}"]`);
          if (e)
            for (let i = 0; i < e.length; i++) {
              const n = e[i].parentNode,
                s = n.querySelector("[data-section-id]");
              if (!s) continue;
              const o = s.getAttribute("data-section-id");
              o &&
                (this.options[t] && this.options[t].lazy
                  ? (null === this.lazyLoader && (this.lazyLoader = new k()),
                    this.lazyLoader.add(n, () => this._createInstance(o, n)))
                  : this._createInstance(o, n));
            }
        }
        _onSectionEvent(t) {
          const e = t.target,
            { sectionId: i, blockId: n } = t.detail,
            s = this.instances[i];
          switch (t.type) {
            case "shopify:section:load":
              this._createInstance(i, e);
              break;
            case "shopify:section:unload":
              this._triggerInstanceEvent(s, "onSectionUnload", {
                el: e,
                id: i,
              }),
                this.lazyLoader && this.lazyLoader.remove(e),
                delete this.instances[i];
              break;
            case "shopify:section:select":
              this._triggerInstanceEvent(s, "onSectionSelect", {
                el: e,
                id: i,
              });
              break;
            case "shopify:section:deselect":
              this._triggerInstanceEvent(s, "onSectionDeselect", {
                el: e,
                id: i,
              });
              break;
            case "shopify:block:select":
              this._triggerInstanceEvent(s, "onSectionBlockSelect", {
                el: e,
                id: n,
              });
              break;
            case "shopify:block:deselect":
              this._triggerInstanceEvent(s, "onSectionBlockDeselect", {
                el: e,
                id: n,
              });
              break;
            default:
              break;
          }
        }
        _triggerInstanceEvent(t, e) {
          if (t && t[e]) {
            for (
              var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), s = 2;
              s < i;
              s++
            )
              n[s - 2] = arguments[s];
            t[e](...n);
          }
        }
        _postMessage(t, e) {
          Object.keys(this.instances).forEach((i) => {
            this._triggerInstanceEvent(
              this.instances[i],
              "onSectionMessage",
              t,
              e
            );
          });
        }
        _createInstance(t, e) {
          const i = e.querySelector("[data-section-type]");
          if (!i) return;
          const n = i.getAttribute("data-section-type");
          if (!n) return;
          const s = this.handlers[n];
          if (!s) return;
          const o = this._loadData(e),
            r = this._postMessage.bind(this),
            a = { id: t, type: n, el: e, data: o, postMessage: r };
          if (this.imports[n]) this.instances[t] = this.imports[n](a);
          else {
            const e = s(a);
            e instanceof Promise
              ? e.then((e) => {
                  let { default: i } = e;
                  (this.imports[n] = () => new i(a)),
                    (this.instances[t] = new i(a));
                })
              : ((this.imports[n] = s), (this.instances[t] = e));
          }
        }
        _loadData(t) {
          const e = t.querySelector("[data-section-data]");
          if (!e) return {};
          const i = e.getAttribute("data-section-data") || e.innerHTML;
          try {
            return JSON.parse(i);
          } catch (t) {
            return {};
          }
        }
      }
      const T = [];
      ("IntersectionObserver" in window &&
        "IntersectionObserverEntry" in window &&
        "intersectionRatio" in window.IntersectionObserverEntry.prototype) ||
        T.push(document.querySelector("[data-scripts]").dataset.pxuPolyfills),
        window.NodeList &&
          !NodeList.prototype.forEach &&
          (NodeList.prototype.forEach = Array.prototype.forEach),
        Element.prototype.closest ||
          (Element.prototype.closest = function (t) {
            var e = this;
            do {
              if (Element.prototype.matches.call(e, t)) return e;
              e = e.parentElement || e.parentNode;
            } while (null !== e && 1 === e.nodeType);
            return null;
          });
      const A = T;
      class L {
        constructor(t) {
          window.Shopify &&
            window.Shopify.designMode &&
            t.postMessage("announcement:load");
        }
      }
      var I = i(729),
        D = i.n(I),
        P = i(414),
        M = i.n(P);
      class O {
        constructor(t) {
          (this.$el = t),
            this._initExternalLinks(),
            (this.groupedContent = null),
            this.$el.length &&
              ((this.groupedContent = new (M())(t.get(0), {
                layout: "tabs",
                intelliparse: !1,
              })),
              D()(".rte"));
        }
        unload() {
          this.groupedContent && this.groupedContent.unload();
        }
        _initExternalLinks() {
          const t = this.$el
            .find('a[href^="http"]')
            .filter((t, e) => -1 === e.href.indexOf(location.hostname));
          t.attr("target", "_blank");
        }
      }
      class q {
        constructor(t) {
          (this.$el = $(t)),
            (this.$inputParent = this.$el.find(".form-field--qty-input")),
            (this.$input = this.$el.find("[data-quantity-input]")),
            (this.$selectParent = this.$el.find(".form-field--qty-select")),
            (this.$select = this.$el.find("[data-quantity-select]")),
            (this._watchSelect = this._watchSelect.bind(this)),
            (this._watchInput = this._watchInput.bind(this)),
            this.$select.on("change.quantity", this._watchSelect),
            this.$input.on("change.quantity", this._watchInput);
        }
        unload() {
          this.$el.off(".quantity");
        }
        _validateValue(t) {
          const e = parseInt(t.currentTarget.value, 10);
          return isNaN(e) ? 1 : e;
        }
        _watchSelect(t) {
          const e = this._validateValue(t);
          this.$input.val(e).trigger("change"),
            e >= 10 &&
              (this.$inputParent.removeClass("hidden").addClass("visible"),
              this.$input.focus().removeAttr("tabindex").select(),
              this.$selectParent.removeClass("visible").addClass("hidden"),
              this.$select.attr("tabindex", "-1"));
        }
        _watchInput(t) {
          this.$input.val(this._validateValue(t));
        }
      }
      class F {
        constructor(t) {
          let i =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : ".form-field-input";
          (this.$el = e()(t)),
            (this.filledClass = "form-field-filled"),
            (this.fieldSelector = i),
            (this.quantityItems = []),
            (this.$quantityWrapper = this.$el.find("[data-quantity-wrapper]")),
            (this._toggleFilled = this._toggleFilled.bind(this)),
            this.$el.on("focus.forms", this.fieldSelector, this._toggleFilled),
            this.$el.on("blur.forms", this.fieldSelector, this._toggleFilled),
            this._checkFilled(),
            this.$quantityWrapper.length &&
              this.$quantityWrapper.each((t, e) => {
                this.quantityItems.push(new q(e));
              });
        }
        unload() {
          this.$el.off(".forms"),
            this.quantityItems.forEach((t) => {
              t.unload();
            });
        }
        _checkFilled() {
          this.$el.find(this.fieldSelector).each((t, i) => {
            e()(i).hasClass(this.filledClass) || this._toggleFilled(null, i);
          });
        }
        _toggleFilled() {
          let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : null,
            i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const n = t ? t.currentTarget : i,
            s = e()(n),
            { value: o } = n;
          let r = o.length > 0;
          try {
            (r = r || s.is(":-webkit-autofill")),
              s.toggleClass(this.filledClass, r);
          } catch (t) {
            s.toggleClass(this.filledClass, r);
          }
        }
      }
      class B {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.$commentForm = this.$el.find("[data-articlecomments-form]")),
            (this.richText = new O(this.$el)),
            this.$commentForm.length &&
              (this.commentForm = new F(this.$commentForm));
        }
        onSectionUnload() {
          this.richText.unload(), this.commentForm && this.commentForm.unload();
        }
      }
      class N {
        constructor(t) {
          (this.$el = e()(t.el)), (this.richText = new O(this.$el));
        }
        onSectionUnload() {
          this.richText.unload();
        }
      }
      var R,
        H = i(405),
        z = i.n(H);
      var j = "undefined" == typeof document ? void 0 : document,
        U = !!j && "content" in j.createElement("template"),
        W =
          !!j && j.createRange && "createContextualFragment" in j.createRange();
      function V(t) {
        return (
          (t = t.trim()),
          U
            ? (function (t) {
                var e = j.createElement("template");
                return (e.innerHTML = t), e.content.childNodes[0];
              })(t)
            : W
            ? (function (t) {
                return (
                  R || (R = j.createRange()).selectNode(j.body),
                  R.createContextualFragment(t).childNodes[0]
                );
              })(t)
            : (function (t) {
                var e = j.createElement("body");
                return (e.innerHTML = t), e.childNodes[0];
              })(t)
        );
      }
      function G(t, e) {
        var i,
          n,
          s = t.nodeName,
          o = e.nodeName;
        return (
          s === o ||
          ((i = s.charCodeAt(0)),
          (n = o.charCodeAt(0)),
          i <= 90 && n >= 97
            ? s === o.toUpperCase()
            : n <= 90 && i >= 97 && o === s.toUpperCase())
        );
      }
      function X(t, e, i) {
        t[i] !== e[i] &&
          ((t[i] = e[i]), t[i] ? t.setAttribute(i, "") : t.removeAttribute(i));
      }
      var Z = {
        OPTION: function (t, e) {
          var i = t.parentNode;
          if (i) {
            var n = i.nodeName.toUpperCase();
            "OPTGROUP" === n &&
              (n = (i = i.parentNode) && i.nodeName.toUpperCase()),
              "SELECT" !== n ||
                i.hasAttribute("multiple") ||
                (t.hasAttribute("selected") &&
                  !e.selected &&
                  (t.setAttribute("selected", "selected"),
                  t.removeAttribute("selected")),
                (i.selectedIndex = -1));
          }
          X(t, e, "selected");
        },
        INPUT: function (t, e) {
          X(t, e, "checked"),
            X(t, e, "disabled"),
            t.value !== e.value && (t.value = e.value),
            e.hasAttribute("value") || t.removeAttribute("value");
        },
        TEXTAREA: function (t, e) {
          var i = e.value;
          t.value !== i && (t.value = i);
          var n = t.firstChild;
          if (n) {
            var s = n.nodeValue;
            if (s == i || (!i && s == t.placeholder)) return;
            n.nodeValue = i;
          }
        },
        SELECT: function (t, e) {
          if (!e.hasAttribute("multiple")) {
            for (var i, n, s = -1, o = 0, r = t.firstChild; r; )
              if ("OPTGROUP" === (n = r.nodeName && r.nodeName.toUpperCase()))
                r = (i = r).firstChild;
              else {
                if ("OPTION" === n) {
                  if (r.hasAttribute("selected")) {
                    s = o;
                    break;
                  }
                  o++;
                }
                !(r = r.nextSibling) && i && ((r = i.nextSibling), (i = null));
              }
            t.selectedIndex = s;
          }
        },
      };
      function Q() {}
      function K(t) {
        if (t) return (t.getAttribute && t.getAttribute("id")) || t.id;
      }
      var Y = (function (t) {
        return function (e, i, n) {
          if ((n || (n = {}), "string" == typeof i))
            if (
              "#document" === e.nodeName ||
              "HTML" === e.nodeName ||
              "BODY" === e.nodeName
            ) {
              var s = i;
              (i = j.createElement("html")).innerHTML = s;
            } else i = V(i);
          var o = n.getNodeKey || K,
            r = n.onBeforeNodeAdded || Q,
            a = n.onNodeAdded || Q,
            l = n.onBeforeElUpdated || Q,
            c = n.onElUpdated || Q,
            h = n.onBeforeNodeDiscarded || Q,
            d = n.onNodeDiscarded || Q,
            u = n.onBeforeElChildrenUpdated || Q,
            p = !0 === n.childrenOnly,
            f = Object.create(null),
            g = [];
          function m(t) {
            g.push(t);
          }
          function v(t, e) {
            if (1 === t.nodeType)
              for (var i = t.firstChild; i; ) {
                var n = void 0;
                e && (n = o(i)) ? m(n) : (d(i), i.firstChild && v(i, e)),
                  (i = i.nextSibling);
              }
          }
          function y(t, e, i) {
            !1 !== h(t) && (e && e.removeChild(t), d(t), v(t, i));
          }
          function b(t) {
            a(t);
            for (var e = t.firstChild; e; ) {
              var i = e.nextSibling,
                n = o(e);
              if (n) {
                var s = f[n];
                s && G(e, s)
                  ? (e.parentNode.replaceChild(s, e), w(s, e))
                  : b(e);
              } else b(e);
              e = i;
            }
          }
          function w(e, i, n) {
            var s = o(i);
            if ((s && delete f[s], !n)) {
              if (!1 === l(e, i)) return;
              if ((t(e, i), c(e), !1 === u(e, i))) return;
            }
            "TEXTAREA" !== e.nodeName
              ? (function (t, e) {
                  var i,
                    n,
                    s,
                    a,
                    l,
                    c = e.firstChild,
                    h = t.firstChild;
                  t: for (; c; ) {
                    for (a = c.nextSibling, i = o(c); h; ) {
                      if (
                        ((s = h.nextSibling), c.isSameNode && c.isSameNode(h))
                      ) {
                        (c = a), (h = s);
                        continue t;
                      }
                      n = o(h);
                      var d = h.nodeType,
                        u = void 0;
                      if (
                        (d === c.nodeType &&
                          (1 === d
                            ? (i
                                ? i !== n &&
                                  ((l = f[i])
                                    ? s === l
                                      ? (u = !1)
                                      : (t.insertBefore(l, h),
                                        n ? m(n) : y(h, t, !0),
                                        (h = l))
                                    : (u = !1))
                                : n && (u = !1),
                              (u = !1 !== u && G(h, c)) && w(h, c))
                            : (3 !== d && 8 != d) ||
                              ((u = !0),
                              h.nodeValue !== c.nodeValue &&
                                (h.nodeValue = c.nodeValue))),
                        u)
                      ) {
                        (c = a), (h = s);
                        continue t;
                      }
                      n ? m(n) : y(h, t, !0), (h = s);
                    }
                    if (i && (l = f[i]) && G(l, c)) t.appendChild(l), w(l, c);
                    else {
                      var p = r(c);
                      !1 !== p &&
                        (p && (c = p),
                        c.actualize && (c = c.actualize(t.ownerDocument || j)),
                        t.appendChild(c),
                        b(c));
                    }
                    (c = a), (h = s);
                  }
                  !(function (t, e, i) {
                    for (; e; ) {
                      var n = e.nextSibling;
                      (i = o(e)) ? m(i) : y(e, t, !0), (e = n);
                    }
                  })(t, h, n);
                  var g = Z[t.nodeName];
                  g && g(t, e);
                })(e, i)
              : Z.TEXTAREA(e, i);
          }
          !(function t(e) {
            if (1 === e.nodeType || 11 === e.nodeType)
              for (var i = e.firstChild; i; ) {
                var n = o(i);
                n && (f[n] = i), t(i), (i = i.nextSibling);
              }
          })(e);
          var _,
            S,
            C = e,
            x = C.nodeType,
            k = i.nodeType;
          if (!p)
            if (1 === x)
              1 === k
                ? G(e, i) ||
                  (d(e),
                  (C = (function (t, e) {
                    for (var i = t.firstChild; i; ) {
                      var n = i.nextSibling;
                      e.appendChild(i), (i = n);
                    }
                    return e;
                  })(
                    e,
                    ((_ = i.nodeName),
                    (S = i.namespaceURI) && "http://www.w3.org/1999/xhtml" !== S
                      ? j.createElementNS(S, _)
                      : j.createElement(_))
                  )))
                : (C = i);
            else if (3 === x || 8 === x) {
              if (k === x)
                return (
                  C.nodeValue !== i.nodeValue && (C.nodeValue = i.nodeValue), C
                );
              C = i;
            }
          if (C === i) d(e);
          else {
            if (i.isSameNode && i.isSameNode(C)) return;
            if ((w(C, i, p), g))
              for (var E = 0, T = g.length; E < T; E++) {
                var A = f[g[E]];
                A && y(A, A.parentNode, !1);
              }
          }
          return (
            !p &&
              C !== e &&
              e.parentNode &&
              (C.actualize && (C = C.actualize(e.ownerDocument || j)),
              e.parentNode.replaceChild(C, e)),
            C
          );
        };
      })(function (t, e) {
        var i,
          n,
          s,
          o,
          r = e.attributes;
        if (11 !== e.nodeType && 11 !== t.nodeType) {
          for (var a = r.length - 1; a >= 0; a--)
            (n = (i = r[a]).name),
              (s = i.namespaceURI),
              (o = i.value),
              s
                ? ((n = i.localName || n),
                  t.getAttributeNS(s, n) !== o &&
                    ("xmlns" === i.prefix && (n = i.name),
                    t.setAttributeNS(s, n, o)))
                : t.getAttribute(n) !== o && t.setAttribute(n, o);
          for (var l = t.attributes, c = l.length - 1; c >= 0; c--)
            (n = (i = l[c]).name),
              (s = i.namespaceURI)
                ? ((n = i.localName || n),
                  e.hasAttributeNS(s, n) || t.removeAttributeNS(s, n))
                : e.hasAttribute(n) || t.removeAttribute(n);
        }
      });
      const J = Y;
      function tt(t) {
        if ("string" != typeof t) throw new TypeError(t + " is not a string.");
        this.countryOptions = t;
      }
      function et(t, e) {
        return t.querySelector('option[value="' + e + '"]');
      }
      function it(t, e, i) {
        var n = et(t, i),
          s = JSON.parse(n.getAttribute("data-provinces"));
        return (
          (e.options.length = 0),
          s.length &&
            (function (t, e) {
              var i = t.getAttribute("data-default");
              e.forEach(function (e) {
                var i = document.createElement("option");
                (i.value = e[0]), (i.textContent = e[1]), t.appendChild(i);
              }),
                i && et(t, i) && (t.value = i);
            })(e, s),
          s
        );
      }
      function nt(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function st(t, e, i) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = i),
          t
        );
      }
      function ot(t, e) {
        var i = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e &&
            (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            i.push.apply(i, n);
        }
        return i;
      }
      function rt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var i = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? ot(Object(i), !0).forEach(function (e) {
                st(t, e, i[e]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i))
            : ot(Object(i)).forEach(function (e) {
                Object.defineProperty(
                  t,
                  e,
                  Object.getOwnPropertyDescriptor(i, e)
                );
              });
        }
        return t;
      }
      function at(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var i = [],
              n = !0,
              s = !1,
              o = void 0;
            try {
              for (
                var r, a = t[Symbol.iterator]();
                !(n = (r = a.next()).done) &&
                (i.push(r.value), !e || i.length !== e);
                n = !0
              );
            } catch (t) {
              (s = !0), (o = t);
            } finally {
              try {
                n || null == a.return || a.return();
              } finally {
                if (s) throw o;
              }
            }
            return i;
          })(t, e) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return lt(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if (
              "Arguments" === i ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
            )
              return lt(t, e);
          })(t, e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function lt(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
        return n;
      }
      tt.prototype.build = function (t, e, i) {
        if ("object" != typeof t) throw new TypeError(t + " is not a object.");
        if ("object" != typeof e) throw new TypeError(e + " is not a object.");
        var n = t.getAttribute("data-default");
        if (
          ((i = i || {}),
          (t.innerHTML = this.countryOptions),
          (t.value = n),
          n && et(t, n))
        ) {
          var s = it(t, e, n);
          i.onCountryChange && i.onCountryChange(s, e, t);
        }
        t.addEventListener("change", function (n) {
          var s = n.target,
            o = s.value,
            r = it(s, e, o);
          i.onCountryChange && i.onCountryChange(r, e, t);
        }),
          i.onProvinceChange &&
            e.addEventListener("change", i.onProvinceChange);
      };
      var ct = {},
        ht = (function () {
          function t() {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t);
          }
          var e, i, n;
          return (
            (e = t),
            (n = [
              {
                key: "load",
                value: function (t, e) {
                  var i =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {},
                    n = t.replace(/\?[^#]+/, ""),
                    s = new RegExp(/.+\?([^#]+)/).exec(t),
                    o = { section_id: e };
                  "query" in i && (o = rt({}, o, {}, i.query)),
                    s &&
                      s.length >= 2 &&
                      s[1].split("&").forEach(function (t) {
                        var e = at(t.split("="), 2),
                          i = e[0],
                          n = e[1];
                        o[i] = n;
                      });
                  var r = rt({}, o, { _: new Date().getTime() }),
                    a = n.replace(/([^#]+)(.*)/, function (t, e, i) {
                      return ""
                        .concat(e, "?")
                        .concat(
                          Object.keys(o)
                            .sort()
                            .map(function (t) {
                              return ""
                                .concat(t, "=")
                                .concat(encodeURIComponent(o[t]));
                            })
                            .join("&")
                        )
                        .concat(i);
                    }),
                    l = n.replace(/([^#]+)(.*)/, function (t, e, i) {
                      return ""
                        .concat(e, "?")
                        .concat(
                          Object.keys(r)
                            .sort()
                            .map(function (t) {
                              return ""
                                .concat(t, "=")
                                .concat(encodeURIComponent(r[t]));
                            })
                            .join("&")
                        )
                        .concat(i);
                    }),
                    c = new Promise(function (t, e) {
                      var n;
                      if (a in ct) t(ct[a]);
                      else {
                        if (
                          ((ct[a] = c),
                          i.hash && (n = sessionStorage.getItem(a)))
                        ) {
                          var s = JSON.parse(n);
                          if (i.hash === s.options.hash)
                            return delete ct[a], void t(s);
                        }
                        var o = new XMLHttpRequest();
                        o.open("GET", l, !0),
                          (o.onload = function () {
                            var e = o.response,
                              n = {},
                              s = e.querySelector("[data-options]");
                            s &&
                              s.innerHTML &&
                              (n = JSON.parse(
                                e.querySelector("[data-options]").innerHTML
                              ));
                            var r = e.querySelectorAll("[data-html]"),
                              l = {};
                            if (
                              1 === r.length &&
                              "" === r[0].getAttribute("data-html")
                            )
                              l = r[0].innerHTML;
                            else
                              for (var c = 0; c < r.length; c++)
                                l[r[c].getAttribute("data-html")] =
                                  r[c].innerHTML;
                            var h = e.querySelectorAll("[data-data]"),
                              d = {};
                            if (
                              1 === h.length &&
                              "" === h[0].getAttribute("data-data")
                            )
                              d = JSON.parse(h[0].innerHTML);
                            else
                              for (var u = 0; u < h.length; u++)
                                d[h[u].getAttribute("data-data")] = JSON.parse(
                                  h[u].innerHTML
                                );
                            if (i.hash)
                              try {
                                sessionStorage.setItem(
                                  a,
                                  JSON.stringify({
                                    options: n,
                                    data: d,
                                    html: l,
                                  })
                                );
                              } catch (t) {}
                            delete ct[a], t({ data: d, html: l });
                          }),
                          (o.onerror = function () {
                            delete ct[a], e();
                          }),
                          (o.responseType = "document"),
                          o.send();
                      }
                    });
                  return c;
                },
              },
            ]),
            (i = null) && nt(e.prototype, i),
            n && nt(e, n),
            t
          );
        })();
      const dt = ht;
      class ut {
        constructor(t) {
          (this.settings = t.data.settings),
            (this.shipping = t.data.shipping),
            (this.updateTimeout = null),
            (this.$window = e()(window)),
            (this.$el = e()(t.el)),
            (this.el = t.el),
            (this.$total = this.$el.find("[data-cart-total]")),
            (this.$shipping = this.$el.find("[data-cartshipping]")),
            (this.$cartSidebar = this.$el.find("[data-cart-sidebar]")),
            (this.$titleTotalSmall = this.$el.find(".cart-title-total--small")),
            (this.$titleTotalLarge = this.$el.find(".cart-title-total--large")),
            (this.$titleTotalContents = this.$el.find(
              "[data-cart-title-total]"
            )),
            (this.cartItemList = this.$el[0].querySelector(
              "[data-cart-item-list]"
            )),
            (this.cartDiscounts = this.$el[0].querySelector(
              "[data-cart-discounts]"
            )),
            (this.$shippingToggle = this.$el.find(
              "[data-cartshipping-toggle]"
            )),
            (this.$shippingResponse = this.$shipping.find(
              "[data-cartshipping-response]"
            )),
            (this.$shippingResponseMessage = this.$shippingResponse.find(
              "[data-cartshipping-message]"
            )),
            (this.$shippingResponseRates = this.$shippingResponse.find(
              "[data-cartshipping-rates]"
            )),
            (this.$shippingSubmit = this.$shipping.find(
              "[data-cartshipping-submit]"
            )),
            this._moveTitleTotal();
          const i = e()("[data-scripts]");
          (this._quantityKeyUp = this._quantityKeyUp.bind(this)),
            (this._editItemQuantity = this._editItemQuantity.bind(this)),
            s()(i.data("shopify-api-url"), () => {
              this._bindEvents(),
                (window.Shopify.onError = this._handleErrors.bind(this));
            }),
            (this.forms = new F(this.$el)),
            this.settings.shipping &&
              this.$shipping.length &&
              s()(i.data("shopify-countries"), () => {
                s()(i.data("shopify-common"), () => {
                  this._initShippingCalc();
                });
              }),
            this.$cartSidebar.length && new O(this.$cartSidebar);
        }
        onSectionUnload() {
          this.$el.off(".cart-page"),
            this.$window.off(".cart-page"),
            this.forms.unload();
        }
        _bindEvents() {
          this.$el.on(
            "keyup.cart-page",
            "[data-cartitem-quantity]",
            this._quantityKeyUp
          ),
            this.$el.on(
              "keydown.cart-page",
              "[data-cartitem-quantity]",
              this._quantityKeyDown
            ),
            this.$el.on(
              "change.cart-page",
              "[data-cartitem-quantity][data-quantity-input]",
              this._editItemQuantity
            ),
            this.$el.on("click.cart-page", "[data-cartitem-remove]", (t) => {
              t.preventDefault(), this._editItemQuantity(t, !0);
            }),
            this.$window.on(
              "resize.cart-page",
              z()(() => this._moveTitleTotal(), 20)
            );
        }
        _getItemQuantity(t) {
          return parseInt(
            this.el.querySelector(
              `[data-cartitem-key="${t}"] [data-quantity-input]`
            ).value,
            10
          );
        }
        _moveTitleTotal() {
          if (this.$titleTotalContents.length)
            if (this.$window.outerWidth() >= 480) {
              if (
                !e().contains(
                  this.$titleTotalLarge[0],
                  this.$titleTotalContents[0]
                )
              ) {
                const t = this.$titleTotalContents.detach();
                this.$titleTotalLarge.append(t);
              }
            } else if (
              !e().contains(
                this.$titleTotalSmall[0],
                this.$titleTotalContents[0]
              )
            ) {
              const t = this.$titleTotalContents.detach();
              this.$titleTotalSmall.append(t);
            }
        }
        _quantityKeyUp(t) {
          "Backspace" !== t.key
            ? this._editItemQuantity(t)
            : null !== this.updateTimeout &&
              (clearTimeout(this.updateTimeout), (this.updateTimeout = null));
        }
        _quantityKeyDown(t) {
          "Enter" === t.key && t.preventDefault();
        }
        _editItemQuantity(t) {
          let i =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const n = e()(t.currentTarget).closest("[data-cartitem-id]")[0];
          i && n.classList.add("removing");
          const s = i
              ? 0
              : parseInt(
                  n.querySelector(
                    ".form-field.visible [data-cartitem-quantity]"
                  ).value,
                  10
                ),
            o = n.getAttribute("data-cartitem-key");
          this._updateCart(o, s);
        }
        _updateCart(t, e) {
          null !== this.updateTimeout && clearTimeout(this.updateTimeout),
            (this.updateTimeout = setTimeout(() => {
              if (e > 0 && this._getItemQuantity(t) !== e)
                return void (this.updateTimeout = null);
              const i = this.updateTimeout;
              window.Shopify.changeItem(t, e, (t) => {
                this.updateTimeout === i && this._didUpdate(t, i);
              });
            }, 300));
        }
        _didUpdate(t, e) {
          t.items.length
            ? dt
                .load(window.Theme.routes.cart_url, "cart-ajax", {
                  view: "_ajax",
                })
                .then((i) => {
                  let { html: n } = i;
                  if (this.updateTimeout !== e) return;
                  const s = new CustomEvent("cartcount:update", { detail: t });
                  window.dispatchEvent(s),
                    this.$total.each((e, i) => {
                      i.innerHTML = Shopify.formatMoney(
                        t.total_price,
                        this.settings.money_format
                      );
                    });
                  const o = document.createElement("div");
                  (o.innerHTML = n.list),
                    J(this.cartItemList, o.querySelector("ul"), {
                      onBeforeElUpdated: (t, e) =>
                        "IMG" !== t.tagName || t.src !== e.src,
                    }),
                    x.watch(this.cartItemList),
                    this.forms.unload(),
                    (this.forms = new F(this.$el)),
                    this.$el.off("keyup.cart-page", "[data-cartitem-quantity]"),
                    this.$el.on(
                      "keyup.cart-page",
                      "[data-cartitem-quantity]",
                      this._quantityKeyUp
                    ),
                    this.$el.off(
                      "keydown.cart-page",
                      "[data-cartitem-quantity]"
                    ),
                    this.$el.on(
                      "keydown.cart-page",
                      "[data-cartitem-quantity]",
                      this._quantityKeyDown
                    ),
                    this.$el.off(
                      "change.cart-page",
                      "[data-cartitem-quantity][data-quantity-input]"
                    ),
                    this.$el.on(
                      "change.cart-page",
                      "[data-cartitem-quantity][data-quantity-input]",
                      this._editItemQuantity
                    ),
                    this.$el.off("click.cart-page", "[data-cartitem-remove]"),
                    this.$el.on(
                      "click.cart-page",
                      "[data-cartitem-remove]",
                      (t) => {
                        t.preventDefault(), this._editItemQuantity(t, !0);
                      }
                    ),
                    (this.cartDiscounts.innerHTML = n.discounts);
                })
                .catch(() => window.location.reload())
            : (window.location = window.Theme.routes.cart_url);
        }
        _handleErrors() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null;
          if (!t) return;
          const e = { message: this.shipping.error_general };
          t.zip &&
            t.zip.length > 0 &&
            ((-1 === t.zip[0].indexOf("is not valid") &&
              -1 === t.zip[0].indexOf("can't be blank")) ||
              (e.message = `${this.shipping.zip} ${t.zip}`)),
            t.error &&
              t.error.length > 0 &&
              -1 !== t.error[0].indexOf("shipment_too_heavy") &&
              (e.message = this.shipping.shipment_too_heavy),
            this._handleShippingResponse(e);
        }
        _initShippingCalc() {
          this._bindShippingCalcEvents();
          const t = document.getElementById("address_country"),
            e = document.getElementById("address_province"),
            i = document.getElementById("address_province_container");
          (this.shippingCountryProvinceSelector = new tt(t.innerHTML)),
            this.shippingCountryProvinceSelector.build(t, e, {
              onCountryChange: (e) => {
                e.length
                  ? (i.style.display = "block")
                  : (i.style.display = "none");
                const { label: n, zip_label: s } = window.Countries[t.value];
                (i.querySelector('label[for="address_province"]').innerHTML =
                  n),
                  (this.el.querySelector(
                    '#address_zip ~ label[for="address_zip"]'
                  ).innerHTML = s);
              },
            });
        }
        _bindShippingCalcEvents() {
          this.$el.on("click.cart-page", "[data-cartshipping-toggle]", () => {
            this._toggleShippingCalc();
          }),
            this.$el.on("click.cart-page", "[data-cartshipping-submit]", () => {
              this._getShippingRates();
            }),
            this.$el.on("keypress.cart-page", "#address_zip", (t) => {
              (10 !== t.keyCode && 13 !== t.keyCode) ||
                (t.preventDefault(), this.$shippingSubmit.trigger("click"));
            });
        }
        _toggleShippingCalc() {
          const t = this.$shippingToggle.text(),
            e = this.$shippingToggle.data("cartshipping-toggle");
          this.$shippingToggle.text(e).data("cartshipping-toggle", t),
            this.$shipping.toggleClass("open");
        }
        _getShippingRates() {
          this._disableShippingButton();
          const t = {};
          (t.country = e()("#address_country").val() || ""),
            (t.province = e()("#address_province").val() || ""),
            (t.zip = e()("#address_zip").val() || "");
          const i = Object.keys(t)
            .map(
              (e) =>
                `${encodeURIComponent(
                  `shipping_address[${e}]`
                )}=${encodeURIComponent(t[e])}`
            )
            .join("&");
          e()
            .ajax(`${window.Theme.routes.cart_url}/shipping_rates.json?${i}`, {
              dataType: "json",
            })
            .fail((t) => this._handleErrors(t.responseJSON || {}))
            .done((e) => {
              const i = e.shipping_rates,
                n = [];
              t.zip.length && n.push(t.zip.trim()),
                t.province.length && n.push(t.province),
                t.country.length && n.push(t.country);
              const s = n.join(", ");
              let o = "";
              if (i.length > 1) {
                const t = window.Shopify.formatMoney(
                  i[0].price,
                  this.settings.money_format
                );
                o = this.shipping.multiple_rates
                  .replace("*address*", s)
                  .replace("*number_of_rates*", i.length)
                  .replace("*rate*", `<span class="money">${t}</span>`);
              } else
                o =
                  1 === i.length
                    ? this.shipping.one_rate.replace("*address*", s)
                    : this.shipping.no_rates;
              const r = i.map((t) => {
                const e = window.Shopify.formatMoney(
                  t.price,
                  this.settings.money_format
                );
                return `<li>${this.shipping.rate_value
                  .replace("*rate_title*", t.name)
                  .replace("*rate*", `<span class="money">${e}</span>`)}</li>`;
              });
              this._handleShippingResponse({ message: o, rates: r });
            });
        }
        _enableShippingButton() {
          this.$shippingSubmit
            .text(this.shipping.calculate_shipping)
            .attr("disabled", !1);
        }
        _disableShippingButton() {
          this.$shippingSubmit
            .text(this.shipping.calculating)
            .attr("disabled", !0);
        }
        _showShippingResponse() {
          this.$shippingResponse.addClass("visible");
        }
        _hideShippingResponse() {
          this.$shippingResponse.removeClass("visible");
        }
        _handleShippingResponse() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this._hideShippingResponse();
          const e = t.message || null,
            i = t.rates || null;
          this.$shippingResponseMessage.empty(),
            this.$shippingResponseRates.empty(),
            e && this.$shippingResponseMessage.html(e),
            i && this.$shippingResponseRates.html(i),
            this._enableShippingButton(),
            (e || i) && this._showShippingResponse();
        }
      }
      function pt(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function ft(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function gt(t, e, i) {
        return e && ft(t.prototype, e), i && ft(t, i), t;
      }
      function mt() {
        return new Promise(function (t) {
          window.requestAnimationFrame(t);
        });
      }
      var vt = (function () {
        function t(e) {
          pt(this, t),
            (this._el = e.el),
            (this.cancelRunning = null),
            (this._state = e.state || "initial"),
            (this.initialState = this._state),
            (this.stateAttribute = e.stateAttribute || "data-animation-state"),
            (this.stateChangeAttribute =
              e.stateChangeAttribute || "data-animation"),
            (this.endEvent = e.endEvent || "transitionend"),
            (this.hold = !!e.hold),
            (this.onStart = e.onStart || function () {}),
            (this.activeEventHandler = null);
        }
        return (
          gt(t, [
            {
              key: "isState",
              value: function (t) {
                return t === this._state;
              },
            },
            {
              key: "animateTo",
              value: function (t) {
                var e = this,
                  i =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {},
                  n = this._el.dataset[this.stateAttribute] || this._state,
                  s = t || this.initialState,
                  o = i.force,
                  r = "hold" in i ? i.hold : this.hold;
                return new Promise(function (t) {
                  if ((e.cancelRunning && e.cancelRunning(), n === s))
                    return (
                      e._el.removeAttribute(e.stateChangeAttribute),
                      void t(n, null)
                    );
                  var a = !0;
                  if (
                    ((e.cancelRunning = function () {
                      (a = !1), t(null, null);
                    }),
                    e._el.removeEventListener(e.endEvent, e.activeEventHandler),
                    (e.activeEventHandler = null),
                    o)
                  )
                    return (
                      e._el.setAttribute(
                        e.stateChangeAttribute,
                        "".concat(n, "=>").concat(s)
                      ),
                      e.onStart({ el: e._el, from: n, to: s }),
                      "function" == typeof i.onStart &&
                        i.onStart({ el: e._el, from: n, to: s }),
                      e._el.setAttribute(e.stateAttribute, s),
                      (e._state = s),
                      r || e._el.removeAttribute(e.stateChangeAttribute),
                      void t(s, null)
                    );
                  mt()
                    .then(function () {
                      if (!a) throw new Error("cancelled");
                      return (
                        e._el.setAttribute(
                          e.stateChangeAttribute,
                          "".concat(n, "=>").concat(s)
                        ),
                        e.onStart({ el: e._el, from: n, to: s }),
                        "function" == typeof i.onStart &&
                          i.onStart({ el: e._el, from: n, to: s }),
                        mt()
                      );
                    })
                    .then(function () {
                      if (!a) throw new Error("cancelled");
                      e._el.removeEventListener(
                        e.endEvent,
                        e.activeEventHandler
                      ),
                        (e.activeEventHandler = function (i) {
                          i.target === e._el &&
                            a &&
                            (e._el.removeEventListener(
                              e.endEvent,
                              e.activeEventHandler
                            ),
                            r || e._el.removeAttribute(e.stateChangeAttribute),
                            t(s, i));
                        }),
                        e._el.addEventListener(
                          e.endEvent,
                          e.activeEventHandler
                        ),
                        e._el.setAttribute(e.stateAttribute, s),
                        (e._state = s);
                    })
                    .catch(function (t) {
                      if ("cancelled" !== t.message) throw t;
                    });
                });
              },
            },
            {
              key: "unload",
              value: function () {
                this._el.removeEventListener(
                  this.endEvent,
                  this.activeEventHandler
                ),
                  (this.activeEventHandler = null);
              },
            },
            {
              key: "el",
              get: function () {
                return this._el;
              },
            },
            {
              key: "state",
              get: function () {
                return this._state;
              },
            },
          ]),
          t
        );
      })();
      function yt(t) {
        return new vt(t);
      }
      var bt = i(646),
        wt = i(442),
        _t = i.n(wt),
        St = i(766);
      const Ct = [];
      let xt = null;
      function kt() {
        return window
          .getComputedStyle(document.documentElement, ":before")
          .getPropertyValue("content")
          .replace(/"/g, "")
          .split(",");
      }
      function Et() {
        return window
          .getComputedStyle(document.documentElement, ":after")
          .getPropertyValue("content")
          .replace(/"/g, "");
      }
      e()(window).on("resize", (t) => {
        const e = Et();
        xt !== e &&
          Ct.forEach((i) => {
            i(t, { previous: xt, current: e });
          }),
          (xt = e);
      });
      const Tt = {
        isLessThanBreakpoint: function (t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const i = kt(),
            n = Et(),
            s = i.indexOf(n) - i.indexOf(t);
          return e ? s <= 0 : s < 0;
        },
        isGreaterThanBreakpoint: function (t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const i = kt(),
            n = Et(),
            s = i.indexOf(n) - i.indexOf(t);
          return e ? s >= 0 : s > 0;
        },
        isBreakpoint: function () {
          const t = Et();
          for (var e = arguments.length, i = new Array(e), n = 0; n < e; n++)
            i[n] = arguments[n];
          return i.some((e) => e === t);
        },
        onBreakpointChange: function (t) {
          -1 === Ct.indexOf(t) && Ct.push(t);
        },
        offBreakpointChange: function (t) {
          const e = Ct.indexOf(t);
          -1 !== e && Ct.splice(e, 1);
        },
      };
      class At {
        constructor(t, e, i) {
          (this.callback = e),
            (this._runCallback = this._runCallback.bind(this)),
            (this.observer = new IntersectionObserver(this._runCallback, {
              rootMargin: "30%",
              threshold: 0,
              ...i,
            })),
            this.observer.observe(t);
        }
        _runCallback(t) {
          !0 === t[0].isIntersecting && (this.unload(), this.callback());
        }
        unload() {
          this.observer.disconnect();
        }
      }
      var Lt = i(529),
        It = i.n(Lt);
      function Dt(t, e) {
        e = e || {};
        var i = t.tabIndex;
        (t.tabIndex = -1),
          (t.dataset.tabIndex = i),
          t.focus(),
          void 0 !== e.className && t.classList.add(e.className),
          t.addEventListener("blur", function n(s) {
            s.target.removeEventListener(s.type, n),
              (t.tabIndex = i),
              delete t.dataset.tabIndex,
              void 0 !== e.className && t.classList.remove(e.className);
          });
      }
      var Pt = {};
      function $t(t, e) {
        e = e || {};
        var i = (function (t) {
            return Array.prototype.slice
              .call(
                t.querySelectorAll(
                  "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                )
              )
              .filter(function (t) {
                return !!(
                  t.offsetWidth ||
                  t.offsetHeight ||
                  t.getClientRects().length
                );
              });
          })(t),
          n = e.elementToFocus || t,
          s = i[0],
          o = i[i.length - 1];
        Mt(),
          (Pt.focusin = function (e) {
            t === e.target || t.contains(e.target) || s.focus(),
              (e.target !== t && e.target !== o && e.target !== s) ||
                document.addEventListener("keydown", Pt.keydown);
          }),
          (Pt.focusout = function () {
            document.removeEventListener("keydown", Pt.keydown);
          }),
          (Pt.keydown = function (e) {
            9 === e.keyCode &&
              (e.target !== o || e.shiftKey || (e.preventDefault(), s.focus()),
              (e.target !== t && e.target !== s) ||
                !e.shiftKey ||
                (e.preventDefault(), o.focus()));
          }),
          document.addEventListener("focusout", Pt.focusout),
          document.addEventListener("focusin", Pt.focusin),
          Dt(n, e);
      }
      function Mt() {
        document.removeEventListener("focusin", Pt.focusin),
          document.removeEventListener("focusout", Pt.focusout),
          document.removeEventListener("keydown", Pt.keydown);
      }
      const { body: Ot } = document,
        qt = document.querySelector("html");
      function Ft(t) {
        t.target.closest(".allow-scroll-while-locked") ||
          (t.preventDefault(), t.stopPropagation());
      }
      class Bt {
        static lock(t) {
          t && t.classList.add("allow-scroll-while-locked"),
            qt.classList.add("scroll-locked"),
            (Ot.style.top = -1 * window.pageYOffset),
            Ot.addEventListener("scroll", Ft, !1),
            Ot.addEventListener("touchmove", Ft, { passive: !1 });
        }
        static unlock() {
          document
            .querySelectorAll(".allow-scroll-while-locked")
            .forEach((t) => t.classList.remove("allow-scroll-while-locked")),
            qt.classList.remove("scroll-locked"),
            (Ot.style.top = ""),
            Ot.removeEventListener("scroll", Ft, !1),
            Ot.removeEventListener("touchmove", Ft, { passive: !1 });
        }
        static get isLocked() {
          return qt.classList.contains("scroll-locked");
        }
      }
      let Nt = [];
      const Rt = () => {
        0 === Nt.length && Bt.unlock();
      };
      class Ht {
        constructor() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          (this.$body = e()(document.body)), (this.$window = e()(window));
          this.options = {
            onOpen: () => {},
            onClose: () => {},
            onBeforeOpen: () => {},
            onBeforeClose: () => {},
            modalId: null,
            ...t,
          };
          const i = this.options.modalId
              ? `[data-modal-container-${this.options.modalId}]`
              : "[data-modal-container]",
            n = this.options.modalId
              ? `[data-modal-${this.options.modalId}-close`
              : "[data-modal-close]";
          (this.loadedClass = this.options.modalId
            ? `modal-${this.options.modalId}-loaded`
            : "modal-loaded"),
            (this.visibleClass = this.options.modalId
              ? `modal-${this.options.modalId}-visible`
              : "modal-visible"),
            (this.modal = null),
            (this.$modal = e()(i)),
            (this.$modalInner = this.$modal.find("[data-modal-inner]")),
            (this.finishedLoading = this.finishedLoading.bind(this)),
            (this._onOpen = this._onOpen.bind(this)),
            (this._onBeforeOpen = this._onBeforeOpen.bind(this)),
            (this._onClose = this._onClose.bind(this)),
            (this._onBeforeClose = this._onBeforeClose.bind(this)),
            (this._closeEsc = this._closeEsc.bind(this)),
            (this.position = this.position.bind(this)),
            (this.modalOptions = {
              modal: i,
              loadClass: "",
              class: this.loadedClass,
              close: n,
              onOpen: this._onOpen,
              onClose: this._onClose,
              onBeforeOpen: this._onBeforeOpen,
              onBeforeClose: this._onBeforeClose,
              transitions: !1,
              closeKeys: [],
            });
        }
        unload() {
          this.modal &&
            (this.modal.destroy(), (Nt = Nt.filter((t) => t !== this)), Rt());
        }
        open(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "general";
          this._addModalClass(e),
            (this.modal = new (It())(this.modalOptions)),
            this.modal.open(t),
            Nt.push(this),
            window.addEventListener("keydown", this._closeEsc);
        }
        close() {
          this.modal.close(),
            window.removeEventListener("keydown", this._closeEsc);
        }
        finishedLoading() {
          $t(this.$modal[0]);
        }
        _closeEsc(t) {
          "Escape" === t.key && Nt[Nt.length - 1] === this && this.close();
        }
        isOpen() {
          return this.modal && this.modal.isOpen;
        }
        position() {
          const t = window.innerHeight,
            e = this.$modalInner.outerHeight(),
            i = (t - 2 * parseInt(this.$modal.css("padding-top"), 10) - e) / 2,
            n = i > 0 ? i : 0;
          this.$modalInner.css({ marginTop: n });
        }
        _addModalClass(t) {
          this.$modal.addClass(`modal--${t}`);
        }
        _removeModalClass() {
          const t = this.$modal.attr("class").match(/modal--[\w-]*\b/);
          t && this.$modal.removeClass(t[0]);
        }
        _onClose() {
          if (
            (this._removeModalClass(),
            this.$body.removeClass(this.visibleClass),
            this.$window.off("resize.modal"),
            this.$modalInner.css({ marginTop: "" }),
            this.options.onClose(),
            Mt(this.$modal[0]),
            this.activeElement)
          ) {
            const t = this.activeElement.closest("[data-trap-focus]");
            t && $t(t), this.activeElement.focus();
          }
          (Nt = Nt.filter((t) => t !== this)), Rt();
        }
        _onOpen() {
          (this.activeElement = document.activeElement),
            this.position(),
            Bt.lock(this.$modal[0]),
            this.$body.addClass(this.visibleClass),
            this.$window.on(
              "resize.modal",
              z()(() => this.position(), 16, !0, !0)
            ),
            this.options.onOpen(),
            $t(this.$modal[0]);
        }
        _onBeforeClose() {
          this.options.onBeforeClose();
        }
        _onBeforeOpen() {
          this.options.onBeforeOpen();
        }
      }
      i(722);
      function zt(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function jt(t, e, i) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = i),
          t
        );
      }
      function Ut(t, e) {
        var i = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e &&
            (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            i.push.apply(i, n);
        }
        return i;
      }
      var Wt = "pxu-shopify-surface-pick-up",
        Vt = "surface-pick-up--loading",
        Gt = function (t) {
          return t + 36e5 <= Date.now();
        },
        Xt = null,
        Zt = function (t) {
          var e = t.latitude,
            i = t.longitude;
          return new Promise(function (t) {
            var n = JSON.parse(localStorage.getItem(Wt)),
              s = { latitude: e, longitude: i, timestamp: Date.now() };
            (Xt = s),
              localStorage.setItem(Wt, JSON.stringify(s)),
              null !== n &&
              n.latitude === e &&
              n.longitude === i &&
              Gt(n.timestamp)
                ? t({ latitude: e, longitude: i })
                : fetch("/localization.json", {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ latitude: e, longitude: i }),
                  }).then(function () {
                    return t({ latitude: e, longitude: i });
                  });
          });
        },
        Qt = function () {
          return new Promise(function (t) {
            Xt && Gt(Xt.timestamp)
              ? t(Xt)
              : t(
                  new Promise(function (t, e) {
                    navigator.geolocation
                      ? navigator.geolocation.getCurrentPosition(
                          function (e) {
                            var i = e.coords;
                            return t(i);
                          },
                          e,
                          { maximumAge: 36e5, timeout: 5e3 }
                        )
                      : e();
                  }).then(Zt)
                );
          });
        },
        Kt = (function () {
          function t(e, i) {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this.el = e),
              (this.options = (function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var i = null != arguments[e] ? arguments[e] : {};
                  e % 2
                    ? Ut(Object(i), !0).forEach(function (e) {
                        jt(t, e, i[e]);
                      })
                    : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        t,
                        Object.getOwnPropertyDescriptors(i)
                      )
                    : Ut(Object(i)).forEach(function (e) {
                        Object.defineProperty(
                          t,
                          e,
                          Object.getOwnPropertyDescriptor(i, e)
                        );
                      });
                }
                return t;
              })(
                {
                  root_url:
                    (window.Theme &&
                      window.Theme.routes &&
                      window.Theme.routes.root_url) ||
                    "",
                },
                i
              )),
              (this.options.root_url = this.options.root_url.replace(
                /(.*)\/$/,
                "$1"
              )),
              (this.callbacks = []),
              (this.onBtnPress = null),
              (this.latestVariantId = null),
              (this.pickUpEnabled = null !== localStorage.getItem(Wt));
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "load",
                value: function (t) {
                  var e = this;
                  this.latestVariantId = t;
                  var i = function () {
                    return Qt()
                      .then(function (i) {
                        return e._getData(t).then(function (t) {
                          return e._injectData(t, i);
                        });
                      })
                      .catch(function () {
                        return e._getData(t).then(function (t) {
                          return e._injectData(t, null);
                        });
                      });
                  };
                  return (
                    this.el.classList.add(Vt),
                    this.pickUpEnabled
                      ? i()
                      : this._getData(t).then(function (t) {
                          return t.items.length > 0
                            ? ((e.pickUpEnabled = !0),
                              e._injectData(t, null),
                              i())
                            : e._injectData(t, null);
                        })
                  );
                },
              },
              {
                key: "onModalRequest",
                value: function (t) {
                  this.callbacks.indexOf(t) >= 0 || this.callbacks.push(t);
                },
              },
              {
                key: "offModalRequest",
                value: function (t) {
                  this.callbacks.splice(this.callbacks.indexOf(t));
                },
              },
              {
                key: "unload",
                value: function () {
                  (this.callbacks = []), (this.el.innerHTML = "");
                },
              },
              {
                key: "_getData",
                value: function (t) {
                  var e = this;
                  return new Promise(function (i) {
                    var n = new XMLHttpRequest(),
                      s = ""
                        .concat(e.options.root_url, "/variants/")
                        .concat(t, "/?section_id=surface-pick-up");
                    n.open("GET", s, !0),
                      (n.onload = function () {
                        var e = n.response,
                          s = e.querySelector(
                            '[data-html="surface-pick-up-embed"]'
                          ),
                          o = e.querySelector(
                            '[data-html="surface-pick-up-items"]'
                          ),
                          r = o.content.querySelectorAll(
                            "[data-surface-pick-up-item]"
                          );
                        i({
                          embed: s,
                          itemsContainer: o,
                          items: r,
                          variantId: t,
                        });
                      }),
                      (n.onerror = function () {
                        i({
                          embed: { innerHTML: "" },
                          itemsContainer: { innerHTML: "" },
                          items: [],
                          variantId: t,
                        });
                      }),
                      (n.responseType = "document"),
                      n.send();
                  });
                },
              },
              {
                key: "_injectData",
                value: function (t, e) {
                  var i = this,
                    n = t.embed,
                    s = t.itemsContainer,
                    o = t.items;
                  if (t.variantId !== this.latestVariantId) return null;
                  if (
                    ((this.el.innerHTML = n.innerHTML),
                    this.el.classList.remove(Vt),
                    0 === o.length)
                  )
                    return this.el;
                  var r = !1,
                    a = function () {
                      r ||
                        ((r = !0),
                        o.forEach(function (t) {
                          var i = t.querySelector("[data-distance]"),
                            n = t.querySelector("[data-distance-unit]"),
                            s = n.dataset.distanceUnit,
                            o = parseFloat(i.dataset.latitude),
                            r = parseFloat(i.dataset.longitude);
                          if (e && isFinite(o) && isFinite(r)) {
                            var a = (function (t, e, i, n, s) {
                              var o = Math.PI / 180,
                                r = "metric" === s ? 6378.14 : 3959,
                                a = t * o,
                                l = i * o,
                                c = e * o - n * o,
                                h = a - l,
                                d =
                                  Math.pow(Math.sin(h / 2), 2) +
                                  Math.cos(a) *
                                    Math.cos(l) *
                                    Math.pow(Math.sin(c / 2), 2);
                              return (
                                r *
                                (2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)))
                              );
                            })(e.latitude, e.longitude, o, r, s);
                            i.innerHTML = a.toFixed(1);
                          } else i.remove(), n.remove();
                        }));
                    };
                  return (
                    this.el
                      .querySelector("[data-surface-pick-up-embed-modal-btn]")
                      .addEventListener("click", function () {
                        a(),
                          i.callbacks.forEach(function (t) {
                            return t(s.innerHTML);
                          });
                      }),
                    this.el
                  );
                },
              },
            ]),
            i && zt(e.prototype, i),
            n && zt(e, n),
            t
          );
        })();
      const Yt = Kt;
      class Jt {
        constructor(t, e) {
          const i = document.querySelector(
            "[data-templates] [data-message-banner]"
          );
          this.banner = i.cloneNode(!0);
          (this.banner.querySelector(
            "[data-message-banner-content]"
          ).innerHTML = t),
            this.banner.classList.add(`message--${e}`);
          (
            document.querySelector(".modal-loaded .modal-inner") ||
            document.querySelector("[data-site-header]")
          ).appendChild(this.banner),
            (this.closeButton = this.banner.querySelector(
              "[data-message-banner-close]"
            )),
            (this.bannerAnimation = yt({ el: this.banner, state: "closed" })),
            this.bannerAnimation.animateTo("open"),
            (this.events = new St.Z()),
            this.events.register(this.closeButton, "click", () =>
              this._close()
            ),
            this.events.register(document, "click", (t) =>
              this._handleDocumentClick(t.target)
            ),
            this.events.register(document, "touchStart", (t) =>
              this._handleDocumentClick(t.target)
            ),
            this.events.register(window, "keydown", (t) => this._closeEsc(t));
        }
        unload() {
          this.banner && this._close();
        }
        _closeEsc(t) {
          "Escape" === t.key && this._close();
        }
        _close() {
          this.bannerAnimation.animateTo("closed").then(() => {
            this.banner.remove(),
              (this.banner = null),
              this.events.unregisterAll(),
              this.bannerAnimation.unload();
          });
        }
        _handleDocumentClick(t) {
          e()(t).parents("[data-message-banner]").length || this._close();
        }
      }
      class te {
        preload(t, e) {
          let i = t;
          "string" == typeof t && (i = [t]);
          for (let t = 0; t < i.length; t++)
            this.loadImage(this.getSizedImageUrl(i[t], e));
        }
        loadImage(t) {
          const e = new Image();
          return (e.src = t), e;
        }
        getSizedImageUrl() {
          let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : null,
            e = arguments.length > 1 ? arguments[1] : void 0;
          if (!e) return null;
          if ("master" === e) return this.removeProtocol(t);
          const i = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (i) {
            const n = t.split(i[0]),
              s = i[0];
            return this.removeProtocol(`${n[0]}_${e}${s}`);
          }
          return null;
        }
        removeProtocol(t) {
          return t.replace(/http(s)?:/, "");
        }
      }
      var ee = function (t, e) {
        return (
          (ee =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
            }),
          ee(t, e)
        );
      };
      function ie(t, e) {
        function i() {
          this.constructor = t;
        }
        ee(t, e),
          (t.prototype =
            null === e
              ? Object.create(e)
              : ((i.prototype = e.prototype), new i()));
      }
      var ne = function () {
        return (
          (ne =
            Object.assign ||
            function (t) {
              for (var e, i = 1, n = arguments.length; i < n; i++)
                for (var s in (e = arguments[i]))
                  Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
              return t;
            }),
          ne.apply(this, arguments)
        );
      };
      function se(t, e) {
        var i = "function" == typeof Symbol && t[Symbol.iterator];
        if (!i) return t;
        var n,
          s,
          o = i.call(t),
          r = [];
        try {
          for (; (void 0 === e || e-- > 0) && !(n = o.next()).done; )
            r.push(n.value);
        } catch (t) {
          s = { error: t };
        } finally {
          try {
            n && !n.done && (i = o.return) && i.call(o);
          } finally {
            if (s) throw s.error;
          }
        }
        return r;
      }
      function oe() {
        for (var t = [], e = 0; e < arguments.length; e++)
          t = t.concat(se(arguments[e]));
        return t;
      }
      var re = (function () {
        function t(t) {
          void 0 === t && (t = {}), (this.adapter_ = t);
        }
        return (
          Object.defineProperty(t, "cssClasses", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          Object.defineProperty(t, "strings", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          Object.defineProperty(t, "numbers", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          Object.defineProperty(t, "defaultAdapter", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          (t.prototype.init = function () {}),
          (t.prototype.destroy = function () {}),
          t
        );
      })();
      var ae = (function () {
        function t(t, e) {
          for (var i = [], n = 2; n < arguments.length; n++)
            i[n - 2] = arguments[n];
          (this.root_ = t),
            this.initialize.apply(this, oe(i)),
            (this.foundation_ = void 0 === e ? this.getDefaultFoundation() : e),
            this.foundation_.init(),
            this.initialSyncWithDOM();
        }
        return (
          (t.attachTo = function (e) {
            return new t(e, new re({}));
          }),
          (t.prototype.initialize = function () {
            for (var t = [], e = 0; e < arguments.length; e++)
              t[e] = arguments[e];
          }),
          (t.prototype.getDefaultFoundation = function () {
            throw new Error(
              "Subclasses must override getDefaultFoundation to return a properly configured foundation class"
            );
          }),
          (t.prototype.initialSyncWithDOM = function () {}),
          (t.prototype.destroy = function () {
            this.foundation_.destroy();
          }),
          (t.prototype.listen = function (t, e, i) {
            this.root_.addEventListener(t, e, i);
          }),
          (t.prototype.unlisten = function (t, e, i) {
            this.root_.removeEventListener(t, e, i);
          }),
          (t.prototype.emit = function (t, e, i) {
            var n;
            void 0 === i && (i = !1),
              "function" == typeof CustomEvent
                ? (n = new CustomEvent(t, { bubbles: i, detail: e }))
                : (n = document.createEvent("CustomEvent")).initCustomEvent(
                    t,
                    i,
                    !1,
                    e
                  ),
              this.root_.dispatchEvent(n);
          }),
          t
        );
      })();
      function le(t) {
        return (
          void 0 === t && (t = window),
          !!(function (t) {
            void 0 === t && (t = window);
            var e = !1;
            try {
              var i = {
                  get passive() {
                    return (e = !0), !1;
                  },
                },
                n = function () {};
              t.document.addEventListener("test", n, i),
                t.document.removeEventListener("test", n, i);
            } catch (t) {
              e = !1;
            }
            return e;
          })(t) && { passive: !0 }
        );
      }
      function ce(t, e) {
        return (
          t.matches ||
          t.webkitMatchesSelector ||
          t.msMatchesSelector
        ).call(t, e);
      }
      var he,
        de = {
          BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
          FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
          FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
          ROOT: "mdc-ripple-upgraded",
          UNBOUNDED: "mdc-ripple-upgraded--unbounded",
        },
        ue = {
          VAR_FG_SCALE: "--mdc-ripple-fg-scale",
          VAR_FG_SIZE: "--mdc-ripple-fg-size",
          VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
          VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
          VAR_LEFT: "--mdc-ripple-left",
          VAR_TOP: "--mdc-ripple-top",
        },
        pe = {
          DEACTIVATION_TIMEOUT_MS: 225,
          FG_DEACTIVATION_MS: 150,
          INITIAL_ORIGIN_SCALE: 0.6,
          PADDING: 10,
          TAP_DELAY_MS: 300,
        };
      var fe = ["touchstart", "pointerdown", "mousedown", "keydown"],
        ge = ["touchend", "pointerup", "mouseup", "contextmenu"],
        me = [],
        ve = (function (t) {
          function e(i) {
            var n = t.call(this, ne(ne({}, e.defaultAdapter), i)) || this;
            return (
              (n.activationAnimationHasEnded_ = !1),
              (n.activationTimer_ = 0),
              (n.fgDeactivationRemovalTimer_ = 0),
              (n.fgScale_ = "0"),
              (n.frame_ = { width: 0, height: 0 }),
              (n.initialSize_ = 0),
              (n.layoutFrame_ = 0),
              (n.maxRadius_ = 0),
              (n.unboundedCoords_ = { left: 0, top: 0 }),
              (n.activationState_ = n.defaultActivationState_()),
              (n.activationTimerCallback_ = function () {
                (n.activationAnimationHasEnded_ = !0),
                  n.runDeactivationUXLogicIfReady_();
              }),
              (n.activateHandler_ = function (t) {
                return n.activate_(t);
              }),
              (n.deactivateHandler_ = function () {
                return n.deactivate_();
              }),
              (n.focusHandler_ = function () {
                return n.handleFocus();
              }),
              (n.blurHandler_ = function () {
                return n.handleBlur();
              }),
              (n.resizeHandler_ = function () {
                return n.layout();
              }),
              n
            );
          }
          return (
            ie(e, t),
            Object.defineProperty(e, "cssClasses", {
              get: function () {
                return de;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e, "strings", {
              get: function () {
                return ue;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e, "numbers", {
              get: function () {
                return pe;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e, "defaultAdapter", {
              get: function () {
                return {
                  addClass: function () {},
                  browserSupportsCssVars: function () {
                    return !0;
                  },
                  computeBoundingRect: function () {
                    return {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      width: 0,
                      height: 0,
                    };
                  },
                  containsEventTarget: function () {
                    return !0;
                  },
                  deregisterDocumentInteractionHandler: function () {},
                  deregisterInteractionHandler: function () {},
                  deregisterResizeHandler: function () {},
                  getWindowPageOffset: function () {
                    return { x: 0, y: 0 };
                  },
                  isSurfaceActive: function () {
                    return !0;
                  },
                  isSurfaceDisabled: function () {
                    return !0;
                  },
                  isUnbounded: function () {
                    return !0;
                  },
                  registerDocumentInteractionHandler: function () {},
                  registerInteractionHandler: function () {},
                  registerResizeHandler: function () {},
                  removeClass: function () {},
                  updateCssVariable: function () {},
                };
              },
              enumerable: !0,
              configurable: !0,
            }),
            (e.prototype.init = function () {
              var t = this,
                i = this.supportsPressRipple_();
              if ((this.registerRootHandlers_(i), i)) {
                var n = e.cssClasses,
                  s = n.ROOT,
                  o = n.UNBOUNDED;
                requestAnimationFrame(function () {
                  t.adapter_.addClass(s),
                    t.adapter_.isUnbounded() &&
                      (t.adapter_.addClass(o), t.layoutInternal_());
                });
              }
            }),
            (e.prototype.destroy = function () {
              var t = this;
              if (this.supportsPressRipple_()) {
                this.activationTimer_ &&
                  (clearTimeout(this.activationTimer_),
                  (this.activationTimer_ = 0),
                  this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)),
                  this.fgDeactivationRemovalTimer_ &&
                    (clearTimeout(this.fgDeactivationRemovalTimer_),
                    (this.fgDeactivationRemovalTimer_ = 0),
                    this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
                var i = e.cssClasses,
                  n = i.ROOT,
                  s = i.UNBOUNDED;
                requestAnimationFrame(function () {
                  t.adapter_.removeClass(n),
                    t.adapter_.removeClass(s),
                    t.removeCssVars_();
                });
              }
              this.deregisterRootHandlers_(),
                this.deregisterDeactivationHandlers_();
            }),
            (e.prototype.activate = function (t) {
              this.activate_(t);
            }),
            (e.prototype.deactivate = function () {
              this.deactivate_();
            }),
            (e.prototype.layout = function () {
              var t = this;
              this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_),
                (this.layoutFrame_ = requestAnimationFrame(function () {
                  t.layoutInternal_(), (t.layoutFrame_ = 0);
                }));
            }),
            (e.prototype.setUnbounded = function (t) {
              var i = e.cssClasses.UNBOUNDED;
              t ? this.adapter_.addClass(i) : this.adapter_.removeClass(i);
            }),
            (e.prototype.handleFocus = function () {
              var t = this;
              requestAnimationFrame(function () {
                return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
              });
            }),
            (e.prototype.handleBlur = function () {
              var t = this;
              requestAnimationFrame(function () {
                return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
              });
            }),
            (e.prototype.supportsPressRipple_ = function () {
              return this.adapter_.browserSupportsCssVars();
            }),
            (e.prototype.defaultActivationState_ = function () {
              return {
                activationEvent: void 0,
                hasDeactivationUXRun: !1,
                isActivated: !1,
                isProgrammatic: !1,
                wasActivatedByPointer: !1,
                wasElementMadeActive: !1,
              };
            }),
            (e.prototype.registerRootHandlers_ = function (t) {
              var e = this;
              t &&
                (fe.forEach(function (t) {
                  e.adapter_.registerInteractionHandler(t, e.activateHandler_);
                }),
                this.adapter_.isUnbounded() &&
                  this.adapter_.registerResizeHandler(this.resizeHandler_)),
                this.adapter_.registerInteractionHandler(
                  "focus",
                  this.focusHandler_
                ),
                this.adapter_.registerInteractionHandler(
                  "blur",
                  this.blurHandler_
                );
            }),
            (e.prototype.registerDeactivationHandlers_ = function (t) {
              var e = this;
              "keydown" === t.type
                ? this.adapter_.registerInteractionHandler(
                    "keyup",
                    this.deactivateHandler_
                  )
                : ge.forEach(function (t) {
                    e.adapter_.registerDocumentInteractionHandler(
                      t,
                      e.deactivateHandler_
                    );
                  });
            }),
            (e.prototype.deregisterRootHandlers_ = function () {
              var t = this;
              fe.forEach(function (e) {
                t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
              }),
                this.adapter_.deregisterInteractionHandler(
                  "focus",
                  this.focusHandler_
                ),
                this.adapter_.deregisterInteractionHandler(
                  "blur",
                  this.blurHandler_
                ),
                this.adapter_.isUnbounded() &&
                  this.adapter_.deregisterResizeHandler(this.resizeHandler_);
            }),
            (e.prototype.deregisterDeactivationHandlers_ = function () {
              var t = this;
              this.adapter_.deregisterInteractionHandler(
                "keyup",
                this.deactivateHandler_
              ),
                ge.forEach(function (e) {
                  t.adapter_.deregisterDocumentInteractionHandler(
                    e,
                    t.deactivateHandler_
                  );
                });
            }),
            (e.prototype.removeCssVars_ = function () {
              var t = this,
                i = e.strings;
              Object.keys(i).forEach(function (e) {
                0 === e.indexOf("VAR_") &&
                  t.adapter_.updateCssVariable(i[e], null);
              });
            }),
            (e.prototype.activate_ = function (t) {
              var e = this;
              if (!this.adapter_.isSurfaceDisabled()) {
                var i = this.activationState_;
                if (!i.isActivated) {
                  var n = this.previousActivationEvent_;
                  if (!(n && void 0 !== t && n.type !== t.type))
                    (i.isActivated = !0),
                      (i.isProgrammatic = void 0 === t),
                      (i.activationEvent = t),
                      (i.wasActivatedByPointer =
                        !i.isProgrammatic &&
                        void 0 !== t &&
                        ("mousedown" === t.type ||
                          "touchstart" === t.type ||
                          "pointerdown" === t.type)),
                      void 0 !== t &&
                      me.length > 0 &&
                      me.some(function (t) {
                        return e.adapter_.containsEventTarget(t);
                      })
                        ? this.resetActivationState_()
                        : (void 0 !== t &&
                            (me.push(t.target),
                            this.registerDeactivationHandlers_(t)),
                          (i.wasElementMadeActive =
                            this.checkElementMadeActive_(t)),
                          i.wasElementMadeActive && this.animateActivation_(),
                          requestAnimationFrame(function () {
                            (me = []),
                              i.wasElementMadeActive ||
                                void 0 === t ||
                                (" " !== t.key && 32 !== t.keyCode) ||
                                ((i.wasElementMadeActive =
                                  e.checkElementMadeActive_(t)),
                                i.wasElementMadeActive &&
                                  e.animateActivation_()),
                              i.wasElementMadeActive ||
                                (e.activationState_ =
                                  e.defaultActivationState_());
                          }));
                }
              }
            }),
            (e.prototype.checkElementMadeActive_ = function (t) {
              return (
                void 0 === t ||
                "keydown" !== t.type ||
                this.adapter_.isSurfaceActive()
              );
            }),
            (e.prototype.animateActivation_ = function () {
              var t = this,
                i = e.strings,
                n = i.VAR_FG_TRANSLATE_START,
                s = i.VAR_FG_TRANSLATE_END,
                o = e.cssClasses,
                r = o.FG_DEACTIVATION,
                a = o.FG_ACTIVATION,
                l = e.numbers.DEACTIVATION_TIMEOUT_MS;
              this.layoutInternal_();
              var c = "",
                h = "";
              if (!this.adapter_.isUnbounded()) {
                var d = this.getFgTranslationCoordinates_(),
                  u = d.startPoint,
                  p = d.endPoint;
                (c = u.x + "px, " + u.y + "px"),
                  (h = p.x + "px, " + p.y + "px");
              }
              this.adapter_.updateCssVariable(n, c),
                this.adapter_.updateCssVariable(s, h),
                clearTimeout(this.activationTimer_),
                clearTimeout(this.fgDeactivationRemovalTimer_),
                this.rmBoundedActivationClasses_(),
                this.adapter_.removeClass(r),
                this.adapter_.computeBoundingRect(),
                this.adapter_.addClass(a),
                (this.activationTimer_ = setTimeout(function () {
                  return t.activationTimerCallback_();
                }, l));
            }),
            (e.prototype.getFgTranslationCoordinates_ = function () {
              var t,
                e = this.activationState_,
                i = e.activationEvent;
              return {
                startPoint: (t = {
                  x:
                    (t = e.wasActivatedByPointer
                      ? (function (t, e, i) {
                          if (!t) return { x: 0, y: 0 };
                          var n,
                            s,
                            o = e.x,
                            r = e.y,
                            a = o + i.left,
                            l = r + i.top;
                          if ("touchstart" === t.type) {
                            var c = t;
                            (n = c.changedTouches[0].pageX - a),
                              (s = c.changedTouches[0].pageY - l);
                          } else {
                            var h = t;
                            (n = h.pageX - a), (s = h.pageY - l);
                          }
                          return { x: n, y: s };
                        })(
                          i,
                          this.adapter_.getWindowPageOffset(),
                          this.adapter_.computeBoundingRect()
                        )
                      : { x: this.frame_.width / 2, y: this.frame_.height / 2 })
                      .x -
                    this.initialSize_ / 2,
                  y: t.y - this.initialSize_ / 2,
                }),
                endPoint: {
                  x: this.frame_.width / 2 - this.initialSize_ / 2,
                  y: this.frame_.height / 2 - this.initialSize_ / 2,
                },
              };
            }),
            (e.prototype.runDeactivationUXLogicIfReady_ = function () {
              var t = this,
                i = e.cssClasses.FG_DEACTIVATION,
                n = this.activationState_,
                s = n.hasDeactivationUXRun,
                o = n.isActivated;
              (s || !o) &&
                this.activationAnimationHasEnded_ &&
                (this.rmBoundedActivationClasses_(),
                this.adapter_.addClass(i),
                (this.fgDeactivationRemovalTimer_ = setTimeout(function () {
                  t.adapter_.removeClass(i);
                }, pe.FG_DEACTIVATION_MS)));
            }),
            (e.prototype.rmBoundedActivationClasses_ = function () {
              var t = e.cssClasses.FG_ACTIVATION;
              this.adapter_.removeClass(t),
                (this.activationAnimationHasEnded_ = !1),
                this.adapter_.computeBoundingRect();
            }),
            (e.prototype.resetActivationState_ = function () {
              var t = this;
              (this.previousActivationEvent_ =
                this.activationState_.activationEvent),
                (this.activationState_ = this.defaultActivationState_()),
                setTimeout(function () {
                  return (t.previousActivationEvent_ = void 0);
                }, e.numbers.TAP_DELAY_MS);
            }),
            (e.prototype.deactivate_ = function () {
              var t = this,
                e = this.activationState_;
              if (e.isActivated) {
                var i = ne({}, e);
                e.isProgrammatic
                  ? (requestAnimationFrame(function () {
                      return t.animateDeactivation_(i);
                    }),
                    this.resetActivationState_())
                  : (this.deregisterDeactivationHandlers_(),
                    requestAnimationFrame(function () {
                      (t.activationState_.hasDeactivationUXRun = !0),
                        t.animateDeactivation_(i),
                        t.resetActivationState_();
                    }));
              }
            }),
            (e.prototype.animateDeactivation_ = function (t) {
              var e = t.wasActivatedByPointer,
                i = t.wasElementMadeActive;
              (e || i) && this.runDeactivationUXLogicIfReady_();
            }),
            (e.prototype.layoutInternal_ = function () {
              var t = this;
              this.frame_ = this.adapter_.computeBoundingRect();
              var i = Math.max(this.frame_.height, this.frame_.width);
              this.maxRadius_ = this.adapter_.isUnbounded()
                ? i
                : Math.sqrt(
                    Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)
                  ) + e.numbers.PADDING;
              var n = Math.floor(i * e.numbers.INITIAL_ORIGIN_SCALE);
              this.adapter_.isUnbounded() && n % 2 != 0
                ? (this.initialSize_ = n - 1)
                : (this.initialSize_ = n),
                (this.fgScale_ = "" + this.maxRadius_ / this.initialSize_),
                this.updateLayoutCssVars_();
            }),
            (e.prototype.updateLayoutCssVars_ = function () {
              var t = e.strings,
                i = t.VAR_FG_SIZE,
                n = t.VAR_LEFT,
                s = t.VAR_TOP,
                o = t.VAR_FG_SCALE;
              this.adapter_.updateCssVariable(i, this.initialSize_ + "px"),
                this.adapter_.updateCssVariable(o, this.fgScale_),
                this.adapter_.isUnbounded() &&
                  ((this.unboundedCoords_ = {
                    left: Math.round(
                      this.frame_.width / 2 - this.initialSize_ / 2
                    ),
                    top: Math.round(
                      this.frame_.height / 2 - this.initialSize_ / 2
                    ),
                  }),
                  this.adapter_.updateCssVariable(
                    n,
                    this.unboundedCoords_.left + "px"
                  ),
                  this.adapter_.updateCssVariable(
                    s,
                    this.unboundedCoords_.top + "px"
                  ));
            }),
            e
          );
        })(re);
      var ye = (function (t) {
        function e() {
          var e = (null !== t && t.apply(this, arguments)) || this;
          return (e.disabled = !1), e;
        }
        return (
          ie(e, t),
          (e.attachTo = function (t, i) {
            void 0 === i && (i = { isUnbounded: void 0 });
            var n = new e(t);
            return void 0 !== i.isUnbounded && (n.unbounded = i.isUnbounded), n;
          }),
          (e.createAdapter = function (t) {
            return {
              addClass: function (e) {
                return t.root_.classList.add(e);
              },
              browserSupportsCssVars: function () {
                return (function (t, e) {
                  void 0 === e && (e = !1);
                  var i,
                    n = t.CSS;
                  if ("boolean" == typeof he && !e) return he;
                  if (!n || "function" != typeof n.supports) return !1;
                  var s = n.supports("--css-vars", "yes"),
                    o =
                      n.supports("(--css-vars: yes)") &&
                      n.supports("color", "#00000000");
                  return (i = s || o), e || (he = i), i;
                })(window);
              },
              computeBoundingRect: function () {
                return t.root_.getBoundingClientRect();
              },
              containsEventTarget: function (e) {
                return t.root_.contains(e);
              },
              deregisterDocumentInteractionHandler: function (t, e) {
                return document.documentElement.removeEventListener(t, e, le());
              },
              deregisterInteractionHandler: function (e, i) {
                return t.root_.removeEventListener(e, i, le());
              },
              deregisterResizeHandler: function (t) {
                return window.removeEventListener("resize", t);
              },
              getWindowPageOffset: function () {
                return { x: window.pageXOffset, y: window.pageYOffset };
              },
              isSurfaceActive: function () {
                return ce(t.root_, ":active");
              },
              isSurfaceDisabled: function () {
                return Boolean(t.disabled);
              },
              isUnbounded: function () {
                return Boolean(t.unbounded);
              },
              registerDocumentInteractionHandler: function (t, e) {
                return document.documentElement.addEventListener(t, e, le());
              },
              registerInteractionHandler: function (e, i) {
                return t.root_.addEventListener(e, i, le());
              },
              registerResizeHandler: function (t) {
                return window.addEventListener("resize", t);
              },
              removeClass: function (e) {
                return t.root_.classList.remove(e);
              },
              updateCssVariable: function (e, i) {
                return t.root_.style.setProperty(e, i);
              },
            };
          }),
          Object.defineProperty(e.prototype, "unbounded", {
            get: function () {
              return Boolean(this.unbounded_);
            },
            set: function (t) {
              (this.unbounded_ = Boolean(t)), this.setUnbounded_();
            },
            enumerable: !0,
            configurable: !0,
          }),
          (e.prototype.activate = function () {
            this.foundation_.activate();
          }),
          (e.prototype.deactivate = function () {
            this.foundation_.deactivate();
          }),
          (e.prototype.layout = function () {
            this.foundation_.layout();
          }),
          (e.prototype.getDefaultFoundation = function () {
            return new ve(e.createAdapter(this));
          }),
          (e.prototype.initialSyncWithDOM = function () {
            var t = this.root_;
            this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
          }),
          (e.prototype.setUnbounded_ = function () {
            this.foundation_.setUnbounded(Boolean(this.unbounded_));
          }),
          e
        );
      })(ae);
      const be = (t) => {
        if ("reduceAnimations" in document.body.dataset) return;
        t.querySelectorAll(
          [
            ".button-primary",
            ".button-secondary",
            ".slideshow-slide__button",
            ".product-form--atc-button",
            ".mobile-nav-content .navmenu-link",
            ".mobile-nav-content .navmenu-button",
            ".mobile-nav-primary-content .navmenu-link",
            ".mobile-nav-primary-content .navmenu-button",
            ".live-search-button",
            ".options-selection__radios .options-selection__option-value-name",
          ].join(",")
        ).forEach((t) => {
          t.classList.contains("disabled") ||
            t.hasAttribute("disabled") ||
            (t.classList.add("mdc-ripple-surface"), ye.attachTo(t));
        });
      };
      class we {
        constructor(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          (this.formData = t),
            (this.settings = {
              moneyFormat: null,
              cartRedirection: !1,
              ...e.settings,
            }),
            (this.atcButton = e.atcButton),
            (this.header = document.querySelector("[data-site-header]")),
            (this.flyOutSelector = "[data-atc-banner]"),
            (this.atcTemplate = document.querySelector(
              `[data-templates] ${this.flyOutSelector}`
            )),
            (this.activeElement = document.activeElement),
            (this.itemId = null),
            (this.flyOut = null),
            (this._onInit = this._onInit.bind(this)),
            (this._onError = this._onError.bind(this)),
            (this._onSuccess = this._onSuccess.bind(this)),
            (this._onCloseAll = this._onCloseAll.bind(this)),
            (this.callbacks = {
              onInit: this._onInit,
              onError: this._onError,
              onSuccess: this._onSuccess,
              onClose: this._onCloseAll,
              ...i,
            }),
            (this._handleDocumentClick = this._handleDocumentClick.bind(this)),
            (this._closeFlyOut = this._closeFlyOut.bind(this)),
            (this._closeEsc = this._closeEsc.bind(this)),
            (this.events = new St.Z()),
            (this.Images = new te()),
            (this.messageBanner = null),
            this.callbacks.onInit(),
            this._disableAtcButton(),
            this._updateCart();
        }
        unload() {
          this.messageBanner && this.messageBanner.unload(),
            this._closeFlyOut();
        }
        _updateCart() {
          const t = this.atcTemplate.cloneNode(!0),
            i = this.formData.filter((t) => "quantity" === t.name)[0].value;
          e()
            .ajax({
              type: "POST",
              url: `${window.Theme.routes.cart_add_url}.js`,
              data: e().param(this.formData),
              dataType: "json",
            })
            .done((n) => {
              if (((this.itemId = n.id), n.image)) {
                const e = this.Images.getSizedImageUrl(n.image, "200x");
                this.Images.loadImage(e);
                t.querySelector(
                  "[data-atc-banner-product-image]"
                ).innerHTML = `<img src="${e}" alt="${n.product_title}">`;
              }
              if (
                ((t.querySelector("[data-atc-banner-product-title]").innerHTML =
                  n.product_title),
                "Title" !== n.variant_options[0] &&
                  "Default Title" !== n.variant_options[0])
              ) {
                t.querySelector("[data-atc-banner-product-options]").innerHTML =
                  n.variant_options.join(", ");
              }
              if (n.selling_plan_allocation) {
                t.querySelector(
                  "[data-atc-banner-product-subscription-title]"
                ).innerHTML = n.selling_plan_allocation.selling_plan.name;
              }
              (t.querySelector(
                "[data-atc-banner-product-price-quantity]"
              ).innerHTML = `${i} × `),
                e()
                  .ajax({
                    type: "GET",
                    url: `${window.Theme.routes.cart_url}.js`,
                    dataType: "json",
                  })
                  .done((e) => {
                    if (this.settings.cartRedirection)
                      return void (location.href =
                        window.Theme.routes.cart_url);
                    this.callbacks.onSuccess(), (this.formData = {});
                    let i = null;
                    e.items.forEach((t) => {
                      t.id === this.itemId &&
                        (i
                          ? ((i.line_level_discount_allocations =
                              i.line_level_discount_allocations.concat(
                                t.line_level_discount_allocations
                              )),
                            (i.final_price =
                              i.final_price > t.final_price
                                ? i.final_price
                                : t.final_price),
                            (i.quantity += t.quantity))
                          : (i = t));
                    });
                    const n = t.querySelector(
                      "[data-atc-banner-product-price-value]"
                    );
                    n.innerHTML = Shopify.formatMoney(
                      i.original_price,
                      this.settings.moneyFormat
                    );
                    const s = t.querySelector(
                      "[data-atc-banner-product-price-discounted]"
                    );
                    i.final_price < i.original_price
                      ? ((s.innerHTML = Shopify.formatMoney(
                          i.final_price,
                          this.settings.moneyFormat
                        )),
                        s.classList.remove("hidden"),
                        n.classList.add("original-price"))
                      : (s.classList.add("hidden"),
                        n.classList.remove("original-price"));
                    const o = t.querySelector(
                        "[data-atc-banner-product-discounts]"
                      ),
                      r = t.querySelector("[data-atc-banner-unit-price]");
                    let a = r.innerHTML;
                    if (
                      (r &&
                        i.unit_price_measurement &&
                        ((a = a.replace(
                          "** total_quantity **",
                          `${i.unit_price_measurement.quantity_value}${i.unit_price_measurement.quantity_unit}`
                        )),
                        (a = a.replace(
                          "** unit_price **",
                          Shopify.formatMoney(
                            i.unit_price,
                            this.settings.money_format
                          )
                        )),
                        (a =
                          1 === i.unit_price_measurement.reference_value
                            ? a.replace(
                                "** unit_measure **",
                                i.unit_price_measurement.reference_unit
                              )
                            : a.replace(
                                "** unit_measure **",
                                `${i.unit_price_measurement.reference_value}${i.unit_price_measurement.reference_unit}`
                              )),
                        (r.innerHTML = a),
                        r.classList.remove("hidden")),
                      i.line_level_discount_allocations.length > 0)
                    ) {
                      const t = o.firstElementChild.cloneNode(!0);
                      (o.innerHTML = ""),
                        i.line_level_discount_allocations.forEach((e) => {
                          const i = t.cloneNode(!0),
                            n = i.querySelector(".discount-title"),
                            s = i.querySelector(".discount-amount");
                          (n.innerHTML = e.discount_application.title),
                            (s.innerHTML = Shopify.formatMoney(
                              e.amount,
                              this.settings.moneyFormat
                            )),
                            o.appendChild(i);
                        }),
                        o.classList.remove("hidden");
                    } else o.classList.add("hidden");
                    t.querySelector(
                      "[data-atc-banner-cart-subtotal]"
                    ).innerHTML = Shopify.formatMoney(
                      e.total_price,
                      this.settings.moneyFormat
                    );
                    (t.querySelector(
                      "[data-atc-banner-cart-button] span"
                    ).innerHTML = e.item_count),
                      this.header.appendChild(t),
                      (this.flyOut = t),
                      be(this.flyOut);
                    const l = new CustomEvent("cartcount:update", {
                      detail: e,
                    });
                    window.dispatchEvent(l),
                      document.dispatchEvent(new Event("closeFlyouts"));
                    const c = t.querySelector("[data-atc-banner-close]");
                    this.events.register(c, "click", (t) =>
                      this._closeFlyOut(t)
                    ),
                      this.events.register(document, "click", (t) =>
                        this._handleDocumentClick(t)
                      ),
                      this.events.register(document, "touchstart", (t) =>
                        this._handleDocumentClick(t)
                      ),
                      this.events.register(document, "closeFlyouts", (t) =>
                        this._closeFlyOut(t)
                      ),
                      this.events.register(window, "keydown", (t) =>
                        this._closeEsc(t)
                      ),
                      this._enableAtcButton(),
                      (this.atcAnimation = yt({
                        el: this.flyOut,
                        state: "closed",
                      })),
                      this.atcAnimation.animateTo("open").then(() => {
                        $t(this.flyOut);
                      });
                  });
            })
            .fail((t) => {
              let e;
              try {
                e = JSON.parse(t.responseText).description;
              } catch (i) {
                (e = `${t.status} ${t.statusText}`),
                  401 === t.status &&
                    (e = `${e}. Try refreshing and logging in.`);
              }
              this._enableAtcButton(), this.callbacks.onError(e);
            });
        }
        _onError(t) {
          this.messageBanner = new Jt(t, "error");
        }
        _onInit() {
          this.messageBanner && this.messageBanner.unload();
        }
        _onSuccess() {}
        _onCloseAll() {}
        _closeEsc(t) {
          "Escape" === t.key && this._closeFlyOut(t);
        }
        _closeFlyOut() {
          this.flyOut &&
            (Mt(this.flyOut),
            this.documentClickEventTarget &&
            "liveSearchInput" in this.documentClickEventTarget.dataset
              ? this.documentClickEventTarget.focus()
              : this.activeElement && this.activeElement.focus(),
            this.atcAnimation.animateTo("closed").then(() => {
              this.callbacks.onClose(),
                this.flyOut.remove(),
                (this.flyOut = null),
                this.events.unregisterAll(),
                this.atcAnimation.unload(),
                delete this.Images;
            }));
        }
        _disableAtcButton() {
          this.atcButton.classList.add("processing"),
            this.atcButton.setAttribute("disabled", "disabled");
        }
        _enableAtcButton() {
          this.atcButton.removeAttribute("disabled"),
            this.atcButton.classList.remove("processing");
        }
        _handleDocumentClick(t) {
          const { target: i } = t;
          e()(i).parents("[data-atc-banner]").length ||
            ((this.documentClickEventTarget = i), this._closeFlyOut(t));
        }
      }
      function _e(t) {
        return (
          (_e =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                }),
          _e(t)
        );
      }
      var Se =
        "object" ===
        ("undefined" == typeof HTMLElement ? "undefined" : _e(HTMLElement));
      function Ce(t) {
        return Se
          ? t instanceof HTMLElement
          : t &&
              "object" === _e(t) &&
              null !== t &&
              1 === t.nodeType &&
              "string" == typeof t.nodeName;
      }
      function xe(t, e) {
        e.forEach(function (e) {
          t.classList.add(e);
        });
      }
      function ke(t, e) {
        e.forEach(function (e) {
          t.classList.remove(e);
        });
      }
      function Ee() {
        if (!document.querySelector(".drift-base-styles")) {
          var t = document.createElement("style");
          (t.type = "text/css"),
            t.classList.add("drift-base-styles"),
            t.appendChild(
              document.createTextNode(
                ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}"
              )
            );
          var e = document.head;
          e.insertBefore(t, e.firstChild);
        }
      }
      function Te() {
        throw new Error("Missing parameter");
      }
      function Ae(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Le = (function () {
        function t(e) {
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
            (this.isShowing = !1);
          var i = e.namespace,
            n = void 0 === i ? null : i,
            s = e.zoomFactor,
            o = void 0 === s ? Te() : s,
            r = e.containerEl,
            a = void 0 === r ? Te() : r;
          (this.settings = { namespace: n, zoomFactor: o, containerEl: a }),
            (this.openClasses = this._buildClasses("open")),
            this._buildElement();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_buildClasses",
              value: function (t) {
                var e = ["drift-".concat(t)],
                  i = this.settings.namespace;
                return i && e.push("".concat(i, "-").concat(t)), e;
              },
            },
            {
              key: "_buildElement",
              value: function () {
                (this.el = document.createElement("div")),
                  xe(this.el, this._buildClasses("bounding-box"));
              },
            },
            {
              key: "show",
              value: function (t, e) {
                (this.isShowing = !0),
                  this.settings.containerEl.appendChild(this.el);
                var i = this.el.style;
                (i.width = "".concat(
                  Math.round(t / this.settings.zoomFactor),
                  "px"
                )),
                  (i.height = "".concat(
                    Math.round(e / this.settings.zoomFactor),
                    "px"
                  )),
                  xe(this.el, this.openClasses);
              },
            },
            {
              key: "hide",
              value: function () {
                this.isShowing &&
                  this.settings.containerEl.removeChild(this.el),
                  (this.isShowing = !1),
                  ke(this.el, this.openClasses);
              },
            },
            {
              key: "setPosition",
              value: function (t, e, i) {
                var n = window.pageXOffset,
                  s = window.pageYOffset,
                  o = i.left + t * i.width - this.el.clientWidth / 2 + n,
                  r = i.top + e * i.height - this.el.clientHeight / 2 + s;
                o < i.left + n
                  ? (o = i.left + n)
                  : o + this.el.clientWidth > i.left + i.width + n &&
                    (o = i.left + i.width - this.el.clientWidth + n),
                  r < i.top + s
                    ? (r = i.top + s)
                    : r + this.el.clientHeight > i.top + i.height + s &&
                      (r = i.top + i.height - this.el.clientHeight + s),
                  (this.el.style.left = "".concat(o, "px")),
                  (this.el.style.top = "".concat(r, "px"));
              },
            },
          ]),
          i && Ae(e.prototype, i),
          n && Ae(e, n),
          t
        );
      })();
      function Ie(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function De(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Pe = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          Ie(this, t),
            (this._show = this._show.bind(this)),
            (this._hide = this._hide.bind(this)),
            (this._handleEntry = this._handleEntry.bind(this)),
            (this._handleMovement = this._handleMovement.bind(this));
          var i = e.el,
            n = void 0 === i ? Te() : i,
            s = e.zoomPane,
            o = void 0 === s ? Te() : s,
            r = e.sourceAttribute,
            a = void 0 === r ? Te() : r,
            l = e.handleTouch,
            c = void 0 === l ? Te() : l,
            h = e.onShow,
            d = void 0 === h ? null : h,
            u = e.onHide,
            p = void 0 === u ? null : u,
            f = e.hoverDelay,
            g = void 0 === f ? 0 : f,
            m = e.touchDelay,
            v = void 0 === m ? 0 : m,
            y = e.hoverBoundingBox,
            b = void 0 === y ? Te() : y,
            w = e.touchBoundingBox,
            _ = void 0 === w ? Te() : w,
            S = e.namespace,
            C = void 0 === S ? null : S,
            x = e.zoomFactor,
            k = void 0 === x ? Te() : x,
            E = e.boundingBoxContainer,
            T = void 0 === E ? Te() : E;
          (this.settings = {
            el: n,
            zoomPane: o,
            sourceAttribute: a,
            handleTouch: c,
            onShow: d,
            onHide: p,
            hoverDelay: g,
            touchDelay: v,
            hoverBoundingBox: b,
            touchBoundingBox: _,
            namespace: C,
            zoomFactor: k,
            boundingBoxContainer: T,
          }),
            (this.settings.hoverBoundingBox ||
              this.settings.touchBoundingBox) &&
              (this.boundingBox = new Le({
                namespace: this.settings.namespace,
                zoomFactor: this.settings.zoomFactor,
                containerEl: this.settings.boundingBoxContainer,
              })),
            (this.enabled = !0),
            this._bindEvents();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_preventDefault",
              value: function (t) {
                t.preventDefault();
              },
            },
            {
              key: "_preventDefaultAllowTouchScroll",
              value: function (t) {
                (this.settings.touchDelay &&
                  this._isTouchEvent(t) &&
                  !this.isShowing) ||
                  t.preventDefault();
              },
            },
            {
              key: "_isTouchEvent",
              value: function (t) {
                return !!t.touches;
              },
            },
            {
              key: "_bindEvents",
              value: function () {
                this.settings.el.addEventListener(
                  "mouseenter",
                  this._handleEntry,
                  !1
                ),
                  this.settings.el.addEventListener(
                    "mouseleave",
                    this._hide,
                    !1
                  ),
                  this.settings.el.addEventListener(
                    "mousemove",
                    this._handleMovement,
                    !1
                  ),
                  this.settings.handleTouch
                    ? (this.settings.el.addEventListener(
                        "touchstart",
                        this._handleEntry,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchend",
                        this._hide,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchmove",
                        this._handleMovement,
                        !1
                      ))
                    : (this.settings.el.addEventListener(
                        "touchstart",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchend",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchmove",
                        this._preventDefault,
                        !1
                      ));
              },
            },
            {
              key: "_unbindEvents",
              value: function () {
                this.settings.el.removeEventListener(
                  "mouseenter",
                  this._handleEntry,
                  !1
                ),
                  this.settings.el.removeEventListener(
                    "mouseleave",
                    this._hide,
                    !1
                  ),
                  this.settings.el.removeEventListener(
                    "mousemove",
                    this._handleMovement,
                    !1
                  ),
                  this.settings.handleTouch
                    ? (this.settings.el.removeEventListener(
                        "touchstart",
                        this._handleEntry,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchend",
                        this._hide,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchmove",
                        this._handleMovement,
                        !1
                      ))
                    : (this.settings.el.removeEventListener(
                        "touchstart",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchend",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchmove",
                        this._preventDefault,
                        !1
                      ));
              },
            },
            {
              key: "_handleEntry",
              value: function (t) {
                this._preventDefaultAllowTouchScroll(t),
                  (this._lastMovement = t),
                  "mouseenter" == t.type && this.settings.hoverDelay
                    ? (this.entryTimeout = setTimeout(
                        this._show,
                        this.settings.hoverDelay
                      ))
                    : this.settings.touchDelay
                    ? (this.entryTimeout = setTimeout(
                        this._show,
                        this.settings.touchDelay
                      ))
                    : this._show();
              },
            },
            {
              key: "_show",
              value: function () {
                if (this.enabled) {
                  var t = this.settings.onShow;
                  if (
                    (t && "function" == typeof t && t(),
                    this.settings.zoomPane.show(
                      this.settings.el.getAttribute(
                        this.settings.sourceAttribute
                      ),
                      this.settings.el.clientWidth,
                      this.settings.el.clientHeight
                    ),
                    this._lastMovement)
                  ) {
                    var e = this._lastMovement.touches;
                    ((e && this.settings.touchBoundingBox) ||
                      (!e && this.settings.hoverBoundingBox)) &&
                      this.boundingBox.show(
                        this.settings.zoomPane.el.clientWidth,
                        this.settings.zoomPane.el.clientHeight
                      );
                  }
                  this._handleMovement();
                }
              },
            },
            {
              key: "_hide",
              value: function (t) {
                t && this._preventDefaultAllowTouchScroll(t),
                  (this._lastMovement = null),
                  this.entryTimeout && clearTimeout(this.entryTimeout),
                  this.boundingBox && this.boundingBox.hide();
                var e = this.settings.onHide;
                e && "function" == typeof e && e(),
                  this.settings.zoomPane.hide();
              },
            },
            {
              key: "_handleMovement",
              value: function (t) {
                if (t)
                  this._preventDefaultAllowTouchScroll(t),
                    (this._lastMovement = t);
                else {
                  if (!this._lastMovement) return;
                  t = this._lastMovement;
                }
                var e, i;
                if (t.touches) {
                  var n = t.touches[0];
                  (e = n.clientX), (i = n.clientY);
                } else (e = t.clientX), (i = t.clientY);
                var s = this.settings.el.getBoundingClientRect(),
                  o = e - s.left,
                  r = i - s.top,
                  a = o / this.settings.el.clientWidth,
                  l = r / this.settings.el.clientHeight;
                this.boundingBox && this.boundingBox.setPosition(a, l, s),
                  this.settings.zoomPane.setPosition(a, l, s);
              },
            },
            {
              key: "isShowing",
              get: function () {
                return this.settings.zoomPane.isShowing;
              },
            },
          ]) && De(e.prototype, i),
          n && De(e, n),
          t
        );
      })();
      function $e(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function Me(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Oe = document.createElement("div").style,
        qe =
          "undefined" != typeof document &&
          ("animation" in Oe || "webkitAnimation" in Oe),
        Fe = (function () {
          function t() {
            var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {};
            $e(this, t),
              (this._completeShow = this._completeShow.bind(this)),
              (this._completeHide = this._completeHide.bind(this)),
              (this._handleLoad = this._handleLoad.bind(this)),
              (this.isShowing = !1);
            var i = e.container,
              n = void 0 === i ? null : i,
              s = e.zoomFactor,
              o = void 0 === s ? Te() : s,
              r = e.inline,
              a = void 0 === r ? Te() : r,
              l = e.namespace,
              c = void 0 === l ? null : l,
              h = e.showWhitespaceAtEdges,
              d = void 0 === h ? Te() : h,
              u = e.containInline,
              p = void 0 === u ? Te() : u,
              f = e.inlineOffsetX,
              g = void 0 === f ? 0 : f,
              m = e.inlineOffsetY,
              v = void 0 === m ? 0 : m,
              y = e.inlineContainer,
              b = void 0 === y ? document.body : y;
            (this.settings = {
              container: n,
              zoomFactor: o,
              inline: a,
              namespace: c,
              showWhitespaceAtEdges: d,
              containInline: p,
              inlineOffsetX: g,
              inlineOffsetY: v,
              inlineContainer: b,
            }),
              (this.openClasses = this._buildClasses("open")),
              (this.openingClasses = this._buildClasses("opening")),
              (this.closingClasses = this._buildClasses("closing")),
              (this.inlineClasses = this._buildClasses("inline")),
              (this.loadingClasses = this._buildClasses("loading")),
              this._buildElement();
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "_buildClasses",
                value: function (t) {
                  var e = ["drift-".concat(t)],
                    i = this.settings.namespace;
                  return i && e.push("".concat(i, "-").concat(t)), e;
                },
              },
              {
                key: "_buildElement",
                value: function () {
                  (this.el = document.createElement("div")),
                    xe(this.el, this._buildClasses("zoom-pane"));
                  var t = document.createElement("div");
                  xe(t, this._buildClasses("zoom-pane-loader")),
                    this.el.appendChild(t),
                    (this.imgEl = document.createElement("img")),
                    this.el.appendChild(this.imgEl);
                },
              },
              {
                key: "_setImageURL",
                value: function (t) {
                  this.imgEl.setAttribute("src", t);
                },
              },
              {
                key: "_setImageSize",
                value: function (t, e) {
                  (this.imgEl.style.width = "".concat(
                    t * this.settings.zoomFactor,
                    "px"
                  )),
                    (this.imgEl.style.height = "".concat(
                      e * this.settings.zoomFactor,
                      "px"
                    ));
                },
              },
              {
                key: "setPosition",
                value: function (t, e, i) {
                  var n = this.imgEl.offsetWidth,
                    s = this.imgEl.offsetHeight,
                    o = this.el.offsetWidth,
                    r = this.el.offsetHeight,
                    a = o / 2 - n * t,
                    l = r / 2 - s * e,
                    c = o - n,
                    h = r - s,
                    d = c > 0,
                    u = h > 0,
                    p = d ? c / 2 : 0,
                    f = u ? h / 2 : 0,
                    g = d ? c / 2 : c,
                    m = u ? h / 2 : h;
                  if (this.el.parentElement === this.settings.inlineContainer) {
                    var v = window.pageXOffset,
                      y = window.pageYOffset,
                      b =
                        i.left +
                        t * i.width -
                        o / 2 +
                        this.settings.inlineOffsetX +
                        v,
                      w =
                        i.top +
                        e * i.height -
                        r / 2 +
                        this.settings.inlineOffsetY +
                        y;
                    this.settings.containInline &&
                      (b < i.left + v
                        ? (b = i.left + v)
                        : b + o > i.left + i.width + v &&
                          (b = i.left + i.width - o + v),
                      w < i.top + y
                        ? (w = i.top + y)
                        : w + r > i.top + i.height + y &&
                          (w = i.top + i.height - r + y)),
                      (this.el.style.left = "".concat(b, "px")),
                      (this.el.style.top = "".concat(w, "px"));
                  }
                  this.settings.showWhitespaceAtEdges ||
                    (a > p ? (a = p) : a < g && (a = g),
                    l > f ? (l = f) : l < m && (l = m)),
                    (this.imgEl.style.transform = "translate("
                      .concat(a, "px, ")
                      .concat(l, "px)")),
                    (this.imgEl.style.webkitTransform = "translate("
                      .concat(a, "px, ")
                      .concat(l, "px)"));
                },
              },
              {
                key: "_removeListenersAndResetClasses",
                value: function () {
                  this.el.removeEventListener(
                    "animationend",
                    this._completeShow,
                    !1
                  ),
                    this.el.removeEventListener(
                      "animationend",
                      this._completeHide,
                      !1
                    ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeShow,
                      !1
                    ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeHide,
                      !1
                    ),
                    ke(this.el, this.openClasses),
                    ke(this.el, this.closingClasses);
                },
              },
              {
                key: "show",
                value: function (t, e, i) {
                  this._removeListenersAndResetClasses(),
                    (this.isShowing = !0),
                    xe(this.el, this.openClasses),
                    this.imgEl.getAttribute("src") != t &&
                      (xe(this.el, this.loadingClasses),
                      this.imgEl.addEventListener("load", this._handleLoad, !1),
                      this._setImageURL(t)),
                    this._setImageSize(e, i),
                    this._isInline
                      ? this._showInline()
                      : this._showInContainer(),
                    qe &&
                      (this.el.addEventListener(
                        "animationend",
                        this._completeShow,
                        !1
                      ),
                      this.el.addEventListener(
                        "webkitAnimationEnd",
                        this._completeShow,
                        !1
                      ),
                      xe(this.el, this.openingClasses));
                },
              },
              {
                key: "_showInline",
                value: function () {
                  this.settings.inlineContainer.appendChild(this.el),
                    xe(this.el, this.inlineClasses);
                },
              },
              {
                key: "_showInContainer",
                value: function () {
                  this.settings.container.appendChild(this.el);
                },
              },
              {
                key: "hide",
                value: function () {
                  this._removeListenersAndResetClasses(),
                    (this.isShowing = !1),
                    qe
                      ? (this.el.addEventListener(
                          "animationend",
                          this._completeHide,
                          !1
                        ),
                        this.el.addEventListener(
                          "webkitAnimationEnd",
                          this._completeHide,
                          !1
                        ),
                        xe(this.el, this.closingClasses))
                      : (ke(this.el, this.openClasses),
                        ke(this.el, this.inlineClasses));
                },
              },
              {
                key: "_completeShow",
                value: function () {
                  this.el.removeEventListener(
                    "animationend",
                    this._completeShow,
                    !1
                  ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeShow,
                      !1
                    ),
                    ke(this.el, this.openingClasses);
                },
              },
              {
                key: "_completeHide",
                value: function () {
                  this.el.removeEventListener(
                    "animationend",
                    this._completeHide,
                    !1
                  ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeHide,
                      !1
                    ),
                    ke(this.el, this.openClasses),
                    ke(this.el, this.closingClasses),
                    ke(this.el, this.inlineClasses),
                    this.el.setAttribute("style", ""),
                    this.el.parentElement === this.settings.container
                      ? this.settings.container.removeChild(this.el)
                      : this.el.parentElement ===
                          this.settings.inlineContainer &&
                        this.settings.inlineContainer.removeChild(this.el);
                },
              },
              {
                key: "_handleLoad",
                value: function () {
                  this.imgEl.removeEventListener("load", this._handleLoad, !1),
                    ke(this.el, this.loadingClasses);
                },
              },
              {
                key: "_isInline",
                get: function () {
                  var t = this.settings.inline;
                  return (
                    !0 === t || ("number" == typeof t && window.innerWidth <= t)
                  );
                },
              },
            ]),
            i && Me(e.prototype, i),
            n && Me(e, n),
            t
          );
        })();
      function Be(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function Ne(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Re = (function () {
        function t(e) {
          var i =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (
            (Be(this, t),
            (this.VERSION = "1.4.1"),
            (this.triggerEl = e),
            (this.destroy = this.destroy.bind(this)),
            !Ce(this.triggerEl))
          )
            throw new TypeError(
              "`new Drift` requires a DOM element as its first argument."
            );
          var n = i.namespace || null,
            s = i.showWhitespaceAtEdges || !1,
            o = i.containInline || !1,
            r = i.inlineOffsetX || 0,
            a = i.inlineOffsetY || 0,
            l = i.inlineContainer || document.body,
            c = i.sourceAttribute || "data-zoom",
            h = i.zoomFactor || 3,
            d = void 0 === i.paneContainer ? document.body : i.paneContainer,
            u = i.inlinePane || 375,
            p = !("handleTouch" in i) || !!i.handleTouch,
            f = i.onShow || null,
            g = i.onHide || null,
            m = !("injectBaseStyles" in i) || !!i.injectBaseStyles,
            v = i.hoverDelay || 0,
            y = i.touchDelay || 0,
            b = i.hoverBoundingBox || !1,
            w = i.touchBoundingBox || !1,
            _ = i.boundingBoxContainer || document.body;
          if (!0 !== u && !Ce(d))
            throw new TypeError(
              "`paneContainer` must be a DOM element when `inlinePane !== true`"
            );
          if (!Ce(l))
            throw new TypeError("`inlineContainer` must be a DOM element");
          (this.settings = {
            namespace: n,
            showWhitespaceAtEdges: s,
            containInline: o,
            inlineOffsetX: r,
            inlineOffsetY: a,
            inlineContainer: l,
            sourceAttribute: c,
            zoomFactor: h,
            paneContainer: d,
            inlinePane: u,
            handleTouch: p,
            onShow: f,
            onHide: g,
            injectBaseStyles: m,
            hoverDelay: v,
            touchDelay: y,
            hoverBoundingBox: b,
            touchBoundingBox: w,
            boundingBoxContainer: _,
          }),
            this.settings.injectBaseStyles && Ee(),
            this._buildZoomPane(),
            this._buildTrigger();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_buildZoomPane",
              value: function () {
                this.zoomPane = new Fe({
                  container: this.settings.paneContainer,
                  zoomFactor: this.settings.zoomFactor,
                  showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                  containInline: this.settings.containInline,
                  inline: this.settings.inlinePane,
                  namespace: this.settings.namespace,
                  inlineOffsetX: this.settings.inlineOffsetX,
                  inlineOffsetY: this.settings.inlineOffsetY,
                  inlineContainer: this.settings.inlineContainer,
                });
              },
            },
            {
              key: "_buildTrigger",
              value: function () {
                this.trigger = new Pe({
                  el: this.triggerEl,
                  zoomPane: this.zoomPane,
                  handleTouch: this.settings.handleTouch,
                  onShow: this.settings.onShow,
                  onHide: this.settings.onHide,
                  sourceAttribute: this.settings.sourceAttribute,
                  hoverDelay: this.settings.hoverDelay,
                  touchDelay: this.settings.touchDelay,
                  hoverBoundingBox: this.settings.hoverBoundingBox,
                  touchBoundingBox: this.settings.touchBoundingBox,
                  namespace: this.settings.namespace,
                  zoomFactor: this.settings.zoomFactor,
                  boundingBoxContainer: this.settings.boundingBoxContainer,
                });
              },
            },
            {
              key: "setZoomImageURL",
              value: function (t) {
                this.zoomPane._setImageURL(t);
              },
            },
            {
              key: "disable",
              value: function () {
                this.trigger.enabled = !1;
              },
            },
            {
              key: "enable",
              value: function () {
                this.trigger.enabled = !0;
              },
            },
            {
              key: "destroy",
              value: function () {
                this.trigger._hide(), this.trigger._unbindEvents();
              },
            },
            {
              key: "isShowing",
              get: function () {
                return this.zoomPane.isShowing;
              },
            },
            {
              key: "zoomFactor",
              get: function () {
                return this.settings.zoomFactor;
              },
              set: function (t) {
                (this.settings.zoomFactor = t),
                  (this.zoomPane.settings.zoomFactor = t),
                  (this.trigger.settings.zoomFactor = t),
                  (this.boundingBox.settings.zoomFactor = t);
              },
            },
          ]) && Ne(e.prototype, i),
          n && Ne(e, n),
          t
        );
      })();
      Object.defineProperty(Re.prototype, "isShowing", {
        get: function () {
          return this.isShowing;
        },
      }),
        Object.defineProperty(Re.prototype, "zoomFactor", {
          get: function () {
            return this.zoomFactor;
          },
          set: function (t) {
            this.zoomFactor = t;
          },
        }),
        (Re.prototype.setZoomImageURL = Re.prototype.setZoomImageURL),
        (Re.prototype.disable = Re.prototype.disable),
        (Re.prototype.enable = Re.prototype.enable),
        (Re.prototype.destroy = Re.prototype.destroy);
      let He = [],
        ze = !1;
      window.onYouTubeIframeAPIReady = () => {
        He.forEach((t) => t()), (He = []), (ze = !0);
      };
      class je {
        constructor(t) {
          let { el: e, videoUrl: i, loop: n } = t;
          (this.el = e),
            (this.id =
              i.match(
                /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i
              )[1] || null),
            (this.onApiLoaded = this._onApiLoaded.bind(this)),
            (this.isReady = !1),
            (this.onReady = this._onReady.bind(this)),
            (this.onReadyCallback = null),
            (this.loop = n ? 1 : 0),
            (this.onStateChange = this._onStateChange.bind(this)),
            (this.onPlayCallback = null),
            ze
              ? this._onApiLoaded()
              : (He.push(this.onApiLoaded),
                s()("https://www.youtube.com/iframe_api"));
        }
        play() {
          return new Promise((t) => {
            (this.onPlayCallback = t),
              this.isReady
                ? this.player.playVideo()
                : (this.onReadyCallback = () => {
                    this.player.playVideo();
                  });
          });
        }
        pause() {
          return new Promise((t) => {
            (this.onPlayCallback = t),
              this.isReady
                ? this.player.pauseVideo()
                : (this.onReadyCallback = () => {
                    this.player.pauseVideo();
                  });
          });
        }
        autoplay() {
          return new Promise((t) => {
            (this.onPlayCallback = t),
              this.isReady
                ? (this.player.playVideo(), this.player.mute())
                : (this.onReadyCallback = () => {
                    this.player.playVideo(), this.player.mute();
                  });
          });
        }
        unload() {
          this.player.destroy();
        }
        _onApiLoaded() {
          const t = {
            modestbranding: !0,
            showinfo: !1,
            controls: !1,
            loop: this.loop,
            rel: 0,
          };
          this.loop && (t.playlist = this.id),
            (this.player = new YT.Player(this.el, {
              videoId: this.id,
              playerVars: t,
              events: {
                onReady: this.onReady,
                onStateChange: this.onStateChange,
              },
            }));
        }
        _onReady() {
          (this.isReady = !0), this.onReadyCallback && this.onReadyCallback();
        }
        _onStateChange(t) {
          const e = t.data;
          this.onPlayCallback &&
            e === YT.PlayerState.BUFFERING &&
            (this.onPlayCallback(), (this.onPlayCallback = null));
        }
      }
      let Ue = !1;
      class We {
        constructor(t) {
          let { el: e, videoUrl: i } = t;
          this.el = e;
          const n = i.split("/");
          (this.id = n[n.length - 1]),
            (this.onReadyCallback = null),
            (this.onApiLoaded = this._onApiLoaded.bind(this)),
            (this.onProgress = this._onProgress.bind(this)),
            (this.onProgressCallback = null),
            Ue
              ? this._onApiLoaded()
              : s()("https://player.vimeo.com/api/player.js", this.onApiLoaded);
        }
        play() {
          return new Promise((t) => {
            (this.onProgressCallback = t),
              Ue
                ? (this.player.on("play", this.onProgress), this.player.play())
                : (this.onReadyCallback = () => {
                    this.player.on("play", this.onProgress), this.player.play();
                  });
          });
        }
        pause() {
          return new Promise((t) => {
            (this.onProgressCallback = t),
              Ue
                ? (this.player.on("pause", this.onProgress),
                  this.player.pause())
                : (this.onReadyCallback = () => {
                    this.player.on("pause", this.onProgress),
                      this.player.pause();
                  });
          });
        }
        autoplay() {
          return new Promise((t) => {
            (this.onProgressCallback = t),
              Ue
                ? (this.player.on("play", this.onProgress),
                  this.player.setVolume(0),
                  this.player.play())
                : (this.onReadyCallback = () => {
                    this.player.on("play", this.onProgress),
                      this.player.setVolume(0),
                      this.player.play();
                  });
          });
        }
        unload() {
          this.player.unload().catch();
        }
        _onApiLoaded() {
          (this.player = new window.Vimeo.Player(this.el, { id: this.id })),
            this.player.ready().then().catch(),
            (Ue = !0),
            this.onReadyCallback && this.onReadyCallback();
        }
        _onProgress() {
          this.player.off("play", this.onProgress),
            this.player.off("pause", this.onProgress),
            this.onProgressCallback &&
              (this.onProgressCallback(), (this.onProgressCallback = null));
        }
      }
      class Ve {
        constructor(t, e) {
          switch (
            ((this.el = t),
            (this.options = e),
            (this.platform = t.getAttribute("data-video").trim()),
            (this.playButton = t.querySelector("[data-video-play-button]")),
            (this.videoEl = t.querySelector("[data-video-element]")),
            (this.onPlayClick = this._onPlayClick.bind(this)),
            (this.onPauseClick = this._onPauseClick.bind(this)),
            (this.autoplay = this._autoplay.bind(this)),
            (this.video = null),
            (this.videoData = {
              el: this.videoEl.childNodes[0],
              videoUrl: this.videoEl.getAttribute("data-video-url"),
              loop: this.options && this.options.loop,
            }),
            this.platform)
          ) {
            case "youtube":
              this.video = new je(this.videoData);
              break;
            case "vimeo":
              this.video = new We(this.videoData);
              break;
            default:
              this.video = null;
              break;
          }
          this.el.addEventListener("click", this.onPlayClick),
            this.playButton &&
              (this.options && this.options.autoplay && this.autoplay(),
              this.playButton.addEventListener("click", this.onPlayClick));
        }
        _onPlayClick() {
          this.el.classList.add("video-loading"),
            this.video.play().then(() => {
              this.el.classList.add("video-transitioning"),
                setTimeout(() => {
                  this.el.classList.remove("video-loading"),
                    this.el.classList.remove("video-transitioning"),
                    this.el.classList.add("video-playing");
                }, 200);
            });
        }
        _onPauseClick() {
          this.video.pause();
        }
        _autoplay() {
          this.el.classList.add("video-loading"),
            this.video.autoplay().then(() => {
              this.el.classList.add("video-transitioning"),
                setTimeout(() => {
                  this.el.classList.remove("video-loading"),
                    this.el.classList.remove("video-transitioning"),
                    this.el.classList.add("video-playing");
                }, 200);
            });
        }
        play() {
          this._onPlayClick();
        }
        pause() {
          this._onPauseClick();
        }
        unload() {
          this.el.removeEventListener("click", this.onPlayClick),
            this.playButton &&
              this.playButton.removeEventListener("click", this.onPlayClick),
            this.video && this.video.unload();
        }
        destroy() {
          this.unload();
        }
      }
      var Ge = i(832),
        Xe = i.n(Ge),
        Ze = i(411),
        Qe = i.n(Ze);
      class Ke {
        constructor(t) {
          let {
            settings: e,
            slides: i,
            originalThumbnails: n,
            startIndex: s,
            selectGalleryIndex: o,
          } = t;
          (this.settings = e),
            (this.photoswipeDialog =
              document.querySelector("[data-photoswipe]")),
            (this.thumbContainer = this.photoswipeDialog.querySelector(
              "[data-photoswipe-thumbs]"
            )),
            (this.thumbScroller = this.photoswipeDialog.querySelector(
              "[data-photoswipe-thumb-scroller]"
            )),
            (this.thumbScrollerButtons = this.photoswipeDialog.querySelectorAll(
              "[data-gallery-scroll-button]"
            )),
            (this.closeButton = this.photoswipeDialog.querySelector(
              ".pswp__button--close"
            )),
            (this.selectedSlide = i[s]),
            (this.thumbScroller.innerHTML = ""),
            (this.thumbnails = []);
          let r = s;
          n.forEach((t, e) => {
            if ("image" !== t.dataset.mediaType) return void (s > e && r--);
            const i = t.cloneNode(!0);
            this.thumbScroller.appendChild(i), this.thumbnails.push(i);
          }),
            x.watch(this.thumbContainer),
            (this.selectedThumb = this.thumbContainer.querySelector(
              '[data-gallery-selected="true"]'
            )),
            (this.events = new St.Z());
          const a = [];
          i.forEach((t) => {
            ["video", "external_video", "model"].indexOf(t.dataset.mediaType) >
              -1 ||
              a.push({
                src: t.dataset.zoom,
                msrc: t.dataset.zoom,
                h: t.dataset.imageHeight,
                w: t.dataset.imageWidth,
              });
          });
          const l = Tt.isGreaterThanBreakpoint("L", !0) ? 0 : 75,
            c = {
              index: r,
              barsSize: { top: 0, bottom: l },
              fullscreenEl: !1,
              zoomEl: !1,
              shareEl: !1,
              counterEl: !1,
              arrowEl: !1,
              preloaderEl: !1,
              closeOnScroll: !1,
              showHideOpacity: !0,
              history: !1,
              loop: !0,
              clickToCloseNonZoomable: !1,
              timeToIdle: !1,
              timeToIdleOutside: !1,
            };
          ("always" === this.settings.gallery_click_to_zoom ||
            (Tt.isGreaterThanBreakpoint("S", !0) &&
              "desktop" === this.settings.gallery_click_to_zoom) ||
            (Tt.isLessThanBreakpoint("S") &&
              "mobile" === this.settings.gallery_click_to_zoom)) &&
            (c.getThumbBoundsFn = () => {
              const t =
                  window.pageYOffset || document.documentElement.scrollTop,
                e = this.selectedSlide
                  .querySelector("[data-rimg]")
                  .getBoundingClientRect();
              return { x: e.left, y: e.top + t, w: e.width };
            }),
            (this.photoswipe = new (Xe())(this.photoswipeDialog, Qe(), a, c)),
            this.events.register(this.closeButton, "click", () =>
              this.photoswipe.close()
            ),
            this.events.register(this.closeButton, "touchstart", () =>
              this.photoswipe.close()
            ),
            this.thumbnails.forEach((t, e) => {
              this.events.register(t, "click", () => {
                this.photoswipe.goTo(e);
              });
            }),
            this.events.register(this.thumbScroller, "scroll", () =>
              this._handleScrollButtonVisibility()
            ),
            this.events.register(this.thumbScrollerButtons[0], "click", () =>
              this._onScrollButtonClick(!0)
            ),
            this.events.register(this.thumbScrollerButtons[1], "click", () =>
              this._onScrollButtonClick(!1)
            ),
            this.photoswipe.options.mouseUsed
              ? (this.photoswipe.options.closeOnVerticalDrag = !1)
              : this.photoswipe.listen("mouseUsed", () => {
                  this.photoswipe.options.closeOnVerticalDrag = !1;
                }),
            this.photoswipe.listen("afterChange", () => {
              const t = this.photoswipe.getCurrentIndex();
              this.selectedThumb &&
                (this.selectedThumb.dataset.gallerySelected = !1),
                (this.selectedThumb = this.thumbnails[t]),
                (this.selectedThumb.dataset.gallerySelected = !0);
              const e = this.selectedThumb.getAttribute("data-gallery-index"),
                n = i[e];
              this._adjustMobileThumbPosition(),
                this._handleScrollButtonVisibility(),
                o(e),
                (this.selectedSlide = n);
            }),
            this.photoswipe.listen("close", () => {
              Mt(this.photoswipeDialog),
                this.selectedSlide.focus(),
                (this.photoswipe = null);
            }),
            this.photoswipe.listen("destroy", () => {
              this.events.unregisterAll(), (this.photoswipe = null);
            }),
            this.events.register(this.thumbContainer, "mouseenter", () => {
              Tt.isLessThanBreakpoint("S") &&
                (this.photoswipe.options.closeOnScroll = !0);
            }),
            this.events.register(this.thumbContainer, "mouseleave", () => {
              Tt.isLessThanBreakpoint("S") &&
                (this.photoswipe.options.closeOnScroll = !1);
            });
          this.events.register(window, "keydown", (t) =>
            ((t) => {
              "Escape" === t.key &&
                i[0].parentNode.querySelector("[data-gallery-expand]").focus();
            })(t)
          ),
            this.photoswipe.init(),
            $t(this.photoswipeDialog);
        }
        _adjustMobileThumbPosition() {
          if (Tt.isLessThanBreakpoint("S")) {
            const t = this.selectedThumb.getBoundingClientRect(),
              e = this.thumbScroller.getBoundingClientRect();
            t.left + t.width + 30 > e.width
              ? (this.thumbScroller.scrollLeft =
                  this.selectedThumb.offsetLeft + t.width - e.width + 35)
              : this.selectedThumb.offsetLeft < this.thumbScroller.scrollLeft &&
                (this.thumbScroller.scrollLeft =
                  this.selectedThumb.offsetLeft - 35);
          }
        }
        _handleScrollButtonVisibility() {
          Tt.isLessThanBreakpoint("S")
            ? (this.thumbScroller.scrollLeft > 4
                ? this.thumbScrollerButtons[0].classList.add("visible")
                : this.thumbScrollerButtons[0].classList.remove("visible"),
              this.thumbScroller.scrollLeft <
              this.thumbScroller.scrollWidth - this.thumbScroller.clientWidth
                ? this.thumbScrollerButtons[1].classList.add("visible")
                : this.thumbScrollerButtons[1].classList.remove("visible"))
            : (this.thumbScrollerButtons[0].classList.remove("visible"),
              this.thumbScrollerButtons[1].classList.remove("visible"));
        }
        _onScrollButtonClick(t) {
          this.thumbScroller.scrollLeft = t
            ? this.thumbScroller.scrollLeft - 100
            : this.thumbScroller.scrollLeft + 100;
        }
        unload() {
          this.photoswipe &&
            (this.photoswipe.destroy(), (this.photoswipe = null));
        }
      }
      let Ye = null;
      class Je {
        constructor(t) {
          let { el: e, settings: i, isQuickshop: n, sectionContext: s } = t;
          (this.el = e),
            (this.settings = i),
            (this.isQuickshop = n || !1),
            (this.sectionContext = s || "default"),
            (this.events = new St.Z()),
            (this.viewer = this.el.querySelector("[data-gallery-viewer]")),
            (this.navigation = this.el.querySelector(
              "[data-gallery-navigation]"
            )),
            (this.navScroller = this.el.querySelector(
              "[data-gallery-scroller]"
            )),
            (this.navScrollerButtons = this.el.querySelectorAll(
              "[data-gallery-scroll-button]"
            )),
            (this.figures = this.viewer.querySelectorAll(
              "[data-gallery-figure]"
            )),
            (this.thumbnails = this.navigation.querySelectorAll(
              "[data-gallery-thumbnail]"
            )),
            (this.zoomButton = this.viewer.querySelector(
              "[data-gallery-expand]"
            )),
            (this.selected = {
              figure: this.viewer.querySelector(
                '[data-gallery-selected="true"]'
              ),
              thumbnail: this.navigation.querySelector(
                '[data-gallery-selected="true"]'
              ),
            }),
            (this.models = {}),
            (this.videos = {}),
            (this.selectedVideo = null),
            (this.selectedModel = null),
            (this.showingInitialSlide = !0),
            (this._setupSelectedVideo = this._setupSelectedVideo.bind(this));
          const o = [];
          if (
            (this.el.querySelector('[data-media-type="video"]') &&
              (Ye instanceof Promise ||
                (Ye = new Promise((t) => {
                  const e = document.createElement("link");
                  e.setAttribute("rel", "stylesheet"),
                    (e.href =
                      "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
                    (e.onload = t),
                    document.body.appendChild(e);
                })),
              o.push({
                name: "video-ui",
                version: "1.0",
                onLoad: () => Ye.then(() => this._setupSelectedVideo()),
              })),
            this.el.querySelector('[data-media-type="model"]') &&
              ((this.viewInYourSpaceEl =
                this.el.querySelector("[data-shopify-xr]")),
              this.events.register(this.viewInYourSpaceEl, "click", () =>
                this._onViewInYourSpaceClick()
              ),
              o.push({
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this._onModelLibraryLoad.bind(this),
              }),
              o.push({ name: "shopify-xr", version: "1.0" })),
            o.length && window.Shopify.loadFeatures(o),
            this.isQuickshop &&
              (x.watch(this.el),
              "video" === this.figures[0].dataset.mediaType &&
                setTimeout(() => this._setSlideHeight(), 800)),
            this.events.register(this.navScroller, "click", (t) =>
              this._onThumbnailClick(t)
            ),
            this.events.register(this.navScroller, "scroll", () =>
              this._handleScrollButtonVisibility()
            ),
            this.events.register(this.navScrollerButtons[0], "click", () =>
              this._onScrollButtonClick(!0)
            ),
            this.events.register(this.navScrollerButtons[1], "click", () =>
              this._onScrollButtonClick(!1)
            ),
            "disabled" !== this.settings.gallery_click_to_zoom)
          ) {
            const t = (t) => {
              t.stopPropagation(), this._openImageZoom();
            };
            this.events.register(this.zoomButton, "click", (e) => t(e)),
              this.events.register(this.viewer, "click", (e) => t(e));
          }
          (this._onResize = this._onResize.bind(this)),
            this.events.register(window, "resize", () => this._onResize()),
            Tt.isLessThanBreakpoint("S") &&
              (this._setupFlickity(), this._handleScrollButtonVisibility()),
            this._selectMediaByEl(this.selected.figure);
        }
        selectMediaByVariant(t) {
          if (!t.featured_media) return;
          const e = this.viewer.querySelector(
            `[data-media="${t.featured_media.id}"]`
          );
          this._selectMediaByEl(e);
        }
        unload() {
          this.events.unregisterAll();
          for (let t; t < this.figures.length; t++)
            this.models[t] && this.models[t].destroy(),
              this.videos[t] && this.videos[t].destroy();
          this.isQuickshop && x.unwatch(this.el),
            this._closeImageZoom(),
            this._disableHoverZoom(),
            this._disableFlickity();
        }
        _onModelLibraryLoad() {
          const t = () => {
              this.flickity && this.flickity.unbindDrag();
            },
            e = () => {
              this.flickity && this.flickity.bindDrag();
            };
          this.el.querySelectorAll(".product-gallery--model").forEach((i) => {
            const n = i.querySelector("model-viewer"),
              { galleryIndex: s } = i.dataset,
              o = ["zoom-in", "zoom-out"];
            document.fullscreenEnabled && o.push("fullscreen"),
              (this.models[s] = new Shopify.ModelViewerUI(n, { controls: o })),
              this.events.register(n, "shopify_model_viewer_ui_toggle_play", t),
              this.events.register(
                n,
                "shopify_model_viewer_ui_toggle_pause",
                e
              );
          });
        }
        _onResize() {
          document.fullscreenElement ||
            (Tt.isGreaterThanBreakpoint("S", !0)
              ? this._disableFlickity()
              : this._setupFlickity(),
            Tt.isGreaterThanBreakpoint("L", !0) && !this.drift
              ? this._setupHoverZoom()
              : Tt.isLessThanBreakpoint("L") && this._disableHoverZoom(),
            this._adjustGalleryPositioning(),
            this._handleScrollButtonVisibility());
        }
        _onThumbnailClick(t) {
          let e;
          if (
            ((this.showingInitialSlide = !1),
            t.target.classList.contains("product-gallery--media-thumbnail"))
          )
            e = t.target;
          else {
            if (
              !t.target.parentNode.parentNode.classList.contains(
                "product-gallery--media-thumbnail"
              )
            )
              return;
            e = t.target.parentNode.parentNode;
          }
          const i = parseInt(e.dataset.galleryIndex, 10);
          this.flickity ? this.flickity.select(i) : this._selectMediaByIndex(i);
        }
        _onViewInYourSpaceClick(t) {
          const { currentTarget: e } = t,
            i = this.viewer.querySelector(
              `[data-media="${e.dataset.shopifyModel3dId}"]`
            );
          this._selectMediaByEl(i);
        }
        _selectMediaByEl(t) {
          this._selectMediaByIndex(parseInt(t.dataset.galleryIndex, 10));
        }
        _selectMediaByIndex(t) {
          const e = this.figures[t];
          (this.selected.figure.dataset.gallerySelected = !1),
            this.selected.figure.setAttribute("aria-hidden", !0),
            (this.selected.figure = e),
            (this.selected.figure.dataset.gallerySelected = !0),
            this.selected.figure.setAttribute("aria-hidden", !1);
          const i = parseInt(this.selected.figure.dataset.galleryIndex, 10);
          (this.selected.thumbnail.dataset.gallerySelected = !1),
            (this.selected.thumbnail = this.thumbnails[i]),
            (this.selected.thumbnail.dataset.gallerySelected = !0);
          const { media: n, mediaType: s } = this.selected.figure.dataset;
          switch (
            ((this.viewer.dataset.selectedMediaType = s),
            this._disableHoverZoom(),
            this.selectedModel && this.selectedModel.pause(),
            this.models[e.dataset.galleryIndex] &&
              ((this.selectedModel = this.models[e.dataset.galleryIndex]),
              document.documentElement.classList.contains("has-touch") ||
                this.showingInitialSlide ||
                this.selectedModel.play()),
            this.selectedVideo && this.selectedVideo.pause(),
            this.viewInYourSpaceEl &&
              (this.viewInYourSpaceEl.dataset.shopifyModel3dId =
                this.viewInYourSpaceEl.dataset.defaultModelId),
            s)
          ) {
            case "model":
              this.viewInYourSpaceEl.dataset.shopifyModel3dId = n;
              break;
            case "video":
            case "external_video":
              this._setupSelectedVideo();
              break;
            case "image":
              this._setupHoverZoom();
              break;
            default:
              break;
          }
          this.flickity && (this.flickity.bindDrag(), this.flickity.select(t)),
            this._adjustGalleryPositioning();
        }
        _setupSelectedVideo() {
          this.selectedVideo && this.selectedVideo.pause();
          const { mediaType: t, galleryIndex: e } =
              this.selected.figure.dataset,
            i =
              Tt.isGreaterThanBreakpoint("L", !0) &&
              this.settings.gallery_video_autoplay &&
              !this.showingInitialSlide;
          if ("video" === t || "external_video" === t) {
            let n;
            if (this.videos[e])
              (this.selectedVideo = this.videos[e]),
                i && this.selectedVideo.play();
            else {
              if ("video" === t) {
                if (!Shopify.Plyr) return;
                (n = this.selected.figure.querySelector("video")),
                  (this.selectedVideo = new Shopify.Plyr(n, {
                    loop: { active: this.settings.gallery_video_looping },
                  })),
                  i && this.selectedVideo.play();
              } else
                (n = this.selected.figure.querySelector("[data-video]")),
                  (this.selectedVideo = new Ve(n, {
                    loop: this.settings.gallery_video_looping,
                  })),
                  i && this.selectedVideo.play();
              this.videos[e] = this.selectedVideo;
            }
            this.selected.figure.focus();
          }
        }
        _setupHoverZoom() {
          if (
            "disabled" === this.settings.gallery_hover_zoom ||
            !Tt.isGreaterThanBreakpoint("L", !0) ||
            "image" !== this.selected.figure.dataset.mediaType ||
            document.documentElement.classList.contains("has-touch")
          )
            return;
          const t = this.selected.figure.querySelector(
            '[data-rimg]:not([data-rimg="noscript"])'
          );
          t.setAttribute(
            "data-zoom",
            this.selected.figure.getAttribute("data-zoom")
          ),
            (this.drift = new Re(t, {
              paneContainer:
                "separate" === this.settings.gallery_hover_zoom
                  ? this.el.querySelector("[data-zoomed-image]")
                  : this.selected.figure,
              inlinePane: !1,
              hoverBoundingBox: "separate" === this.settings.gallery_hover_zoom,
              handleTouch: !1,
              onShow: () => {
                if ("separate" === this.settings.gallery_hover_zoom) {
                  const t = document.querySelector(".product-main"),
                    e = document.querySelector(".product-form--alt");
                  t.classList.add("product-gallery--fade"),
                    e && e.classList.add("product-gallery--fade");
                }
              },
              onHide: () => {
                if ("separate" === this.settings.gallery_hover_zoom) {
                  const t = document.querySelector(".product-main"),
                    e = document.querySelector(".product-form--alt");
                  t.classList.remove("product-gallery--fade"),
                    e && e.classList.remove("product-gallery--fade");
                }
              },
            }));
        }
        _disableHoverZoom() {
          this.drift && (this.drift.disable(), (this.drift = null));
        }
        _setupFlickity() {
          !this.flickity &&
            Tt.isLessThanBreakpoint("S") &&
            ((this.flickity = new (_t())(this.viewer, {
              accessibility: !1,
              adaptiveHeight: !0,
              cellSelector: ".product-gallery--media",
              contain: !0,
              friction: 0.5,
              freeScroll: !1,
              initialIndex: parseInt(
                this.selected.figure.dataset.galleryIndex,
                10
              ),
              lazyLoad: !1,
              percentPosition: !1,
              prevNextButtons: !1,
              pageDots: !1,
              selectedAttraction: 0.1,
              setGallerySize: !1,
              wrapAround: !0,
            })),
            (this.flickityEvent = this.events.register(
              this.viewer,
              "rimg:load",
              () => {
                this._setSlideHeight();
              }
            )),
            this.flickity.on("change", (t) => {
              (this.showingInitialSlide = !1),
                this._selectMediaByEl(this.figures[t]);
            }),
            this.flickity.on("staticClick", (t, e, i) => {
              const n = i.querySelector(".product-gallery--model");
              if (n && this.models[n.dataset.galleryIndex]) {
                this.models[n.dataset.galleryIndex].play();
              }
            }),
            this.flickity.on("pointerDown", () => {
              this.viewer.blur();
            }),
            "disabled" !== this.settings.gallery_click_to_zoom &&
              document.documentElement.classList.contains("no-touch") &&
              this.flickity.on("dragEnd", () => {
                this.swiped = !0;
              }),
            this._setSlideHeight());
        }
        _disableFlickity() {
          this.flickity &&
            (this.flickity.destroy(),
            (this.flickity = null),
            this.events.unregister(this.flickityEvent));
        }
        _setSlideHeight() {
          this.navigation.classList.remove("loading");
          const t =
            this.storedImageHeight ||
            this.selected.figure.getBoundingClientRect().height;
          
        }
        _adjustGalleryPositioning() {
          if ("left" === this.settings.gallery_thumbnail_position) {
            if (
              (this.isQuickshop &&
                (Tt.isGreaterThanBreakpoint("L", !0) &&
                "default" === this.sectionContext
                  ? (this.el.dataset.productGalleryThumbnails = "left")
                  : ((this.storedImageHeight =
                      this.selected.figure.getBoundingClientRect().height),
                    (this.el.dataset.productGalleryThumbnails = "center"))),
              "default" === this.sectionContext &&
                (Tt.isGreaterThanBreakpoint("L", !0) ||
                  (Tt.isGreaterThanBreakpoint("S", !0) && !this.isQuickshop)))
            ) {
              if (this.el.firstChild !== this.navigation) {
                const t = document.activeElement;
                this.el.insertBefore(this.navigation, this.viewer), t.focus();
              }
              setTimeout(
                () => {
                  const t = this.thumbnails[0].getBoundingClientRect(),
                    e =
                      this.thumbnails[0].currentStyle ||
                      window.getComputedStyle(this.thumbnails[0]),
                    i = 2 * parseInt(e.marginLeft, 10);
                  Array.prototype.some.call(
                    this.thumbnails,
                    (e) => e.getBoundingClientRect().left > t.left
                  ) &&
                    ((this.navigation.style.width = 2 * (t.width + i) + "px"),
                    (this.navigation.style.maxWidth =
                      2 * (t.width + i) + "px")),
                    this._setSlideHeight();
                },
                this.isQuickshop ? 500 : 100
              );
            } else
              this.el.firstElementChild === this.navigation &&
                this.el.appendChild(this.navigation),
                (this.navigation.style.width = ""),
                (this.navigation.style.maxWidth = ""),
                this._setSlideHeight();
            Tt.isLessThanBreakpoint("S") &&
              this._adjustMobileThumbnailPosition();
          } else this._setSlideHeight(), this._adjustMobileThumbnailPosition();
        }
        _adjustMobileThumbnailPosition() {
          if (Tt.isLessThanBreakpoint("S")) {
            const t = this.selected.thumbnail.getBoundingClientRect(),
              e = this.navScroller.getBoundingClientRect();
            this.selected.thumbnail.offsetLeft +
              t.width +
              30 -
              this.navScroller.scrollLeft >
            e.width
              ? (this.navScroller.scrollLeft =
                  this.selected.thumbnail.offsetLeft + t.width - e.width + 35)
              : this.selected.thumbnail.offsetLeft <
                  this.navScroller.scrollLeft &&
                (this.navScroller.scrollLeft =
                  this.selected.thumbnail.offsetLeft - 35);
          }
        }
        _handleScrollButtonVisibility() {
          Tt.isLessThanBreakpoint("S")
            ? (this.navScroller.scrollLeft > 4
                ? this.navScrollerButtons[0].classList.add("visible")
                : this.navScrollerButtons[0].classList.remove("visible"),
              this.navScroller.scrollLeft <
              this.navScroller.scrollWidth - this.navScroller.clientWidth
                ? this.navScrollerButtons[1].classList.add("visible")
                : this.navScrollerButtons[1].classList.remove("visible"))
            : (this.navScrollerButtons[0].classList.remove("visible"),
              this.navScrollerButtons[1].classList.remove("visible"));
        }
        _onScrollButtonClick(t) {
          this.navScroller.scrollLeft = t
            ? this.navScroller.scrollLeft - 100
            : this.navScroller.scrollLeft + 100;
        }
        _closeImageZoom() {
          this.imageZoom && (this.imageZoom.unload(), (this.imageZoom = null));
        }
        _openImageZoom() {
          "image" !== this.selected.figure.dataset.mediaType ||
            (Tt.isGreaterThanBreakpoint("L") &&
              "mobile" === this.settings.gallery_click_to_zoom) ||
            (Tt.isLessThanBreakpoint("L") &&
              "desktop" === this.settings.gallery_click_to_zoom) ||
            (this.swiped
              ? (this.swiped = !1)
              : (this._closeImageZoom(),
                (this.imageZoom = new Ke({
                  settings: this.settings,
                  slides: this.figures,
                  originalThumbnails: this.thumbnails,
                  startIndex: parseInt(
                    this.selected.figure.dataset.galleryIndex,
                    10
                  ),
                  selectGalleryIndex: (t) => this._selectMediaByIndex(t),
                }))));
        }
      }
      class ti {
        constructor(t) {
          (this._el = t),
            (this._reference = this._el.querySelector(
              "[data-payment-terms-reference] shopify-payment-terms"
            )),
            (this._target = this._el.querySelector(
              "[data-payment-terms-target]"
            )),
            this._reference &&
              this._target &&
              ((this._input = document.createElement("input")),
              (this._input.name = "id"),
              (this._input.type = "hidden"),
              this._target.appendChild(this._input),
              this._target.appendChild(this._reference),
              (this._target.style.display = null));
        }
        update(t) {
          this._reference &&
            this._target &&
            ((this._input.value = t),
            this._input.dispatchEvent(new Event("change", { bubbles: !0 })));
        }
      }
      class ei {
        constructor(t) {
          (this.$window = e()(window)),
            (this.$formArea = t.$formArea),
            (this.$details = t.$details),
            (this.context = t.context),
            (this.settings = t.settings),
            (this.product = t.product),
            (this.useHistory = t.useHistory),
            (this.sectionId = t.sectionId),
            (this.el = t.productEl),
            (this.paymentTerms = new ti(this.el)),
            (this.variantSelection = this.el.querySelector(
              "[data-variant-selection]"
            )),
            (this.surfacePickUpEl = this.el.querySelector(
              "[data-surface-pick-up]"
            )),
            this.surfacePickUpEl &&
              (this.surfacePickUp = new Yt(this.surfacePickUpEl)),
            (this.events = new St.Z()),
            this.product &&
              "media" in this.product &&
              (this.gallery = new Je({
                el: t.gallery,
                sectionContext: t.sectionContext,
                settings: this.settings,
                isQuickshop: t.isQuickshop,
              })),
            e()(this.$formArea).length &&
              (this.variantSelection &&
                ((this.isDefaultVariant = !!this.variantSelection.querySelector(
                  "[data-variants].variant-selection__variants--default"
                )),
                this.variantSelection.getVariant().then((t) => {
                  this.surfacePickUp.load(t ? t.id : null),
                    this._updateBadge(t),
                    this._updatePrice(t),
                    t || (this._showPriceRange(), this._updateSKU()),
                    this.events.register(
                      this.variantSelection,
                      "variant-change",
                      (t) => this._switchVariant(t.detail)
                    );
                })),
              (this.modal = new Ht({
                onClose: () => this.modal.unload(),
                modalId: 1,
              })),
              this.surfacePickUp &&
                this.surfacePickUp.onModalRequest((t) => {
                  let e = this.$formArea[0].querySelector(
                    "[data-surface-pick-up-modal-contents]"
                  );
                  this.variantSelection.getVariant().then((i) => {
                    const n = this.isDefaultVariant
                        ? ""
                        : `<div class="surface-pick-up-modal__variant">${i.title}</div>`,
                      s = `\n            <div class="surface-pick-up-modal__header">\n              <h2 class="surface-pick-up-modal__title">${this.product.title}</h2>\n              ${n}\n            </div>\n            ${t}\n            `;
                    e
                      ? (e.innerHTML = s)
                      : ((e = document.createElement("div")),
                        e.setAttribute(
                          "data-surface-pick-up-modal-contents",
                          ""
                        ),
                        (e.style.display = "none"),
                        (e.innerHTML = s),
                        this.$formArea[0].appendChild(e)),
                      this.modal.open(
                        "[data-surface-pick-up-modal-contents]",
                        "surface-pick-up"
                      );
                  });
                }),
              (this.addToCartFlyout = null),
              (this.atcCallbacks = t.atcCallbacks),
              (this.$form = this.$formArea.find("[data-product-form]")),
              (this.$productAtcButton =
                this.$formArea.find("[data-product-atc]")),
              (this.$productVariants = this.$form.find("[data-variants]")),
              (this.$productOptions = this.$form.find("[data-product-option]")),
              (this.productPricing = this.$details[0].querySelector(
                "[data-product-pricing]"
              )),
              (this.detailsLink = this.$formArea[0].querySelector(
                "[data-product-details-link]"
              )),
              this.detailsLink &&
                (this.detailsBaseHref = this.detailsLink.getAttribute("href")),
              (this.variantFields = {
                $priceContainer: this.$details.find("[data-price-container]"),
                $priceMoney: this.$details.find(
                  "[data-price-container] [data-price]"
                ),
                $compareAtPrice: this.$details.find(
                  "[data-price-compare-container]"
                ),
                $compareAtPriceMoney: this.$details.find(
                  "[data-price-compare-container] [data-price-compare]"
                ),
                $badge: this.$details.find("[data-badge-sales]"),
                $badgeRange: this.$details.find("[data-badge-sales-range]"),
                $badgeSingle: this.$details.find("[data-badge-sales-single]"),
                $sku: this.$details.find("[data-product-sku]"),
                unitPrice: this.$details[0].querySelector("[data-unit-price]"),
                totalQuantity: this.$details[0].querySelector(
                  "[data-total-quantity]"
                ),
                unitPriceAmount: this.$details[0].querySelector(
                  "[data-unit-price-amount]"
                ),
                unitPriceMeasure: this.$details[0].querySelector(
                  "[data-unit-price-measure]"
                ),
                taxLine: this.$details[0].querySelector("[data-tax-line]"),
                hiddenComparePrice: this.$details[0].querySelector(
                  "[data-compare-price-hidden]"
                ),
                hiddenCurrentPrice: this.$details[0].querySelector(
                  "[data-current-price-hidden]"
                ),
                hiddenComparePriceRange: this.$details[0].querySelector(
                  "[data-compare-price-range-hidden]"
                ),
                hiddenCurrentPriceRange: this.$details[0].querySelector(
                  "[data-current-price-range-hidden]"
                ),
              }),
              (this.forms = new F(this.$form)),
              this.product && this._bindEvents());
        }
        unload() {
          this.$form && this.$form.off(`.product-details-${this.sectionId}`),
            this.forms && this.forms.unload(),
            this.gallery && this.gallery.unload(),
            this.messageBanner && this.messageBanner.unload();
        }
        _bindEvents() {
          this.$form.on(`submit.product-details-${this.sectionId}`, (t) =>
            this._addToCartFlyout(t)
          );
        }
        _switchVariant(t) {
          const { variant: i } = t;
          if (
            (this.productPricing &&
              (this.productPricing.style.visibility = i ? "visible" : "hidden"),
            this.$productVariants.val(i.id),
            this.gallery && this.gallery.selectMediaByVariant(i),
            this.surfacePickUp.load(i.id),
            this._updatePrice(i),
            this._updateSKU(i),
            this._updateBadge(i),
            this._updateButton(i),
            this._updateSwatchLabel(i),
            this._updateFullDetailsLink(i),
            this._updateUnitPrice(i),
            this.paymentTerms.update(i.id),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            this.useHistory)
          ) {
            const t = `${this.product.handle}?${e().param({ variant: i.id })}`;
            history.replaceState({}, "variant", t);
          }
        }
        _updatePrice(t) {
          if (!this.productPricing) return;
          const e = this.variantFields.hiddenComparePrice.innerHTML,
            i = this.variantFields.hiddenCurrentPrice.innerHTML;
          (this.variantFields.$compareAtPrice[0].innerHTML = e),
            (this.variantFields.$priceContainer[0].innerHTML = i),
            (this.variantFields.$priceMoney = this.$details.find(
              "[data-price-container] [data-price]"
            )),
            (this.variantFields.$compareAtPriceMoney = this.$details.find(
              "[data-price-compare-container] [data-price-compare]"
            ));
          const n = !!t.compare_at_price && t.compare_at_price > t.price;
          this.variantFields.$compareAtPrice.toggleClass("visible", n),
            this.variantFields.$compareAtPriceMoney.text(
              Shopify.formatMoney(
                t.compare_at_price,
                this.settings.money_format
              )
            ),
            this.variantFields.$priceMoney.text(
              Shopify.formatMoney(t.price, this.settings.money_format)
            );
        }
        _showPriceRange() {
          this._updateBadge(!1);
          const t = this.product.price_varies,
            e = this.product.variants.some(
              (t) =>
                (t.compare_at_price || t.price) !==
                this.product.compare_at_price
            ),
            i = t
              ? this.variantFields.hiddenCurrentPriceRange.innerHTML
              : this.variantFields.hiddenCurrentPrice.innerHTML,
            n = e
              ? this.variantFields.hiddenComparePriceRange.innerHTML
              : this.variantFields.hiddenComparePrice.innerHTML,
            s = this.product.compare_at_price_max > this.product.price_min;
          this.variantFields.$compareAtPrice.toggleClass("visible", s),
            (this.variantFields.$compareAtPrice[0].innerHTML = n),
            (this.variantFields.$priceContainer[0].innerHTML = i);
        }
        _updateSKU() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          t
            ? ("" === t.sku
                ? this.variantFields.$sku
                    .parent()
                    .addClass("product-sku--empty")
                : (this.variantFields.$sku
                    .parent()
                    .removeClass("product-sku--empty"),
                  this.variantFields.$sku.parent().show()),
              this.variantFields.$sku.text(t.sku))
            : this.variantFields.$sku.parent().hide();
        }
        _updateBadge() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (t) {
            const e = t.compare_at_price ? t.compare_at_price - t.price : 0;
            if (e <= 0) this.variantFields.$badge.toggle(!1);
            else {
              this.variantFields.$badgeRange.toggle(!1),
                this.variantFields.$badgeSingle.toggle(!!e),
                this.variantFields.$badge.toggle(!!e);
              const i = this.variantFields.$badgeSingle.find(
                  "[data-price-money-saved]"
                ),
                n = this.variantFields.$badgeSingle.find(
                  "[data-price-percent-saved]"
                );
              if (
                (i.length &&
                  i.text(Shopify.formatMoney(e, this.settings.money_format)),
                n.length)
              ) {
                const i = Math.round((100 * e) / t.compare_at_price);
                n.text(i);
              }
            }
          } else {
            const t = this.product.compare_at_price
              ? this.product.compare_at_price_max - this.product.price_min
              : 0;
            t <= 0
              ? this.variantFields.$badge.toggle(!1)
              : (this.variantFields.$badgeSingle.toggle(!1),
                this.variantFields.$badgeRange.toggle(!!t),
                this.variantFields.$badge.toggle(!!t));
          }
        }
        _updateButton(t) {
          t
            ? t.available
              ? (this.$productAtcButton.text(this.context.product_available),
                this.$productAtcButton
                  .removeClass("disabled")
                  .prop("disabled", !1))
              : (this.$productAtcButton.text(this.context.product_sold_out),
                this.$productAtcButton
                  .addClass("disabled")
                  .prop("disabled", !0))
            : (this.$productAtcButton.text(this.context.product_unavailable),
              this.$productAtcButton.addClass("disabled").prop("disabled", !0));
        }
        _updateSwatchLabel(t) {
          if (this.settings.swatches_enable) {
            const e = this.$form[0].querySelector("[data-option-swatch-value]");
            e &&
              (e.innerText =
                t.options[parseInt(e.dataset.optionSwatchValue, 10)]);
          }
        }
        _updateFullDetailsLink(t) {
          this.detailsLink &&
            this.detailsLink.setAttribute(
              "href",
              `${this.detailsBaseHref}?variant=${t.id}`
            );
        }
        _updateUnitPrice(t) {
          this.variantFields.unitPrice && t.unit_price_measurement
            ? ((this.variantFields.totalQuantity.innerHTML = `${t.unit_price_measurement.quantity_value}${t.unit_price_measurement.quantity_unit}`),
              (this.variantFields.unitPriceAmount.innerHTML =
                Shopify.formatMoney(t.unit_price, this.settings.money_format)),
              1 === t.unit_price_measurement.reference_value
                ? (this.variantFields.unitPriceMeasure.innerHTML =
                    t.unit_price_measurement.reference_unit)
                : (this.variantFields.unitPriceMeasure.innerHTML = `${t.unit_price_measurement.reference_value}${t.unit_price_measurement.reference_unit}`),
              this.variantFields.unitPrice.classList.remove("hidden"))
            : this.variantFields.unitPrice &&
              this.variantFields.unitPrice.classList.add("hidden"),
            this.variantFields.taxLine &&
              (t.taxable
                ? this.variantFields.taxLine.classList.remove("hidden")
                : this.variantFields.taxLine.classList.add("hidden"));
        }
        _addToCartFlyout(t) {
          t.preventDefault(),
            this.variantSelection.getVariant().then((t) => {
              if (!t)
                return (
                  (this.messageBanner = new Jt(
                    this.context.select_variant,
                    "error"
                  )),
                  void this.$form
                    .get(0)
                    .classList.add("product-form--error-option-unselected")
                );
            }),
            this.addToCartFlyout && this.addToCartFlyout.unload();
          const e = this.$form.serializeArray(),
            i = {
              atcButton: this.$productAtcButton[0],
              settings: {
                moneyFormat: this.settings.money_format,
                cartRedirection: this.settings.cart_redirection,
              },
            };
          this.addToCartFlyout = new we(e, i, this.atcCallbacks);
        }
      }
      const ii = () => {
        window.SPR &&
          (window.SPR.registerCallbacks(),
          window.SPR.initRatingHandler(),
          window.SPR.initDomEls(),
          window.SPR.loadProducts(),
          window.SPR.loadBadges());
      };
      class ni {
        constructor(t) {
          (this.$el = t.$el),
            (this.id = t.id),
            (this.sectionContext = t.sectionContext),
            (this.initialVariant = t.initialVariant || null),
            (this.quickShopSelector = t.quickShopSelector
              ? t.quickShopSelector
              : `#shopify-section-${this.id} [data-product-quickshop]`),
            (this.$quickShop = e()(this.quickShopSelector)),
            (this.quickshopSpinner =
              this.$quickShop[0].querySelector(".quickshop-spinner")),
            (this.modalClass = t.modalClass),
            (this.loaded = !1),
            (this.richText = null),
            (this.productDetails = null),
            (this.trigger = t.trigger),
            (this.isOpen = !1),
            (this.openingAddToCart = !1),
            (this.modal = t.modal ? t.modal : null),
            (this.quickshopContainer = t.quickshopContainer
              ? t.quickshopContainer
              : null),
            (this.view = t.view ? t.view : "product-quickshop"),
            (this.url = t.productUrl
              ? t.productUrl
              : this.$el.data("product-quickshop-url")),
            (this.hash = t.hash ? t.hash : this.$el.data("quickshop-hash")),
            (this.modalCallbacks = {
              onOpen: this._open.bind(this),
              onClose: this._close.bind(this),
            }),
            (this.atcCallbacks = {
              onInit: this._onATCInit.bind(this),
              onError: this._onATCError.bind(this),
              onSuccess: this._onATCSuccess.bind(this),
              onClose: this._onATCClose.bind(this),
            }),
            this._initialize();
        }
        _initialize() {
          null == this.modal &&
            ((this.modal = new Ht(this.modalCallbacks)),
            this.modal.open(this.quickShopSelector, this.modalClass)),
            (this.isOpen = !0);
          let t = this.modal.$modalInner.find("[data-modal-content]");
          this.quickshopContainer && (t = e()(this.quickshopContainer)),
            fetch(
              this.url.indexOf("?") >= 0
                ? `${this.url}&view=quickshop`
                : `${this.url}?view=quickshop`
            )
              .then((t) => t.text())
              .then((e) => {
                const i = new DOMParser().parseFromString(e, "text/html"),
                  n = i.querySelector("[data-product-wrapper]"),
                  s = i.querySelector('[data-section-type="static-product"]');
                (this.productSettings = JSON.parse(s.innerHTML)),
                  this.isOpen &&
                    (t.html(n.innerHTML),
                    ii(),
                    be(t[0]),
                    window.Shopify &&
                      Shopify.PaymentButton &&
                      Shopify.PaymentButton.init(),
                    (this.$message = t.find(
                      "[data-product-quickshop-message]"
                    )),
                    (this.$formArea = t.find("[data-product-form-area]")),
                    (this.gallery = t[0].querySelector(
                      "[data-product-gallery]"
                    )),
                    (this.$details = t.find("[data-product-details]")),
                    (this.$description = t.find("[data-product-description]")),
                    (this.productEl = t[0]),
                    (this.context = this.productSettings.context),
                    (this.settings = this.productSettings.settings),
                    (this.product = this.productSettings.product),
                    this._onQuickshopLoaded());
              })
              .catch();
        }
        _onQuickshopLoaded() {
          if (this.loaded) return;
          this.$description &&
            this.$description.length &&
            (this.richText = new O(this.$description));
          const t = {
            $formArea: this.$formArea,
            gallery: this.gallery,
            $details: this.$details,
            atcCallbacks: this.atcCallbacks,
            context: this.productSettings.context,
            sectionContext: this.sectionContext,
            settings: this.productSettings.settings,
            product: this.productSettings.product,
            useHistory: !1,
            isQuickshop: !0,
            initialVariant: this.initialVariant,
            productEl: this.productEl,
          };
          this.modal.position(),
            this.modal.finishedLoading(),
            (this.loaded = !0),
            window.requestAnimationFrame(() => {
              this.productDetails = new ei(t);
            });
        }
        _open() {}
        _close() {
          this.productDetails && this.productDetails.unload(),
            this.richText && this.richText.unload(),
            this.openingAddToCart || this.trigger.focus(),
            (this.loaded = !1),
            (this.isOpen = !1),
            this.$quickShop.empty(),
            this.$quickShop.html(this.quickshopSpinner),
            this._toggleMessage("", !1),
            this.modal.unload();
        }
        _toggleMessage(t, e) {
          this.$message && this.$message.html(t).toggleClass("visible", e);
        }
        _onATCInit() {
          (this.openingAddToCart = !0), this.$message.removeClass("visible");
        }
        _onATCError(t) {
          const i = e()(
            `<div class="product-message--error" tabindex="-1">${t}</div>`
          );
          this._toggleMessage(i, !0), i.focus();
        }
        _onATCSuccess() {
          this._close();
        }
        _onATCClose() {}
        unload() {
          this._close();
        }
      }
      let si = null;
      class oi {
        constructor(t) {
          (this.el = t.el),
            (this.setInitialVariant = t.setInitialVariant),
            (this.expanded = !1),
            (this.swatchImages = {}),
            (this.swatchVariantIds = {}),
            (this.selectedImage = null),
            (this.state = {}),
            (this.events = new St.Z()),
            (this.data = JSON.parse(
              this.el.querySelector("[data-swatch-data]").innerHTML
            )),
            (this.variants = this.data.variants),
            (this.swatchesContainer = this.el.querySelector(
              "[data-swatches-container]"
            )),
            (this.cardLinks = this.el.querySelectorAll(
              "[data-product-page-link]"
            )),
            (this.cardLinkHref = this.cardLinks[0].getAttribute("href")),
            (this.activeControlTime = 0),
            (this.activeControl =
              this.swatchesContainer.querySelector("[checked]")),
            (this.isPreselected = !!this.activeControl),
            (this.swatches =
              this.swatchesContainer.querySelectorAll("[data-swatch]")),
            (this.swatchCount = this.swatches.length),
            (this.swatchCountWrapper = this.el.querySelector(
              "[data-swatch-count-wrapper]"
            )),
            (this.swatchCount = this.swatchCountWrapper.querySelector(
              "[data-swatch-count]"
            )),
            (this.swatchWidths = Array.prototype.map.call(
              this.swatches,
              (t) => t.getBoundingClientRect().width
            )),
            this.resize(),
            this.el.querySelector("[data-swatches]").classList.add("processed"),
            (this.originalImages = {
              primary: this.el.querySelector(".productitem--image-primary"),
              alternate: this.el.querySelector(".productitem--image-alternate"),
            }),
            this.disableUnavailable(),
            this.events.register(
              window,
              "resize",
              z()(() => this.resize(), 50)
            ),
            this.events.register(this.swatchCountWrapper, "click", () =>
              this._toggleExpanded()
            ),
            (this.injectImagesMouseoverEvent = this.events.register(
              this.el,
              "mouseover",
              () => this._injectImages()
            )),
            (this.injectImagesFocusinEvent = this.events.register(
              this.el,
              "focusin",
              () => this._injectImages()
            )),
            this.events.register(this.swatchesContainer, "mouseover", (t) =>
              this._handleMouseOver(t)
            ),
            this.events.register(this.swatchesContainer, "mouseleave", (t) =>
              this._handleMouseLeave(t)
            ),
            this.events.register(this.swatchesContainer, "click", (t) =>
              this._handleClick(t)
            ),
            this.events.register(this.swatchesContainer, "change", (t) =>
              this._handleChange(t)
            ),
            this.events.register(this.swatchesContainer, "focusin", (t) =>
              this._handleSwatchFocus(t)
            );
        }
        disableUnavailable() {
          if (!this.variants) return;
          const t = {};
          this.variants.forEach((e) => {
            e.available && (t[e[this.data.swatchOptionKey]] = !0);
          });
          this.swatchesContainer
            .querySelectorAll('input[name="swatch"]')
            .forEach((e) => {
              e.value in t ||
                (e.classList.add("swatch-disabled"),
                e.classList.contains("sold_out_option--selectable") ||
                  (e.disabled = !0));
            });
        }
        resize() {
          this.expanded && this._toggleExpanded();
          const t =
            this.swatchesContainer.getBoundingClientRect().width -
            parseInt(
              window.getComputedStyle(this.swatchesContainer).paddingRight,
              10
            );
          let e = this.swatches.length,
            i = 0;
          for (let n = 0; n < this.swatches.length; n++) {
            if (!(i + this.getSwatchGap() + this.swatchWidths[n] < t)) {
              e = n;
              break;
            }
            i += si + this.swatchWidths[n];
          }
          e !== this.showSwatchCount &&
            ((this.showSwatchCount = e),
            this.swatches.forEach((t, e) => {
              e < this.showSwatchCount
                ? (t.classList.add("productitem--swatches-swatch-visible"),
                  t.classList.remove("productitem--swatches-swatch-hidden"))
                : (t.classList.remove("productitem--swatches-swatch-visible"),
                  t.classList.add("productitem--swatches-swatch-hidden"));
            }),
            (this.swatchCountWrapper.style.left = `${i}px`),
            this.swatches.length > this.showSwatchCount
              ? ((this.swatchCountWrapper.style.display = "flex"),
                (this.swatchCount.innerText =
                  "+" + (this.swatches.length - this.showSwatchCount)))
              : (this.swatchCountWrapper.style.display = "none"));
        }
        _injectImages() {
          this.events.unregister(this.injectImagesFocusinEvent),
            this.events.unregister(this.injectImagesMouseoverEvent),
            dt
              .load(this.cardLinkHref, "product-swatch-data", {
                hash: this.data.hash,
              })
              .then((t) => {
                let { data: e } = t;
                if (this.imagesInjected) return;
                this.imagesInjected = !0;
                const i = document.createDocumentFragment();
                if (e.featuredImage) {
                  const t = document.createElement("div");
                  t.innerHTML = e.featuredImage;
                  const n = t.querySelector("img");
                  i.appendChild(n), (this.featuredImage = n);
                }
                e.swatches.forEach((t) => {
                  let { swatchValue: e, imageString: n, variantId: s } = t;
                  if (((this.swatchVariantIds[e] = s), n)) {
                    const t = document.createElement("div");
                    t.innerHTML = n;
                    const s = t.querySelector("img");
                    i.appendChild(s), (this.swatchImages[e] = s);
                  }
                });
                const n = this.el.querySelector("[data-product-item-image]"),
                  s = n.querySelector("[data-badge-sales]");
                n.insertBefore(i, s),
                  x.watch(n),
                  this._setState({
                    swatchName: this.activeControl
                      ? this.activeControl.value
                      : null,
                    primaryImage: this.originalImages.primary,
                    hideAlternateImage: !!this.activeControl,
                  });
              });
        }
        _setState(t) {
          let { swatchName: e, primaryImage: i, hideAlternateImage: n } = t;
          const s = this.state.primaryImage,
            o = e
              ? `${this.cardLinkHref}?variant=${this.swatchVariantIds[e]}`
              : this.cardLinkHref;
          this.cardLinks.forEach((t) => t.setAttribute("href", o)),
            this.setInitialVariant(
              this.swatchVariantIds[e] || this.variants[0].id
            ),
            s &&
              (s.classList.remove("productitem--image-primary"),
              (s.style.visibility = "")),
            i &&
              (i.classList.add("productitem--image-primary"),
              (i.style.visibility = n ? "visible" : "")),
            this.originalImages.alternate &&
              (this.originalImages.alternate.style.visibility = n
                ? "hidden"
                : ""),
            (this.state = {
              swatchName: e,
              primaryImage: i,
              hideAlternateImage: n,
            });
        }
        _handleChange(t) {
          let { target: e } = t;
          (this.activeControlTime = Date.now()), (this.activeControl = e);
          const i = e.value;
          (this.selectedImage =
            this.swatchImages[i] || this.originalImages.primary),
            this._setState({
              swatchName: i,
              primaryImage: this.selectedImage,
              hideAlternateImage: !0,
            });
        }
        _handleClick(t) {
          let { target: e } = t;
          e === this.activeControl &&
            this.activeControlTime + 150 < Date.now() &&
            ((e.checked = !1),
            (this.activeControl = null),
            (this.selectedImage = null),
            this.isPreselected &&
              this.featuredImage &&
              ((this.originalImages.primary = this.featuredImage),
              (this.isPreselected = !1)),
            this._setState({
              swatchName: null,
              primaryImage: this.state.primaryImage,
              hideAlternateImage: !0,
            }));
        }
        _handleMouseOver(t) {
          t.target.hasAttribute("data-swatch-tooltip") &&
            this._setState({
              swatchName: this.state.swatchName,
              primaryImage:
                this.swatchImages[t.target.dataset.swatchTooltip] ||
                this.originalImages.primary,
              hideAlternateImage: !0,
            });
        }
        _handleMouseLeave(t) {
          let { target: e } = t;
          e.hasAttribute("data-swatches-container") &&
            this._setState({
              swatchName: this.state.swatchName,
              primaryImage: this.selectedImage || this.originalImages.primary,
              hideAlternateImage: !!this.selectedImage,
            });
        }
        _handleSwatchFocus(t) {
          let { target: e } = t;
          !1 === this.expanded &&
            e.nextElementSibling.classList.contains(
              "productitem--swatches-swatch-hidden"
            ) &&
            this._toggleExpanded();
        }
        _toggleExpanded() {
          const t = this.el.querySelector("[data-swatches]");
          this.expanded
            ? ((this.expanded = !1),
              t.classList.remove("productitem--swatches-expanded"),
              (this.swatchCount.innerText =
                "+" + (this.swatches.length - this.showSwatchCount)))
            : ((this.expanded = !0),
              t.classList.add("productitem--swatches-expanded"));
        }
        getSwatchGap() {
          return (
            null === si &&
              (si = parseInt(
                window
                  .getComputedStyle(this.swatches[0])
                  .getPropertyValue("margin-right"),
                10
              )),
            si
          );
        }
        unload() {
          this.events.unregisterAll();
        }
      }
      class ri {
        constructor(t) {
          (this.el = t.el),
            (this.$el = e()(t.el)),
            (this.id = t.id),
            (this.productQuickshop = null),
            (this.quickshopInitialVariant = null),
            (this.quickBuySettings = null),
            (this.actionsOpen = !1),
            (this.defaultView = t.grid_list),
            (this.events = new St.Z()),
            t.lazy
              ? (this.lazyLoader = new At(this.$el[0], () => this._init()))
              : this._init();
        }
        _init() {
          (this.$window = e()(window)),
            (this.$html = e()("html")),
            (this.content = this.el.querySelector(
              "[data-product-item-content]"
            )),
            (this.actions = this.el.querySelector("[data-product-actions]")),
            (this.swatchesEl = this.el.querySelector("[data-swatches]")),
            (this.quickBuyEl = this.el.querySelector("[data-quick-buy]")),
            (this.quickshopSlimEl = this.el.querySelector(
              "[data-quickshop-slim]"
            )),
            (this.quickshopFullEl = this.el.querySelector(
              "[data-quickshop-full]"
            )),
            (this.hasProductActions = null !== this.actions),
            (this._addToCart = this._addToCart.bind(this)),
            (this._actionsToggle = this._actionsToggle.bind(this)),
            (this._openQuickShop = this._openQuickShop.bind(this)),
            this.hasProductActions &&
              (this._setSortByQueryParameters(),
              this.$html.hasClass("no-touch") &&
                "list-view" !== this.defaultView &&
                (this.events.register(this.el, "mouseenter", (t) =>
                  this._actionsToggle(t)
                ),
                this.events.register(this.el, "mouseleave", (t) =>
                  this._actionsToggle(t)
                ),
                this.events.register(this.el, "focusin", (t) =>
                  this._actionsToggle(t)
                )),
              s()(e()("[data-scripts]").data("shopify-api-url"), () => {
                this.events.register(this.quickBuyEl, "click", (t) =>
                  this._addToCart(t)
                ),
                  this.events.register(this.quickshopSlimEl, "click", (t) =>
                    this._openQuickShop(t)
                  ),
                  this.events.register(this.quickshopFullEl, "click", (t) =>
                    this._openQuickShop(t)
                  );
              })),
            (this.expandAnimation = yt({ el: this.content, state: "closed" })),
            null !== this.quickbuyEl && this._initQuickBuy(),
            this._objectFitPolyfill(),
            this.swatchesEl &&
              (this.swatches = new oi({
                el: this.$el[0],
                setInitialVariant: (t) => {
                  this.quickshopInitialVariant = t;
                },
                product: this.product,
              }));
        }
        _setSortByQueryParameters() {
          if (((Shopify.queryParams = {}), location.search.length))
            for (
              let t = 0, e = location.search.substr(1).split("&");
              t < e.length;
              t++
            ) {
              const i = e[t].split("=");
              i.length > 1 &&
                "page" !== i[0] &&
                (Shopify.queryParams[decodeURIComponent(i[0])] =
                  decodeURIComponent(i[1]));
            }
        }
        _initQuickBuy() {
          try {
            this.quickBuySettings = JSON.parse(
              this.$el.find("[data-quick-buy-settings]").text()
            );
          } catch (t) {}
        }
        _openQuickShop(t) {
          t.preventDefault();
          const e = t.currentTarget.hasAttribute("data-thumbs-left")
              ? " quickshop-thumbs-left"
              : "",
            i = t.currentTarget.hasAttribute("data-quickshop-full")
              ? `quickshop-full${e}`
              : "quickshop-slim";
          this.productQuickshop && this.productQuickshop.unload(),
            (this.productQuickshop = new ni({
              $el: this.$el,
              id: this.id,
              modalClass: i,
              trigger: this.$el.find(".productitem--title a"),
              initialVariant: this.quickshopInitialVariant,
            }));
        }
        _isObjectFitAvailable() {
          return "objectFit" in document.documentElement.style;
        }
        _objectFitPolyfill() {
          if (this._isObjectFitAvailable()) return;
          const t = e()("[data-product-item-image]", this.$el),
            i = e()("img:not(.productitem--image-alternate)", t).attr("src"),
            n = e()(".productitem--image-alternate", t).attr("src");
          t.addClass("product-item-image-no-objectfit"),
            t.css("background-image", `url("${i}")`),
            n &&
              (this.events.register(this.el, "mouseover", () => {
                t.css("background-image", `url("${n}")`);
              }),
              this.events.register(this.el, "mouseleave", () => {
                t.css("background-image", `url("${i}")`);
              }));
        }
        _getHeights() {
          const { height: t } = this.el.getBoundingClientRect();
          return {
            heightBase: t,
            heightExpanded: t + this.actions.getBoundingClientRect().height,
          };
        }
        _actionsToggle(t) {
          if (!Tt.isGreaterThanBreakpoint("M")) return;
          const i = e()(t.currentTarget),
            n = e()(t.target);
          let s = !1;
          const o =
            this.$el.is(i) ||
            this.$el.is(n) ||
            this.$el.is(n.parents(".productgrid--item").first()) ||
            ("focusin" === t.type && n[0].contains(this.$el[0]));
          "mouseenter" === t.type || "mouseleave" === t.type
            ? (s = "mouseenter" === t.type)
            : o && (s = !0),
            s ? this._showActions() : this._hideActions();
        }
        _showActions() {
          if (this.actionsOpen) return;
          const { heightBase: t, heightExpanded: e } = this._getHeights();
          this.el.style.setProperty("--base-height", `${t}px`),
            this.el.style.setProperty("--open-height", `${e}px`),
            this.el.setAttribute("data-open", ""),
            this.expandAnimation.animateTo("open"),
            (this.focusinEvent = this.events.register(
              document,
              "focusin",
              (t) => this._actionsToggle(t)
            )),
            (this.actionsOpen = !0);
        }
        _hideActions() {
          this.expandAnimation.animateTo("closed").then(() => {
            this.el.removeAttribute("data-open");
          }),
            this.focusinEvent && this.events.unregister(this.focusinEvent),
            (this.actionsOpen = !1);
        }
        _addToCart(t) {
          t.preventDefault(),
            this.addToCartFlyout && this.addToCartFlyout.unload();
          const e = t.currentTarget,
            i = [
              { name: "id", value: e.getAttribute("data-variant-id") },
              { name: "quantity", value: 1 },
            ],
            n = {
              atcButton: e,
              settings: {
                moneyFormat: this.quickBuySettings.money_format,
                cartRedirection: this.quickBuySettings.cart_redirection,
              },
            };
          this.addToCartFlyout = new we(i, n);
        }
        unload() {
          this.events.unregisterAll(),
            this.productQuickshop && this.productQuickshop.unload(),
            document.removeEventListener("focusin", this._actionsToggle),
            this.swatches && this.swatches.unload(),
            this.lazyLoader && this.lazyLoader.unload();
        }
      }
      const ai = (t) => {
        t.style.setProperty("--menu-open-height", `${t.scrollHeight}px`);
      };
      class li {
        constructor(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          (this.el = t),
            (this.options = {
              content: "[data-accordion-content]",
              animate: !0,
              onStart: () => {},
              ...e,
            }),
            (this.blocks = new Map());
        }
        closeAll() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.el
            .querySelectorAll(this.options.content)
            .forEach((e) => this.close(e, t));
        }
        openAll() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.el
            .querySelectorAll(this.options.content)
            .forEach((e) => this.open(e, t));
        }
        open(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this._open(t, e);
        }
        close(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this._close(t, e);
        }
        toggle(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const { isOpen: i } = this._getBlock(t);
          i ? this._close(t, e) : this._open(t, e);
        }
        unload() {
          this.blocks.forEach((t) => {
            let { animation: e } = t;
            return e.unload();
          });
        }
        _getBlock(t) {
          const e = t.matches(this.options.content)
            ? t
            : t.querySelector(this.options.content);
          return (
            this.blocks.has(e) ||
              this.blocks.set(
                e,
                ((t) => ({
                  animation: yt({
                    el: t,
                    state: "open",
                    stateAttribute: "data-accordion-state",
                    stateChangeAttribute: "data-accordion-animation",
                  }),
                  isOpen: !0,
                }))(e)
              ),
            this.blocks.get(e)
          );
        }
        _open(t, e) {
          let { onComplete: i = () => {}, force: n = !this.options.animate } =
            e;
          const s = this._getBlock(t);
          s.isOpen ||
            ((s.isOpen = !0),
            this.options.onStart({ el: s.animation.el, state: "open" }),
            s.animation
              .animateTo("open", {
                force: n,
                onStart: (t) => {
                  let { el: e } = t;
                  return ai(e);
                },
              })
              .then((t) => {
                "open" === t && i();
              }));
        }
        _close(t, e) {
          let { onComplete: i = () => {}, force: n = !this.options.animate } =
            e;
          const s = this._getBlock(t);
          s.isOpen &&
            ((s.isOpen = !1),
            this.options.onStart({ el: s.animation.el, state: "closed" }),
            ai(s.animation.el),
            s.animation.animateTo("closed", { force: n }).then((t) => {
              "closed" === t && i();
            }));
        }
      }
      class ci {
        constructor(t, e) {
          (this.el = t),
            (this.filterGroupsSetting = e.groups),
            (this.filterStyleSetting = e.style),
            (this.Accordion = new li(t)),
            this._closeAllGroups(),
            (this.activeMenuClass = "filter-group-active"),
            (this.activeButtonClass = "productgrid--sidebar-button-active"),
            (this.buttonSelector = "[data-filter-group-trigger]"),
            (this.listSelector = "[data-accordion-content]"),
            (this.buttonTriggers = this.el.querySelectorAll(
              this.buttonSelector
            )),
            (this.events = new St.Z()),
            this.buttonTriggers.forEach((t) =>
              this.events.register(t, "click", (t) => this._toggleGroup(t))
            ),
            this._init();
        }
        _init() {
          if (this.el.querySelector(this.listSelector))
            if ("tags" === this.filterStyleSetting && bt.max("S"))
              this._openFirst();
            else
              switch (this.filterGroupsSetting) {
                case "expand_all":
                  this._openAllGroups();
                  break;
                case "expand_first":
                  this._openFirst();
                  break;
                default:
                  this._closeAllGroups();
                  break;
              }
        }
        _openFirst() {
          const t = this.el.querySelector(this.buttonSelector),
            e = t.parentElement.querySelector(this.listSelector);
          this.openGroup(t, e, !0);
        }
        _openAllGroups() {
          this.buttonTriggers.forEach((t) => {
            const e = t.parentElement.querySelector(this.listSelector);
            this.openGroup(t, e, !0);
          });
        }
        _closeAllGroups() {
          this.Accordion.closeAll({ force: !0 });
        }
        _toggleGroup(t) {
          const e = t.target,
            i = e.parentElement.querySelector(this.listSelector);
          i.classList.contains(this.activeMenuClass)
            ? this._closeGroup(e, i)
            : this.openGroup(e, i);
        }
        openGroup(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          e.classList.add(this.activeMenuClass),
            t.classList.add(this.activeButtonClass);
          this.Accordion.open(e, {
            onComplete: () => {
              e.setAttribute("aria-expanded", !0),
                t.setAttribute("aria-expanded", !0);
            },
            force: i,
          });
        }
        _closeGroup(t, e) {
          e.classList.remove(this.activeMenuClass),
            t.classList.remove(this.activeButtonClass);
          this.Accordion.close(e, {
            onComplete: () => {
              e.setAttribute("aria-expanded", !1),
                t.setAttribute("aria-expanded", !1);
            },
          });
        }
        unload() {
          this.events.unregisterAll();
        }
      }
      class hi {
        constructor(t) {
          if (
            ((this.section = t),
            (this.$el = e()(t.el)),
            (this.el = t.el),
            (this.view = null),
            (this.flickity = null),
            (this.handleEvents = new St.Z()),
            (this.subcollectionSlideshow = this.el.querySelector(
              '[data-subcollections-layout="slideshow"]'
            )),
            (this.slides = this.el.querySelectorAll(
              "[data-subcollections-grid-item]"
            )),
            this._shouldInitFlickity(bt)
              ? this._initFlickity()
              : this._destroyFlickity(),
            (this.context = t.data.context),
            (this.showFilterProductCount = t.data.show_filter_product_count),
            (this.productCount = t.data.product_count),
            (this.hash = t.data.hash),
            (this.filterGroups = t.data.filter_groups),
            (this.filterStyle = t.data.filter_style),
            (this.noMatchedProductsText = t.data.no_matched_products_text),
            (this.collectionUrl = this.context.collectionUrl),
            (this.$focusItem = null),
            (this.defaultView = this.context.grid_list),
            (this.postMessage = t.postMessage),
            (this.filterType = t.data.filter_type),
            (this.filtersContentSelector =
              "[data-productgrid-filters-content]"),
            (this.filterGroupSelector = "[data-productgrid-sidebar-group]"),
            (this.sortContent = "[data-productgrid-sort-content]"),
            (this.$sortTrigger = this.$el.find(
              "[data-productgrid-trigger-sort]"
            )),
            (this.$sortTriggerButton = this.$el.find(
              "[data-productgrid-trigger-sort-button]"
            )),
            (this.$sortTriggerModal = this.$el.find(
              "[data-productgrid-modal-sort]"
            )),
            (this.$filtersTrigger = this.$el.find(
              "[data-productgrid-trigger-filters]"
            )),
            (this.$filtersContent = this.$el.find(this.filtersContentSelector)),
            (this.$allTags = this.$filtersContent.find(
              ".filter-item a:not([data-filter-toggle])"
            )),
            (this.$advancedTags = this.$el.find("[data-tag-advanced] a")),
            (this.$additionalTags = this.$el.find("[data-filter-toggle]")),
            (this.$viewToggle = this.$el.find("[data-collection-view]")),
            (this.$gridContainer = this.$el.find(".productgrid--outer")),
            (this.filterCheckboxes = this.el.querySelectorAll(
              ".filter-icon--checkbox"
            )),
            (this.stickyUtils = this.el.querySelector("[data-sticky-utils]")),
            (this.stickyUtilsIntersectionTarget = this.el.querySelector(
              "[data-utils-intersection-target]"
            )),
            (this.header = document.querySelector("[data-site-header]")),
            (this.stickyHeaderClass = "site-header-sticky"),
            (this._changeSorting = this._changeSorting.bind(this)),
            (this._changeSortingButton = this._changeSortingButton.bind(this)),
            (this._showSortModal = this._showSortModal.bind(this)),
            (this._showFiltersModal = this._showFiltersModal.bind(this)),
            (this._activateTag = this._activateTag.bind(this)),
            (this._advancedTags = this._advancedTags.bind(this)),
            (this._toggleTags = this._toggleTags.bind(this)),
            (this._toggleView = this._toggleView.bind(this)),
            (this._checkListView = this._checkListView.bind(this)),
            (this.events = [
              this.$sortTrigger.on("change.collection", this._changeSorting),
              this.$sortTriggerButton.on(
                "click.collection",
                this._changeSortingButton
              ),
              this.$sortTriggerModal.on(
                "click.collection",
                this._showSortModal
              ),
              this.$filtersTrigger.on(
                "click.collection",
                this._showFiltersModal
              ),
              this.$allTags.on("click.collection", (t) =>
                this._activateTag(t.currentTarget)
              ),
              this.$additionalTags.on("click.collection", this._toggleTags),
              this.$viewToggle.on("click.collection", this._toggleView),
            ]),
            (this.productItems = []),
            (this.fillAnimations = {}),
            (this.checkAnimations = {}),
            this._initAnimations(),
            this._setSortByQueryParameters(),
            this._checkListView(),
            bt.max("S") && this._initProductGridUtils(),
            (this.modal = new Ht()),
            this.$filtersContent.length > 0)
          ) {
            const t = { groups: this.filterGroups, style: this.filterStyle };
            (this.filterGroupAccordions = new ci(this.$filtersContent[0], t)),
              this._initTags();
          }
          (this.handleBreakpointChange = (t) => this.onBreakpointChange(t)),
            bt.onChange(this.handleBreakpointChange);
        }
        _initAnimations() {
          this.filterCheckboxes.forEach((t) => {
            const e = t.dataset.handle,
              i = t.querySelector(".checkmark"),
              n = t.querySelector(".checkmark__check");
            let s = "unchecked";
            "true" === t.closest(".filter-item").dataset.filterActive &&
              (s = "checked");
            const o = yt({ el: i, state: s }),
              r = yt({ el: n, state: s });
            (this.fillAnimations[e] = o), (this.checkAnimations[e] = r);
          });
        }
        onSectionUnload() {
          this._destroyFlickity(),
            bt.offChange(this.handleBreakpointChange),
            this.handleEvents.unregisterAll(),
            this.events.forEach((t) => t.off(".collection")),
            this.modal.unload(),
            Object.keys(this.fillAnimations).forEach((t) => {
              this.fillAnimations[t].unload(), this.checkAnimations[t].unload();
            }),
            this.productItems.forEach((t) => {
              t.unload();
            }),
            this.$filtersContent.length > 0 &&
              this.filterGroupAccordions.unload(),
            this.observer && this.observer.disconnect();
        }
        _initFlickity() {
          if (this.flickity) return;
          this.flickity = new (_t())(this.subcollectionSlideshow, {
            autoPlay: 0,
            accessibility: !0,
            cellAlign: "left",
            cellSelector: "[data-subcollections-grid-item]",
            groupCells: !0,
            contain: !0,
            pageDots: !1,
            arrowShape:
              "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
          });
          const t =
              this.subcollectionSlideshow.querySelector(".flickity-viewport"),
            e = this.subcollectionSlideshow.querySelector(".flickity-slider"),
            i = document.createElement("div");
          i.classList.add("flickity-slider--wrapper"),
            t.appendChild(i),
            i.appendChild(e),
            this.handleEvents.register(
              this.subcollectionSlideshow,
              "rimg:load",
              () => {
                this.flickity && this.flickity.resize();
              }
            );
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
        _initProductItems() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "grid-view";
          this.$el.find("[data-product-item]").each((e, i) => {
            this.productItems.push(
              new ri({ el: i, id: this.section.id, lazy: !0, grid_list: t })
            );
          });
        }
        _shouldInitFlickity(t) {
          return (
            !!(
              (t.max("XXXS") && this.slides.length > 3) ||
              (t.max("M") && this.slides.length >= 5) ||
              (t.min("L") && this.slides.length > 7)
            ) ||
            (!this.subcollectionSlideshow && void 0)
          );
        }
        _showFiltersModal(t) {
          t.preventDefault(),
            (this.$focusItem = e()(t.currentTarget)),
            this.modal.open(this.filtersContentSelector, "productgrid-filters");
        }
        _showSortModal(t) {
          t.preventDefault(),
            (this.$focusItem = e()(t.currentTarget)),
            this.modal.open(this.sortContent, "productgrid-sort");
        }
        _deactivateTags(t) {
          const e = t.closest("[data-filter-group]");
          e.querySelectorAll('[data-filter-active="true"]').forEach((t) => {
            const i = t.dataset.handle;
            (e.querySelector(
              `.filter-item[data-handle='${i}']`
            ).dataset.filterActive = !1),
              this.fillAnimations[i] &&
                this.checkAnimations[i] &&
                (this.fillAnimations[i].animateTo("unchecked"),
                this.checkAnimations[i].animateTo("unchecked"));
          });
        }
        _activateTag(t) {
          event.preventDefault();
          const i = t.getAttribute("href"),
            n = t.closest(".filter-item"),
            s = n.dataset.handle;
          if (n.classList.contains("filter-item--disabled")) return;
          let o = "checked";
          "true" === n.dataset.filterActive && (o = "unchecked"),
            this._deactivateTags(n),
            (n.dataset.filterActive = "checked" === o),
            this.fillAnimations[s] && this.checkAnimations[s]
              ? (this.fillAnimations[s].animateTo(o),
                this.checkAnimations[s].animateTo(o).then(() => {
                  0 === this.$advancedTags.length
                    ? (location.href = i)
                    : this._advancedTags(e()(t));
                }))
              : this._advancedTags(e()(t));
        }
        _advancedTags(t) {
          const i = t.parent().closest("nav").find("[data-filter-group]"),
            n = [];
          i.each((t, i) => {
            const s = i.querySelectorAll('[data-filter-active="true"]');
            s.length && n.push(e()(s).data("handle"));
          }),
            this._updateLocation(n.join("+"));
        }
        _updateLocation(t) {
          this.collectionUrl.indexOf("vendors") > -1
            ? (location.href = `${this.collectionUrl}&constraint=${t}`)
            : (location.href = `${this.collectionUrl}/${t}`);
        }
        _toggleTags(t) {
          t.preventDefault();
          const i = e()(t.currentTarget),
            n = i.parent().siblings("[data-hidden-default]"),
            s = i.data("filter-toggle");
          n.toggleClass("filter-item--hidden", s),
            i
              .data("filter-toggle", !s)
              .text(s ? this.context.see_more : this.context.see_less),
            this.modal.isOpen() && this.modal.position();
        }
        _setSortByQueryParameters() {
          if (((Shopify.queryParams = {}), location.search.length))
            for (
              let t = 0, e = location.search.substr(1).split("&");
              t < e.length;
              t++
            ) {
              const i = e[t].split("=");
              i.length > 1 &&
                "page" !== i[0] &&
                (Shopify.queryParams[decodeURIComponent(i[0])] =
                  decodeURIComponent(i[1]));
            }
        }
        _changeSortingButton(t) {
          const i = "utils-sortby--modal-button--active";
          e()(t.currentTarget)
            .addClass(i)
            .parent()
            .siblings()
            .find(`.${i}`)
            .removeClass(i),
            this._changeSorting(t);
        }
        _changeSorting(t) {
          t.preventDefault();
          const i = e()(t.currentTarget);
          (Shopify.queryParams.sort_by = i.val()),
            (location.search = jQuery
              .param(Shopify.queryParams)
              .replace(/\+/g, "%20"));
        }
        _toggleView(t) {
          const i = e()(t.currentTarget);
          (Shopify.queryParams.grid_list = i.data("collection-view")),
            (location.search = jQuery
              .param(Shopify.queryParams)
              .replace(/\+/g, "%20"));
        }
        _checkListView() {
          const t = Shopify.queryParams.grid_list
            ? Shopify.queryParams.grid_list
            : this.defaultView;
          this.$el.find('[href*="&grid_list"]').attr("href", (e, i) => {
            let n = i;
            if (i.indexOf("?") < 0) {
              const t = i.indexOf("&"),
                e = i.substr(0, t),
                s = i.substr(t + 1);
              n = e.concat("?", s);
            }
            return (n = n.replace("grid_list", `grid_list=${t}`)), n;
          }),
            this.$el.find(".utils-viewtoggle-button").removeClass("active"),
            e()(`[data-collection-view=${t}]`).addClass("active");
          const i = t.replace("-", "");
          this.$gridContainer.addClass(`productgrid-${i}`),
            "listview" === i
              ? this.$gridContainer.removeClass("productgrid-gridview")
              : this.$gridContainer.removeClass("productgrid-listview"),
            (this.view = t),
            this._initProductItems(t);
        }
        _initTags() {
          const t = this.$filtersContent[0].querySelectorAll(
            '[data-filter-active="false"]'
          );
          this.$filtersContent[0]
            .querySelectorAll('[data-filter-active="true"]')
            .forEach((t) => {
              null === t.querySelector(".filter-item--swatch-wrapper") &&
                this._addProductCount(t, !0),
                this._openActiveGroup(t);
            }),
            t.forEach((t) => {
              this._addProductCount(t, !1);
            });
        }
        _addProductCount(t, e) {
          if (
            "faceted" === this.filterType ||
            (!1 === this.showFilterProductCount &&
              "groups" !== this.filterStyle)
          )
            return;
          const i = t.querySelector("[data-filtered-product-count]");
          if (e) i.innerHTML = `(${this.productCount})`;
          else {
            const e = t.querySelector("a");
            let n = e.getAttribute("href");
            (n = n.split("?")[0]),
              dt
                .load(n, "ajax-product-count", { hash: this.hash })
                .then((n) => {
                  let { data: s } = n;
                  const o = s.product_count;
                  if (((i.innerHTML = `(${o})`), 0 === o)) {
                    const i = this.noMatchedProductsText.replace(
                      "*tag*",
                      t.dataset.tagTitle
                    );
                    t.classList.add("filter-item--disabled"),
                      (e.ariaDisabled = !0),
                      (e.title = i);
                  }
                });
          }
        }
        _openActiveGroup(t) {
          const e =
              "tags" === this.filterStyle
                ? this.el.querySelector(this.filtersContentSelector)
                : t
                    .closest(this.filterGroupSelector)
                    .querySelector("[data-filter-group-trigger]"),
            i = t.closest("[data-accordion-content]");
          this.filterGroupAccordions.openGroup(e, i, !0);
          if ("hiddenDefault" in t.dataset) {
            t.parentElement
              .querySelector('[data-filter-toggle="false"]')
              .click();
          }
        }
        _initProductGridUtils() {
          const t = document.querySelector("[data-site-header-main]"),
            e = document.querySelector("body"),
            i = `${t.offsetHeight}px`;
          e.classList.contains(this.stickyHeaderClass)
            ? ((this.stickyUtils.style.top = i),
              (this.stickyUtilsIntersectionTarget.style.top = `-${i}`))
            : ((this.stickyUtils.style.top = "0"),
              (this.stickyUtilsIntersectionTarget.style.top = "0")),
            this._observeHeaders(this.el);
        }
        _observeHeaders() {
          (this.observer = new IntersectionObserver((t, e) => {
            t.forEach((t) => {
              const e = t.boundingClientRect,
                i = t.target.parentElement.querySelector("[data-sticky-utils]"),
                n = t.rootBounds;
              e.bottom < n.top &&
                (this.postMessage(
                  "collection-page:collection-utils-sticky-change",
                  { stuck: !0, target: i }
                ),
                this._handleStickyChange({ stuck: !0, target: i })),
                e.bottom >= n.top &&
                  e.bottom < n.bottom &&
                  (this.postMessage(
                    "collection-page:collection-utils-sticky-change",
                    { stuck: !1, target: i }
                  ),
                  this._handleStickyChange({ stuck: !1, target: i }));
            });
          })),
            this.observer.observe(
              document.querySelector("[data-utils-intersection-target]")
            );
        }
        _fireEvent(t, e) {
          this.postMessage("collection-page:collection-utils-sticky-change", {
            stuck: t,
            target: e,
          });
        }
        _handleStickyChange(t) {
          const { stuck: e, target: i } = t;
          i.classList.toggle("productgrid--utils-box-shadow", e);
        }
        onBreakpointChange(t) {
          this.observer && this.observer.disconnect(),
            t.current.max("S") &&
              ((this.headerTransitionEnd = () => {
                this._initProductGridUtils(),
                  this.header.removeEventListener(
                    "transitionend",
                    this.headerTransitionEnd
                  );
              }),
              this.header.addEventListener(
                "transitionend",
                this.headerTransitionEnd
              )),
            this._shouldInitFlickity(bt)
              ? this._initFlickity()
              : this._destroyFlickity();
        }
      }
      function di(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var ui,
        pi,
        fi,
        gi =
          ((ui = function (t, e) {
            e.__esModule = !0;
            var i = (function () {
              function t() {
                this.events = [];
              }
              return (
                (t.prototype.register = function (t, e, i) {
                  return t && e && i
                    ? (this.events.push({ el: t, event: e, listener: i }),
                      t.addEventListener(e, i),
                      { el: t, event: e, listener: i })
                    : null;
                }),
                (t.prototype.unregister = function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e && i && n
                    ? ((this.events = this.events.filter(function (t) {
                        return e !== t.el || i !== t.event || n !== t.listener;
                      })),
                      e.removeEventListener(i, n),
                      { el: e, event: i, listener: n })
                    : null;
                }),
                (t.prototype.unregisterAll = function () {
                  this.events.forEach(function (t) {
                    var e = t.el,
                      i = t.event,
                      n = t.listener;
                    return e.removeEventListener(i, n);
                  }),
                    (this.events = []);
                }),
                t
              );
            })();
            e.default = i;
          }),
          ui((pi = { exports: {} }), pi.exports),
          pi.exports),
        mi =
          (fi = gi) &&
          fi.__esModule &&
          Object.prototype.hasOwnProperty.call(fi, "default")
            ? fi.default
            : fi,
        vi = "[data-disclosure-list]",
        yi = "[data-disclosure-toggle]",
        bi = "[data-disclosure-input]",
        wi = "[data-disclosure-option]",
        _i = "disclosure-list--visible",
        Si = "disclosure-list--alternate-drop",
        Ci = (function () {
          function t(e) {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this.el = e),
              (this.events = new mi()),
              (this.cache = {}),
              this._cacheSelectors(),
              this._connectOptions(),
              this._connectToggle(),
              this._onFocusOut();
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "_cacheSelectors",
                value: function () {
                  this.cache = {
                    disclosureList: this.el.querySelector(vi),
                    disclosureToggle: this.el.querySelector(yi),
                    disclosureInput: this.el.querySelector(bi),
                    disclosureOptions: this.el.querySelectorAll(wi),
                  };
                },
              },
              {
                key: "_connectToggle",
                value: function () {
                  var t = this;
                  this.events.register(
                    this.cache.disclosureToggle,
                    "click",
                    function (e) {
                      var i =
                        "true" ===
                        e.currentTarget.getAttribute("aria-expanded");
                      e.currentTarget.setAttribute("aria-expanded", !i),
                        t.cache.disclosureList.classList.remove(Si),
                        t.cache.disclosureList.classList.toggle(_i),
                        window.requestAnimationFrame(function () {
                          var e =
                            t.cache.disclosureList.getBoundingClientRect();
                          e.left + e.width + 30 > window.innerWidth &&
                            t.cache.disclosureList.classList.add(Si);
                        });
                    }
                  );
                },
              },
              {
                key: "_connectOptions",
                value: function () {
                  for (
                    var t = this, e = this.cache.disclosureOptions, i = 0;
                    i < e.length;
                    i++
                  ) {
                    var n = e[i];
                    this.events.register(n, "click", function (e) {
                      return t._submitForm(e.currentTarget.dataset.value);
                    });
                  }
                },
              },
              {
                key: "_onFocusOut",
                value: function () {
                  var t = this;
                  this.events.register(
                    this.cache.disclosureToggle,
                    "focusout",
                    function (e) {
                      !t.el.contains(e.relatedTarget) && t._hideList();
                    }
                  ),
                    this.events.register(
                      this.cache.disclosureList,
                      "focusout",
                      function (e) {
                        var i = e.currentTarget.contains(e.relatedTarget);
                        t.cache.disclosureList.classList.contains(_i) &&
                          !i &&
                          t._hideList();
                      }
                    ),
                    this.events.register(this.el, "keyup", function (e) {
                      e.defaultPrevented ||
                        ("Escape" === e.key &&
                          "Esc" === e.key &&
                          (t._hideList(), t.cache.disclosureToggle.focus()));
                    }),
                    this.events.register(document.body, "click", function (e) {
                      var i = t.el.contains(e.target);
                      t.cache.disclosureList.classList.contains(_i) &&
                        !i &&
                        t._hideList();
                    });
                },
              },
              {
                key: "_submitForm",
                value: function (t) {
                  (this.cache.disclosureInput.value = t),
                    this.el.closest("form").submit();
                },
              },
              {
                key: "_hideList",
                value: function () {
                  this.cache.disclosureList.classList.remove(_i),
                    this.cache.disclosureToggle.setAttribute(
                      "aria-expanded",
                      !1
                    );
                },
              },
              {
                key: "unload",
                value: function () {
                  this.events.unregisterAll();
                },
              },
            ]) && di(e.prototype, i),
            n && di(e, n),
            t
          );
        })();
      Element.prototype.matches ||
        (Element.prototype.matches =
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector),
        Element.prototype.closest ||
          (Element.prototype.closest = function (t) {
            var e = this;
            do {
              if (e.matches(t)) return e;
              e = e.parentElement || e.parentNode;
            } while (null !== e && 1 === e.nodeType);
            return null;
          });
      const xi = Ci;
      class ki {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.el = t.el),
            (this.countryDisclosureEl = this.el.querySelector(
              "[data-disclosure-country]"
            )),
            (this.localeDisclosureEl = this.el.querySelector(
              "[data-disclosure-locale]"
            )),
            (this.accordionTrigger = "[data-accordion-trigger]"),
            (this.disclosures = []),
            (this.Accordion = new li(this.el, {
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.parentNode.querySelector(
                  this.accordionTrigger
                ).dataset.accordionTrigger = i;
              },
            })),
            bt.max("M") && this.Accordion.closeAll({ force: !0 }),
            (this.forms = new F(this.$el)),
            this.countryDisclosureEl &&
              this.disclosures.push(new xi(this.countryDisclosureEl)),
            this.localeDisclosureEl &&
              this.disclosures.push(new xi(this.localeDisclosureEl)),
            bt.onChange((t) => this.onBreakpointChange(t)),
            this._bindEvents();
        }
        _bindEvents() {
          this.$el.on("click.footer", this.accordionTrigger, (t) => {
            t.preventDefault(),
              this._toggleAccordion(e()(t.currentTarget).parent()[0]);
          });
        }
        onSectionUnload() {
          this.$el.off(".footer"),
            this.forms.unload(),
            this.disclosures.forEach((t) => t.unload()),
            this.Accordion.unload();
        }
        onSectionBlockSelect(t) {
          t.el.classList.contains("has-accordion") && this._toggleAccordion(t);
        }
        onSectionBlockDeselect(t) {
          t.el.classList.contains("has-accordion") && this._toggleAccordion(t);
        }
        _toggleAccordion(t) {
          bt.min("L") || this.Accordion.toggle(t);
        }
        onBreakpointChange(t) {
          t.current.min("L")
            ? this.Accordion.openAll({ force: !0 })
            : t.previous.min("L") &&
              t.current.max("M") &&
              this.Accordion.closeAll({ force: !0 });
        }
      }
      class Ei {
        constructor(t, e) {
          (this.body = document.querySelector("body")),
            (this.header = document.querySelector("[data-site-header]")),
            (this.menu = this.header.querySelector("[data-site-navigation]")),
            (this.menuToggle = t.menuToggle),
            (this.postMessage = t.postMessage),
            (this.settings = e),
            (this.transitioning = !1),
            (this.lastToggle = Date.now() - 1e3),
            (this.stickyClass = "site-header-sticky"),
            (this.scrolledClass = "site-header-sticky--scrolled"),
            (this.navOpenClass = "site-header-nav--open"),
            (this._toggleStickyHeader = this._toggleStickyHeader.bind(this)),
            (this._toggleMenu = this._toggleMenu.bind(this)),
            this.settings.sticky_header &&
              (this.body.classList.add(this.stickyClass),
              window.requestAnimationFrame(() => {
                window
                  .getComputedStyle(this.header)
                  .position.indexOf("sticky") > -1 &&
                  ((this.observer = new IntersectionObserver((t) =>
                    this._toggleStickyHeader(t)
                  )),
                  this.observer.observe(
                    document.querySelector("[data-header-intersection-target]")
                  ),
                  (this.toggleClick = (t) => {
                    t.preventDefault(),
                      Tt.isGreaterThanBreakpoint("M") && this._toggleMenu();
                  }),
                  this.menuToggle.addEventListener("click", this.toggleClick));
              }));
        }
        closeNavigation() {
          this.transitioning ||
            (this.menuToggle.classList.remove("active"),
            (this.navTransitionOutEvent = () => {
              this.header.classList.remove(this.navOpenClass),
                (this.transitioning = !1),
                this.menu.removeEventListener(
                  "transitionend",
                  this.navTransitionOutEvent
                );
            }),
            this.menu.addEventListener(
              "transitionend",
              this.navTransitionOutEvent
            ),
            (this.transitioning = !0),
            this.menu.setAttribute(
              "style",
              `margin-top: -${this.menu.getBoundingClientRect().height}px;`
            ),
            this.postMessage("nav:close-all"));
        }
        openNavigation() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : () => {};
          this.transitioning ||
          this.header.classList.contains(this.navOpenClass)
            ? t()
            : (this.menuToggle.classList.add("active"),
              (this.navTransitionInEvent = () => {
                (this.transitioning = !1),
                  this.menu.removeEventListener(
                    "transitionend",
                    this.navTransitionInEvent
                  ),
                  t();
              }),
              this.menu.addEventListener(
                "transitionend",
                this.navTransitionInEvent
              ),
              (this.transitioning = !0),
              window.requestAnimationFrame(() => {
                this.header.classList.add(this.navOpenClass),
                  window.requestAnimationFrame(() => {
                    this.menu.setAttribute("style", "margin-top: 0;");
                  });
              }));
        }
        _toggleMenu() {
          this.header.classList.contains(this.navOpenClass)
            ? this.closeNavigation()
            : this.openNavigation();
        }
        _toggleStickyHeader(t) {
          if (Bt.isLocked || !Tt.isGreaterThanBreakpoint("M")) return;
          const e = !t[0].isIntersecting;
          (e && this.header.classList.contains(this.scrolledClass)) ||
            this.lastToggle + 250 > Date.now() ||
            ((this.lastToggle = Date.now()),
            e ? this._shrink() : this._expand());
        }
        _shrink() {
          this.closeNavigation(), this.header.classList.add(this.scrolledClass);
        }
        _expand() {
          this.openNavigation(),
            this.header.classList.remove(this.scrolledClass),
            this.menuToggle.classList.remove("active");
        }
        unload() {
          this.body.classList.remove(this.stickyClass),
            this.body.classList.remove(this.scrolledClass),
            this.observer && this.observer.disconnect(),
            this.menuToggle.removeEventListener("click", this.toggleClick);
        }
      }
      class Ti {
        constructor(t) {
          (this.$el = e()(t)),
            (this.Accordion = new li(t)),
            this.closeAllSubmenus(),
            (this.activeMenuClass = "navmenu-link-parent-active"),
            (this.activeMenu = `.${this.activeMenuClass}`),
            (this.linkClass = "navmenu-link-parent"),
            (this.linkSelector = `.${this.linkClass}`),
            (this.navTrigger = "[data-navmenu-parent]"),
            (this.subMenu = "[data-navmenu-submenu]"),
            (this.buttonClass = "navmenu-button"),
            (this.buttonSelector = `.${this.buttonClass}`),
            this._bindEvents();
        }
        unload() {
          this.$el.off(".mobile-nav"), this.Accordion.unload();
        }
        closeSubMenus(t) {
          e()(t)
            .find(this.activeMenu)
            .each((t, i) => {
              this._closeSubmenu(e()(i));
            });
        }
        closeAllSubmenus() {
          this.Accordion.closeAll({ force: !0 });
        }
        _bindEvents() {
          this.$el.on("mousedown.mobile-nav", ".navmenu-link", (t) => {
            t.preventDefault();
          }),
            this.$el.on(
              "click.mobile-nav",
              `${this.navTrigger} > .navmenu-link-parent`,
              this._linkClicked.bind(this)
            ),
            this.$el.on(
              "click.mobile-nav",
              `${this.navTrigger} > .navmenu-button`,
              (t) => {
                t.preventDefault(), this._toggleSubmenu(t);
              }
            );
        }
        _linkClicked(t) {
          const i = e()(t.currentTarget);
          i.hasClass(this.activeMenuClass) ||
            (t.preventDefault(), this._openSubmenu(i));
        }
        _toggleSubmenu(t) {
          const i = e()(t.currentTarget);
          (i.hasClass(this.linkClass)
            ? i
            : i.siblings(this.linkSelector).first()
          ).hasClass(this.activeMenuClass)
            ? this._closeSubmenu(i)
            : this._openSubmenu(i);
        }
        _openSubmenu(t) {
          const e = t.siblings(this.subMenu).first(),
            i = t.hasClass(this.linkClass)
              ? t
              : t.siblings(this.linkSelector).first(),
            n = t.hasClass(this.buttonClass)
              ? t
              : t.siblings(this.buttonSelector).first();
          i.addClass(this.activeMenuClass);
          this.Accordion.open(e[0], {
            onComplete: () => {
              i.attr("aria-expanded", !0), n.attr("aria-expanded", !0);
            },
          });
        }
        _closeSubmenu(t) {
          const e = t.siblings(this.subMenu).first(),
            i = t.hasClass(this.linkClass)
              ? t
              : t.siblings(this.linkSelector).first(),
            n = t.hasClass(this.buttonClass)
              ? t
              : t.siblings(this.buttonSelector).first();
          i.removeClass(this.activeMenuClass);
          this.Accordion.close(e[0], {
            onComplete: () => {
              i.attr("aria-expanded", !1), n.attr("aria-expanded", !1);
            },
          }),
            this.closeSubMenus(e);
        }
      }
      class Ai {
        constructor(t) {
          (this.el = t.el),
            (this.toggleOpen = t.toggleOpen),
            (this.mobileNav = this.el.querySelector("[data-mobile-nav]")),
            (this.navPanel = this.el.querySelector("[data-mobile-nav-panel]")),
            (this.navOverlay = this.el.querySelector(
              "[data-mobile-nav-overlay]"
            )),
            (this.toggleClose = this.el.querySelector(
              "[data-mobile-nav-close]"
            )),
            (this.isOpen = !1),
            (this.subMenus = null),
            (this.events = new St.Z()),
            (this.breakpointHandler = this.onBreakpointChange.bind(this)),
            bt.onChange(this.breakpointHandler),
            (this.navPanelAnimation = yt({
              el: this.navPanel,
              state: "closed",
            })),
            (this.navOverlayAnimation = yt({
              el: this.navOverlay,
              state: "closed",
            })),
            this.events.register(this.toggleOpen, "click", (t) =>
              this._open(t)
            );
        }
        unload() {
          this.events.unregisterAll(),
            bt.offChange(this.breakpointHandler),
            Bt.unlock();
        }
        onBreakpointChange() {
          bt.min("L") && this.isOpen && this._close();
        }
        _open(t) {
          t.preventDefault(),
            bt.min("L") ||
              (Bt.lock(this.navPanel),
              (this.isOpen = !0),
              (this.subMenus = new Ti(this.navPanel)),
              (this.mobileNav.dataset.open = "true"),
              this.navPanelAnimation.animateTo("open"),
              this.navOverlayAnimation.animateTo("open"),
              this.mobileNav.focus(),
              $t(this.mobileNav),
              (this.overlayClickEvent = this.events.register(
                this.navOverlay,
                "click",
                (t) => this._close(t)
              )),
              (this.toggleCloseEvent = this.events.register(
                this.toggleClose,
                "click",
                (t) => this._close(t)
              )),
              (this.overlayTouchEvent = this.events.register(
                this.navOverlay,
                "touchmove",
                (t) => t.preventDefault()
              )),
              (this.closeEsc = this.events.register(window, "keydown", (t) => {
                "Escape" === t.key && this._close(t);
              })));
        }
        _close(t) {
          t && t.preventDefault(),
            this.navPanelAnimation.animateTo("closed"),
            this.navOverlayAnimation.animateTo("closed").then(() => {
              (this.mobileNav.dataset.open = "false"),
                Mt(this.mobileNav),
                this.toggleOpen.focus();
            }),
            Bt.unlock(),
            (this.isOpen = !1),
            this.subMenus &&
              (this.subMenus.closeSubMenus(this.navPanel),
              this.subMenus.closeAllSubmenus(),
              this.subMenus.unload()),
            this.events.unregister(this.overlayClickEvent),
            this.events.unregister(this.overlayTouchEvent),
            this.events.unregister(this.toggleCloseEvent),
            this.events.unregister(this.closeEsc);
        }
      }
      const Li = yt({
          el: document.querySelector("[data-site-main-dimmer]"),
          state: "closed",
        }),
        Ii = new Set(),
        Di = "reduceAnimations" in document.body.dataset;
      function Pi(t) {
        Di || Ii.has(t) || (Ii.add(t), Li.animateTo("open"));
      }
      function $i(t) {
        Ii.delete(t), Ii.size || Li.animateTo("closed", { force: Di });
      }
      class Mi {
        constructor(t, e) {
          (this.listitem = t),
            (this.link = null),
            (this.submenu = null),
            (this._isOpen = !1),
            (this.menu = null),
            (this.parentMenu = e.parentMenu),
            (this.closeSiblings = this.parentMenu.closeSiblings),
            (this.details = t.querySelector("[data-navmenu-details]"));
          const { children: i } = this.details;
          for (let t = 0; t < i.length; t++)
            i[t].classList.contains("navmenu-link")
              ? (this.link = i[t])
              : i[t].classList.contains("navmenu-submenu") &&
                (this.submenu = i[t]);
          (this.animation = yt({ el: this.submenu, state: "closed" })),
            (this.open = () => {
              this._open();
            }),
            (this.close = () => {
              this._close();
            }),
            (this.closeEsc = (t) => {
              "Escape" === t.key && (this.link.focus(), this.close());
            }),
            (this.closeTimer = null),
            (this.openTimer = null),
            (this.mouseover = () => {
              clearTimeout(this.closeTimer),
                this.submenu.classList.contains("navmenu-depth-3")
                  ? this.open()
                  : (this.openTimer = setTimeout(this.open, 200));
            }),
            (this.mouseout = () => {
              clearTimeout(this.openTimer),
                (this.closeTimer = setTimeout(this.close, 400));
            }),
            (this.click = (t) => {
              t.stopPropagation();
              const e = t.target.closest(".navmenu-link-parent");
              if (e && e.dataset.href) {
                if ((t.preventDefault(), this._isOpen))
                  return void (window.location = e.dataset.href);
                this.open();
              }
            }),
            (this.focusin = (t) => {
              t.stopPropagation(),
                t.target.classList.contains("navmenu-link-parent") &&
                  this.closeSiblings(this);
            }),
            (this.touchend = (t) => {
              t.target.focus(), this.click(t);
            }),
            this.listitem.addEventListener("mouseover", this.mouseover),
            this.listitem.addEventListener("mouseout", this.mouseout),
            this.details.addEventListener("touchend", this.touchend),
            this.details.addEventListener("click", this.click),
            this.listitem.addEventListener("focusin", this.focusin),
            document.body.addEventListener("click", this.close),
            document.body.addEventListener("focusin", this.close);
        }
        get isOpen() {
          return this._isOpen;
        }
        forceOpen() {
          return this._open(!0);
        }
        forceClose() {
          return this._close(!0);
        }
        _open() {
          this._isOpen ||
            ((this._isOpen = !0),
            this.details.setAttribute("open", "open"),
            Pi(this),
            this.closeSiblings(this),
            window.addEventListener("keydown", this.closeEsc),
            this.menu || (this.menu = new qi(this.submenu)),
            this.animation
              .animateTo("open", {
                hold: !0,
                onStart: (t) => {
                  let { el: e } = t,
                    i = 0;
                  for (let t = 0; t < e.children.length; t++)
                    i += e.children[t].offsetHeight;
                  this.listitem.style.setProperty(
                    "--menu-open-height",
                    `${i}px`
                  );
                  this.submenu.getBoundingClientRect().right >
                    document.documentElement.clientWidth &&
                    this.listitem.classList.add("alternate-drop");
                },
              })
              .then((t) => {
                "open" === t && this.link.setAttribute("aria-expanded", !0);
              }));
        }
        _close() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          this._isOpen &&
            (this.menu && (this.menu.unload(), (this.menu = null)),
            (this._isOpen = !1),
            window.removeEventListener("keydown", this.closeEsc),
            $i(this),
            this.listitem.classList.remove("navmenu-item--preselected"),
            this.animation.animateTo("closed", { force: t }).then((t) => {
              "closed" === t &&
                (this.listitem.classList.remove("alternate-drop"),
                this.link.setAttribute("aria-expanded", !1),
                this.parentMenu.openSelectedBlock(),
                this.details.removeAttribute("open"));
            }));
        }
        unload() {
          this.forceClose(),
            this.listitem.removeEventListener("mouseover", this.mouseover),
            this.listitem.removeEventListener("mouseout", this.mouseout),
            this.listitem.removeEventListener("touchend", this.touchend),
            this.listitem.removeEventListener("click", this.click),
            this.listitem.removeEventListener("focusin", this.focusin),
            window.removeEventListener("keydown", this.closeEsc),
            document.body.removeEventListener("click", this.bodyClose),
            document.body.removeEventListener("focusin", this.focusInClose),
            this.animation.unload();
        }
      }
      class Oi extends Mi {
        constructor(t, e) {
          super(t, e),
            (this.enableSubmenu =
              "meganav-sidenav" === this.listitem.dataset.navmenuMeganavType);
        }
        get content() {
          return this.submenu.querySelector(".navmenu-meganav-wrapper");
        }
        get openHeight() {
          return this._openHeight;
        }
        get blockId() {
          return this.submenu.dataset.meganavId;
        }
        mouseout() {
          this.parentMenu.shouldBlockClose(this) &&
            (this.timer = setTimeout(this.close, 400));
        }
        _open() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (this._isOpen) return;
          (this._isOpen = !0),
            this.details.setAttribute("open", "open"),
            window.addEventListener("keydown", this.closeEsc),
            this.enableSubmenu &&
              !this.menu &&
              ((this.menu = new qi(
                this.listitem.querySelector("[data-navmenu]")
              )),
              this.menu.preselectFirstItem());
          new Promise((t) => {
            const { openMeganav: e } = this.parentMenu;
            if (e) {
              this.listitem.style.setProperty(
                "--menu-closed-height",
                `${e.openHeight}px`
              );
              const i = e.content.cloneNode(!0),
                { width: n, left: s } = e.content.getBoundingClientRect();
              i.classList.add("meganav-ghost"),
                (i.style.left = `${s}px`),
                (i.style.width = `${n}px`),
                this.submenu.appendChild(i),
                Pi(this),
                this.animation
                  .animateTo("ghost", { force: !0 })
                  .then(() => this.parentMenu.openMeganav.forceClose())
                  .then(t);
            } else
              this.listitem.style.setProperty("--menu-closed-height", 0),
                Pi(this),
                t();
          })
            .then(() => this.closeSiblings(this))
            .then(() =>
              this.animation.animateTo("open", {
                force: t,
                hold: !t,
                onStart: (t) => {
                  let { el: e } = t;
                  const i = e.querySelector(".navmenu-meganav-wrapper"),
                    n = parseInt(window.getComputedStyle(i).maxHeight, 10),
                    s = isFinite(n)
                      ? Math.min(i.scrollHeight, n)
                      : i.scrollHeight;
                  this.listitem.style.setProperty(
                    "--menu-open-height",
                    `${s}px`
                  ),
                    (this._openHeight = s);
                },
              })
            )
            .then(() => {
              this.link.setAttribute("aria-expanded", !0),
                (this.parentMenu.openMeganav = this),
                this.submenu.querySelectorAll(".meganav-ghost").forEach((t) => {
                  t.parentNode.removeChild(t);
                });
            });
        }
        _close() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return (
            this.menu && (this.menu.unload(), (this.menu = null)),
            this.parentMenu.openMeganav === this &&
              (this.parentMenu.openMeganav = null),
            (this._isOpen = !1),
            window.removeEventListener("keydown", this.closeEsc),
            this.listitem.style.setProperty("--menu-closed-height", 0),
            $i(this),
            this.animation.animateTo("closed", { force: t }).then(() => {
              this.link.setAttribute("aria-expanded", !1),
                this.parentMenu.openSelectedBlock();
            })
          );
        }
      }
      class qi {
        constructor(t) {
          let { children: e } = t;
          (this.parents = []),
            (this.children = e),
            (this._openMeganav = null),
            (this._selectedBlock = null),
            (this._megaNavs = null),
            (this.closeSiblings = (t) => {
              this.parents.forEach((e) => {
                e !== t && e.close();
              });
            });
          for (let t = 0; t < this.children.length; t++) {
            const e = this.children[t];
            void 0 !== e.dataset.navmenuMeganavTrigger
              ? this.parents.push(new Oi(e, { parentMenu: this }))
              : void 0 !== e.dataset.navmenuParent
              ? this.parents.push(new Mi(e, { parentMenu: this }))
              : e.classList.contains("navmenu-item") &&
                e.addEventListener("focusin", this.closeSiblings);
          }
        }
        get openMeganav() {
          return this._openMeganav;
        }
        set openMeganav(t) {
          this._openMeganav = t;
        }
        selectBlock(t) {
          this._megaNavs ||
            ((this._megaNavs = {}),
            this.parents
              .filter((t) => t instanceof Oi)
              .forEach((t) => {
                this._megaNavs[t.blockId] = t;
              }));
          const e = this._megaNavs[t];
          this._selectedBlock !== e &&
            (this._selectedBlock && this._selectedBlock.close(),
            (this._selectedBlock = this._megaNavs[t]),
            this._selectedBlock.forceOpen());
        }
        openSelectedBlock() {
          this._selectedBlock &&
            0 === this.parents.filter((t) => t.isOpen).length &&
            this._selectedBlock.open();
        }
        shouldBlockClose(t) {
          return (
            t !== this._selectedBlock ||
            1 !== this.parents.filter((t) => t.isOpen).length
          );
        }
        preselectFirstItem() {
          const t = this.parents[0];
          t &&
            t.listitem === this.children[0] &&
            (t.listitem.classList.add("navmenu-item--preselected"), t.open());
        }
        closeAllMenus() {
          (this._selectedBlock = null), this.parents.forEach((t) => t.close());
        }
        unload() {
          this.parents.forEach((t) => {
            t.unload();
          });
          for (let t = 0; t < this.children.length; t++)
            this.children[t].removeEventListener("focusin", this.closeSiblings);
        }
      }
      var Fi = i(387),
        Bi = i.n(Fi);
      class Ni extends Bi() {
        constructor() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          super(),
            (this.searchType = t.type || ""),
            (this.view = t.view || "json"),
            (this.inProgress = !1),
            (this.xhr = window.XMLHttpRequest
              ? new XMLHttpRequest()
              : new ActiveXObject("Microsoft.XMLHTTP")),
            (this._xhrLoad = this._xhrLoad.bind(this)),
            (this._xhrError = this._xhrError.bind(this)),
            (this._xhrAbort = this._xhrAbort.bind(this)),
            this._bindEvents();
        }
        _bindEvents() {
          this.xhr.addEventListener("load", this._xhrLoad),
            this.xhr.addEventListener("error", this._xhrError),
            this.xhr.addEventListener("abort", this._xhrAbort);
        }
        _xhrLoad(t) {
          let e = {};
          const { readyState: i, status: n } = t.target;
          try {
            if (!(i > 3 && 200 === n)) {
              const e = `Invalid readyState: ${i}, or status: ${n}.`;
              return void this._xhrError(t, e);
            }
            {
              e = t.target.responseText;
              const i = JSON.parse(e);
              this.emit("complete", i);
            }
          } catch (e) {
            return void this._xhrError(t, "Invalid JSON", e);
          }
          this.inProgress = !1;
        }
        _xhrError(t) {
          let e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : null,
            i =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : null;
          (this.inProgress = !1),
            this.emit("error", { event: t, message: e, error: i });
        }
        _xhrAbort() {
          this.emit("aborted");
        }
        execute(t) {
          this.emit("initialized", { term: t }),
            this.inProgress && (this.emit("cancelled"), this.xhr.abort()),
            (this.inProgress = !0);
          const e = window.Theme.routes.search_url,
            i = { q: t, type: this.searchType, view: this.view },
            n = Object.keys(i)
              .map((t) => {
                const e = i[t];
                return `${encodeURIComponent(t)}=${encodeURIComponent(e)}`;
              })
              .join("&");
          this.xhr.open("get", `${e}?${n}`),
            this.xhr.setRequestHeader("Accept", "application/json"),
            this.xhr.send();
        }
      }
      class Ri {
        constructor(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (
            ((this.container = t),
            (this.form = this.container.querySelector(
              "[data-live-search-form]"
            )),
            (this.filter = this.container.querySelector(
              "[data-live-search-filter]"
            )),
            (this.isLiveSearch = !!e.liveSearch && e.liveSearch),
            (this.setCategory = e.setCategory || (() => {})),
            (this.events = new St.Z()),
            this.events.register(this.form, "submit", (t) =>
              this.submitHandler(t)
            ),
            this.filter)
          ) {
            (this.filterLabel = this.container.querySelector(
              "[data-live-search-filter-label]"
            )),
              this.filterLabel &&
                (this.setCategory(this.filterLabel.value),
                this.events.register(this.filter, "change", (t) => {
                  const { value: e } = t.target;
                  if (e) {
                    const t = (function (t) {
                      return t.replace(
                        /(tag|product_type):(searchfilter_)?/,
                        ""
                      );
                    })(e);
                    (this.filterLabel.innerHTML = t),
                      this.setCategory(t),
                      this.form.classList.add("live-search-filter-active");
                  } else
                    (this.filterLabel.innerHTML = t.target.dataset.filterAll),
                      this.form.classList.remove("live-search-filter-active"),
                      this.setCategory("");
                }));
            const t = () => {
              Tt.isLessThanBreakpoint("S") &&
                ((this.filter.value = ""),
                this.form.classList.remove("live-search-filter-active"),
                this.filterLabel &&
                  (this.filterLabel.innerHTML = this.filter.dataset.filterAll));
            };
            t(), Tt.onBreakpointChange(() => t());
          }
        }
        unload() {
          this.events.unregisterAll();
        }
        submitHandler(t) {
          t.preventDefault();
          const e = t.currentTarget.cloneNode(!0),
            i = e.querySelector("[name=q]");
          (e.style.position = "absolute"),
            (e.style.left = "-1000px"),
            (e.style.bottom = "-1000px"),
            (e.style.visibility = "hidden");
          let n = i.value;
          (this.isLiveSearch && !n) ||
            (n.indexOf(" ") > 0 && (n = n.split(" ").join("* ").trim()),
            (n = `${n}*`),
            (n =
              this.filter && this.filter.value
                ? `${n} ${this.filter.value}`
                : n),
            (i.value = n),
            window.document.body.appendChild(e),
            e.submit());
        }
      }
      function Hi(t) {
        return `\n    <h5 class="search-flydown--content-title">\n      ${t.content_results.title}\n    </h5>\n  `;
      }
      class zi {
        constructor(t, i) {
          (this.$el = e()(t.el)),
            (this.$header = e()(t.header)),
            (this.closeEvents = new St.Z()),
            (this.closeEventRequestors = new Set()),
            (this.settings = i),
            (this.enableContent = this.settings.enable_content),
            (this.enableImages = this.settings.enable_images),
            (this.mobileSearchBar = this.settings.show_mobile_search_bar),
            (this.searchType = this.enableContent
              ? "article,page,product"
              : "product"),
            (this.category = "");
          const n = this.$el.find("[data-live-search-form]");
          (this.$input = n.find("[data-live-search-input]")),
            (this.$button = n.find("[data-live-search-submit]")),
            (this.$takeOverButton = n.find(
              "[data-live-search-takeover-cancel]"
            )),
            (this.$filter = this.$el.find("[data-live-search-filter]")),
            (this.$flyDown = this.$el.find("[data-live-search-flydown]")),
            (this.$searchResults = this.$flyDown.find(
              "[data-live-search-results]"
            )),
            (this.$searchPlaceholder = this.$flyDown.find(
              "[data-live-search-placeholder]"
            )),
            (this.$quickLinks = this.$flyDown.find(
              "[data-live-search-quick-links]"
            )),
            (this._onClose = () => {}),
            (this.disableAnimations =
              "reduceAnimations" in document.body.dataset),
            (this.animationFlyDown = yt({
              el: this.$flyDown.get(0),
              state: "closed",
            })),
            (this.animationSearchResults = yt({
              el: this.$searchResults.get(0),
              state: "closed",
            })),
            (this.animationTakeover = yt({ el: this.$el[0], state: "closed" })),
            this.$quickLinks.length &&
              (this.animationQuickLinks = yt({
                el: this.$quickLinks.get(0),
                state: "closed",
              })),
            (this.staticSearch = new Ri(this.$el[0], {
              liveSearch: !0,
              setCategory: (t) => {
                this.category = t;
              },
            })),
            (this.search = new Ni({ view: "header", type: this.searchType })),
            (this._search = this._search.bind(this)),
            (this._documentFocus = this._documentFocus.bind(this)),
            (this._searchCancelled = this._searchCancelled.bind(this)),
            (this._searchComplete = this._searchComplete.bind(this)),
            (this._searchError = this._searchError.bind(this)),
            this.search.on("cancelled", this._searchCancelled),
            this.search.on("complete", this._searchComplete),
            this.search.on("error", this._searchError),
            (this._closeEsc = (t) => {
              "Escape" === t.key &&
                (t.stopPropagation(),
                this.$input.focus(),
                this._closeFlyDown(!0),
                this._closeTakeOver());
            }),
            (this.events = [
              this.$input.on("keyup.live-search", z()(this._search, 250)),
              this.$input.on("focus.live-search", (t) => {
                t.stopPropagation(), this._onSearchFocus();
              }),
              this.$takeOverButton.on("click.live-search", (t) => {
                t.preventDefault(),
                  this._closeFlyDown(!0),
                  this._closeTakeOver();
              }),
              this.$filter.on("change.live-search", (t) => {
                this.$input.val().length > 0 && this._search(t);
              }),
            ]);
        }
        open() {
          Tt.isLessThanBreakpoint("S") && this._openTakeOver(),
            this._openFlyDown(),
            this.$input.focus();
        }
        set onClose(t) {
          this._onClose = t;
        }
        unload() {
          this.events.forEach((t) => t.off(".live-search")),
            this.closeEvents.unregisterAll(),
            this.closeEventRequestors.clear(),
            this.search.off("cancelled", this._searchCancelled),
            this.search.off("complete", this._searchComplete),
            this.search.off("error", this._searchError),
            this.settings.use_dimmer && $i(this),
            this.staticSearch.unload(),
            Bt.unlock();
        }
        get _terms() {
          return this.$input.val();
        }
        get _hasTerms() {
          return this._terms.length > 0;
        }
        _onSearchFocus() {
          if (
            (this.$el.addClass("live-search--focused"),
            Tt.isLessThanBreakpoint("S"))
          ) {
            if (!this._hasTerms) return;
            this._openTakeOver();
          }
          this._openFlyDown();
        }
        _search(t) {
          if (
            t.key &&
            -1 !==
              [
                "Alt",
                "ArrowRight",
                "ArrowLeft",
                "ArrowUp",
                "ArrowDown",
                "Capslock",
                "Control",
                "Escape",
                "Meta",
                "Shift",
                "Tab",
                "Enter",
              ].indexOf(t.key)
          )
            return;
          let e = this._terms;
          if (
            (Tt.isLessThanBreakpoint("S") && this._openTakeOver(),
            this._toggleButton(this._hasTerms),
            this._hasTerms)
          ) {
            this.$searchResults.html(""),
              this._openFlyDown(!0),
              e.indexOf(" ") > 0 && (e = e.split(" ").join("* ").trim()),
              (e = `${e}*`);
            const t = this.$filter[0];
            (e = t && t.value ? `${e} ${t.value}` : e), this.search.execute(e);
          } else
            this.$quickLinks.length
              ? this._openFlyDown()
              : this._closeFlyDown(!0);
        }
        _searchError(t) {
          this._toggleButton(!1);
        }
        _searchCancelled() {}
        _searchComplete(t) {
          let { content: e, products: i } = t;
          const { terms: n, sanitizedTerms: s } = t;
          (e = e.slice(0, 7)), (i = i.slice(0, 7));
          const { enable_images: o, context: r } = this.settings,
            a = {
              products: {
                results: { products: i, enableImages: o },
                noResults: { context: r, terms: s, category: this.category },
              },
              content: {
                results: { context: r, content: e },
                noResults: { context: r },
              },
              footer: { context: r, terms: n, type: this.searchType },
            },
            l = i.length
              ? (function (t) {
                  const { products: e, enableImages: i } = t,
                    n = e.map((t) =>
                      (function (t, e) {
                        const i = e
                            ? `\n    <div class="search-flydown--product-image">\n      ${t.image}\n    </div>\n  `
                            : "",
                          n = (function (t) {
                            const e = (function (t) {
                                const {
                                    price: e,
                                    onSale: i,
                                    consistentSaved: n,
                                  } = t,
                                  s =
                                    i && n
                                      ? (function (t) {
                                          return `\n  <span class="search-flydown--product-price--compare-at">\n    <span class="money">${t.compare_at_price}</span>\n  </span>\n  `;
                                        })(e)
                                      : "",
                                  o = (function (t) {
                                    return `\n  <span class="search-flydown--product-price--main">\n    <span class="money">${t.price}</span>\n  </span>\n  `;
                                  })(e);
                                return `\n    <span class="search-flydown--product-price ${
                                  i
                                    ? "search-flydown--product-price-has-sale"
                                    : ""
                                }">\n      ${o}\n      ${s}\n    </span>\n  `;
                              })({
                                price: t.price,
                                onSale: t.on_sale,
                                consistentSaved: t.consistent_saved,
                              }),
                              i = t.swatch_count
                                ? `<span class="search-flydown--product-swatch-count">${t.swatch_count}</span>`
                                : "";
                            return `\n    <div class="search-flydown--product-text">\n      <span class="search-flydown--product-title">\n        ${t.title}\n      </span>\n      ${e}\n      ${i}\n    </div>\n  `;
                          })(t);
                        return `\n    <a class="search-flydown--product search-flydown--product" href="${t.url}">\n      ${i}\n      ${n}\n    </a>\n  `;
                      })(t, i)
                    );
                  return $(
                    `\n    <div class="search-flydown--product-items">\n      ${n.join(
                      ""
                    )}\n    </div>\n  `
                  );
                })(a.products.results)
              : (function (t) {
                  const { context: e, terms: i, category: n } = t;
                  let s = e.no_results_products.title.replace("*terms*", i);
                  return (
                    n &&
                      (s = e.no_results_products.title_in_category
                        .replace("*terms*", i)
                        .replace("*category*", n)),
                    $(
                      `\n    <div class="search-flydown--product-items--none" data-live-search-no-products>\n      <h5>\n        ${s}\n      </h5>\n      <p>\n        ${e.no_results_products.message}\n      </p>\n      <p>\n        <a class="search-flydown--continue" href="${window.Theme.routes.all_products_collection_url}">\n          ${e.view_all_products}\n        </a>\n      </p>\n    </div>\n  `
                    )
                  );
                })(a.products.noResults),
            c = e.length
              ? (function (t) {
                  const { content: e, context: i } = t,
                    n = Hi(i),
                    s = e.map((t) =>
                      (function (t) {
                        return `\n  <li class="search-flydown--content-item">\n    <a href="${t.url}">${t.title}</a>\n  </li>\n  `;
                      })(t)
                    );
                  return $(
                    `\n    <div class="search-flydown--content-items">\n      ${n}\n\n      <ul class="search-flydown--content-items-list">\n        ${s.join(
                      ""
                    )}\n      </ul>\n    </div>\n  `
                  );
                })(a.content.results)
              : (function (t) {
                  const { context: e } = t,
                    i = Hi(e);
                  return $(
                    `\n    <div class="search-flydown--content-items">\n      ${i}\n\n      <p class="search-flydown--content-items-none">\n        ${e.content_results.no_results}\n      </p>\n    </div>\n  `
                  );
                })(a.content.noResults);
          l.find(".money").each((t, e) => {
            e.innerHTML = Shopify.formatMoney(
              e.innerHTML,
              this.settings.money_format
            );
          }),
            this.$searchResults.html(l),
            this.enableContent && this.$searchResults.append(c),
            this.$searchResults.append(
              (function (t) {
                const { context: e, terms: i, type: n } = t;
                return $(
                  `\n    <div class="search-flydown--footer">\n      <a class="search-flydown--continue" href="${window.Theme.routes.search_url}?q=${i}&type=${n}">\n        ${e.view_all_results}\n      </a>\n    </div>\n  `
                );
              })(a.footer)
            ),
            this._openFlyDown(),
            this._toggleButton(!1);
        }
        _toggleButton(t) {
          t
            ? this.$button.addClass("search-icon--processing").attr("disabled")
            : this.$button
                .removeClass("search-icon--processing")
                .removeAttr("disabled");
        }
        _shouldOpenFlyDown() {
          if (arguments.length > 0 && void 0 !== arguments[0] && arguments[0])
            return !0;
          const t = this.$input.val().length > 0,
            e =
              this.$searchResults.find("[data-live-search-no-products]")
                .length > 0,
            i = this.$searchResults.children().length > 0,
            n = this.$quickLinks.length;
          return (t && (i || e)) || (!t && n);
        }
        _registerCloseEvents(t) {
          0 === this.closeEventRequestors.size &&
            (this.closeEvents.register(window, "keydown", this._closeEsc),
            this.closeEvents.register(document, "focusin", this._documentFocus),
            this.closeEvents.register(
              document,
              "touchstart",
              this._documentFocus
            ),
            this.closeEvents.register(document, "click", this._documentFocus)),
            this.closeEventRequestors.add(t);
        }
        _unregisterCloseEvents(t) {
          this.closeEventRequestors.delete(t),
            this.closeEventRequestors.size ||
              (this.closeEvents.unregisterAll(), this._onClose());
        }
        _openFlyDown() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (!this._shouldOpenFlyDown(t)) return;
          const e = (t) => {
            let { el: e } = t;
            const i = e.querySelector(":scope > .visible"),
              n = i ? i.scrollHeight : 0;
            e.style.setProperty("--open-height", `${n}px`);
          };
          this._updateFlyDown(t),
            this.$flyDown.data("is-open")
              ? e({ el: this.$flyDown.get(0) })
              : (this._registerCloseEvents("flydown"),
                this.settings.use_dimmer && Pi(this),
                this.$flyDown.data("is-open", !0),
                this.animationFlyDown
                  .animateTo("open", {
                    force: this.disableAnimations,
                    onStart: e,
                  })
                  .then(() => this.$el.addClass("live-search--active")));
        }
        _updateFlyDown() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          const e = this.$input.val().length > 0,
            i =
              this.$searchResults.find("[data-live-search-no-products]")
                .length > 0,
            n = this.$searchResults.children().length > 0,
            s = this.$quickLinks.length;
          t
            ? (this.$searchResults.removeClass("visible"),
              this.$quickLinks.removeClass("visible"),
              this.$searchPlaceholder.addClass("visible"),
              this.animationQuickLinks &&
                this.animationQuickLinks.animateTo("hidden", {
                  force: this.disableAnimations,
                }),
              this.animationSearchResults.animateTo("hidden", {
                force: this.disableAnimations,
              }))
            : e && (i || n)
            ? (this.$searchPlaceholder.removeClass("visible"),
              this.$quickLinks.removeClass("visible"),
              this.$searchResults.addClass("visible"),
              this.animationQuickLinks &&
                this.animationQuickLinks.animateTo("hidden", {
                  force: this.disableAnimations,
                }),
              this.animationSearchResults.animateTo("visible", {
                force: this.disableAnimations,
              }))
            : s &&
              (this.$searchPlaceholder.removeClass("visible"),
              this.$searchResults.removeClass("visible"),
              this.$quickLinks.addClass("visible"),
              this.animationSearchResults.animateTo("hidden", {
                force: this.disableAnimations,
              }),
              this.animationQuickLinks.animateTo("visible", {
                force: this.disableAnimations,
              }));
        }
        _closeFlyDown() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          this.$flyDown.data("is-open") &&
            (this._unregisterCloseEvents("flydown"),
            $i(this),
            this.$flyDown.data("is-open", !1),
            this.$searchPlaceholder.removeClass("visible"),
            this.$quickLinks.removeClass("visible"),
            this.$searchResults.removeClass("visible"),
            this.animationQuickLinks &&
              this.animationQuickLinks.animateTo("closed", {
                force: this.disableAnimations,
              }),
            this.animationSearchResults.animateTo("closed", {
              force: this.disableAnimations,
            }),
            this.animationFlyDown
              .animateTo("closed", {
                force: this.disableAnimations,
                onStart: (t) => {
                  let { el: e } = t;
                  return e.style.setProperty("--open-height", "0");
                },
              })
              .then(() => {
                this.$el.removeClass("live-search--active"),
                  t || this.$el.removeClass("live-search--focused");
              }));
        }
        _openTakeOver() {
          if ("open" !== this.animationTakeover.state)
            if (
              (this.$header.hasClass("search--section") &&
                document.body.classList.add("search-takeover-active"),
              Bt.lock(this.$el[0]),
              this.$el.addClass("live-search--takeover"),
              this._registerCloseEvents("takeover"),
              this.settings.use_dimmer && Pi(this),
              this.mobileSearchBar)
            ) {
              const t = this.$el[0],
                {
                  top: e,
                  right: i,
                  left: n,
                  width: s,
                } = t.getBoundingClientRect();
              t.style.setProperty(
                "--live-search-takeover-initial-top",
                `${e}px`
              ),
                t.style.setProperty(
                  "--live-search-takeover-initial-right",
                  window.innerWidth - i + "px"
                ),
                t.style.setProperty(
                  "--live-search-takeover-initial-left",
                  `${n}px`
                ),
                t.style.setProperty(
                  "--live-search-takeover-initial-width",
                  `${s}px`
                ),
                (t.parentNode.style.height = `${
                  t.parentNode.getBoundingClientRect().height
                }px`),
                this.animationTakeover.animateTo("open", {
                  force: this.disableAnimations,
                });
            } else
              this.animationTakeover.animateTo("open", {
                force: this.disableAnimations,
                hold: !0,
              });
        }
        _closeTakeOver() {
          "closed" !== this.animationTakeover.state &&
            (this._unregisterCloseEvents("takeover"),
            this.settings.use_dimmer && $i(this),
            this.animationTakeover
              .animateTo("closed", { force: this.disableAnimations })
              .then(() => {
                Bt.unlock(),
                  document.body.classList.remove("search-takeover-active"),
                  this.$el.removeClass("live-search--takeover"),
                  this.mobileSearchBar &&
                    (this.$el[0].parentNode.style.height = "");
              }));
        }
        _documentFocus(t) {
          e()(t.target).closest("[data-live-search]").length ||
            (this._closeFlyDown(), this._closeTakeOver());
        }
      }
      class ji {
        constructor(t) {
          (this.el = t.el),
            (this.settings = t.data.settings),
            (this.postMessage = t.postMessage),
            (this.headerSearch = null),
            (this.scripts = document.querySelector("[data-scripts]")),
            (this.menuToggle = this.el.querySelector("[data-menu-toggle]")),
            (this.cartCount = this.el.querySelector(
              "[data-header-cart-count]"
            )),
            (this.searchField = this.el.querySelector("[data-live-search]")),
            (this.siteNavigation = this.el.querySelector(
              "[data-site-navigation]"
            )),
            (this.desktopNavigation =
              this.siteNavigation.querySelector("ul.navmenu-depth-1")),
            (this.headerTools = this.siteNavigation.querySelector(
              "[data-header-actions]"
            )),
            (this.stickyHeader = new Ei(
              {
                header: this.el,
                menuToggle: this.menuToggle,
                postMessage: this.postMessage,
              },
              this.settings
            )),
            (this.navMobile = new Ai({
              el: this.el,
              toggleOpen: this.menuToggle,
            })),
            (this.navDesktop = new qi(
              document.querySelector(".site-navigation > [data-navmenu]")
            )),
            (this.forms = new F(this.el)),
            (this.events = new St.Z()),
            this.settings.live_search.enable
              ? s()(this.scripts.dataset.shopifyApiUrl, () => {
                  if (
                    ((this.headerSearch = new zi(
                      { el: this.searchField, header: this.el },
                      { ...this.settings.live_search, use_dimmer: !0 }
                    )),
                    (this.mobileSearchButtonEl = t.el.querySelector(
                      "[data-mobile-search-button]"
                    )),
                    this.mobileSearchButtonEl)
                  ) {
                    const t = "reduceAnimations" in document.body.dataset;
                    (this.mobileSearchButtonAnimation = yt({
                      el: this.mobileSearchButtonEl,
                      state: "visible",
                    })),
                      this.events.register(
                        this.mobileSearchButtonEl,
                        "click",
                        (e) => {
                          e.stopPropagation(),
                            this.headerSearch.open(),
                            this.mobileSearchButtonAnimation.animateTo(
                              "hidden",
                              { force: t }
                            );
                        }
                      ),
                      (this.headerSearch.onClose = () => {
                        this.mobileSearchButtonAnimation.animateTo("visible", {
                          force: t,
                        }),
                          this.mobileSearchButtonEl.focus();
                      });
                  }
                })
              : (this.headerSearch = new Ri(this.searchField)),
            this.events.register(window, "cartcount:update", (t) => {
              (this.cartCount.dataset.headerCartCount = t.detail.item_count),
                t.detail.item_count > 0
                  ? this.cartCount.classList.add("visible")
                  : this.cartCount.classList.remove("visible");
            });
        }
        onSectionSelect() {
          this.stickyHeader.openNavigation();
        }
        onSectionDeselect() {
          this._closeAllNavigation();
        }
        onSectionUnload() {
          this.stickyHeader.unload(),
            this.navMobile.unload(),
            this.navDesktop.unload(),
            this.forms.unload(),
            this.headerSearch.unload(),
            this.events.unregisterAll();
        }
        onSectionMessage(t, e) {
          "nav:close-all" === t &&
            Tt.isGreaterThanBreakpoint("M") &&
            this._closeAllNavigation(),
            "collection-page:collection-utils-sticky-change" === t &&
              this._handleStickyChange(e);
        }
        onSectionBlockSelect(t) {
          Tt.isGreaterThanBreakpoint("M") &&
            this.stickyHeader.openNavigation(() => {
              this.navDesktop.selectBlock(t.id);
            });
        }
        onSectionBlockDeselect() {
          this._closeAllNavigation();
        }
        _closeAllNavigation() {
          this.navDesktop.closeAllMenus();
        }
        _handleStickyChange(t) {
          if (!this.settings.sticky_header || !this.settings.has_box_shadow)
            return;
          const { stuck: e, target: i } = t;
          this.el.classList.toggle("site-header-wrapper--no-shadow", e);
        }
      }
      class Ui {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.modalForms = null),
            (this.newsletterForm = null),
            (this.modalContents = "[data-passwordentry]"),
            (this.$newsletterForm = this.$el.find(
              "[data-password-newsletter]"
            )),
            (this.modalOpen = this.onModalOpen.bind(this)),
            (this.modalClose = this.onModalClose.bind(this)),
            (this._openModal = this._openModal.bind(this)),
            (this.modal = new Ht({
              onOpen: this.modalOpen,
              onClose: this.modalClose,
            })),
            this.$newsletterForm &&
              (this.newsletterForm = new F(this.$newsletterForm)),
            this._checkForPasswordAttempt(),
            this._bindEvents();
        }
        onSectionUnload() {
          this.$el.off(".static-password"),
            this.newsletterForm && this.newsletterForm.unload(),
            this.modalForms && this.modalForms.unload();
        }
        onModalOpen() {
          const t = e()("[data-passwordentry-contents]");
          this.modalForms = new F(t);
        }
        onModalClose() {
          this.modalForms.unload(), (this.modalForms = null);
        }
        _bindEvents() {
          this.$el.on(
            "click.static-password",
            "[data-passwordentry-toggle]",
            this._openModal
          );
        }
        _openModal() {
          this.modal.open(this.modalContents, "passwordentry");
        }
        _checkForPasswordAttempt() {
          e()("[data-passwordentry-errors]").length && this._openModal();
        }
      }
      class Wi {
        constructor(t) {
          let i =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          (this.section = t),
            (this.$el = e()(this.section.el)),
            (this.context = t.data.context),
            (this.settings = t.data.settings),
            (this.product = t.data.product),
            (this.richText = null),
            (this.readmoreText = null),
            (this.reviewForm = null),
            (this.isThemeEditor = window.Shopify && window.Shopify.designMode),
            (this.useHistory =
              "useHistory" in i
                ? i.useHistory
                : !(this.isThemeEditor || !history.replaceState));
          const n = this.$el.find("[data-product-gallery]")[0],
            o = this.$el.find("[data-product-wrapper]");
          (this.$details = this.$el.find("[data-product-details]")),
            (this.$description = this.$el.find("[data-product-description]")),
            (this.$readmore = this.$el.find("[data-product-readmore]")),
            (this.$formRegular = this.$el.find("[data-product-form-regular]")),
            (this.$formAlt = this.$el.find("[data-product-form-alt]")),
            (this.$formArea = this.$el.find("[data-product-form-area]")),
            (this.layoutHandler = this.onBreakpointChange.bind(this)),
            Tt.onBreakpointChange(this.layoutHandler),
            (this.$productReviews = this.$el.find("[data-product-reviews]")),
            o.hasClass("layout--three-col") && this._moveForm(),
            this.$description.length &&
              (this.richText = new O(this.$description)),
            this.$readmore.length &&
              (this.readmoreText = new O(this.$readmore)),
            this.$productReviews.length &&
              (this.reviewForm = new F(
                this.$productReviews,
                ".spr-form-input"
              )),
            s()(e()("[data-scripts]").data("shopify-api-url"), () => {
              this.productDetails = new ei({
                $formArea: this.$formArea,
                $details: this.$details,
                gallery: n,
                context: this.context,
                settings: this.settings,
                product: this.product,
                useHistory: this.useHistory,
                sectionId: t.id,
                productEl: this.$el[0],
              });
            });
        }
        onSectionUnload() {
          Tt.offBreakpointChange(this.layoutHandler),
            this.productDetails && this.productDetails.unload(),
            this.richText && this.richText.unload(),
            this.readmoreText && this.readmoreText.unload(),
            this.reviewForm && this.reviewForm.unload();
        }
        onBreakpointChange() {
          this.$formAlt.length && this._moveForm();
        }
        _moveForm() {
          if (Tt.isGreaterThanBreakpoint("M")) {
            if (!e().contains(this.$formAlt[0], this.$formArea[0])) {
              const t = this.$formArea.detach();
              this.$formAlt.append(t);
            }
          } else if (!e().contains(this.$formRegular[0], this.$formArea[0])) {
            const t = this.$formArea.detach();
            this.$formRegular.append(t);
          }
        }
      }
      class Vi extends Wi {}
      class Gi {
        constructor(t) {
          (this.$window = $(window)),
            (this.flickity = null),
            (this.productRow = t),
            (this.$productRow = $(this.productRow)),
            (this._mobileSlider = this._mobileSlider.bind(this)),
            Tt.onBreakpointChange(this._mobileSlider),
            this._mobileSlider();
        }
        unload() {
          Tt.offBreakpointChange(this._mobileSlider), this._destroyFlickity();
        }
        _initFlickity() {
          (this.flickity = new (_t())(this.productRow, {
            cellSelector: ".productgrid--item",
            contain: !0,
            freeScroll: !0,
            percentPosition: !1,
            prevNextButtons: !1,
            pageDots: !1,
            setGallerySize: !1,
          })),
            this._bindSlider();
        }
        _destroyFlickity() {
          this.flickity &&
            (this.$window.off(".product-row"),
            this.$productRow.off(".product-row"),
            this.flickity.destroy(),
            (this.flickity = null));
        }
        _mobileSlider() {
          Tt.isGreaterThanBreakpoint("M")
            ? this._destroyFlickity()
            : this.flickity || this._initFlickity();
        }
        _bindSlider() {
          const t = this.$productRow.find(".flickity-slider");
          this.$window.on(
            "resize.product-row",
            z()(() => {
              this.$productRow.trigger("heightUpdate.product-row");
            })
          ),
            this.flickity.on("cellSelect", () => {
              this.$productRow.trigger("heightUpdate.product-row");
            }),
            this.$productRow.on("heightUpdate.product-row", () => {
              this.flickity && t.height(Math.ceil(this.flickity.maxCellHeight));
            }),
            this.$productRow.trigger("heightUpdate.product-row");
        }
      }
      class Xi {
        constructor(t) {
          (this.section = t),
            (this.productId = t.data.productId),
            (this.limit = t.data.settings.limit),
            (this.recommendedProducts = []),
            (this.productsScroller = null),
            (this.sectionId = t.data.sectionId),
            (this.recommendationContainer = document.querySelector(
              "[data-product-recommendations]"
            )),
            (this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}`),
            (this._loadRecommendations = this._loadRecommendations.bind(this)),
            (this._resizeRowScroller = this._resizeRowScroller.bind(this)),
            this._loadRecommendations();
        }
        _loadRecommendations() {
          dt.load(this.recommendUrl, { view: "" }).then((t) => {
            let { html: e } = t;
            (this.recommendationContainer.innerHTML = e),
              x.watch(this.recommendationContainer);
            const i = this.recommendationContainer.querySelectorAll(
                "[data-product-item]"
              ),
              n = Tt.isGreaterThanBreakpoint("L", !0);
            i.length &&
              (i.forEach((t) => {
                this.recommendedProducts.push(
                  new ri({ el: t, id: this.section.id, lazy: n })
                );
              }),
              ii(),
              window.Shopify &&
                Shopify.PaymentButton &&
                Shopify.PaymentButton.init(),
              this.recommendationContainer.addEventListener(
                "rimg:load",
                this._resizeRowScroller
              ),
              (this.productsScroller = new Gi(
                this.section.el.querySelector("[data-product-row]")
              )));
          });
        }
        _resizeRowScroller() {
          this.productsScroller &&
            this.productsScroller.flickity &&
            this.productsScroller.flickity.resize();
        }
        onSectionUnload() {
          this.productsScroller && this.productsScroller.unload(),
            this.recommendedProducts.forEach((t) => {
              t.unload();
            }),
            this.recommendationContainer.removeEventListener(
              "rimg:load",
              this._resizeRowScroller
            );
        }
      }
      class Zi {
        constructor(t) {
          (this.namespace = "pxu"),
            (this.maxRecentlyViewed = 30),
            (this.maxStorageTime = 2592e3),
            (this.version = `${t.data.currency}-${window.Theme.routes.root_url}`),
            (this.storageKey = `${this.namespace}-recentlyViewed-${this.version}`),
            (this.$el = e()(t.el)),
            (this.time = t.data.time),
            (this.flickity = null),
            (this.recentlyViewed = t.data.recently_viewed_info),
            (this.cardSettings = t.data.product_card_settings),
            this.recentlyViewed &&
              this.time &&
              (this.recentlyViewed.timestamp = Math.round(
                new Date().getTime() / 1e3
              )),
            (this.slideImageLoaded = this._onSlideImageLoaded.bind(this));
          let i = [];
          if (this.time) {
            (i = this._getRecentlyViewed()),
              this.recentlyViewed &&
                (this.removeRecentlyViewed(this.recentlyViewed.handle, i),
                i.push(this.recentlyViewed));
            const t = this._setRecentlyViewed(i);
            e()
              .when(...t)
              .done(() => {
                if (i.length) {
                  const t = this._getRecentlyViewedCards(),
                    i = this._getRecentlyViewed();
                  this.$el.find("[data-recently-viewed-container]").append(t),
                    i.forEach((t) => {
                      const i = this.timeSince(t.timestamp);
                      e()(`[data-product-handle=${t.handle}]`).prepend(i);
                    }),
                    x.watch(this.$el[0]),
                    (this.$carousel = this.$el.find(
                      ".product-recently-viewed__content"
                    )),
                    (this.slides = ".product-recently-viewed-card"),
                    this.$carousel.find(this.slides).length > 1 &&
                      this._initSlider();
                } else
                  this.$el
                    .find(".product-recently-viewed--section")
                    .addClass("hide");
              });
          } else
            this.recentlyViewed &&
              (i.push(this.recentlyViewed), this._setRecentlyViewed(i)),
              this.$el
                .find(".product-recently-viewed--section")
                .addClass("hide");
          this.bindEvents();
        }
        bindEvents() {
          this.$el.on("click", "[data-remove-recently-viewed]", (t) => {
            const i = e()(t.currentTarget),
              n = i.closest("[data-product-handle]").data("product-handle"),
              s = this._getRecentlyViewed();
            this.removeRecentlyViewed(n, s),
              this._setRecentlyViewed(s),
              i.parents("[data-recently-viewed-card]").addClass("hide-card"),
              i
                .parents("[data-recently-viewed-card]")
                .nextAll()
                .addClass("move-card"),
              setTimeout(() => {
                let t = i.parents("[data-recently-viewed-card]").index();
                0 !== t && t--,
                  i
                    .parents("[data-recently-viewed-card]")
                    .nextAll()
                    .removeClass("move-card"),
                  i.parents("[data-recently-viewed-card]").length &&
                    this.flickity.remove(
                      i.parents("[data-recently-viewed-card]")
                    ),
                  this.flickity.selectCell(t);
              }, 500);
          }),
            this.$el.on("click", "[data-clear-recently-viewed]", () => {
              this.clearRecentlyViewed();
            });
        }
        timeSince(t) {
          const e = Math.round(new Date().getTime() / 1e3),
            i = e - t,
            { lang: n } = document.documentElement;
          if (i < 60) {
            const t = parseInt(i, 10);
            return 1 === t
              ? `${t} ${this.time.second} ${this.time.ago}`
              : `${t} ${this.time.seconds} ${this.time.ago}`;
          }
          if (i < 3600) {
            const t = parseInt(i / 60, 10);
            return 1 === t
              ? `${t} ${this.time.minute} ${this.time.ago}`
              : `${t} ${this.time.minutes} ${this.time.ago}`;
          }
          if (i <= 86400) {
            const t = parseInt(i / 3600, 10);
            return 1 === t
              ? `${t} ${this.time.hour} ${this.time.ago}`
              : `${t} ${this.time.hours} ${this.time.ago}`;
          }
          const s = new Date(1e3 * t),
            o = new Date(1e3 * e),
            r = s.getDate();
          return `${s.toLocaleDateString(n, { month: "long" })} ${r} ${
            s.getFullYear() === o.getFullYear() ? "" : `, ${s.getFullYear()}`
          }`;
        }
        removeRecentlyViewed(t, e) {
          for (let i = 0; i < e.length; i++)
            e[i].handle === t && e.splice(i, 1);
          this._setRecentlyViewed(e);
          const i = sessionStorage.getItem(this.storageKey)
            ? JSON.parse(sessionStorage.getItem(this.storageKey))
            : {};
          delete i[t],
            sessionStorage.setItem(this.storageKey, JSON.stringify(i)),
            0 === e.length &&
              this.$el
                .find(".product-recently-viewed--section")
                .addClass("hide"),
            this.$carousel &&
              this.$carousel[0].removeEventListener(
                "rimg:load",
                this.slideImageLoaded
              );
        }
        clearRecentlyViewed() {
          localStorage.removeItem(this.storageKey),
            sessionStorage.removeItem(this.storageKey),
            this.$el.find("[data-recently-viewed-card]").remove(),
            this.$el.find(".product-recently-viewed--section").addClass("hide");
        }
        _onSlideImageLoaded() {
          this.flickity.resize();
        }
        _initSlider() {
          (this.flickityOptions = {
            autoPlay: 0,
            accessibility: !0,
            cellAlign: "left",
            cellSelector: this.slides,
            groupCells: !0,
            pageDots: !1,
            contain: !0,
            arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
          }),
            (this.flickity = new (_t())(
              this.$carousel[0],
              this.flickityOptions
            )),
            this.$carousel[0].addEventListener(
              "rimg:load",
              this.slideImageLoaded
            );
        }
        _setRecentlyViewed(t) {
          const i = Math.floor(Date.now() / 1e3) - this.maxStorageTime,
            n = t.filter((t) => t.timestamp > i);
          if (n.length > this.maxRecentlyViewed) {
            const t = n.length - this.maxRecentlyViewed;
            n.splice(0, t);
          }
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(n));
          } catch (t) {}
          try {
            const t = n ? n.map((t) => t.handle) : [];
            let i = sessionStorage.getItem(this.storageKey)
              ? JSON.parse(sessionStorage.getItem(this.storageKey))
              : {};
            i.cardSettings &&
              Object.keys(i.cardSettings).forEach((t) => {
                i.cardSettings[t] !== this.cardSettings[t] &&
                  ((i = {}), sessionStorage.removeItem(this.storageKey));
              }),
              (i.cardSettings = this.cardSettings);
            return t.map((t) => {
              if (i[t]) return null;
              const n = `${window.Theme.routes.all_products_collection_url}/products/${t}?view=recently-viewed`;
              return e()
                .get(n)
                .then((e) => {
                  if (e) {
                    i[t] = e;
                    try {
                      sessionStorage.setItem(
                        this.storageKey,
                        JSON.stringify(i)
                      );
                    } catch (t) {}
                  }
                })
                .catch((t) => {});
            });
          } catch (t) {
            return !1;
          }
        }
        _getRecentlyViewed() {
          try {
            return localStorage.getItem(this.storageKey)
              ? JSON.parse(localStorage.getItem(this.storageKey))
              : [];
          } catch (t) {
            return [];
          }
        }
        _getRecentlyViewedCards() {
          const t = sessionStorage.getItem(this.storageKey)
              ? JSON.parse(sessionStorage.getItem(this.storageKey))
              : {},
            e = localStorage.getItem(this.storageKey)
              ? JSON.parse(localStorage.getItem(this.storageKey))
              : {},
            i = [];
          for (let n = e.length - 1; n >= 0; n--) {
            const s = e[n].handle;
            new DOMParser()
              .parseFromString(t[s], "text/html")
              .querySelector(".productgrid--item") && i.push(t[s]);
          }
          return i.join("");
        }
      }
      class Qi {
        constructor(t) {
          (this.section = t),
            (this.el = t.el),
            (this.searchField = this.el.querySelector("[data-live-search]")),
            (this.productItems = []);
          this.el.querySelectorAll("[data-product-item]").forEach((t) => {
            this.productItems.push(
              new ri({ el: t, id: this.section.id, lazy: !0 })
            );
          }),
            (this.searchForm = new Ri(this.searchField));
        }
        onSectionUnload() {
          this.searchForm.unload(),
            this.productItems.forEach((t) => {
              t.unload();
            });
        }
      }
      class Ki {
        constructor(t) {
          (this.el = t.el),
            (this.mobileUtilityMenuEl = t.el.querySelector(
              "[data-utility-menu-mobile]"
            )),
            (this.mobileNavContentEl = null),
            (this.mobileElChildren = []),
            (this.documentFragmentMenu = document.createDocumentFragment()),
            (this.mobileLayout = t.data.settings.mobile_layout),
            (this._loadMobileNavItems = this._loadMobileNavItems.bind(this)),
            (this.mobileUtilityBarEl = t.el.querySelector(
              "[data-utility-bar-mobile]"
            )),
            (this.mobileUtilityContentEl = null),
            (this.mobileUtilityChildren = []),
            (this.mobileUtilityPlacement = document.querySelector(
              "[data-utility-mobile]"
            )),
            (this.documentFragmentDisclosure =
              document.createDocumentFragment()),
            (this._loadMobileUtilityItems =
              this._loadMobileUtilityItems.bind(this)),
            (this.mobileScrollHeight = document.querySelector(
              "[data-mobile-nav-content]"
            )),
            (this.mobileUtilitySocial = document.querySelector(
              "[data-utility-social-mobile]"
            )),
            (this.countryDisclosureEl = this.el.querySelector(
              "[data-disclosure-country]"
            )),
            (this.localeDisclosureEl = this.el.querySelector(
              "[data-disclosure-locale]"
            )),
            (this.disclosures = []),
            this.mobileUtilityMenuEl &&
              (this._loadMobileNavItems(),
              window.addEventListener(
                "shopify:section:load",
                this._loadMobileNavItems
              )),
            this.mobileUtilityBarEl &&
              (this._loadMobileUtilityItems(),
              window.addEventListener(
                "shopify:section:load",
                this._loadMobileUtilityItems
              )),
            this.countryDisclosureEl &&
              this.disclosures.push(new xi(this.countryDisclosureEl)),
            this.localeDisclosureEl &&
              this.disclosures.push(new xi(this.localeDisclosureEl)),
            this.mobileUtilitySocial &&
              this.mobileScrollHeight.classList.add("utility-social-enabled");
        }
        onSectionUnload() {
          window.removeEventListener(
            "shopify:section:load",
            this._loadMobileNavItems
          ),
            window.removeEventListener(
              "shopify:section:load",
              this._loadMobileUtilityItems
            ),
            this.mobileNavContentEl &&
              this.mobileElChildren.forEach((t) =>
                this.mobileNavContentEl.removeChild(t)
              ),
            this.mobileUtilityContentEl &&
              this.mobileUtilityChildren.forEach((t) =>
                this.mobileUtilityPlacement.removeChild(t)
              ),
            this.disclosures.forEach((t) => t.unload());
        }
        _loadMobileNavItems() {
          if (
            !this.mobileElChildren.some((t) => document.body.contains(t)) &&
            ((this.mobileNavContentEl = document.querySelector(
              "[data-mobile-nav-content]"
            )),
            (this.mobileElChildren = []),
            this.mobileNavContentEl)
          ) {
            const { children: t } = this.mobileUtilityMenuEl;
            for (let e = 0; e < t.length; e++) {
              const i = t[e].cloneNode(!0);
              this.mobileElChildren.push(i),
                this.documentFragmentMenu.appendChild(i);
            }
            "below" === this.mobileLayout
              ? (this.mobileNavContentEl.appendChild(this.documentFragmentMenu),
                this.mobileNavContentEl.classList.add("utility-nav-below"))
              : this.mobileNavContentEl.insertBefore(
                  this.documentFragmentMenu,
                  this.mobileNavContentEl.firstElementChild
                );
          }
        }
        _loadMobileUtilityItems() {
          if (
            !this.mobileUtilityChildren.some((t) =>
              document.body.contains(t)
            ) &&
            ((this.mobileUtilityContentEl = document.querySelector(
              "[data-utility-bar-mobile]"
            )),
            (this.mobileUtilityChildren = []),
            this.mobileUtilityContentEl)
          ) {
            const { children: t } = this.mobileUtilityContentEl;
            for (let e = 0; e < t.length; e++) {
              const i = t[e].cloneNode(!0);
              this.mobileUtilityChildren.push(i),
                this.documentFragmentDisclosure.appendChild(i);
            }
            this.mobileUtilityPlacement.appendChild(
              this.documentFragmentDisclosure
            );
            const e = this.mobileUtilityPlacement.querySelector(
                "[data-disclosure-country]"
              ),
              i = this.mobileUtilityPlacement.querySelector(
                "[data-disclosure-locale]"
              );
            e && this.disclosures.push(new xi(e)),
              i && this.disclosures.push(new xi(i));
          }
        }
      }
      class Yi {
        constructor(t) {
          (this.el = t.el),
            (this.context = t.data.context),
            (this.handleEvents = new St.Z()),
            (this.accordionTrigger = "[data-accordion-trigger]"),
            (this.mobileAccordionOpen = this.el.querySelector(
              ".mobile-accordion__open--true"
            )),
            (this.Accordion = new li(this.el, {
              content: "[data-accordion-content]",
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.querySelector(
                  this.accordionTrigger
                ).dataset.accordionTrigger = i;
              },
            })),
            this.mobileAccordionOpen
              ? this.Accordion.openAll({ force: !0 })
              : bt.max("XS") &&
                (this.Accordion.closeAll({ force: !0 }),
                this._addAccordionClickEvent()),
            bt.onChange((t) => this.onBreakpointChange(t));
        }
        onSectionUnload() {
          this.Accordion.unload(), this.handleEvents.unregisterAll();
        }
        onSectionBlockSelect(t) {
          this._toggleAccordion(t.el);
        }
        onSectionBlockDeselect(t) {
          this._toggleAccordion(t.el);
        }
        _addAccordionClickEvent() {
          this.el.querySelectorAll(this.accordionTrigger).forEach((t) => {
            this.handleEvents.register(t, "click", (t) => {
              t.preventDefault(),
                this._toggleAccordion(t.currentTarget.parentNode);
            });
          });
        }
        _toggleAccordion(t) {
          bt.min("S") || this.Accordion.toggle(t);
        }
        onBreakpointChange(t) {
          t.current.min("S") || this.mobileAccordionOpen
            ? (this.Accordion.openAll({ force: !0 }),
              this.handleEvents.unregisterAll())
            : t.previous.min("S") &&
              t.current.max("XS") &&
              (this.Accordion.closeAll({ force: !0 }),
              this._addAccordionClickEvent());
        }
      }
      class Ji {
        constructor(t) {
          let { el: e, sectionId: i } = t;
          (this.el = e),
            (this.contentWrapperEl = e.querySelector("[data-content-wrapper]")),
            (this.contentEl = e.querySelector("[data-content]")),
            (this.initialLayout = this.contentEl.dataset.layout),
            (this.productItems = []);
          const n = this.el.querySelectorAll("[data-product-item]");
          for (let t = 0; t < n.length; t++)
            this.productItems.push(new ri({ el: n[t], id: i, lazy: !1 }));
          "slideshow" === this.initialLayout
            ? window.requestAnimationFrame(() => this._initializeFlickity())
            : ((this.onBreakpointChange = () => {
                Tt.isLessThanBreakpoint("XL")
                  ? this._initializeFlickity()
                  : this._destroyFlickity();
              }),
              Tt.onBreakpointChange(this.onBreakpointChange),
              Tt.isLessThanBreakpoint("XL") &&
                window.requestAnimationFrame(() => this._initializeFlickity()));
        }
        unload() {
          this.productItems.forEach((t) => t.unload()),
            Tt.offBreakpointChange(this.onBreakpointChange),
            this._destroyFlickity();
        }
        _initializeFlickity() {
          if (this.flickity) return;
          (this.contentEl.dataset.layout = "slideshow"),
            (this.flickity = new (_t())(this.contentEl, {
              autoPlay: 0,
              accessibility: !0,
              cellAlign: "left",
              cellSelector: ".productgrid--item",
              groupCells: !0,
              pageDots: !1,
              contain: !0,
              arrowShape:
                "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
            }));
          const { resize: t } = _t().prototype,
            e = this.contentEl.querySelector(".flickity-viewport"),
            i = this.contentEl.querySelector(".flickity-slider"),
            n = document.createElement("div");
          n.classList.add("flickity-slider--wrapper"),
            e.appendChild(n),
            n.appendChild(i),
            (this.flickity.resize = function () {
              (e.style.height = ""), t.call(this);
            });
        }
        _destroyFlickity() {
          if (!this.flickity) return;
          this.contentEl.dataset.layout = this.initialLayout;
          const t = this.contentEl.querySelector(".flickity-viewport"),
            e = this.contentEl.querySelector(".flickity-slider"),
            i = this.contentEl.querySelector(".flickity-slider--wrapper");
          t.appendChild(e),
            t.removeChild(i),
            this.flickity.destroy(),
            (this.flickity = null);
        }
      }
      class tn {
        constructor(t) {
          this.context = t.data.context;
          const e = t.el.querySelectorAll("[data-featured-collection]");
          (this.collections = Array.prototype.map.call(
            e,
            (e) => new Ji({ el: e, sectionId: t.id })
          )),
            (this.menuWrapper = t.el.querySelector(
              "[data-subcollection-menu-wrapper]"
            )),
            (this.menuToggle = t.el.querySelector(
              "[data-subcollection-menu-toggle-more]"
            )),
            this.menuWrapper &&
              this.menuToggle &&
              ((this.events = new St.Z()),
              (this.menuIsOpen = !1),
              (this.menuTransition = yt({
                el: this.menuWrapper,
                state: "closed",
                stateAttribute: "data-subcollections-menu-state",
                stateChangeAttribute: "data-subcollections-menu-animation",
              })),
              this.events.register(this.menuToggle, "click", () => {
                this.menuIsOpen ? this._closeMenu() : this._openMenu();
              }),
              (this.onBreakpointChange = () => this._closeMenu()),
              bt.onChange(this.onBreakpointChange));
        }
        onSectionUnload() {
          this.collections.forEach((t) => t.unload()),
            this.events && this.events.unregisterAll(),
            bt.offChange(this.onBreakpointChange);
        }
        _openMenu() {
          (this.menuIsOpen = !0),
            (this.menuToggle.innerHTML = this.context.see_less);
          const { height: t } = this.menuWrapper.getBoundingClientRect();
          this.menuWrapper.style.setProperty("--menu-closed-height", `${t}px`),
            (this.menuWrapper.style.maxHeight = "none"),
            this.menuTransition.animateTo("open", {
              onStart: () => {
                const { height: t } = this.menuToggle.getBoundingClientRect(),
                  e = this.menuWrapper.scrollHeight + t;
                this.menuWrapper.style.setProperty(
                  "--menu-open-height",
                  `${e}px`
                );
              },
            });
        }
        _closeMenu() {
          (this.menuIsOpen = !1),
            (this.menuToggle.innerHTML = this.context.see_more),
            this.menuTransition.animateTo("closed").then(() => {
              this.menuWrapper.style.removeProperty("--menu-closed-height"),
                (this.menuWrapper.style.maxHeight = null);
            });
        }
      }
      class en extends hi {
        constructor(t) {
          if (
            (super(t),
            (this.el = t.el),
            (this.filterInputs = null),
            (this.filterEvents = new St.Z()),
            (this.updateTimeout = null),
            (this._initFilterEvents = this._initFilterEvents.bind(this)),
            (this._updatePrice = this._updatePrice.bind(this)),
            (this._buildFilterQuery = this._buildFilterQuery.bind(this)),
            (this.filterGroups = t.data.filter_groups),
            (this.filterStyle = t.data.filter_style),
            (this.filtersContentSelector = "[data-productgrid-sidebar]"),
            (this.filtersContent = this.el.querySelector(
              this.filtersContentSelector
            )),
            (this.filterRange = this.el.querySelectorAll(
              "[data-filter-range]"
            )),
            (this.rangeNames = []),
            this.filterRange.forEach((t) => {
              this.rangeNames.push(t.name);
            }),
            (this.allowedQueryParams = ["view", "sort_by", "grid_list"]),
            this.filtersContent)
          ) {
            const t = { groups: this.filterGroups, style: this.filterStyle };
            (this.filterGroupAccordions = new ci(this.filtersContent, t)),
              this._initFilters();
          }
          (this.forms = new F(this.el)), this._initFilterEvents();
        }
        _initFilterEvents() {
          (this.filterInputs = this.el.querySelectorAll("[data-filter-input]")),
            this.filterInputs.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
                const e = t.currentTarget;
                if (e.dataset.hasOwnProperty("disabled")) return;
                const i = e.getAttribute("data-handle");
                let n = "checked";
                e.getAttribute("data-filter-active")
                  ? ((n = "unchecked"), e.removeAttribute("data-filter-active"))
                  : e.setAttribute("data-filter-active", ""),
                  this.fillAnimations[i] &&
                    this.checkAnimations[i] &&
                    (this.fillAnimations[i].animateTo(n),
                    this.checkAnimations[i].animateTo(n)),
                  this.getFilteredResults(t.currentTarget);
              });
            }),
            this.filterRange.forEach((t) => {
              this.filterEvents.register(t, "keyup", (t) =>
                this._updatePrice(t.currentTarget)
              ),
                this.filterEvents.register(t, "change", (t) =>
                  this._updatePrice(t.currentTarget)
                );
            }),
            (this.filterAccordionButton = this.el.querySelectorAll(
              "[data-filter-group-trigger]"
            )),
            this.filterAccordionButton.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
              });
            });
        }
        _initAnimations() {
          this.filterCheckboxes.forEach((t) => {
            const e = t.dataset.handle,
              i = t.querySelector(".checkmark"),
              n = t.querySelector(".checkmark__check");
            let s = "unchecked";
            t
              .closest("[data-filter-input]")
              .getAttribute("data-filter-active") && (s = "checked");
            const o = yt({ el: i, state: s }),
              r = yt({ el: n, state: s });
            (this.fillAnimations[e] = o), (this.checkAnimations[e] = r);
          });
        }
        _initFilters() {
          const t = this.el.querySelector("[data-filter-group-range]");
          this.filterRange.forEach((e) => {
            e.value.length > 0 && t.setAttribute("data-filter-open", "true");
          });
          this.el.querySelectorAll('[data-filter-open="true"]').forEach((t) => {
            this._openActiveGroup(t);
          });
        }
        _openActiveGroup(t) {
          const e = t
              .closest("[data-filter-group]")
              .querySelector("[data-filter-group-trigger]"),
            i = t.closest("[data-accordion-content]");
          this.filterGroupAccordions.openGroup(e, i, !0);
        }
        _buildFilterQuery(t) {
          let e;
          if (t.classList.contains("collection-filters__filter-range-input")) {
            const i = window.location.search.replace("?", ""),
              n = new FormData(t.closest("form")),
              s = new URLSearchParams(n).toString();
            let o = i
              .split("&")
              .filter(
                (t) =>
                  !t.includes(this.rangeNames[0]) &&
                  !t.includes(this.rangeNames[1])
              );
            (o = o.join("&")), (e = o.length > 0 ? `${o}&${s}` : `${s}`);
          } else {
            const i = t.dataset.url,
              n = decodeURIComponent(i);
            (e = n.split("?")[1]), e || (e = "");
          }
          const i = Object.entries(Shopify.queryParams);
          let n = [];
          i.forEach((t) => {
            !e.includes(t[0]) &&
              this.allowedQueryParams.includes(t[0]) &&
              n.push(t.join("="));
          }),
            (n = n.join("&"));
          let s = "";
          return (s = n && e ? `?${e}&${n}` : e && !n ? `?${e}` : `?${n}`), s;
        }
        _updatePrice(t) {
          null !== this.updateTimeout && clearTimeout(this.updateTimeout),
            (this.updateTimeout = setTimeout(() => {
              this.getFilteredResults(t);
            }, 2e3));
        }
        _changeSorting(t) {
          t.preventDefault();
          const e = t.currentTarget;
          Shopify.queryParams.sort_by = e.value;
          const i = this._stringifyShopifyQueries();
          window.location.search = i;
        }
        _toggleView(t) {
          const e = t.currentTarget;
          Shopify.queryParams.grid_list = e.dataset.collectionView;
          const i = this._stringifyShopifyQueries();
          window.location.search = i;
        }
        _setSortByQueryParameters() {
          Shopify.queryParams = {};
          const t = ["view", "sort_by", "grid_list"],
            e = location.search.substr(1).split("&");
          location.search.length &&
            e.forEach((e) => {
              const i = e.split("=");
              i.length > 1 &&
                t.includes(i[0]) &&
                (Shopify.queryParams[decodeURIComponent(i[0])] =
                  decodeURIComponent(i[1]));
            });
        }
        _stringifyShopifyQueries() {
          const t = Object.entries(Shopify.queryParams);
          let e = [];
          return (
            t.forEach((t) => {
              e.push(t.join("="));
            }),
            (e = e.join("&")),
            e
          );
        }
        getFilteredResults(t) {
          const e = this._buildFilterQuery(t);
          window.location.search = e;
        }
        onSectionUnload() {
          super.onSectionUnload(),
            this.filterEvents.unregisterAll(),
            this.forms.unload();
        }
      }
      class nn extends Qi {
        constructor(t) {
          if (
            (super(t),
            (this.el = t.el),
            (this.filterInputs = null),
            (this.filterEvents = new St.Z()),
            (this.updateTimeout = null),
            (this._initFilterEvents = this._initFilterEvents.bind(this)),
            (this._updatePrice = this._updatePrice.bind(this)),
            (this._buildFilterQuery = this._buildFilterQuery.bind(this)),
            (this.filterGroups = t.data.filter_groups),
            (this.filterStyle = "faceted"),
            (this.filtersContentSelector = "[data-productgrid-sidebar]"),
            (this.filtersContent = this.el.querySelector(
              this.filtersContentSelector
            )),
            (this.filtersTrigger = this.el.querySelector(
              "[data-productgrid-trigger-filters]"
            )),
            (this.filterRange = this.el.querySelectorAll(
              "[data-filter-range]"
            )),
            (this.filterCheckboxes = this.el.querySelectorAll(
              ".filter-icon--checkbox"
            )),
            (this.rangeNames = []),
            (this.fillAnimations = {}),
            (this.checkAnimations = {}),
            (this.modal = new Ht()),
            this.filterEvents.register(this.filtersTrigger, "click", (t) => {
              this._showFiltersModal(t);
            }),
            this._initAnimations(),
            this.filterRange.forEach((t) => {
              this.rangeNames.push(t.name);
            }),
            this.filtersContent)
          ) {
            const t = { groups: this.filterGroups, style: this.filterStyle };
            (this.filterGroupAccordions = new ci(this.filtersContent, t)),
              this._initFilters();
          }
          (this.forms = new F(this.el)), this._initFilterEvents();
        }
        _initFilterEvents() {
          (this.filterInputs = this.el.querySelectorAll("[data-filter-input]")),
            this.filterInputs.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
                const e = t.currentTarget;
                if (e.dataset.hasOwnProperty("disabled")) return;
                const i = e.getAttribute("data-handle");
                let n = "checked";
                e.getAttribute("data-filter-active")
                  ? ((n = "unchecked"), e.removeAttribute("data-filter-active"))
                  : e.setAttribute("data-filter-active", ""),
                  this.fillAnimations[i] &&
                    this.checkAnimations[i] &&
                    (this.fillAnimations[i].animateTo(n),
                    this.checkAnimations[i].animateTo(n)),
                  this.getFilteredResults(t.currentTarget);
              });
            }),
            this.filterRange.forEach((t) => {
              this.filterEvents.register(t, "keyup", (t) =>
                this._updatePrice(t.currentTarget)
              ),
                this.filterEvents.register(t, "change", (t) =>
                  this._updatePrice(t.currentTarget)
                );
            }),
            (this.filterAccordionButton = this.el.querySelectorAll(
              "[data-filter-group-trigger]"
            )),
            this.filterAccordionButton.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
              });
            });
        }
        _initAnimations() {
          this.filterCheckboxes.forEach((t) => {
            const e = t.dataset.handle,
              i = t.querySelector(".checkmark"),
              n = t.querySelector(".checkmark__check");
            let s = "unchecked";
            t
              .closest("[data-filter-input]")
              .getAttribute("data-filter-active") && (s = "checked");
            const o = yt({ el: i, state: s }),
              r = yt({ el: n, state: s });
            (this.fillAnimations[e] = o), (this.checkAnimations[e] = r);
          });
        }
        _initFilters() {
          const t = this.el.querySelector("[data-filter-group-range]");
          this.filterRange.forEach((e) => {
            e.value.length > 0 && t.setAttribute("data-filter-open", "true");
          });
          this.el.querySelectorAll('[data-filter-open="true"]').forEach((t) => {
            this._openActiveGroup(t);
          });
        }
        _showFiltersModal(t) {
          t.preventDefault(),
            (this.focusItem = t.currentTarget),
            this.modal.open(this.filtersContentSelector, "productgrid-filters");
        }
        _openActiveGroup(t) {
          const e = t
              .closest("[data-filter-group]")
              .querySelector("[data-filter-group-trigger]"),
            i = t.closest("[data-accordion-content]");
          this.filterGroupAccordions.openGroup(e, i, !0);
        }
        _buildFilterQuery(t) {
          let e;
          if (t.classList.contains("collection-filters__filter-range-input")) {
            const i = window.location.search.replace("?", ""),
              n = new FormData(t.closest("form")),
              s = new URLSearchParams(n).toString();
            let o = i
              .split("&")
              .filter(
                (t) =>
                  !t.includes(this.rangeNames[0]) &&
                  !t.includes(this.rangeNames[1])
              );
            (o = o.join("&")), (e = o.length > 0 ? `${o}&${s}` : `${s}`);
          } else {
            const i = t.dataset.url;
            (e = decodeURIComponent(i).split("?")[1]), e || (e = "");
          }
          let i = "";
          return e && (i = `?${e}`), i;
        }
        _updatePrice(t) {
          null !== this.updateTimeout && clearTimeout(this.updateTimeout),
            (this.updateTimeout = setTimeout(() => {
              this.getFilteredResults(t);
            }, 2e3));
        }
        getFilteredResults(t) {
          const e = this._buildFilterQuery(t);
          window.location.search = e;
        }
        onSectionUnload() {
          super.onSectionUnload(),
            this.filterEvents.unregisterAll(),
            this.forms.unload();
        }
      }
      class sn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.$window = e()(window)),
            (this.flickity = null),
            (this.$blogPosts = this.$el.find("[data-blog-posts]")),
            (this._mobileSlider = this._mobileSlider.bind(this)),
            Tt.onBreakpointChange(this._mobileSlider),
            this._mobileSlider();
        }
        onSectionUnload() {
          Tt.offBreakpointChange(this._mobileSlider), this._destroyFlickity();
        }
        _initFlickity() {
          (this.flickity = new (_t())(this.$blogPosts[0], {
            cellSelector: ".article--excerpt-wrapper",
            contain: !0,
            freeScroll: !0,
            percentPosition: !1,
            prevNextButtons: !1,
            pageDots: !1,
            setGallerySize: !1,
          })),
            this._bindSlider();
        }
        _destroyFlickity() {
          this.flickity &&
            (this.$window.off(".blog-posts"),
            this.$blogPosts.off(".blog-posts"),
            this.flickity.destroy(),
            (this.flickity = null));
        }
        _mobileSlider() {
          Tt.isGreaterThanBreakpoint("M")
            ? this._destroyFlickity()
            : this.flickity || this._initFlickity();
        }
        _bindSlider() {
          const t = this.$blogPosts.find(".flickity-slider");
          this.$window.on(
            "resize.blog-posts",
            z()(() => {
              this.$blogPosts.trigger("heightUpdate.blog-posts");
            })
          ),
            this.flickity.on("cellSelect", () => {
              this.$blogPosts.trigger("heightUpdate.blog-posts");
            }),
            this.$blogPosts.on("heightUpdate.blog-posts", () => {
              this.flickity && t.height(Math.ceil(this.flickity.maxCellHeight));
            }),
            this.$blogPosts.trigger("heightUpdate.blog-posts");
        }
      }
      const on = (t) => {
          const i = e()(t),
            n = i.find(".promo-block--content-wrapper"),
            s = window
              .getComputedStyle(i[0], null)
              .getPropertyValue("padding-top")
              .replace("px", "");
          i.innerHeight() - 2 * s < n.innerHeight() &&
            (i.css({ height: `${n.innerHeight() + 2 * s}px` }),
            n.css({ transform: "none", top: "auto" }));
        },
        rn = (t) => {
          const i = e()(t),
            n = i.find(".promo-block--content-wrapper");
          i.css({ height: "" }), n.css({ transform: "", top: "" });
        };
      class an {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.content = "[data-promo-block-content]"),
            (this.expandedClass = "promo-block--expanded"),
            (this.compressBlocks = t.data.compress_blocks),
            (this.layoutHandler = this.onBreakpointChange.bind(this)),
            Tt.onBreakpointChange(this.layoutHandler),
            (this._blockInteraction = this._blockInteraction.bind(this)),
            this.$el.on(
              "click.promo-block",
              this.content,
              this._blockInteraction
            ),
            !this.compressBlocks &&
              Tt.isLessThanBreakpoint("S") &&
              this.$el.find(this.content).each((t, e) => {
                on(e);
              }),
            this.compressBlocks ||
              e()(window).on("resize", () => {
                this.$el.find(this.content).each((t, e) => {
                  Tt.isLessThanBreakpoint("S") ? on(e) : rn(e);
                });
              });
        }
        onBreakpointChange() {
          Tt.isLessThanBreakpoint("S")
            ? this.compressBlocks ||
              this.$el.find(this.content).each((t, e) => {
                on(e);
              })
            : (this.$el.find(`.${this.expandedClass}`).each((t, e) => {
                this._collapse(e);
              }),
              this.$el.find(this.content).each((t, e) => {
                rn(e);
              }));
        }
        onSectionUnload() {
          this.$el.off(".promo-block"),
            Tt.offBreakpointChange(this.layoutHandler);
        }
        onSectionBlockSelect(t) {
          Tt.isLessThanBreakpoint("S") &&
            this._expand(t.el.querySelector(this.content));
        }
        onSectionBlockDeselect(t) {
          Tt.isLessThanBreakpoint("S") &&
            this._collapse(t.el.querySelector(this.content));
        }
        _blockInteraction(t) {
          const e = t.currentTarget;
          !e.getAttribute("data-clicked") &&
            Tt.isLessThanBreakpoint("S") &&
            this.compressBlocks &&
            (t.preventDefault(),
            e.setAttribute("data-clicked", "clicked"),
            this._expand(e));
        }
        _expand(t) {
          if (!this.compressBlocks) return;
          const i = e()(t);
          i.addClass("animating animating-in").one("trend", () => {
            i
              .removeClass("animating animating-in")
              .addClass(this.expandedClass)
              .off("trend"),
              on(i);
          });
        }
        _collapse(t) {
          if (!this.compressBlocks) return;
          const i = e()(t);
          i.addClass("animating animating-out").one("trend", () => {
            i
              .removeClass(`animating animating-out ${this.expandedClass}`)
              .off("trend"),
              t.removeAttribute("data-clicked"),
              rn(i);
          });
        }
      }
      class ln {
        constructor(t) {
          const e = t.el.querySelector("[data-featured-collection]");
          this.featuredCollection = new Ji({ el: e, sectionId: t.id });
        }
        onSectionUnload() {
          this.featuredCollection.unload();
        }
      }
      class cn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.context = t.data.context),
            (this.accordionTrigger = "[data-accordion-trigger]"),
            (this.seeMoreTrigger = "[data-menulist-toggle]"),
            (this.Accordion = new li(this.$el[0], {
              content: ".menulist-menu--initial[data-accordion-content]",
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.querySelector(
                  this.accordionTrigger
                ).dataset.accordionTrigger = i;
              },
            })),
            (this.seeMore = new li(this.$el[0], {
              content: ".menulist-menu--show-more[data-accordion-content]",
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.querySelector(this.seeMoreTrigger).innerHTML =
                  "open" === i ? this.context.see_less : this.context.see_more;
              },
            })),
            bt.max("XS") && this.Accordion.closeAll({ force: !0 }),
            this.seeMore.closeAll({ force: !0 }),
            bt.onChange((t) => this.onBreakpointChange(t)),
            this._bindEvents();
        }
        _bindEvents() {
          this.$el.on("click.menu-list", this.accordionTrigger, (t) => {
            t.preventDefault(),
              this._toggleAccordion(t.currentTarget.parentNode);
          }),
            this.$el.on("click.menu-list", this.seeMoreTrigger, (t) => {
              t.preventDefault(),
                this.seeMore.toggle(t.currentTarget.parentNode);
            });
        }
        onSectionUnload() {
          this.$el.off(".menu-list"),
            this.Accordion.unload(),
            this.seeMore.unload();
        }
        onSectionBlockSelect(t) {
          this._toggleAccordion(t.el);
        }
        onSectionBlockDeselect(t) {
          this._toggleAccordion(t.el);
        }
        _toggleAccordion(t) {
          bt.min("S") || this.Accordion.toggle(t);
        }
        onBreakpointChange(t) {
          t.current.min("S")
            ? this.Accordion.openAll({ force: !0 })
            : t.previous.min("S") &&
              t.current.max("XS") &&
              this.Accordion.closeAll({ force: !0 });
        }
      }
      var hn = i(637),
        dn = i.n(hn);
      class un {
        constructor(t) {
          (this.$el = e()(t.el)), (this.settings = t.data), this._load();
        }
        _load() {
          (this.$window = e()(window)),
            (this.flickity = null),
            (this.$content = this.$el.find("[data-twitter-content]")),
            (this.$wrapper = this.$el.find("[data-twitter-wrapper]")),
            (this.$tweets = this.$el.find("[data-tweet-content]")),
            (this.$template = e()(this.settings.template));
          const {
              onboarding: t,
              username: i,
              retweets: n,
              images: s,
            } = this.settings,
            o = this.settings.locale || "en";
          (this._mobileSlider = this._mobileSlider.bind(this)),
            Tt.onBreakpointChange(this._mobileSlider),
            this._mobileSlider(),
            !t &&
              i &&
              dn().fetch({
                profile: { screenName: i },
                maxTweets: 3,
                enableLinks: !0,
                showUser: !0,
                showTime: !0,
                dataOnly: !1,
                useEmoji: !0,
                showImages: s,
                showRetweet: n,
                lang: o,
                customCallback: (t) => this._renderTweets(t),
                showInteraction: !1,
              });
        }
        onSectionUnload() {
          this.$window.off(".twitter"),
            this.$content.off(".twitter"),
            Tt.offBreakpointChange(this._mobileSlider),
            this._destroyFlickity();
        }
        _initFlickity() {
          (this.flickity = new (_t())(this.$content[0], {
            cellSelector: "[data-tweet-content]",
            contain: !0,
            freeScroll: !0,
            percentPosition: !1,
            prevNextButtons: !1,
            pageDots: !1,
            setGallerySize: !1,
          })),
            this._bindSlider();
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
        _mobileSlider() {
          Tt.isGreaterThanBreakpoint("S")
            ? this._destroyFlickity()
            : this.flickity || this._initFlickity();
        }
        _bindSlider() {
          const t = this.$content.find(".flickity-slider");
          this.$window.on(
            "resize.twitter",
            z()(() => {
              this.$content.trigger("heightUpdate.twitter");
            })
          ),
            this.flickity.on("cellSelect", () => {
              this.$content.trigger("heightUpdate.twitter");
            }),
            this.$content.on("heightUpdate.twitter", () => {
              this.flickity && t.height(Math.ceil(this.flickity.maxCellHeight));
            }),
            this.$content.trigger("heightUpdate.twitter");
        }
        _extractAuthor(t) {
          const i = e()(t),
            n = i.find("a").attr("href"),
            s = i.find('[data-scribe="element:name"]').text(),
            o = i.find('[data-scribe="element:screen_name"]').text();
          return { $avatar: i.find("img"), link: n, name: s, screenName: o };
        }
        _extractMeta(t) {
          const i = e()(t);
          return { link: i.find("a").attr("href"), postedAt: i.text() };
        }
        _extractWrapperClass() {
          const t = this.$wrapper.attr("class").match(/tweet--count-\d+$/);
          return t ? t[0] : "";
        }
        _renderTweets(t) {
          const i = t.length;
          if (!t || !i) return;
          const n = [],
            s = `tweet--count-${i}`;
          t.forEach((t) => {
            const i = e()(t),
              s = this.$template.clone(),
              o = this._extractAuthor(i[0]),
              r = this._extractMeta(i[2]),
              a = i[1];
            s.find(".tweet--header").attr("href", o.link),
              s.find(".tweet--header-image").html(o.$avatar),
              s.find(".tweet--header-name").text(o.name),
              s.find(".tweet--header-screenname").text(o.screenName),
              s
                .find(".tweet--content")
                .append(i[3] ? i[3] : null)
                .append(a),
              s
                .find(".tweet--footer")
                .attr("href", r.link)
                .find(".tweet--footer--posted")
                .text(r.postedAt),
              n.push(s);
          }),
            this.$wrapper.css("min-height", this.$wrapper.height()),
            this.$tweets
              .fadeOut()
              .promise()
              .then(() => {
                this._destroyFlickity(),
                  this.$tweets.remove(),
                  this.$content.append(n),
                  this.$wrapper
                    .removeClass(this._extractWrapperClass())
                    .addClass(s)
                    .css("min-height", ""),
                  (this.$tweets = this.$el.find("[data-tweet-content]")),
                  this._mobileSlider();
              });
        }
      }
      class pn {
        constructor(t) {
          this.el = t.el;
          const e = this.el.querySelectorAll("[data-collection-image]");
          bt.onChange((t) => {
            if (t.previous.max("L") && "S" === t.current.value)
              for (let t = 0; t < e.length; t++) x.instance.update(e[t]);
          });
        }
      }
      class fn extends Wi {
        constructor(t) {
          super(t, { useHistory: !1 });
        }
      }
      class gn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.rte = []),
            this.$el.find("[data-rte]").each((t, i) => {
              this.rte.push(new O(e()(i)));
            });
        }
        onSectionUnload() {
          this.rte.forEach((t) => {
            t.unload();
          });
        }
      }
      class mn {
        constructor(t) {
          (this.el = t.el),
            (this.settings = t.data.settings),
            (this.search = null),
            (this.scripts = document.querySelector("[data-scripts]")),
            (this.searchField = this.el.querySelector("[data-live-search]")),
            (this.forms = new F(this.el)),
            this.settings.live_search.enable
              ? s()(this.scripts.dataset.shopifyApiUrl, () => {
                  this.search = new zi(
                    { el: this.searchField, header: this.el },
                    { ...this.settings.live_search, use_dimmer: !1 }
                  );
                })
              : (this.search = new Ri(this.searchField));
        }
        onSectionUnload() {
          this.search.unload(), this.forms.unload();
        }
      }
      function vn(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var yn =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
          ? window
          : void 0 !== i.g
          ? i.g
          : "undefined" != typeof self
          ? self
          : {};
      function bn(t, e) {
        return t((e = { exports: {} }), e.exports), e.exports;
      }
      var wn = bn(function (t) {
          var e, i;
          (e = "undefined" != typeof window ? window : yn),
            (i = function () {
              function t() {}
              var e = t.prototype;
              return (
                (e.on = function (t, e) {
                  if (t && e) {
                    var i = (this._events = this._events || {}),
                      n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                  }
                }),
                (e.once = function (t, e) {
                  if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                  }
                }),
                (e.off = function (t, e) {
                  var i = this._events && this._events[t];
                  if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                  }
                }),
                (e.emitEvent = function (t, e) {
                  var i = this._events && this._events[t];
                  if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (
                      var n = this._onceEvents && this._onceEvents[t], s = 0;
                      s < i.length;
                      s++
                    ) {
                      var o = i[s];
                      n && n[o] && (this.off(t, o), delete n[o]),
                        o.apply(this, e);
                    }
                    return this;
                  }
                }),
                (e.allOff = function () {
                  delete this._events, delete this._onceEvents;
                }),
                t
              );
            }),
            t.exports ? (t.exports = i()) : (e.EvEmitter = i());
        }),
        _n = bn(function (t) {
          !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.getSize = i());
          })(window, function () {
            function t(t) {
              var e = parseFloat(t);
              return -1 == t.indexOf("%") && !isNaN(e) && e;
            }
            var e =
                "undefined" == typeof console
                  ? function () {}
                  : function (t) {},
              i = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
              ],
              n = i.length;
            function s(t) {
              var i = getComputedStyle(t);
              return (
                i ||
                  e(
                    "Style returned " +
                      i +
                      ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                  ),
                i
              );
            }
            var o,
              r = !1;
            function a(e) {
              if (
                ((function () {
                  if (!r) {
                    r = !0;
                    var e = document.createElement("div");
                    (e.style.width = "200px"),
                      (e.style.padding = "1px 2px 3px 4px"),
                      (e.style.borderStyle = "solid"),
                      (e.style.borderWidth = "1px 2px 3px 4px"),
                      (e.style.boxSizing = "border-box");
                    var i = document.body || document.documentElement;
                    i.appendChild(e);
                    var n = s(e);
                    (o = 200 == Math.round(t(n.width))),
                      (a.isBoxSizeOuter = o),
                      i.removeChild(e);
                  }
                })(),
                "string" == typeof e && (e = document.querySelector(e)),
                e && "object" == typeof e && e.nodeType)
              ) {
                var l = s(e);
                if ("none" == l.display)
                  return (function () {
                    for (
                      var t = {
                          width: 0,
                          height: 0,
                          innerWidth: 0,
                          innerHeight: 0,
                          outerWidth: 0,
                          outerHeight: 0,
                        },
                        e = 0;
                      e < n;
                      e++
                    )
                      t[i[e]] = 0;
                    return t;
                  })();
                var c = {};
                (c.width = e.offsetWidth), (c.height = e.offsetHeight);
                for (
                  var h = (c.isBorderBox = "border-box" == l.boxSizing), d = 0;
                  d < n;
                  d++
                ) {
                  var u = i[d],
                    p = l[u],
                    f = parseFloat(p);
                  c[u] = isNaN(f) ? 0 : f;
                }
                var g = c.paddingLeft + c.paddingRight,
                  m = c.paddingTop + c.paddingBottom,
                  v = c.marginLeft + c.marginRight,
                  y = c.marginTop + c.marginBottom,
                  b = c.borderLeftWidth + c.borderRightWidth,
                  w = c.borderTopWidth + c.borderBottomWidth,
                  _ = h && o,
                  S = t(l.width);
                !1 !== S && (c.width = S + (_ ? 0 : g + b));
                var C = t(l.height);
                return (
                  !1 !== C && (c.height = C + (_ ? 0 : m + w)),
                  (c.innerWidth = c.width - (g + b)),
                  (c.innerHeight = c.height - (m + w)),
                  (c.outerWidth = c.width + v),
                  (c.outerHeight = c.height + y),
                  c
                );
              }
            }
            return a;
          });
        }),
        Sn = bn(function (t) {
          !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.matchesSelector = i());
          })(window, function () {
            var t = (function () {
              var t = window.Element.prototype;
              if (t.matches) return "matches";
              if (t.matchesSelector) return "matchesSelector";
              for (
                var e = ["webkit", "moz", "ms", "o"], i = 0;
                i < e.length;
                i++
              ) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
              }
            })();
            return function (e, i) {
              return e[t](i);
            };
          });
        }),
        Cn = bn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, Sn))
              : (e.fizzyUIUtils = i(e, e.matchesSelector));
          })(window, function (t, e) {
            var i = {
                extend: function (t, e) {
                  for (var i in e) t[i] = e[i];
                  return t;
                },
                modulo: function (t, e) {
                  return ((t % e) + e) % e;
                },
              },
              n = Array.prototype.slice;
            (i.makeArray = function (t) {
              return Array.isArray(t)
                ? t
                : null == t
                ? []
                : "object" == typeof t && "number" == typeof t.length
                ? n.call(t)
                : [t];
            }),
              (i.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
              }),
              (i.getParent = function (t, i) {
                for (; t.parentNode && t != document.body; )
                  if (((t = t.parentNode), e(t, i))) return t;
              }),
              (i.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
              }),
              (i.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
              }),
              (i.filterFindElements = function (t, n) {
                t = i.makeArray(t);
                var s = [];
                return (
                  t.forEach(function (t) {
                    if (t instanceof HTMLElement)
                      if (n) {
                        e(t, n) && s.push(t);
                        for (
                          var i = t.querySelectorAll(n), o = 0;
                          o < i.length;
                          o++
                        )
                          s.push(i[o]);
                      } else s.push(t);
                  }),
                  s
                );
              }),
              (i.debounceMethod = function (t, e, i) {
                i = i || 100;
                var n = t.prototype[e],
                  s = e + "Timeout";
                t.prototype[e] = function () {
                  var t = this[s];
                  clearTimeout(t);
                  var e = arguments,
                    o = this;
                  this[s] = setTimeout(function () {
                    n.apply(o, e), delete o[s];
                  }, i);
                };
              }),
              (i.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e
                  ? setTimeout(t)
                  : document.addEventListener("DOMContentLoaded", t);
              }),
              (i.toDashed = function (t) {
                return t
                  .replace(/(.)([A-Z])/g, function (t, e, i) {
                    return e + "-" + i;
                  })
                  .toLowerCase();
              });
            var s = t.console;
            return (
              (i.htmlInit = function (e, n) {
                i.docReady(function () {
                  var o = i.toDashed(n),
                    r = "data-" + o,
                    a = document.querySelectorAll("[" + r + "]"),
                    l = document.querySelectorAll(".js-" + o),
                    c = i.makeArray(a).concat(i.makeArray(l)),
                    h = r + "-options",
                    d = t.jQuery;
                  c.forEach(function (t) {
                    var i,
                      o = t.getAttribute(r) || t.getAttribute(h);
                    try {
                      i = o && JSON.parse(o);
                    } catch (e) {
                      return void (
                        s &&
                        s.error(
                          "Error parsing " + r + " on " + t.className + ": " + e
                        )
                      );
                    }
                    var a = new e(t, i);
                    d && d.data(t, n, a);
                  });
                });
              }),
              i
            );
          });
        }),
        xn = bn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, _n))
              : ((e.Flickity = e.Flickity || {}),
                (e.Flickity.Cell = i(e, e.getSize)));
          })(window, function (t, e) {
            function i(t, e) {
              (this.element = t), (this.parent = e), this.create();
            }
            var n = i.prototype;
            return (
              (n.create = function () {
                (this.element.style.position = "absolute"),
                  this.element.setAttribute("aria-hidden", "true"),
                  (this.x = 0),
                  (this.shift = 0);
              }),
              (n.destroy = function () {
                this.unselect(), (this.element.style.position = "");
                var t = this.parent.originSide;
                this.element.style[t] = "";
              }),
              (n.getSize = function () {
                this.size = e(this.element);
              }),
              (n.setPosition = function (t) {
                (this.x = t), this.updateTarget(), this.renderPosition(t);
              }),
              (n.updateTarget = n.setDefaultTarget =
                function () {
                  var t =
                    "left" == this.parent.originSide
                      ? "marginLeft"
                      : "marginRight";
                  this.target =
                    this.x +
                    this.size[t] +
                    this.size.width * this.parent.cellAlign;
                }),
              (n.renderPosition = function (t) {
                var e = this.parent.originSide;
                this.element.style[e] = this.parent.getPositionValue(t);
              }),
              (n.select = function () {
                this.element.classList.add("is-selected"),
                  this.element.removeAttribute("aria-hidden");
              }),
              (n.unselect = function () {
                this.element.classList.remove("is-selected"),
                  this.element.setAttribute("aria-hidden", "true");
              }),
              (n.wrapShift = function (t) {
                (this.shift = t),
                  this.renderPosition(this.x + this.parent.slideableWidth * t);
              }),
              (n.remove = function () {
                this.element.parentNode.removeChild(this.element);
              }),
              i
            );
          });
        }),
        kn = bn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i())
              : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = i()));
          })(window, function () {
            function t(t) {
              (this.parent = t),
                (this.isOriginLeft = "left" == t.originSide),
                (this.cells = []),
                (this.outerWidth = 0),
                (this.height = 0);
            }
            var e = t.prototype;
            return (
              (e.addCell = function (t) {
                if (
                  (this.cells.push(t),
                  (this.outerWidth += t.size.outerWidth),
                  (this.height = Math.max(t.size.outerHeight, this.height)),
                  1 == this.cells.length)
                ) {
                  this.x = t.x;
                  var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                  this.firstMargin = t.size[e];
                }
              }),
              (e.updateTarget = function () {
                var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                  e = this.getLastCell(),
                  i = e ? e.size[t] : 0,
                  n = this.outerWidth - (this.firstMargin + i);
                this.target =
                  this.x + this.firstMargin + n * this.parent.cellAlign;
              }),
              (e.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (e.select = function () {
                this.cells.forEach(function (t) {
                  t.select();
                });
              }),
              (e.unselect = function () {
                this.cells.forEach(function (t) {
                  t.unselect();
                });
              }),
              (e.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              t
            );
          });
        }),
        En = bn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, Cn))
              : ((e.Flickity = e.Flickity || {}),
                (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)));
          })(window, function (t, e) {
            var i = {
              startAnimation: function () {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  (this.restingFrames = 0),
                  this.animate());
              },
              animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if (
                  (this.integratePhysics(),
                  this.positionSlider(),
                  this.settle(t),
                  this.isAnimating)
                ) {
                  var e = this;
                  requestAnimationFrame(function () {
                    e.animate();
                  });
                }
              },
              positionSlider: function () {
                var t = this.x;
                this.options.wrapAround &&
                  this.cells.length > 1 &&
                  ((t = e.modulo(t, this.slideableWidth)),
                  (t -= this.slideableWidth),
                  this.shiftWrapCells(t)),
                  this.setTranslateX(t, this.isAnimating),
                  this.dispatchScrollEvent();
              },
              setTranslateX: function (t, e) {
                (t += this.cursorPosition),
                  (t = this.options.rightToLeft ? -t : t);
                var i = this.getPositionValue(t);
                this.slider.style.transform = e
                  ? "translate3d(" + i + ",0,0)"
                  : "translateX(" + i + ")";
              },
              dispatchScrollEvent: function () {
                var t = this.slides[0];
                if (t) {
                  var e = -this.x - t.target,
                    i = e / this.slidesWidth;
                  this.dispatchEvent("scroll", null, [i, e]);
                }
              },
              positionSliderAtSelected: function () {
                this.cells.length &&
                  ((this.x = -this.selectedSlide.target),
                  (this.velocity = 0),
                  this.positionSlider());
              },
              getPositionValue: function (t) {
                return this.options.percentPosition
                  ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
                  : Math.round(t) + "px";
              },
              settle: function (t) {
                this.isPointerDown ||
                  Math.round(100 * this.x) != Math.round(100 * t) ||
                  this.restingFrames++,
                  this.restingFrames > 2 &&
                    ((this.isAnimating = !1),
                    delete this.isFreeScrolling,
                    this.positionSlider(),
                    this.dispatchEvent("settle", null, [this.selectedIndex]));
              },
              shiftWrapCells: function (t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var i =
                  this.size.innerWidth -
                  (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i, 1);
              },
              _shiftCells: function (t, e, i) {
                for (var n = 0; n < t.length; n++) {
                  var s = t[n],
                    o = e > 0 ? i : 0;
                  s.wrapShift(o), (e -= s.size.outerWidth);
                }
              },
              _unshiftCells: function (t) {
                if (t && t.length)
                  for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
              },
              integratePhysics: function () {
                (this.x += this.velocity),
                  (this.velocity *= this.getFrictionFactor());
              },
              applyForce: function (t) {
                this.velocity += t;
              },
              getFrictionFactor: function () {
                return (
                  1 -
                  this.options[
                    this.isFreeScrolling ? "freeScrollFriction" : "friction"
                  ]
                );
              },
              getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
              },
              applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                  var t = this.dragX - this.x - this.velocity;
                  this.applyForce(t);
                }
              },
              applySelectedAttraction: function () {
                if (
                  !(this.isDraggable && this.isPointerDown) &&
                  !this.isFreeScrolling &&
                  this.slides.length
                ) {
                  var t =
                    (-1 * this.selectedSlide.target - this.x) *
                    this.options.selectedAttraction;
                  this.applyForce(t);
                }
              },
            };
            return i;
          });
        }),
        Tn = bn(function (t) {
          !(function (e, i) {
            if (t.exports) t.exports = i(e, wn, _n, Cn, xn, kn, En);
            else {
              var n = e.Flickity;
              e.Flickity = i(
                e,
                e.EvEmitter,
                e.getSize,
                e.fizzyUIUtils,
                n.Cell,
                n.Slide,
                n.animatePrototype
              );
            }
          })(window, function (t, e, i, n, s, o, r) {
            var a = t.jQuery,
              l = t.getComputedStyle,
              c = t.console;
            function h(t, e) {
              for (t = n.makeArray(t); t.length; ) e.appendChild(t.shift());
            }
            var d = 0,
              u = {};
            function p(t, e) {
              var i = n.getQueryElement(t);
              if (i) {
                if (((this.element = i), this.element.flickityGUID)) {
                  var s = u[this.element.flickityGUID];
                  return s.option(e), s;
                }
                a && (this.$element = a(this.element)),
                  (this.options = n.extend({}, this.constructor.defaults)),
                  this.option(e),
                  this._create();
              } else c && c.error("Bad element for Flickity: " + (i || t));
            }
            (p.defaults = {
              accessibility: !0,
              cellAlign: "center",
              freeScrollFriction: 0.075,
              friction: 0.28,
              namespaceJQueryEvents: !0,
              percentPosition: !0,
              resize: !0,
              selectedAttraction: 0.025,
              setGallerySize: !0,
            }),
              (p.createMethods = []);
            var f = p.prototype;
            n.extend(f, e.prototype),
              (f._create = function () {
                var e = (this.guid = ++d);
                for (var i in ((this.element.flickityGUID = e),
                (u[e] = this),
                (this.selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? "right" : "left"),
                (this.viewport = document.createElement("div")),
                (this.viewport.className = "flickity-viewport"),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) &&
                  t.addEventListener("resize", this),
                this.options.on)) {
                  var n = this.options.on[i];
                  this.on(i, n);
                }
                p.createMethods.forEach(function (t) {
                  this[t]();
                }, this),
                  this.options.watchCSS ? this.watchCSS() : this.activate();
              }),
              (f.option = function (t) {
                n.extend(this.options, t);
              }),
              (f.activate = function () {
                this.isActive ||
                  ((this.isActive = !0),
                  this.element.classList.add("flickity-enabled"),
                  this.options.rightToLeft &&
                    this.element.classList.add("flickity-rtl"),
                  this.getSize(),
                  h(
                    this._filterFindCellElements(this.element.children),
                    this.slider
                  ),
                  this.viewport.appendChild(this.slider),
                  this.element.appendChild(this.viewport),
                  this.reloadCells(),
                  this.options.accessibility &&
                    ((this.element.tabIndex = 0),
                    this.element.addEventListener("keydown", this)),
                  this.emitEvent("activate"),
                  this.selectInitialIndex(),
                  (this.isInitActivated = !0),
                  this.dispatchEvent("ready"));
              }),
              (f._createSlider = function () {
                var t = document.createElement("div");
                (t.className = "flickity-slider"),
                  (t.style[this.originSide] = 0),
                  (this.slider = t);
              }),
              (f._filterFindCellElements = function (t) {
                return n.filterFindElements(t, this.options.cellSelector);
              }),
              (f.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)),
                  this.positionCells(),
                  this._getWrapShiftCells(),
                  this.setGallerySize();
              }),
              (f._makeCells = function (t) {
                return this._filterFindCellElements(t).map(function (t) {
                  return new s(t, this);
                }, this);
              }),
              (f.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (f.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
              }),
              (f.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
              }),
              (f._positionCells = function (t) {
                (t = t || 0),
                  (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                var e = 0;
                if (t > 0) {
                  var i = this.cells[t - 1];
                  e = i.x + i.size.outerWidth;
                }
                for (var n = this.cells.length, s = t; s < n; s++) {
                  var o = this.cells[s];
                  o.setPosition(e),
                    (e += o.size.outerWidth),
                    (this.maxCellHeight = Math.max(
                      o.size.outerHeight,
                      this.maxCellHeight
                    ));
                }
                (this.slideableWidth = e),
                  this.updateSlides(),
                  this._containSlides(),
                  (this.slidesWidth = n
                    ? this.getLastSlide().target - this.slides[0].target
                    : 0);
              }),
              (f._sizeCells = function (t) {
                t.forEach(function (t) {
                  t.getSize();
                });
              }),
              (f.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                  var t = new o(this);
                  this.slides.push(t);
                  var e =
                      "left" == this.originSide ? "marginRight" : "marginLeft",
                    i = this._getCanCellFit();
                  this.cells.forEach(function (n, s) {
                    if (t.cells.length) {
                      var r =
                        t.outerWidth -
                        t.firstMargin +
                        (n.size.outerWidth - n.size[e]);
                      i.call(this, s, r) ||
                        (t.updateTarget(),
                        (t = new o(this)),
                        this.slides.push(t)),
                        t.addCell(n);
                    } else t.addCell(n);
                  }, this),
                    t.updateTarget(),
                    this.updateSelectedSlide();
                }
              }),
              (f._getCanCellFit = function () {
                var t = this.options.groupCells;
                if (!t)
                  return function () {
                    return !1;
                  };
                if ("number" == typeof t) {
                  var e = parseInt(t, 10);
                  return function (t) {
                    return t % e != 0;
                  };
                }
                var i = "string" == typeof t && t.match(/^(\d+)%$/),
                  n = i ? parseInt(i[1], 10) / 100 : 1;
                return function (t, e) {
                  return e <= (this.size.innerWidth + 1) * n;
                };
              }),
              (f._init = f.reposition =
                function () {
                  this.positionCells(), this.positionSliderAtSelected();
                }),
              (f.getSize = function () {
                (this.size = i(this.element)),
                  this.setCellAlign(),
                  (this.cursorPosition = this.size.innerWidth * this.cellAlign);
              });
            var g = {
              center: { left: 0.5, right: 0.5 },
              left: { left: 0, right: 1 },
              right: { right: 0, left: 1 },
            };
            return (
              (f.setCellAlign = function () {
                var t = g[this.options.cellAlign];
                this.cellAlign = t
                  ? t[this.originSide]
                  : this.options.cellAlign;
              }),
              (f.setGallerySize = function () {
                if (this.options.setGallerySize) {
                  var t =
                    this.options.adaptiveHeight && this.selectedSlide
                      ? this.selectedSlide.height
                      : this.maxCellHeight;
                  this.viewport.style.height = t + "px";
                }
              }),
              (f._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                  this._unshiftCells(this.beforeShiftCells),
                    this._unshiftCells(this.afterShiftCells);
                  var t = this.cursorPosition,
                    e = this.cells.length - 1;
                  (this.beforeShiftCells = this._getGapCells(t, e, -1)),
                    (t = this.size.innerWidth - this.cursorPosition),
                    (this.afterShiftCells = this._getGapCells(t, 0, 1));
                }
              }),
              (f._getGapCells = function (t, e, i) {
                for (var n = []; t > 0; ) {
                  var s = this.cells[e];
                  if (!s) break;
                  n.push(s), (e += i), (t -= s.size.outerWidth);
                }
                return n;
              }),
              (f._containSlides = function () {
                if (
                  this.options.contain &&
                  !this.options.wrapAround &&
                  this.cells.length
                ) {
                  var t = this.options.rightToLeft,
                    e = t ? "marginRight" : "marginLeft",
                    i = t ? "marginLeft" : "marginRight",
                    n = this.slideableWidth - this.getLastCell().size[i],
                    s = n < this.size.innerWidth,
                    o = this.cursorPosition + this.cells[0].size[e],
                    r = n - this.size.innerWidth * (1 - this.cellAlign);
                  this.slides.forEach(function (t) {
                    s
                      ? (t.target = n * this.cellAlign)
                      : ((t.target = Math.max(t.target, o)),
                        (t.target = Math.min(t.target, r)));
                  }, this);
                }
              }),
              (f.dispatchEvent = function (t, e, i) {
                var n = e ? [e].concat(i) : i;
                if ((this.emitEvent(t, n), a && this.$element)) {
                  var s = (t += this.options.namespaceJQueryEvents
                    ? ".flickity"
                    : "");
                  if (e) {
                    var o = a.Event(e);
                    (o.type = t), (s = o);
                  }
                  this.$element.trigger(s, i);
                }
              }),
              (f.select = function (t, e, i) {
                if (
                  this.isActive &&
                  ((t = parseInt(t, 10)),
                  this._wrapSelect(t),
                  (this.options.wrapAround || e) &&
                    (t = n.modulo(t, this.slides.length)),
                  this.slides[t])
                ) {
                  var s = this.selectedIndex;
                  (this.selectedIndex = t),
                    this.updateSelectedSlide(),
                    i ? this.positionSliderAtSelected() : this.startAnimation(),
                    this.options.adaptiveHeight && this.setGallerySize(),
                    this.dispatchEvent("select", null, [t]),
                    t != s && this.dispatchEvent("change", null, [t]),
                    this.dispatchEvent("cellSelect");
                }
              }),
              (f._wrapSelect = function (t) {
                var e = this.slides.length;
                if (!(this.options.wrapAround && e > 1)) return t;
                var i = n.modulo(t, e),
                  s = Math.abs(i - this.selectedIndex),
                  o = Math.abs(i + e - this.selectedIndex),
                  r = Math.abs(i - e - this.selectedIndex);
                !this.isDragSelect && o < s
                  ? (t += e)
                  : !this.isDragSelect && r < s && (t -= e),
                  t < 0
                    ? (this.x -= this.slideableWidth)
                    : t >= e && (this.x += this.slideableWidth);
              }),
              (f.previous = function (t, e) {
                this.select(this.selectedIndex - 1, t, e);
              }),
              (f.next = function (t, e) {
                this.select(this.selectedIndex + 1, t, e);
              }),
              (f.updateSelectedSlide = function () {
                var t = this.slides[this.selectedIndex];
                t &&
                  (this.unselectSelectedSlide(),
                  (this.selectedSlide = t),
                  t.select(),
                  (this.selectedCells = t.cells),
                  (this.selectedElements = t.getCellElements()),
                  (this.selectedCell = t.cells[0]),
                  (this.selectedElement = this.selectedElements[0]));
              }),
              (f.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
              }),
              (f.selectInitialIndex = function () {
                var t = this.options.initialIndex;
                if (this.isInitActivated)
                  this.select(this.selectedIndex, !1, !0);
                else {
                  if (t && "string" == typeof t)
                    if (this.queryCell(t))
                      return void this.selectCell(t, !1, !0);
                  var e = 0;
                  t && this.slides[t] && (e = t), this.select(e, !1, !0);
                }
              }),
              (f.selectCell = function (t, e, i) {
                var n = this.queryCell(t);
                if (n) {
                  var s = this.getCellSlideIndex(n);
                  this.select(s, e, i);
                }
              }),
              (f.getCellSlideIndex = function (t) {
                for (var e = 0; e < this.slides.length; e++) {
                  if (-1 != this.slides[e].cells.indexOf(t)) return e;
                }
              }),
              (f.getCell = function (t) {
                for (var e = 0; e < this.cells.length; e++) {
                  var i = this.cells[e];
                  if (i.element == t) return i;
                }
              }),
              (f.getCells = function (t) {
                t = n.makeArray(t);
                var e = [];
                return (
                  t.forEach(function (t) {
                    var i = this.getCell(t);
                    i && e.push(i);
                  }, this),
                  e
                );
              }),
              (f.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              (f.getParentCell = function (t) {
                var e = this.getCell(t);
                return (
                  e ||
                  ((t = n.getParent(t, ".flickity-slider > *")),
                  this.getCell(t))
                );
              }),
              (f.getAdjacentCellElements = function (t, e) {
                if (!t) return this.selectedSlide.getCellElements();
                e = void 0 === e ? this.selectedIndex : e;
                var i = this.slides.length;
                if (1 + 2 * t >= i) return this.getCellElements();
                for (var s = [], o = e - t; o <= e + t; o++) {
                  var r = this.options.wrapAround ? n.modulo(o, i) : o,
                    a = this.slides[r];
                  a && (s = s.concat(a.getCellElements()));
                }
                return s;
              }),
              (f.queryCell = function (t) {
                if ("number" == typeof t) return this.cells[t];
                if ("string" == typeof t) {
                  if (t.match(/^[#\.]?[\d\/]/)) return;
                  t = this.element.querySelector(t);
                }
                return this.getCell(t);
              }),
              (f.uiChange = function () {
                this.emitEvent("uiChange");
              }),
              (f.childUIPointerDown = function (t) {
                "touchstart" != t.type && t.preventDefault(), this.focus();
              }),
              (f.onresize = function () {
                this.watchCSS(), this.resize();
              }),
              n.debounceMethod(p, "onresize", 150),
              (f.resize = function () {
                if (this.isActive) {
                  this.getSize(),
                    this.options.wrapAround &&
                      (this.x = n.modulo(this.x, this.slideableWidth)),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize(),
                    this.emitEvent("resize");
                  var t = this.selectedElements && this.selectedElements[0];
                  this.selectCell(t, !1, !0);
                }
              }),
              (f.watchCSS = function () {
                this.options.watchCSS &&
                  (-1 != l(this.element, ":after").content.indexOf("flickity")
                    ? this.activate()
                    : this.deactivate());
              }),
              (f.onkeydown = function (t) {
                var e =
                  document.activeElement &&
                  document.activeElement != this.element;
                if (this.options.accessibility && !e) {
                  var i = p.keyboardHandlers[t.keyCode];
                  i && i.call(this);
                }
              }),
              (p.keyboardHandlers = {
                37: function () {
                  var t = this.options.rightToLeft ? "next" : "previous";
                  this.uiChange(), this[t]();
                },
                39: function () {
                  var t = this.options.rightToLeft ? "previous" : "next";
                  this.uiChange(), this[t]();
                },
              }),
              (f.focus = function () {
                var e = t.pageYOffset;
                this.element.focus({ preventScroll: !0 }),
                  t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
              }),
              (f.deactivate = function () {
                this.isActive &&
                  (this.element.classList.remove("flickity-enabled"),
                  this.element.classList.remove("flickity-rtl"),
                  this.unselectSelectedSlide(),
                  this.cells.forEach(function (t) {
                    t.destroy();
                  }),
                  this.element.removeChild(this.viewport),
                  h(this.slider.children, this.element),
                  this.options.accessibility &&
                    (this.element.removeAttribute("tabIndex"),
                    this.element.removeEventListener("keydown", this)),
                  (this.isActive = !1),
                  this.emitEvent("deactivate"));
              }),
              (f.destroy = function () {
                this.deactivate(),
                  t.removeEventListener("resize", this),
                  this.allOff(),
                  this.emitEvent("destroy"),
                  a && this.$element && a.removeData(this.element, "flickity"),
                  delete this.element.flickityGUID,
                  delete u[this.guid];
              }),
              n.extend(f, r),
              (p.data = function (t) {
                var e = (t = n.getQueryElement(t)) && t.flickityGUID;
                return e && u[e];
              }),
              n.htmlInit(p, "flickity"),
              a && a.bridget && a.bridget("flickity", p),
              (p.setJQuery = function (t) {
                a = t;
              }),
              (p.Cell = s),
              (p.Slide = o),
              p
            );
          });
        }),
        An = bn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, wn))
              : (e.Unipointer = i(e, e.EvEmitter));
          })(window, function (t, e) {
            function i() {}
            var n = (i.prototype = Object.create(e.prototype));
            (n.bindStartEvent = function (t) {
              this._bindStartEvent(t, !0);
            }),
              (n.unbindStartEvent = function (t) {
                this._bindStartEvent(t, !1);
              }),
              (n._bindStartEvent = function (e, i) {
                var n = (i = void 0 === i || i)
                    ? "addEventListener"
                    : "removeEventListener",
                  s = "mousedown";
                t.PointerEvent
                  ? (s = "pointerdown")
                  : "ontouchstart" in t && (s = "touchstart"),
                  e[n](s, this);
              }),
              (n.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
              }),
              (n.getTouch = function (t) {
                for (var e = 0; e < t.length; e++) {
                  var i = t[e];
                  if (i.identifier == this.pointerIdentifier) return i;
                }
              }),
              (n.onmousedown = function (t) {
                var e = t.button;
                (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
              }),
              (n.ontouchstart = function (t) {
                this._pointerDown(t, t.changedTouches[0]);
              }),
              (n.onpointerdown = function (t) {
                this._pointerDown(t, t);
              }),
              (n._pointerDown = function (t, e) {
                t.button ||
                  this.isPointerDown ||
                  ((this.isPointerDown = !0),
                  (this.pointerIdentifier =
                    void 0 !== e.pointerId ? e.pointerId : e.identifier),
                  this.pointerDown(t, e));
              }),
              (n.pointerDown = function (t, e) {
                this._bindPostStartEvents(t),
                  this.emitEvent("pointerDown", [t, e]);
              });
            var s = {
              mousedown: ["mousemove", "mouseup"],
              touchstart: ["touchmove", "touchend", "touchcancel"],
              pointerdown: ["pointermove", "pointerup", "pointercancel"],
            };
            return (
              (n._bindPostStartEvents = function (e) {
                if (e) {
                  var i = s[e.type];
                  i.forEach(function (e) {
                    t.addEventListener(e, this);
                  }, this),
                    (this._boundPointerEvents = i);
                }
              }),
              (n._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                  (this._boundPointerEvents.forEach(function (e) {
                    t.removeEventListener(e, this);
                  }, this),
                  delete this._boundPointerEvents);
              }),
              (n.onmousemove = function (t) {
                this._pointerMove(t, t);
              }),
              (n.onpointermove = function (t) {
                t.pointerId == this.pointerIdentifier &&
                  this._pointerMove(t, t);
              }),
              (n.ontouchmove = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerMove(t, e);
              }),
              (n._pointerMove = function (t, e) {
                this.pointerMove(t, e);
              }),
              (n.pointerMove = function (t, e) {
                this.emitEvent("pointerMove", [t, e]);
              }),
              (n.onmouseup = function (t) {
                this._pointerUp(t, t);
              }),
              (n.onpointerup = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
              }),
              (n.ontouchend = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerUp(t, e);
              }),
              (n._pointerUp = function (t, e) {
                this._pointerDone(), this.pointerUp(t, e);
              }),
              (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]);
              }),
              (n._pointerDone = function () {
                this._pointerReset(),
                  this._unbindPostStartEvents(),
                  this.pointerDone();
              }),
              (n._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
              }),
              (n.pointerDone = function () {}),
              (n.onpointercancel = function (t) {
                t.pointerId == this.pointerIdentifier &&
                  this._pointerCancel(t, t);
              }),
              (n.ontouchcancel = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerCancel(t, e);
              }),
              (n._pointerCancel = function (t, e) {
                this._pointerDone(), this.pointerCancel(t, e);
              }),
              (n.pointerCancel = function (t, e) {
                this.emitEvent("pointerCancel", [t, e]);
              }),
              (i.getPointerPoint = function (t) {
                return { x: t.pageX, y: t.pageY };
              }),
              i
            );
          });
        }),
        Ln = bn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, An))
              : (e.Unidragger = i(e, e.Unipointer));
          })(window, function (t, e) {
            function i() {}
            var n = (i.prototype = Object.create(e.prototype));
            (n.bindHandles = function () {
              this._bindHandles(!0);
            }),
              (n.unbindHandles = function () {
                this._bindHandles(!1);
              }),
              (n._bindHandles = function (e) {
                for (
                  var i = (e = void 0 === e || e)
                      ? "addEventListener"
                      : "removeEventListener",
                    n = e ? this._touchActionValue : "",
                    s = 0;
                  s < this.handles.length;
                  s++
                ) {
                  var o = this.handles[s];
                  this._bindStartEvent(o, e),
                    o[i]("click", this),
                    t.PointerEvent && (o.style.touchAction = n);
                }
              }),
              (n._touchActionValue = "none"),
              (n.pointerDown = function (t, e) {
                this.okayPointerDown(t) &&
                  ((this.pointerDownPointer = e),
                  t.preventDefault(),
                  this.pointerDownBlur(),
                  this._bindPostStartEvents(t),
                  this.emitEvent("pointerDown", [t, e]));
              });
            var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
              o = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0,
              };
            return (
              (n.okayPointerDown = function (t) {
                var e = s[t.target.nodeName],
                  i = o[t.target.type],
                  n = !e || i;
                return n || this._pointerReset(), n;
              }),
              (n.pointerDownBlur = function () {
                var t = document.activeElement;
                t && t.blur && t != document.body && t.blur();
              }),
              (n.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.emitEvent("pointerMove", [t, e, i]),
                  this._dragMove(t, e, i);
              }),
              (n._dragPointerMove = function (t, e) {
                var i = {
                  x: e.pageX - this.pointerDownPointer.pageX,
                  y: e.pageY - this.pointerDownPointer.pageY,
                };
                return (
                  !this.isDragging &&
                    this.hasDragStarted(i) &&
                    this._dragStart(t, e),
                  i
                );
              }),
              (n.hasDragStarted = function (t) {
                return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
              }),
              (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
              }),
              (n._dragPointerUp = function (t, e) {
                this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
              }),
              (n._dragStart = function (t, e) {
                (this.isDragging = !0),
                  (this.isPreventingClicks = !0),
                  this.dragStart(t, e);
              }),
              (n.dragStart = function (t, e) {
                this.emitEvent("dragStart", [t, e]);
              }),
              (n._dragMove = function (t, e, i) {
                this.isDragging && this.dragMove(t, e, i);
              }),
              (n.dragMove = function (t, e, i) {
                t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
              }),
              (n._dragEnd = function (t, e) {
                (this.isDragging = !1),
                  setTimeout(
                    function () {
                      delete this.isPreventingClicks;
                    }.bind(this)
                  ),
                  this.dragEnd(t, e);
              }),
              (n.dragEnd = function (t, e) {
                this.emitEvent("dragEnd", [t, e]);
              }),
              (n.onclick = function (t) {
                this.isPreventingClicks && t.preventDefault();
              }),
              (n._staticClick = function (t, e) {
                (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                  (this.staticClick(t, e),
                  "mouseup" != t.type &&
                    ((this.isIgnoringMouseUp = !0),
                    setTimeout(
                      function () {
                        delete this.isIgnoringMouseUp;
                      }.bind(this),
                      400
                    )));
              }),
              (n.staticClick = function (t, e) {
                this.emitEvent("staticClick", [t, e]);
              }),
              (i.getPointerPoint = e.getPointerPoint),
              i
            );
          });
        }),
        In =
          (bn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, Tn, Ln, Cn))
                : (e.Flickity = i(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
            })(window, function (t, e, i, n) {
              n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
                e.createMethods.push("_createDrag");
              var s = e.prototype;
              n.extend(s, i.prototype), (s._touchActionValue = "pan-y");
              var o = "createTouch" in document,
                r = !1;
              (s._createDrag = function () {
                this.on("activate", this.onActivateDrag),
                  this.on("uiChange", this._uiChangeDrag),
                  this.on("deactivate", this.onDeactivateDrag),
                  this.on("cellChange", this.updateDraggable),
                  o &&
                    !r &&
                    (t.addEventListener("touchmove", function () {}), (r = !0));
              }),
                (s.onActivateDrag = function () {
                  (this.handles = [this.viewport]),
                    this.bindHandles(),
                    this.updateDraggable();
                }),
                (s.onDeactivateDrag = function () {
                  this.unbindHandles(),
                    this.element.classList.remove("is-draggable");
                }),
                (s.updateDraggable = function () {
                  ">1" == this.options.draggable
                    ? (this.isDraggable = this.slides.length > 1)
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable
                      ? this.element.classList.add("is-draggable")
                      : this.element.classList.remove("is-draggable");
                }),
                (s.bindDrag = function () {
                  (this.options.draggable = !0), this.updateDraggable();
                }),
                (s.unbindDrag = function () {
                  (this.options.draggable = !1), this.updateDraggable();
                }),
                (s._uiChangeDrag = function () {
                  delete this.isFreeScrolling;
                }),
                (s.pointerDown = function (e, i) {
                  this.isDraggable
                    ? this.okayPointerDown(e) &&
                      (this._pointerDownPreventDefault(e),
                      this.pointerDownFocus(e),
                      document.activeElement != this.element &&
                        this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = l()),
                      t.addEventListener("scroll", this),
                      this._pointerDownDefault(e, i))
                    : this._pointerDownDefault(e, i);
                }),
                (s._pointerDownDefault = function (t, e) {
                  (this.pointerDownPointer = {
                    pageX: e.pageX,
                    pageY: e.pageY,
                  }),
                    this._bindPostStartEvents(t),
                    this.dispatchEvent("pointerDown", t, [e]);
                });
              var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
              function l() {
                return { x: t.pageXOffset, y: t.pageYOffset };
              }
              return (
                (s.pointerDownFocus = function (t) {
                  a[t.target.nodeName] || this.focus();
                }),
                (s._pointerDownPreventDefault = function (t) {
                  var e = "touchstart" == t.type,
                    i = "touch" == t.pointerType,
                    n = a[t.target.nodeName];
                  e || i || n || t.preventDefault();
                }),
                (s.hasDragStarted = function (t) {
                  return Math.abs(t.x) > this.options.dragThreshold;
                }),
                (s.pointerUp = function (t, e) {
                  delete this.isTouchScrolling,
                    this.viewport.classList.remove("is-pointer-down"),
                    this.dispatchEvent("pointerUp", t, [e]),
                    this._dragPointerUp(t, e);
                }),
                (s.pointerDone = function () {
                  t.removeEventListener("scroll", this),
                    delete this.pointerDownScroll;
                }),
                (s.dragStart = function (e, i) {
                  this.isDraggable &&
                    ((this.dragStartPosition = this.x),
                    this.startAnimation(),
                    t.removeEventListener("scroll", this),
                    this.dispatchEvent("dragStart", e, [i]));
                }),
                (s.pointerMove = function (t, e) {
                  var i = this._dragPointerMove(t, e);
                  this.dispatchEvent("pointerMove", t, [e, i]),
                    this._dragMove(t, e, i);
                }),
                (s.dragMove = function (t, e, i) {
                  if (this.isDraggable) {
                    t.preventDefault(), (this.previousDragX = this.dragX);
                    var n = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround &&
                      (i.x = i.x % this.slideableWidth);
                    var s = this.dragStartPosition + i.x * n;
                    if (!this.options.wrapAround && this.slides.length) {
                      var o = Math.max(
                        -this.slides[0].target,
                        this.dragStartPosition
                      );
                      s = s > o ? 0.5 * (s + o) : s;
                      var r = Math.min(
                        -this.getLastSlide().target,
                        this.dragStartPosition
                      );
                      s = s < r ? 0.5 * (s + r) : s;
                    }
                    (this.dragX = s),
                      (this.dragMoveTime = new Date()),
                      this.dispatchEvent("dragMove", t, [e, i]);
                  }
                }),
                (s.dragEnd = function (t, e) {
                  if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var i = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                      var n = this.getRestingPosition();
                      this.isFreeScrolling =
                        -n > this.slides[0].target &&
                        -n < this.getLastSlide().target;
                    } else
                      this.options.freeScroll ||
                        i != this.selectedIndex ||
                        (i += this.dragEndBoostSelect());
                    delete this.previousDragX,
                      (this.isDragSelect = this.options.wrapAround),
                      this.select(i),
                      delete this.isDragSelect,
                      this.dispatchEvent("dragEnd", t, [e]);
                  }
                }),
                (s.dragEndRestingSelect = function () {
                  var t = this.getRestingPosition(),
                    e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                    i = this._getClosestResting(t, e, 1),
                    n = this._getClosestResting(t, e, -1);
                  return i.distance < n.distance ? i.index : n.index;
                }),
                (s._getClosestResting = function (t, e, i) {
                  for (
                    var n = this.selectedIndex,
                      s = 1 / 0,
                      o =
                        this.options.contain && !this.options.wrapAround
                          ? function (t, e) {
                              return t <= e;
                            }
                          : function (t, e) {
                              return t < e;
                            };
                    o(e, s) &&
                    ((n += i),
                    (s = e),
                    null !== (e = this.getSlideDistance(-t, n)));

                  )
                    e = Math.abs(e);
                  return { distance: s, index: n - i };
                }),
                (s.getSlideDistance = function (t, e) {
                  var i = this.slides.length,
                    s = this.options.wrapAround && i > 1,
                    o = s ? n.modulo(e, i) : e,
                    r = this.slides[o];
                  if (!r) return null;
                  var a = s ? this.slideableWidth * Math.floor(e / i) : 0;
                  return t - (r.target + a);
                }),
                (s.dragEndBoostSelect = function () {
                  if (
                    void 0 === this.previousDragX ||
                    !this.dragMoveTime ||
                    new Date() - this.dragMoveTime > 100
                  )
                    return 0;
                  var t = this.getSlideDistance(
                      -this.dragX,
                      this.selectedIndex
                    ),
                    e = this.previousDragX - this.dragX;
                  return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                }),
                (s.staticClick = function (t, e) {
                  var i = this.getParentCell(t.target),
                    n = i && i.element,
                    s = i && this.cells.indexOf(i);
                  this.dispatchEvent("staticClick", t, [e, n, s]);
                }),
                (s.onscroll = function () {
                  var t = l(),
                    e = this.pointerDownScroll.x - t.x,
                    i = this.pointerDownScroll.y - t.y;
                  (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
                }),
                e
              );
            });
          }),
          bn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, Tn, An, Cn))
                : i(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (t, e, i, n) {
              var s = "http://www.w3.org/2000/svg";
              function o(t, e) {
                (this.direction = t), (this.parent = e), this._create();
              }
              (o.prototype = Object.create(i.prototype)),
                (o.prototype._create = function () {
                  (this.isEnabled = !0),
                    (this.isPrevious = -1 == this.direction);
                  var t = this.parent.options.rightToLeft ? 1 : -1;
                  this.isLeft = this.direction == t;
                  var e = (this.element = document.createElement("button"));
                  (e.className = "flickity-button flickity-prev-next-button"),
                    (e.className += this.isPrevious ? " previous" : " next"),
                    e.setAttribute("type", "button"),
                    this.disable(),
                    e.setAttribute(
                      "aria-label",
                      this.isPrevious ? "Previous" : "Next"
                    );
                  var i = this.createSVG();
                  e.appendChild(i),
                    this.parent.on("select", this.update.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (o.prototype.activate = function () {
                  this.bindStartEvent(this.element),
                    this.element.addEventListener("click", this),
                    this.parent.element.appendChild(this.element);
                }),
                (o.prototype.deactivate = function () {
                  this.parent.element.removeChild(this.element),
                    this.unbindStartEvent(this.element),
                    this.element.removeEventListener("click", this);
                }),
                (o.prototype.createSVG = function () {
                  var t = document.createElementNS(s, "svg");
                  t.setAttribute("class", "flickity-button-icon"),
                    t.setAttribute("viewBox", "0 0 100 100");
                  var e = document.createElementNS(s, "path"),
                    i = (function (t) {
                      if ("string" == typeof t) return t;
                      return (
                        "M " +
                        t.x0 +
                        ",50 L " +
                        t.x1 +
                        "," +
                        (t.y1 + 50) +
                        " L " +
                        t.x2 +
                        "," +
                        (t.y2 + 50) +
                        " L " +
                        t.x3 +
                        ",50  L " +
                        t.x2 +
                        "," +
                        (50 - t.y2) +
                        " L " +
                        t.x1 +
                        "," +
                        (50 - t.y1) +
                        " Z"
                      );
                    })(this.parent.options.arrowShape);
                  return (
                    e.setAttribute("d", i),
                    e.setAttribute("class", "arrow"),
                    this.isLeft ||
                      e.setAttribute(
                        "transform",
                        "translate(100, 100) rotate(180) "
                      ),
                    t.appendChild(e),
                    t
                  );
                }),
                (o.prototype.handleEvent = n.handleEvent),
                (o.prototype.onclick = function () {
                  if (this.isEnabled) {
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                  }
                }),
                (o.prototype.enable = function () {
                  this.isEnabled ||
                    ((this.element.disabled = !1), (this.isEnabled = !0));
                }),
                (o.prototype.disable = function () {
                  this.isEnabled &&
                    ((this.element.disabled = !0), (this.isEnabled = !1));
                }),
                (o.prototype.update = function () {
                  var t = this.parent.slides;
                  if (this.parent.options.wrapAround && t.length > 1)
                    this.enable();
                  else {
                    var e = t.length ? t.length - 1 : 0,
                      i = this.isPrevious ? 0 : e;
                    this[
                      this.parent.selectedIndex == i ? "disable" : "enable"
                    ]();
                  }
                }),
                (o.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                n.extend(e.defaults, {
                  prevNextButtons: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 70,
                    y2: 40,
                    x3: 30,
                  },
                }),
                e.createMethods.push("_createPrevNextButtons");
              var r = e.prototype;
              return (
                (r._createPrevNextButtons = function () {
                  this.options.prevNextButtons &&
                    ((this.prevButton = new o(-1, this)),
                    (this.nextButton = new o(1, this)),
                    this.on("activate", this.activatePrevNextButtons));
                }),
                (r.activatePrevNextButtons = function () {
                  this.prevButton.activate(),
                    this.nextButton.activate(),
                    this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (r.deactivatePrevNextButtons = function () {
                  this.prevButton.deactivate(),
                    this.nextButton.deactivate(),
                    this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (e.PrevNextButton = o),
                e
              );
            });
          }),
          bn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, Tn, An, Cn))
                : i(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (t, e, i, n) {
              function s(t) {
                (this.parent = t), this._create();
              }
              (s.prototype = Object.create(i.prototype)),
                (s.prototype._create = function () {
                  (this.holder = document.createElement("ol")),
                    (this.holder.className = "flickity-page-dots"),
                    (this.dots = []),
                    (this.handleClick = this.onClick.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (s.prototype.activate = function () {
                  this.setDots(),
                    this.holder.addEventListener("click", this.handleClick),
                    this.bindStartEvent(this.holder),
                    this.parent.element.appendChild(this.holder);
                }),
                (s.prototype.deactivate = function () {
                  this.holder.removeEventListener("click", this.handleClick),
                    this.unbindStartEvent(this.holder),
                    this.parent.element.removeChild(this.holder);
                }),
                (s.prototype.setDots = function () {
                  var t = this.parent.slides.length - this.dots.length;
                  t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
                }),
                (s.prototype.addDots = function (t) {
                  for (
                    var e = document.createDocumentFragment(),
                      i = [],
                      n = this.dots.length,
                      s = n + t,
                      o = n;
                    o < s;
                    o++
                  ) {
                    var r = document.createElement("li");
                    (r.className = "dot"),
                      r.setAttribute("aria-label", "Page dot " + (o + 1)),
                      e.appendChild(r),
                      i.push(r);
                  }
                  this.holder.appendChild(e), (this.dots = this.dots.concat(i));
                }),
                (s.prototype.removeDots = function (t) {
                  this.dots
                    .splice(this.dots.length - t, t)
                    .forEach(function (t) {
                      this.holder.removeChild(t);
                    }, this);
                }),
                (s.prototype.updateSelected = function () {
                  this.selectedDot &&
                    ((this.selectedDot.className = "dot"),
                    this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length &&
                      ((this.selectedDot =
                        this.dots[this.parent.selectedIndex]),
                      (this.selectedDot.className = "dot is-selected"),
                      this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (s.prototype.onTap = s.prototype.onClick =
                  function (t) {
                    var e = t.target;
                    if ("LI" == e.nodeName) {
                      this.parent.uiChange();
                      var i = this.dots.indexOf(e);
                      this.parent.select(i);
                    }
                  }),
                (s.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                (e.PageDots = s),
                n.extend(e.defaults, { pageDots: !0 }),
                e.createMethods.push("_createPageDots");
              var o = e.prototype;
              return (
                (o._createPageDots = function () {
                  this.options.pageDots &&
                    ((this.pageDots = new s(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
                }),
                (o.activatePageDots = function () {
                  this.pageDots.activate();
                }),
                (o.updateSelectedPageDots = function () {
                  this.pageDots.updateSelected();
                }),
                (o.updatePageDots = function () {
                  this.pageDots.setDots();
                }),
                (o.deactivatePageDots = function () {
                  this.pageDots.deactivate();
                }),
                (e.PageDots = s),
                e
              );
            });
          }),
          bn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(wn, Cn, Tn))
                : i(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
            })(window, function (t, e, i) {
              function n(t) {
                (this.parent = t),
                  (this.state = "stopped"),
                  (this.onVisibilityChange = this.visibilityChange.bind(this)),
                  (this.onVisibilityPlay = this.visibilityPlay.bind(this));
              }
              (n.prototype = Object.create(t.prototype)),
                (n.prototype.play = function () {
                  "playing" != this.state &&
                    (document.hidden
                      ? document.addEventListener(
                          "visibilitychange",
                          this.onVisibilityPlay
                        )
                      : ((this.state = "playing"),
                        document.addEventListener(
                          "visibilitychange",
                          this.onVisibilityChange
                        ),
                        this.tick()));
                }),
                (n.prototype.tick = function () {
                  if ("playing" == this.state) {
                    var t = this.parent.options.autoPlay;
                    t = "number" == typeof t ? t : 3e3;
                    var e = this;
                    this.clear(),
                      (this.timeout = setTimeout(function () {
                        e.parent.next(!0), e.tick();
                      }, t));
                  }
                }),
                (n.prototype.stop = function () {
                  (this.state = "stopped"),
                    this.clear(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityChange
                    );
                }),
                (n.prototype.clear = function () {
                  clearTimeout(this.timeout);
                }),
                (n.prototype.pause = function () {
                  "playing" == this.state &&
                    ((this.state = "paused"), this.clear());
                }),
                (n.prototype.unpause = function () {
                  "paused" == this.state && this.play();
                }),
                (n.prototype.visibilityChange = function () {
                  this[document.hidden ? "pause" : "unpause"]();
                }),
                (n.prototype.visibilityPlay = function () {
                  this.play(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityPlay
                    );
                }),
                e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                i.createMethods.push("_createPlayer");
              var s = i.prototype;
              return (
                (s._createPlayer = function () {
                  (this.player = new n(this)),
                    this.on("activate", this.activatePlayer),
                    this.on("uiChange", this.stopPlayer),
                    this.on("pointerDown", this.stopPlayer),
                    this.on("deactivate", this.deactivatePlayer);
                }),
                (s.activatePlayer = function () {
                  this.options.autoPlay &&
                    (this.player.play(),
                    this.element.addEventListener("mouseenter", this));
                }),
                (s.playPlayer = function () {
                  this.player.play();
                }),
                (s.stopPlayer = function () {
                  this.player.stop();
                }),
                (s.pausePlayer = function () {
                  this.player.pause();
                }),
                (s.unpausePlayer = function () {
                  this.player.unpause();
                }),
                (s.deactivatePlayer = function () {
                  this.player.stop(),
                    this.element.removeEventListener("mouseenter", this);
                }),
                (s.onmouseenter = function () {
                  this.options.pauseAutoPlayOnHover &&
                    (this.player.pause(),
                    this.element.addEventListener("mouseleave", this));
                }),
                (s.onmouseleave = function () {
                  this.player.unpause(),
                    this.element.removeEventListener("mouseleave", this);
                }),
                (i.Player = n),
                i
              );
            });
          }),
          bn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, Tn, Cn))
                : i(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (t, e, i) {
              var n = e.prototype;
              return (
                (n.insert = function (t, e) {
                  var i = this._makeCells(t);
                  if (i && i.length) {
                    var n = this.cells.length;
                    e = void 0 === e ? n : e;
                    var s = (function (t) {
                        var e = document.createDocumentFragment();
                        return (
                          t.forEach(function (t) {
                            e.appendChild(t.element);
                          }),
                          e
                        );
                      })(i),
                      o = e == n;
                    if (o) this.slider.appendChild(s);
                    else {
                      var r = this.cells[e].element;
                      this.slider.insertBefore(s, r);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (o) this.cells = this.cells.concat(i);
                    else {
                      var a = this.cells.splice(e, n - e);
                      this.cells = this.cells.concat(i).concat(a);
                    }
                    this._sizeCells(i), this.cellChange(e, !0);
                  }
                }),
                (n.append = function (t) {
                  this.insert(t, this.cells.length);
                }),
                (n.prepend = function (t) {
                  this.insert(t, 0);
                }),
                (n.remove = function (t) {
                  var e = this.getCells(t);
                  if (e && e.length) {
                    var n = this.cells.length - 1;
                    e.forEach(function (t) {
                      t.remove();
                      var e = this.cells.indexOf(t);
                      (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                    }, this),
                      this.cellChange(n, !0);
                  }
                }),
                (n.cellSizeChange = function (t) {
                  var e = this.getCell(t);
                  if (e) {
                    e.getSize();
                    var i = this.cells.indexOf(e);
                    this.cellChange(i);
                  }
                }),
                (n.cellChange = function (t, e) {
                  var i = this.selectedElement;
                  this._positionCells(t),
                    this._getWrapShiftCells(),
                    this.setGallerySize();
                  var n = this.getCell(i);
                  n && (this.selectedIndex = this.getCellSlideIndex(n)),
                    (this.selectedIndex = Math.min(
                      this.slides.length - 1,
                      this.selectedIndex
                    )),
                    this.emitEvent("cellChange", [t]),
                    this.select(this.selectedIndex),
                    e && this.positionSliderAtSelected();
                }),
                e
              );
            });
          }),
          bn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, Tn, Cn))
                : i(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (t, e, i) {
              e.createMethods.push("_createLazyload");
              var n = e.prototype;
              function s(t, e) {
                (this.img = t), (this.flickity = e), this.load();
              }
              return (
                (n._createLazyload = function () {
                  this.on("select", this.lazyLoad);
                }),
                (n.lazyLoad = function () {
                  var t = this.options.lazyLoad;
                  if (t) {
                    var e = "number" == typeof t ? t : 0,
                      n = this.getAdjacentCellElements(e),
                      o = [];
                    n.forEach(function (t) {
                      var e = (function (t) {
                        if ("IMG" == t.nodeName) {
                          var e = t.getAttribute("data-flickity-lazyload"),
                            n = t.getAttribute("data-flickity-lazyload-src"),
                            s = t.getAttribute("data-flickity-lazyload-srcset");
                          if (e || n || s) return [t];
                        }
                        var o =
                            "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                          r = t.querySelectorAll(o);
                        return i.makeArray(r);
                      })(t);
                      o = o.concat(e);
                    }),
                      o.forEach(function (t) {
                        new s(t, this);
                      }, this);
                  }
                }),
                (s.prototype.handleEvent = i.handleEvent),
                (s.prototype.load = function () {
                  this.img.addEventListener("load", this),
                    this.img.addEventListener("error", this);
                  var t =
                      this.img.getAttribute("data-flickity-lazyload") ||
                      this.img.getAttribute("data-flickity-lazyload-src"),
                    e = this.img.getAttribute("data-flickity-lazyload-srcset");
                  (this.img.src = t),
                    e && this.img.setAttribute("srcset", e),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
                }),
                (s.prototype.onload = function (t) {
                  this.complete(t, "flickity-lazyloaded");
                }),
                (s.prototype.onerror = function (t) {
                  this.complete(t, "flickity-lazyerror");
                }),
                (s.prototype.complete = function (t, e) {
                  this.img.removeEventListener("load", this),
                    this.img.removeEventListener("error", this);
                  var i = this.flickity.getParentCell(this.img),
                    n = i && i.element;
                  this.flickity.cellSizeChange(n),
                    this.img.classList.add(e),
                    this.flickity.dispatchEvent("lazyLoad", t, n);
                }),
                (e.LazyLoader = s),
                e
              );
            });
          }),
          bn(function (t) {
            window, t.exports && (t.exports = Tn);
          })),
        Dn = bn(function (t) {
          !(function (e, i) {
            t.exports ? (t.exports = i(In, Cn)) : i(e.Flickity, e.fizzyUIUtils);
          })(yn, function (t, e) {
            var i = t.Slide,
              n = i.prototype.updateTarget;
            (i.prototype.updateTarget = function () {
              if ((n.apply(this, arguments), this.parent.options.fade)) {
                var t = this.target - this.x,
                  e = this.cells[0].x;
                this.cells.forEach(function (i) {
                  var n = i.x - e - t;
                  i.renderPosition(n);
                });
              }
            }),
              (i.prototype.setOpacity = function (t) {
                this.cells.forEach(function (e) {
                  e.element.style.opacity = t;
                });
              });
            var s = t.prototype;
            t.createMethods.push("_createFade"),
              (s._createFade = function () {
                (this.fadeIndex = this.selectedIndex),
                  (this.prevSelectedIndex = this.selectedIndex),
                  this.on("select", this.onSelectFade),
                  this.on("dragEnd", this.onDragEndFade),
                  this.on("settle", this.onSettleFade),
                  this.on("activate", this.onActivateFade),
                  this.on("deactivate", this.onDeactivateFade);
              });
            var o = s.updateSlides;
            (s.updateSlides = function () {
              o.apply(this, arguments),
                this.options.fade &&
                  this.slides.forEach(function (t, e) {
                    var i = e == this.selectedIndex ? 1 : 0;
                    t.setOpacity(i);
                  }, this);
            }),
              (s.onSelectFade = function () {
                (this.fadeIndex = Math.min(
                  this.prevSelectedIndex,
                  this.slides.length - 1
                )),
                  (this.prevSelectedIndex = this.selectedIndex);
              }),
              (s.onSettleFade = function () {
                (delete this.didDragEnd, this.options.fade) &&
                  (this.selectedSlide.setOpacity(1),
                  this.slides[this.fadeIndex] &&
                    this.fadeIndex != this.selectedIndex &&
                    this.slides[this.fadeIndex].setOpacity(0));
              }),
              (s.onDragEndFade = function () {
                this.didDragEnd = !0;
              }),
              (s.onActivateFade = function () {
                this.options.fade && this.element.classList.add("is-fade");
              }),
              (s.onDeactivateFade = function () {
                this.options.fade &&
                  (this.element.classList.remove("is-fade"),
                  this.slides.forEach(function (t) {
                    t.setOpacity("");
                  }));
              });
            var r = s.positionSlider;
            s.positionSlider = function () {
              this.options.fade
                ? (this.fadeSlides(), this.dispatchScrollEvent())
                : r.apply(this, arguments);
            };
            var a = s.positionSliderAtSelected;
            (s.positionSliderAtSelected = function () {
              this.options.fade && this.setTranslateX(0),
                a.apply(this, arguments);
            }),
              (s.fadeSlides = function () {
                if (!(this.slides.length < 2)) {
                  var t = this.getFadeIndexes(),
                    e = this.slides[t.a],
                    i = this.slides[t.b],
                    n = this.wrapDifference(e.target, i.target),
                    s = this.wrapDifference(e.target, -this.x);
                  (s /= n), e.setOpacity(1 - s), i.setOpacity(s);
                  var o = t.a;
                  this.isDragging && (o = s > 0.5 ? t.a : t.b),
                    null != this.fadeHideIndex &&
                      this.fadeHideIndex != o &&
                      this.fadeHideIndex != t.a &&
                      this.fadeHideIndex != t.b &&
                      this.slides[this.fadeHideIndex].setOpacity(0),
                    (this.fadeHideIndex = o);
                }
              }),
              (s.getFadeIndexes = function () {
                return this.isDragging || this.didDragEnd
                  ? this.options.wrapAround
                    ? this.getFadeDragWrapIndexes()
                    : this.getFadeDragLimitIndexes()
                  : { a: this.fadeIndex, b: this.selectedIndex };
              }),
              (s.getFadeDragWrapIndexes = function () {
                var t = this.slides.map(function (t, e) {
                    return this.getSlideDistance(-this.x, e);
                  }, this),
                  i = t.map(function (t) {
                    return Math.abs(t);
                  }),
                  n = Math.min.apply(Math, i),
                  s = i.indexOf(n),
                  o = t[s],
                  r = this.slides.length,
                  a = o >= 0 ? 1 : -1;
                return { a: s, b: e.modulo(s + a, r) };
              }),
              (s.getFadeDragLimitIndexes = function () {
                for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
                  var i = this.slides[e];
                  if (-this.x < i.target) break;
                  t = e;
                }
                return { a: t, b: t + 1 };
              }),
              (s.wrapDifference = function (t, e) {
                var i = e - t;
                if (!this.options.wrapAround) return i;
                var n = i + this.slideableWidth,
                  s = i - this.slideableWidth;
                return (
                  Math.abs(n) < Math.abs(i) && (i = n),
                  Math.abs(s) < Math.abs(i) && (i = s),
                  i
                );
              });
            var l = s._getWrapShiftCells;
            s._getWrapShiftCells = function () {
              this.options.fade || l.apply(this, arguments);
            };
            var c = s.shiftWrapCells;
            return (
              (s.shiftWrapCells = function () {
                this.options.fade || c.apply(this, arguments);
              }),
              t
            );
          });
        }),
        Pn = bn(function (t, e) {
          e.__esModule = !0;
          var i = (function () {
            function t() {
              this.events = [];
            }
            return (
              (t.prototype.register = function (t, e, i) {
                return t && e && i
                  ? (this.events.push({ el: t, event: e, listener: i }),
                    t.addEventListener(e, i),
                    { el: t, event: e, listener: i })
                  : null;
              }),
              (t.prototype.unregister = function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e && i && n
                  ? ((this.events = this.events.filter(function (t) {
                      return e !== t.el || i !== t.event || n !== t.listener;
                    })),
                    e.removeEventListener(i, n),
                    { el: e, event: i, listener: n })
                  : null;
              }),
              (t.prototype.unregisterAll = function () {
                this.events.forEach(function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e.removeEventListener(i, n);
                }),
                  (this.events = []);
              }),
              t
            );
          })();
          e.default = i;
        }),
        $n = (function (t) {
          return t &&
            t.__esModule &&
            Object.prototype.hasOwnProperty.call(t, "default")
            ? t.default
            : t;
        })(Pn);
      const Mn = (function () {
          function t(e) {
            var i = this;
            if (
              ((function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t),
              (this.el = e.el),
              (this.settings = e.data),
              (this.paginationClicked = !1),
              (this.events = new $n()),
              (this.carousel = this.el.querySelector(
                "[data-slideshow-wrapper]"
              )),
              (this.slides = this.el.querySelectorAll(
                "[data-slideshow-slide]"
              )),
              (this.pagination = this.el.querySelector(
                "[data-slideshow-pagination]"
              )),
              (this.paginationButtons = this.pagination
                ? this.pagination.querySelectorAll("[data-slide-button]")
                : null),
              (this.counter = this.el.querySelector("[data-slide-counter]")),
              this.el.style.setProperty(
                "--slide-text-color",
                "".concat(this.slides[0].dataset.textColor)
              ),
              this.carousel &&
                this.slides.length > 1 &&
                ((this.flickity = new Dn(this.carousel, {
                  accessibility: !1,
                  adaptiveHeight: !0,
                  autoPlay:
                    !!this.settings.enable_autoplay &&
                    1e3 * this.settings.autoplay_interval,
                  cellAlign: "left",
                  cellSelector: "[data-slideshow-slide]",
                  contain: !0,
                  fade: this.settings.transition_fade,
                  pageDots: this.settings.show_pagination,
                  pauseAutoPlayOnHover: !0,
                  selectedAttraction: this.settings.slide_attraction
                    ? parseFloat(this.settings.slide_attraction)
                    : 0.03,
                  friction: this.settings.slide_friction
                    ? parseFloat(this.settings.slide_friction)
                    : 0.3,
                  wrapAround: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 45,
                    x3: 20,
                  },
                })),
                (this.prevNextButtons = this.el.querySelectorAll(
                  ".flickity-prev-next-button"
                )),
                2 === this.prevNextButtons.length &&
                  (this.prevNextButtons[0].setAttribute(
                    "aria-label",
                    this.settings.previous_text
                  ),
                  this.prevNextButtons[1].setAttribute(
                    "aria-label",
                    this.settings.next_text
                  )),
                this._updateTabindex(),
                this._positionNavigation(),
                this._updateCounter(1),
                this.flickity.on("change", function (t) {
                  i.el.style.setProperty(
                    "--slide-text-color",
                    "".concat(i.slides[t].dataset.textColor)
                  ),
                    i._updatePagination(),
                    i._positionNavigation(),
                    i._updateTabindex(),
                    i._updateCounter(t + 1);
                }),
                this.flickity.on("pointerDown", function () {
                  return i.flickity.pausePlayer();
                }),
                this.events.register(this.carousel, "rimg:load", function () {
                  i.flickity.resize(), i._positionNavigation();
                }),
                this.events.register(this.carousel, "focusin", function () {
                  return i.flickity.pausePlayer();
                }),
                this.events.register(window, "resize", function () {
                  i._positionNavigation();
                }),
                this.flickity.on("settle", function (t) {
                  i.paginationClicked &&
                    (i.slides[t].focus(), (i.paginationClicked = !1));
                }),
                this.pagination))
            )
              for (
                var n = function (t) {
                    i.events.register(
                      i.paginationButtons[t],
                      "click",
                      function () {
                        var e = parseInt(
                          i.paginationButtons[t].dataset.slideButton,
                          10
                        );
                        i.flickity.pausePlayer(),
                          i.flickity.select(e, !0, !1),
                          (i.paginationClicked = !0);
                      }
                    );
                  },
                  s = 0;
                s < this.paginationButtons.length;
                s++
              )
                n(s);
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "_updatePagination",
                value: function () {
                  if (this.pagination) {
                    for (var t = 0; t < this.paginationButtons.length; t++)
                      (this.paginationButtons[t].dataset.selected = "false"),
                        this.paginationButtons[t].setAttribute(
                          "aria-selected",
                          "false"
                        );
                    (this.paginationButtons[
                      this.flickity.selectedIndex
                    ].dataset.selected = "true"),
                      this.paginationButtons[
                        this.flickity.selectedIndex
                      ].setAttribute("aria-selected", "true");
                  }
                },
              },
              {
                key: "_positionNavigation",
                value: function () {
                  if (this.settings.mobile_navigation_adjust) {
                    var t = this.el.querySelectorAll(
                        ".flickity-prev-next-button"
                      ),
                      e = this.flickity.selectedElement.querySelector(
                        "[data-slide-image-wrapper]"
                      ).offsetHeight;
                    if (t) {
                      var i = "50%";
                      this.viewportIsMobile() && (i = "".concat(e / 2, "px")),
                        (t[0].style.top = i),
                        (t[1].style.top = i);
                    }
                    if (this.pagination) {
                      var n = "auto";
                      if (this.viewportIsMobile())
                        if (
                          this.flickity.selectedElement.querySelector(
                            "[data-slide-content]"
                          )
                        )
                          n = "".concat(e, "px");
                        else {
                          var s = this.pagination.offsetHeight;
                          n = "".concat(e - s, "px");
                        }
                      this.pagination.style.top = n;
                    }
                  }
                },
              },
              {
                key: "_updateTabindex",
                value: function () {
                  for (var t = 0; t < this.slides.length; t++)
                    for (
                      var e = this.slides[t].querySelectorAll("a"), i = 0;
                      i < e.length;
                      i++
                    )
                      e[i].setAttribute(
                        "tabindex",
                        t === this.flickity.selectedIndex ? "0" : "-1"
                      );
                },
              },
              {
                key: "_updateCounter",
                value: function (t) {
                  var e = this.counter.dataset.counterTemplate
                    .replace("", t)
                    .replace("", this.slides.length);
                  this.counter.innerHTML = e;
                },
              },
              {
                key: "viewportIsMobile",
                value: function () {
                  return window.innerWidth < 720;
                },
              },
              {
                key: "onSectionUnload",
                value: function () {
                  this.events.unregisterAll(), this.flickity.destroy();
                },
              },
              {
                key: "onSectionBlockSelect",
                value: function (t) {
                  var e = t.el.dataset.slideIndex;
                  this.flickity.select(e), this.flickity.pausePlayer();
                },
              },
              {
                key: "onSectionBlockDeselect",
                value: function () {
                  this.settings.enable_autoplay && this.flickity.playPlayer();
                },
              },
            ]) && vn(e.prototype, i),
            n && vn(e, n),
            t
          );
        })(),
        On = "pxu-lia-block",
        qn = "pxu-lia-element",
        Fn = "pxu-lia-block--play",
        Bn = "pxu-lia-block--reset",
        Nn = "pxu-lia-section--play",
        Rn = "pxu-lia-section--reset",
        Hn = (t) => {
          let { parentNode: e } = t;
          return e.querySelector(
            '[type="application/pxs-animation-mapping+json"]'
          )
            ? e
            : Hn(e);
        },
        zn = (t, e) => {
          (t.style.animationName = "none"),
            t.classList.add(Bn),
            e.forEach((t) => {
              t.style.animationName = "none";
            });
        },
        jn = (t, e) => {
          (t.style.animationName = ""),
            t.classList.remove(Bn),
            e.forEach((t) => {
              t.style.animationName = "";
            });
        },
        Un = (t, e) => {
          (t.style.animationPlayState = "running"),
            t.classList.add(Fn),
            e.forEach((t) => {
              t.style.animationPlayState = "running";
            });
        },
        Wn = (t, e) => {
          (t.style.animationPlayState = ""),
            t.classList.remove(Fn),
            e.forEach((t) => {
              t.style.animationPlayState = "";
            });
        },
        Vn = function (t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "play";
          const i = [];
          if ("reset" === e) {
            t.forEach((t) => {
              const e = t.querySelectorAll(`.${qn}`);
              Wn(t, e),
                zn(t, e),
                i.push(() => {
                  jn(t, e);
                });
            });
            const e = Hn(t[0]);
            e.classList.remove(Nn),
              e.classList.add(Rn),
              i.push(() => {
                e.classList.remove(Rn);
              });
          } else
            t.forEach((e, n) => {
              e.style.setProperty("--pxu-lia-outer-sequence", n);
              const s = e.querySelectorAll(`.${qn}`);
              s.forEach((t, e) => {
                t.style.setProperty("--pxu-lia-inner-sequence", e);
              }),
                e.classList.contains(Fn)
                  ? (zn(e, s),
                    i.push(() => {
                      jn(e, s), Un(e, s);
                    }))
                  : Un(e, s);
              const o = Hn(t[0]);
              o.classList.contains(Nn)
                ? (o.classList.add(Rn),
                  i.push(() => {
                    o.classList.remove(Rn), o.classList.add(Nn);
                  }))
                : o.classList.add(Nn);
            });
          window.requestAnimationFrame(() => i.forEach((t) => t()));
        },
        Gn = (t) => Vn(t, "play"),
        Xn = (t, e) => {
          const i = new Map();
          t.forEach((t) => {
            if (t.isIntersecting) {
              e.unobserve(t.target);
              const n = Hn(t.target),
                s = i.get(n);
              i.set(n, s ? [...s, t.target] : [t.target]);
            }
          }),
            i.forEach((t, e) => Gn(t));
        };
      let Zn = null;
      class Qn extends Mn {
        constructor(t) {
          super(t),
            (this.carouselContainer = this.carousel.parentNode),
            (this.slideWrappers = this.carousel.querySelectorAll(
              "[data-slide-image-wrapper]"
            )),
            (this.header = document.querySelector(".site-header")),
            (this.announcementBar =
              document.querySelector(".announcement-bar")),
            (this.carouselContainer.classList.contains(
              "slideshow--height-fit_screen"
            ) ||
              this.carouselContainer.classList.contains(
                "slideshow--height-fit_screen-mobile"
              )) &&
              (this._setupCCSVariables(),
              this.events.register(window, "resize", () =>
                this._setupCCSVariables()
              ),
              this._positionNavigation()),
            this.slides.forEach((t) => Zn && Zn.unobserve(t)),
            Gn([this.slides[0]]),
            this.flickity &&
              this.flickity.on("change", (t) => {
                setTimeout(() => {
                  ((t) => {
                    Vn(t, "reset");
                  })(
                    Array.prototype.filter.call(this.slides, (e, i) => i !== t)
                  );
                }, 100),
                  setTimeout(() => {
                    Gn([this.slides[t]]);
                  }, 150),
                  this._setContentHeight(),
                  this._positionNavigation();
              });
        }
        _setContentHeight() {
          const t = ((t) => {
            t = "string" == typeof t ? document.querySelector(t) : t;
            const e = window.getComputedStyle(t),
              i = parseFloat(e.marginTop) + parseFloat(e.marginBottom);
            return Math.ceil(t.offsetHeight + i);
          })(
            this.slides[this.flickity.selectedIndex].querySelector(
              ".slideshow-slide__content"
            )
          );
          this.el.style.setProperty("--content-height", `${t}px`);
        }
        _setupCCSVariables() {
          const t = this.header.offsetHeight;
          let e = 0;
          this.announcmentBar &&
            (e = document.querySelector(".announcement-bar").offsetHeight),
            this.el.style.setProperty("--header-height", t - e + "px"),
            this._setContentHeight(),
            this.flickity.resize();
        }
      }
      class Kn {
        constructor(t) {
          (this.el = t.el), (this.autoplay = t.data.autoplay), this.init();
        }
        init() {
          const t = this.el.querySelector("[data-video]");
          if (
            ((this.hasPlayed = !1),
            t && (this.video = new Ve(t)),
            this.video && this.autoplay)
          ) {
            const e = { play: 0.5, pause: 0.2 };
            (this.playPauseObserver = new IntersectionObserver(
              (t) => {
                const { intersectionRatio: i, isIntersecting: n } = t[0];
                i >= e.play && n && !this.hasPlayed
                  ? (this.video._autoplay(), (this.hasPlayed = !0))
                  : i <= e.pause && !1 === n && this.video._onPauseClick();
              },
              { threshold: [e.pause, e.play] }
            )),
              this.playPauseObserver.observe(t);
          }
        }
        onSectionUnload() {
          this.video && this.video.unload(),
            this.playPauseObserver && this.playPauseObserver.disconnect();
        }
      }
      class Yn {
        constructor(t) {
          (this.$el = e()(t.el)), (this.forms = new F(this.$el));
        }
        onSectionUnload() {
          this.forms.unload();
        }
      }
      class Jn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.$window = e()(window)),
            (this.$carousel = this.$el.find("[data-highlights-slider]")),
            (this.slides = "[data-highlights-block]"),
            (this.flickity = null),
            (this.flickityOptions = null),
            this.$carousel.length > 0 &&
              this.$carousel.find(this.slides).length > 1 &&
              this._initSlider(),
            bt.onChange((t) => this.onBreakpointChange(t));
        }
        _initSlider() {
          (this.flickityOptions = {
            autoPlay: 0,
            accessibility: !0,
            cellAlign: "left",
            cellSelector: this.slides,
            pageDots: !1,
            prevNextButtons: !1,
            contain: !0,
          }),
            this._bindFlickity();
        }
        onSectionUnload() {
          this._destroyFlickity(), this.$window.off(".twitter");
        }
        _bindFlickity() {
          bt.max("M") &&
            null === this.flickity &&
            (this.flickity = new (_t())(
              this.$carousel[0],
              this.flickityOptions
            ));
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
        onBreakpointChange(t) {
          t.current.min("M") && this.flickity
            ? this._destroyFlickity()
            : t.previous.min("M") && this._bindFlickity();
        }
      }
      function ts(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var es = (function (t, e) {
          return t((e = { exports: {} }), e.exports), e.exports;
        })(function (t, e) {
          e.__esModule = !0;
          var i = (function () {
            function t() {
              this.events = [];
            }
            return (
              (t.prototype.register = function (t, e, i) {
                return t && e && i
                  ? (this.events.push({ el: t, event: e, listener: i }),
                    t.addEventListener(e, i),
                    { el: t, event: e, listener: i })
                  : null;
              }),
              (t.prototype.unregister = function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e && i && n
                  ? ((this.events = this.events.filter(function (t) {
                      return e !== t.el || i !== t.event || n !== t.listener;
                    })),
                    e.removeEventListener(i, n),
                    { el: e, event: i, listener: n })
                  : null;
              }),
              (t.prototype.unregisterAll = function () {
                this.events.forEach(function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e.removeEventListener(i, n);
                }),
                  (this.events = []);
              }),
              t
            );
          })();
          e.default = i;
        }),
        is = (function (t) {
          return t &&
            t.__esModule &&
            Object.prototype.hasOwnProperty.call(t, "default")
            ? t.default
            : t;
        })(es);
      const ns = (function () {
        function t(e) {
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
            (this.el = e.el),
            (this.bounds = this.el.getBoundingClientRect()),
            (this.imageWrapper = this.el.querySelector(
              "[data-shoppable-image-wrapper]"
            )),
            (this.image = this.el.querySelector("[data-shoppable-image-img]")),
            (this.points = this.el.querySelectorAll("[data-hotspot]")),
            (this.tooltips = this.el.querySelectorAll(
              "[data-tooltip-wrapper]"
            )),
            (this.activeClass = "shoppable-image__hotspot--active"),
            (this.events = new is()),
            (this.window = window),
            (this.hoverTimer = null),
            (this.tooltipDelay = 300),
            (this.windowScrollTimer = null),
            (this.windowScrollEvent = null),
            this._bindEvents();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_bindEvents",
              value: function () {
                var t = this;
                this._positionElements(),
                  this.image &&
                    this.events.register(this.image, "rimg:load", function (e) {
                      return t._positionElements();
                    }),
                  this.events.register(this.el, "touchend", function () {
                    return t._clearAllActive();
                  });
                for (var e = 0; e < this.points.length; e++) {
                  var i = this.points[e],
                    n = this.tooltips[e];
                  this.events.register(i, "click", function (e) {
                    return t._setActivePoint(e);
                  }),
                    this.events.register(i, "touchend", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(i, "mouseover", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(i, "mouseout", function (e) {
                      return t._closeActivePoint(e);
                    }),
                    this.events.register(i, "focus", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(n, "touchend", function (t) {
                      return t.stopPropagation();
                    }),
                    this.events.register(n, "mouseover", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(n, "mouseout", function (e) {
                      return t._closeActivePoint(e);
                    }),
                    this.events.register(n, "focus", function (t) {
                      return t.stopPropagation();
                    });
                }
              },
            },
            {
              key: "_positionElements",
              value: function () {
                this.positionHotspots(), this.positionTooltips();
              },
            },
            {
              key: "_setActivePoint",
              value: function (t) {
                t.stopPropagation();
                var e = t.currentTarget,
                  i = null;
                if (
                  (null !== this.hoverTimer &&
                    (clearTimeout(this.hoverTimer), (this.hoverTimer = null)),
                  (i = e.closest("[data-hotspot]")),
                  "touchend" === t.type &&
                    i.classList.contains(this.activeClass))
                )
                  i.classList.remove(this.activeClass);
                else if (
                  !(
                    ("click" === t.type &&
                      i.classList.contains(this.activeClass)) ||
                    i.classList.contains(this.activeClass)
                  )
                ) {
                  var n = this.el.querySelector(".".concat(this.activeClass));
                  n && n.classList.remove(this.activeClass),
                    this.positionTooltips(),
                    i.classList.add(this.activeClass);
                }
              },
            },
            {
              key: "_closeActivePoint",
              value: function (t) {
                var e = this,
                  i = t.currentTarget,
                  n = null;
                (n = i.closest("[data-hotspot]")),
                  null !== this.hoverTimer && clearTimeout(this.hoverTimer),
                  (this.hoverTimer = setTimeout(function () {
                    n.classList.remove(e.activeClass);
                  }, this.tooltipDelay));
              },
            },
            {
              key: "_clearAllActive",
              value: function () {
                var t = this.el.querySelector(".".concat(this.activeClass));
                t && t.classList.remove(this.activeClass);
              },
            },
            {
              key: "_resetTooltips",
              value: function () {
                this.tooltips.forEach(function (t) {
                  t.classList.remove("tooltip--overflow-top"),
                    t.classList.remove("tooltip--overflow-right"),
                    t.classList.remove("tooltip--overflow-bottom"),
                    t.classList.remove("tooltip--overflow-left"),
                    (t.style.top = null),
                    (t.style.right = null),
                    (t.style.bottom = null),
                    (t.style.left = null);
                });
              },
            },
            {
              key: "positionHotspots",
              value: function () {
                var t = this;
                this.points.forEach(function (e) {
                  var i = parseInt(e.dataset.hotspotYAxis, 10),
                    n = parseInt(e.dataset.hotspotXAxis, 10),
                    s = e.getBoundingClientRect(),
                    o = t.imageWrapper.getBoundingClientRect(),
                    r = ((o.height - s.height) / o.height) * i;
                  e.style.bottom = "".concat(r, "%");
                  var a = ((o.width - s.width) / o.width) * n;
                  (e.style.left = "".concat(a, "%")),
                    (e.style.visibility = "visible");
                });
              },
            },
            {
              key: "positionTooltips",
              value: function () {
                var t = this;
                this._resetTooltips(),
                  this.tooltips.forEach(function (e) {
                    var i = e.getBoundingClientRect(),
                      n = window.getComputedStyle
                        ? getComputedStyle(e, null)
                        : e.currentStyle,
                      s = parseInt(n.marginTop, 10) || 0,
                      o = parseInt(n.marginRight, 10) || 0,
                      r = parseInt(n.marginBottom, 10) || 0,
                      a = parseInt(n.marginLeft, 10) || 0,
                      l = i.top - s,
                      c = i.right + o,
                      h = i.bottom + r,
                      d = i.left - a;
                    if (c >= t.window.innerWidth) {
                      e.classList.add("tooltip--overflow-right");
                      var u = t.window.innerWidth - c;
                      e.style.left = "".concat(u, "px");
                    }
                    if (d <= 0) {
                      e.classList.add("tooltip--overflow-left");
                      var p = Math.abs(d);
                      e.style.left = "".concat(p, "px");
                    }
                    if (
                      (l <= 0 && e.classList.add("tooltip--overflow-top"),
                      h >= t.window.innerHeight)
                    ) {
                      e.classList.add("tooltip--overflow-bottom");
                      var f = t.window.innerHeight - h;
                      e.style.top = "".concat(f, "px");
                    }
                  });
              },
            },
            {
              key: "onSectionBlockSelect",
              value: function (t) {
                var e = this;
                this._clearAllActive();
                var i = !1;
                (this.windowScrollEvent = this.events.register(
                  this.window,
                  "scroll",
                  function () {
                    (i = !0),
                      null !== e.windowScrollTimer &&
                        clearTimeout(e.windowScrollTimer),
                      (e.windowScrollTimer = setTimeout(function () {
                        e.positionTooltips(),
                          t.el.classList.add(e.activeClass),
                          (e.windowScrollTimer = null);
                      }, 200));
                  }
                )),
                  !1 === i &&
                    (this.positionTooltips(),
                    t.el.classList.add(this.activeClass));
              },
            },
            {
              key: "onSectionBlockDeselect",
              value: function (t) {
                this.events.unregister(this.windowScrollEvent),
                  (this.windowScrollEvent = null),
                  t.el.classList.remove(this.activeClass);
              },
            },
            {
              key: "onSectionUnload",
              value: function () {
                this.events.unregisterAll();
              },
            },
          ]) && ts(e.prototype, i),
          n && ts(e, n),
          t
        );
      })();
      class ss extends ns {
        constructor(t) {
          super(t),
            (this.modalSelector = `[data-hotspot-modal-id='${t.id}']`),
            (this.modalEl = document.querySelector(this.modalSelector)),
            (this.modalWrapper = document.querySelector(
              `[data-hotspot-section-id='${t.id}']`
            )),
            (this.quickShopSelector = `[data-hotspot-section-id='${t.id}'] [data-hotspot-modal-quickshop]`),
            (this.quickshopSpinner = this.modalEl.querySelector(
              this.quickShopSelector
            ).innerHTML),
            (this.isOpen = !1),
            (this.modalSidebar = this.modalWrapper.querySelector(
              "[data-hotspot-modal-sidebar]"
            )),
            (this.modalSidebarItems = this.modalWrapper.querySelectorAll(
              "[data-hotspot-modal-sidebar-item]"
            )),
            (this.sidebarArrow = this.modalEl.querySelector(
              "[data-sidebar-arrow]"
            )),
            (this.sidebarItemActiveClass = "active-item"),
            (this.qsTrigger = null),
            (this.modal = new Ht({ onClose: () => this.unload() })),
            this.tooltips.forEach((t) => {
              this.events.register(t, "click", (t) => this.onTooltipClick(t));
            }),
            this.modalSidebarItems.forEach((t) => {
              this.events.register(t, "click", (t) =>
                this.onSidebarItemClick(t)
              );
            });
        }
        onTooltipClick(t) {
          t.preventDefault();
          const e = t.currentTarget
              .querySelector("[data-tooltip]")
              .getAttribute("href"),
            i =
              t.currentTarget.closest("[data-hotspot]").dataset.hotspotProduct;
          if (
            (this.points.forEach((t) => {
              t.dataset.hotspotProduct === i && (this.qsTrigger = t);
            }),
            "#" === e)
          )
            return;
          this.modal.open(this.modalSelector, "quickshop-full hotspot__modal");
          const n = this.modalWrapper.querySelector(`[data-product-id='${i}']`);
          n.classList.add(this.sidebarItemActiveClass);
          const s = n.dataset.quickshopHash;
          this.positionSidebarArrow(n),
            (this.isOpen = !0),
            this._fetchQuickshop(i, e, s);
        }
        onSidebarItemClick(t) {
          t.preventDefault();
          const e = t.currentTarget,
            i = e.dataset.productQuickshopUrl,
            n = e.dataset.productId,
            s = this.modalWrapper.querySelectorAll(
              `.${this.sidebarItemActiveClass}`
            ),
            o = e.dataset.quickshopHash;
          (this.modalWrapper.querySelector(
            "[data-hotspot-modal-quickshop]"
          ).innerHTML = this.quickshopSpinner),
            this.positionSidebarArrow(e),
            s.forEach((t) => {
              t.classList.remove(this.sidebarItemActiveClass);
            }),
            e.classList.add(this.sidebarItemActiveClass),
            i && n && this._fetchQuickshop(n, i, o);
        }
        positionSidebarArrow(t) {
          const e = t
              .querySelector("[data-modal-sidebar-image]")
              .getBoundingClientRect(),
            i = t.offsetTop + e.height / 2;
          this.sidebarArrow.style.top = `${i}px`;
        }
        _fetchQuickshop(t, i, n) {
          const s = this.modal.$modalInner[0].querySelector(
              "[data-hotspot-modal-quickshop]"
            ),
            o = this.modal.$modalInner.find(
              "[data-hotspot-modal-sidebar-item]"
            ),
            r = this.modalWrapper.querySelector(".productitem-quickshop");
          r && (r.style.display = "block"),
            (this.productQuickshop = new ni({
              $el: o,
              id: this.sectionId,
              modal: this.modal,
              sectionContext: "shoppable-image",
              trigger: e()(this.qsTrigger),
              quickshopContainer: s,
              quickShopSelector: this.quickShopSelector,
              productUrl: i,
              view: "product-shoppable-img-qs",
              hash: n,
            }));
        }
        unload() {
          this.productQuickshop && this.productQuickshop.unload();
          this.modalWrapper
            .querySelectorAll(`.${this.sidebarItemActiveClass}`)
            .forEach((t) => {
              t.classList.remove(this.sidebarItemActiveClass);
            });
        }
      }
      class os {
        constructor(t) {
          (this.$el = t.el),
            (this.$window = $(window)),
            (this.flickity = null),
            (this.events = new St.Z()),
            (this.carousel = this.$el.querySelector(".testimonials")),
            (this.slides = this.$el.querySelectorAll(".testimonial")),
            (this.onBreakpointChange = () => {
              (bt.max("XS") && this.slides.length > 1) ||
              (bt.max("L") && this.slides.length >= 3) ||
              (bt.min("XL") && this.slides.length > 3)
                ? this._initFlickity()
                : this._destroyFlickity();
            }),
            this.onBreakpointChange(),
            bt.onChange(this.onBreakpointChange);
        }
        onSectionUnload() {
          this._destroyFlickity(),
            bt.offChange(this.onBreakpointChange),
            this.events.unregisterAll();
        }
        _initFlickity() {
          this.Flickity ||
            ((this.flickity = new (_t())(this.carousel, {
              autoPlay: 0,
              accessibility: !0,
              cellAlign: "left",
              cellSelector: ".testimonial",
              groupCells: !0,
              pageDots: !0,
              contain: !0,
              adaptiveHeight: !1,
              arrowShape:
                "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
            })),
            this.events.register(this.carousel, "rimg:load", () => {
              this.flickity.resize();
            }));
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
      }
      class rs {
        constructor() {
          (this.$accountContents = e()("[data-template-account]")),
            (this.$loginContent = e()("[data-template-account-login]")),
            (this.$addressesContent = e()("[data-template-account-addresses]")),
            (this.$addressButtonFocus = null),
            (this.checkFillAnimation = null),
            (this.checkAnimation = null),
            (this._loginToggle = this._loginToggle.bind(this)),
            this.$loginContent.length && this._initLoginPage(),
            this.$addressesContent.length &&
              ((this.defaultAddressCheckbox =
                this.$addressesContent[0].querySelector(".checkmark")),
              (this.defaultAddressCheck =
                this.$addressesContent[0].querySelector(".checkmark__check")),
              (this.checkFillAnimation = yt({
                el: this.defaultAddressCheckbox,
              })),
              (this.checkAnimation = yt({ el: this.defaultAddressCheck })),
              this._initAddressPage()),
            this.$accountContents.length && this._init();
        }
        _init() {
          new F(this.$accountContents);
        }
        _initLoginPage() {
          (this.$loginToggle = this.$loginContent.find("[data-login-toggle]")),
            (this.$login = this.$loginContent.find(
              "[data-account-login-main]"
            )),
            (this.$recovery = this.$loginContent.find(
              "[data-account-login-recovery]"
            )),
            (this.$recoveryHasMessage = this.$recovery.find(
              "[data-recovery-has-message]"
            )),
            this.$loginToggle.on("click", this._loginToggle),
            this.$recoveryHasMessage.length && this._loginToggle();
        }
        _loginToggle() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null;
          t && t.preventDefault(),
            this.$login.toggleClass("visible"),
            this.$recovery.toggleClass("visible");
        }
        _initAddressPage() {
          const t = this.$addressesContent.find("[data-address-id]");
          this.$addressesContent.on("click", "[data-edit-address]", (i) => {
            const n = e()(i.currentTarget),
              s = n.attr("data-edit-address");
            t.removeClass("visible"),
              (this.$addressButtonFocus = n),
              e()(`[data-address-id="${s}"]`)
                .addClass("visible")
                .find(".form-field-input")
                .eq(0)
                .focus();
          }),
            this.$addressesContent.on(
              "click",
              "[data-edit-address-cancel]",
              () => {
                t.removeClass("visible"),
                  e()('[data-address-id="new"]').addClass("visible"),
                  this.$addressButtonFocus.focus(),
                  (this.$addressButtonFocus = null);
              }
            ),
            this.$addressesContent.on("click", "[data-delete-address]", (t) => {
              const i = e()(t.target).attr("data-delete-address");
              Shopify.CustomerAddress.destroy(i, "");
            }),
            t.each((t, i) => {
              const n = e()(i).attr("data-address-id"),
                s = `customer_addr_${n}_country`,
                o = `customer_addr_${n}_province`,
                r = { hideElement: `address_province_container_${n}` };
              new Shopify.CountryProvinceSelector(s, o, r);
            }),
            this.$addressesContent.on(
              "click",
              "#address_default_address_new",
              () => {
                let t = "checked";
                "checked" ===
                  this.defaultAddressCheckbox.dataset.animationState &&
                  (t = "unchecked"),
                  this.checkFillAnimation.animateTo(t),
                  this.checkAnimation.animateTo(t);
              }
            );
        }
      }
      class as {
        constructor() {
          (this.$contactContents = e()("[data-template-contact]")),
            this.$contactContents.length && new F(this.$contactContents);
        }
      }
      class ls {
        constructor() {
          (this.el = document.querySelector(".template-giftcard")),
            (this.$el = e()(this.el)),
            (this.qrCode = this.el.querySelector("[data-giftcard-qr]")),
            (this.giftCardCode = this.el.querySelector("[data-giftcard-code]")),
            this._bindEvents(),
            this.addQrCode();
        }
        addQrCode() {
          return new QRCode(this.qrCode, {
            text: e()(this.qrCode).data("giftcard-qr"),
            width: 120,
            height: 120,
          });
        }
        _bindEvents() {
          this.$el.on("click", "[data-giftcard-print]", () => {
            window.print();
          }),
            this.$el.on("click", "[data-giftcard-code]", () => {
              this._selectText();
            });
        }
        _selectText() {
          let t,
            e = "";
          document.body.createTextRange
            ? ((e = document.body.createTextRange()),
              e.moveToElementText(this.giftCardCode),
              e.select())
            : window.getSelection &&
              ((t = window.getSelection()),
              (e = document.createRange()),
              e.selectNodeContents(this.giftCardCode),
              t.removeAllRanges(),
              t.addRange(e));
        }
      }
      class cs {
        constructor() {
          (this.$pageContent = e()("[data-template-page]")),
            this.$pageContent.length && new O(this.$pageContent);
        }
      }
      const hs = () => {
        let t = !1,
          e = 0;
        document.body.addEventListener("touchstart", (i) => {
          i.target.closest && i.target.closest(".flickity-slider")
            ? ((t = !0), (e = i.touches[0].pageX))
            : (t = !1);
        }),
          document.body.addEventListener(
            "touchmove",
            (i) => {
              t &&
                i.cancelable &&
                Math.abs(i.touches[0].pageX - e) > 10 &&
                i.preventDefault();
            },
            { passive: !1 }
          );
      };
      function ds(t) {
        let { target: e } = t;
        (e.dataset && !e.dataset.swatchTooltip) ||
          window.requestAnimationFrame(() =>
            (function (t) {
              const { innerWidth: e } = window,
                { x: i, width: n } = t.getBoundingClientRect(),
                s =
                  0.5 * parseFloat(window.getComputedStyle(t, ":after").width);
              let o = 0,
                r = 0;
              i < 0.5 * e
                ? ((o = i + 0.5 * n - 10), (r = s - o))
                : ((o = e - i - 0.5 * n - 10), (r = o - s)),
                t.style.setProperty(
                  "--swatch-tooltip-offset",
                  `${s >= o ? r : 0}px`
                );
            })(e)
          );
      }
      class us {
        constructor() {
          window.addEventListener("mouseover", ds);
        }
        unload() {
          window.removeEventListener("mouseover", ds);
        }
      }
      const ps = () => {
        (Zn = new IntersectionObserver(Xn, { threshold: 0.3 })),
          "reduceAnimations" in document.body.dataset ||
            document.querySelectorAll(`.${On}`).forEach((t) => Zn.observe(t)),
          x.init('[data-rimg="lazy"]', { round: 1 });
        const t = () => be(document);
        "requestIdleCallback" in window ? window.requestIdleCallback(t) : t();
        const e = new E();
        e.register("static-header", (t) => new ji(t)),
          e.register("static-announcement", (t) => new L(t)),
          e.register("static-footer", (t) => new ki(t)),
          e.register("static-article", (t) => new B(t)),
          e.register("static-blog", (t) => new N(t)),
          e.register("static-cart", (t) => new ut(t)),
          e.register("static-collection", (t) => new hi(t)),
          e.register("static-collection-faceted-filters", (t) => new en(t)),
          e.register("static-subcollections-menu", (t) => new Yi(t)),
          e.register("static-password", (t) => new Ui(t)),
          e.register("static-product", (t) => new Vi(t)),
          e.register("static-product-recommendations", (t) => new Xi(t)),
          e.register("static-recently-viewed", (t) => new Zi(t)),
          e.register("static-search", (t) => new Qi(t)),
          e.register("static-search-faceted-filters", (t) => new nn(t)),
          e.register("static-utility-bar", (t) => new Ki(t)),
          e.register(
            "static-subcollections-featured-collection",
            (t) => new tn(t)
          ),
          e.register("dynamic-blog-posts", (t) => new sn(t), { lazy: !0 }),
          e.register("dynamic-promo-mosaic", (t) => new an(t), { lazy: !0 }),
          e.register("dynamic-menu-list", (t) => new cn(t), { lazy: !0 }),
          e.register("dynamic-twitter-feed", (t) => new un(t), { lazy: !0 }),
          e.register("dynamic-collection-list", (t) => new pn(t), { lazy: !0 }),
          e.register("dynamic-featured-collection", (t) => new ln(t), {
            lazy: !0,
          }),
          e.register("dynamic-featured-product", (t) => new fn(t), {
            lazy: !0,
          }),
          e.register("dynamic-rich-text", (t) => new gn(t), { lazy: !0 }),
          e.register("dynamic-page", (t) => new gn(t), { lazy: !0 }),
          e.register("dynamic-html", (t) => new gn(t), { lazy: !0 }),
          e.register("dynamic-search", (t) => new mn(t), { lazy: !0 }),
          e.register("dynamic-highlights-banner", (t) => new Jn(t)),
          e.register("pxs-slideshow", (t) => new Qn(t), { lazy: !0 }),
          e.register("dynamic-video", (t) => new Kn(t), { lazy: !0 }),
          e.register("pxs-newsletter", (t) => new Yn(t), { lazy: !0 }),
          e.register("pxs-map", (t) => new index_es(t), { lazy: !0 }),
          e.register("pxs-shoppable-image", (t) => new ss(t), { lazy: !1 }),
          e.register("dynamic-testimonials", (t) => new os(t), { lazy: !0 }),
          document.body.classList.contains("template-giftcard") && new ls(),
          document.querySelector("[data-template-account]") && new rs(),
          document.querySelector("[data-template-contact]") && new as(),
          document.body.classList.contains("template-page") && new cs(),
          document.querySelector("[data-swatch-tooltip]") && new us();
      };
      hs(), A.length ? s()(A, ps) : ps();
    })();
})();
